
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree984"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree984"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jk232", function(module, exports) {
'use strict';

module.exports = (parcelRequire("c4rdg"));

});
parcelRegister("c4rdg", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $8c9af7af61162037$export$ffb0004e005737fa; }, function (v) { return $8c9af7af61162037$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $8c9af7af61162037$export$34b9dba7ce09269b; }, function (v) { return $8c9af7af61162037$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $8c9af7af61162037$export$25062201e9e25d76; }, function (v) { return $8c9af7af61162037$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8c9af7af61162037$export$ffb0004e005737fa;
var $8c9af7af61162037$export$34b9dba7ce09269b;
var $8c9af7af61162037$export$25062201e9e25d76;
"use strict";
var $8c9af7af61162037$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $8c9af7af61162037$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $8c9af7af61162037$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $8c9af7af61162037$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$8c9af7af61162037$export$ffb0004e005737fa = $8c9af7af61162037$var$REACT_FRAGMENT_TYPE;
$8c9af7af61162037$export$34b9dba7ce09269b = $8c9af7af61162037$var$jsxProd;
$8c9af7af61162037$export$25062201e9e25d76 = $8c9af7af61162037$var$jsxProd;

});


parcelRegister("4RFnf", function(module, exports) {
'use strict';

module.exports = (parcelRequire("b63jL"));

});
parcelRegister("b63jL", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $8142d41a6b407d96$export$dca3b0875bd9a954; }, function (v) { return $8142d41a6b407d96$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $8142d41a6b407d96$export$16fa2f45be04daa8; }, function (v) { return $8142d41a6b407d96$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $8142d41a6b407d96$export$ffb0004e005737fa; }, function (v) { return $8142d41a6b407d96$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $8142d41a6b407d96$export$e2c29f18771995cb; }, function (v) { return $8142d41a6b407d96$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $8142d41a6b407d96$export$221d75b3f55bb0bd; }, function (v) { return $8142d41a6b407d96$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $8142d41a6b407d96$export$5f8d39834fd61797; }, function (v) { return $8142d41a6b407d96$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $8142d41a6b407d96$export$74bf444e3cd11ea5; }, function (v) { return $8142d41a6b407d96$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $8142d41a6b407d96$export$1ced07cd6b1985ce; }, function (v) { return $8142d41a6b407d96$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "act", function () { return $8142d41a6b407d96$export$3ba232387fd5d6dd; }, function (v) { return $8142d41a6b407d96$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cache", function () { return $8142d41a6b407d96$export$69a3209f1a06c04d; }, function (v) { return $8142d41a6b407d96$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $8142d41a6b407d96$export$e530037191fcd5d7; }, function (v) { return $8142d41a6b407d96$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $8142d41a6b407d96$export$fd42f52fd3ae1109; }, function (v) { return $8142d41a6b407d96$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $8142d41a6b407d96$export$c8a8987d4410bf2d; }, function (v) { return $8142d41a6b407d96$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $8142d41a6b407d96$export$7d1e3a5e95ceca43; }, function (v) { return $8142d41a6b407d96$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $8142d41a6b407d96$export$257a8862b851cb5b; }, function (v) { return $8142d41a6b407d96$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $8142d41a6b407d96$export$a8257692ac88316c; }, function (v) { return $8142d41a6b407d96$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $8142d41a6b407d96$export$488013bae63b21da; }, function (v) { return $8142d41a6b407d96$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $8142d41a6b407d96$export$7c73462e0d25e514; }, function (v) { return $8142d41a6b407d96$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $8142d41a6b407d96$export$7568632d0d33d16d; }, function (v) { return $8142d41a6b407d96$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $8142d41a6b407d96$export$f93f40ac0ca7e3a8; }, function (v) { return $8142d41a6b407d96$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $8142d41a6b407d96$export$1f96ae73734a86cc; }, function (v) { return $8142d41a6b407d96$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $8142d41a6b407d96$export$9a47ced3238df325; }, function (v) { return $8142d41a6b407d96$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $8142d41a6b407d96$export$35808ee640e87ca7; }, function (v) { return $8142d41a6b407d96$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $8142d41a6b407d96$export$fae74005e78b1a27; }, function (v) { return $8142d41a6b407d96$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $8142d41a6b407d96$export$dc8fbce3eb94dc1e; }, function (v) { return $8142d41a6b407d96$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $8142d41a6b407d96$export$6a7bc4e911dc01cf; }, function (v) { return $8142d41a6b407d96$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $8142d41a6b407d96$export$6d9c69b0de29b591; }, function (v) { return $8142d41a6b407d96$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $8142d41a6b407d96$export$f680877a34711e37; }, function (v) { return $8142d41a6b407d96$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $8142d41a6b407d96$export$d5a552a76deda3c2; }, function (v) { return $8142d41a6b407d96$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $8142d41a6b407d96$export$aaabe4eda9ed9969; }, function (v) { return $8142d41a6b407d96$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $8142d41a6b407d96$export$e5c5a5f917a5871c; }, function (v) { return $8142d41a6b407d96$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $8142d41a6b407d96$export$1538c33de8887b59; }, function (v) { return $8142d41a6b407d96$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $8142d41a6b407d96$export$fca7f784ae7a249a; }, function (v) { return $8142d41a6b407d96$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $8142d41a6b407d96$export$13e3392192263954; }, function (v) { return $8142d41a6b407d96$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $8142d41a6b407d96$export$b8f5890fc79d6aca; }, function (v) { return $8142d41a6b407d96$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $8142d41a6b407d96$export$60241385465d0a34; }, function (v) { return $8142d41a6b407d96$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $8142d41a6b407d96$export$306c0aa65ff9ec16; }, function (v) { return $8142d41a6b407d96$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $8142d41a6b407d96$export$7b286972b8d8ccbf; }, function (v) { return $8142d41a6b407d96$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $8142d41a6b407d96$export$83d89fbfd8236492; }, function (v) { return $8142d41a6b407d96$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8142d41a6b407d96$export$dca3b0875bd9a954;
var $8142d41a6b407d96$export$16fa2f45be04daa8;
var $8142d41a6b407d96$export$ffb0004e005737fa;
var $8142d41a6b407d96$export$e2c29f18771995cb;
var $8142d41a6b407d96$export$221d75b3f55bb0bd;
var $8142d41a6b407d96$export$5f8d39834fd61797;
var $8142d41a6b407d96$export$74bf444e3cd11ea5;
var $8142d41a6b407d96$export$1ced07cd6b1985ce;
var $8142d41a6b407d96$export$3ba232387fd5d6dd;
var $8142d41a6b407d96$export$69a3209f1a06c04d;
var $8142d41a6b407d96$export$e530037191fcd5d7;
var $8142d41a6b407d96$export$fd42f52fd3ae1109;
var $8142d41a6b407d96$export$c8a8987d4410bf2d;
var $8142d41a6b407d96$export$7d1e3a5e95ceca43;
var $8142d41a6b407d96$export$257a8862b851cb5b;
var $8142d41a6b407d96$export$a8257692ac88316c;
var $8142d41a6b407d96$export$488013bae63b21da;
var $8142d41a6b407d96$export$7c73462e0d25e514;
var $8142d41a6b407d96$export$7568632d0d33d16d;
var $8142d41a6b407d96$export$f93f40ac0ca7e3a8;
var $8142d41a6b407d96$export$1f96ae73734a86cc;
var $8142d41a6b407d96$export$9a47ced3238df325;
var $8142d41a6b407d96$export$35808ee640e87ca7;
var $8142d41a6b407d96$export$fae74005e78b1a27;
var $8142d41a6b407d96$export$dc8fbce3eb94dc1e;
var $8142d41a6b407d96$export$6a7bc4e911dc01cf;
var $8142d41a6b407d96$export$6d9c69b0de29b591;
var $8142d41a6b407d96$export$f680877a34711e37;
var $8142d41a6b407d96$export$d5a552a76deda3c2;
var $8142d41a6b407d96$export$aaabe4eda9ed9969;
var $8142d41a6b407d96$export$e5c5a5f917a5871c;
var $8142d41a6b407d96$export$1538c33de8887b59;
var $8142d41a6b407d96$export$fca7f784ae7a249a;
var $8142d41a6b407d96$export$13e3392192263954;
var $8142d41a6b407d96$export$b8f5890fc79d6aca;
var $8142d41a6b407d96$export$60241385465d0a34;
var $8142d41a6b407d96$export$306c0aa65ff9ec16;
var $8142d41a6b407d96$export$7b286972b8d8ccbf;
var $8142d41a6b407d96$export$83d89fbfd8236492;
"use strict";
var $8142d41a6b407d96$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $8142d41a6b407d96$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $8142d41a6b407d96$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $8142d41a6b407d96$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $8142d41a6b407d96$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $8142d41a6b407d96$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $8142d41a6b407d96$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $8142d41a6b407d96$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $8142d41a6b407d96$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $8142d41a6b407d96$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $8142d41a6b407d96$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $8142d41a6b407d96$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $8142d41a6b407d96$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $8142d41a6b407d96$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$8142d41a6b407d96$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $8142d41a6b407d96$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $8142d41a6b407d96$var$assign = Object.assign, $8142d41a6b407d96$var$emptyObject = {};
function $8142d41a6b407d96$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $8142d41a6b407d96$var$emptyObject;
    this.updater = updater || $8142d41a6b407d96$var$ReactNoopUpdateQueue;
}
$8142d41a6b407d96$var$Component.prototype.isReactComponent = {};
$8142d41a6b407d96$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$8142d41a6b407d96$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $8142d41a6b407d96$var$ComponentDummy() {}
$8142d41a6b407d96$var$ComponentDummy.prototype = $8142d41a6b407d96$var$Component.prototype;
function $8142d41a6b407d96$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $8142d41a6b407d96$var$emptyObject;
    this.updater = updater || $8142d41a6b407d96$var$ReactNoopUpdateQueue;
}
var $8142d41a6b407d96$var$pureComponentPrototype = $8142d41a6b407d96$var$PureComponent.prototype = new $8142d41a6b407d96$var$ComponentDummy();
$8142d41a6b407d96$var$pureComponentPrototype.constructor = $8142d41a6b407d96$var$PureComponent;
$8142d41a6b407d96$var$assign($8142d41a6b407d96$var$pureComponentPrototype, $8142d41a6b407d96$var$Component.prototype);
$8142d41a6b407d96$var$pureComponentPrototype.isPureReactComponent = !0;
var $8142d41a6b407d96$var$isArrayImpl = Array.isArray, $8142d41a6b407d96$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $8142d41a6b407d96$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $8142d41a6b407d96$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $8142d41a6b407d96$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $8142d41a6b407d96$var$cloneAndReplaceKey(oldElement, newKey) {
    return $8142d41a6b407d96$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $8142d41a6b407d96$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $8142d41a6b407d96$var$REACT_ELEMENT_TYPE;
}
function $8142d41a6b407d96$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $8142d41a6b407d96$var$userProvidedKeyEscapeRegex = /\/+/g;
function $8142d41a6b407d96$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $8142d41a6b407d96$var$escape("" + element.key) : index.toString(36);
}
function $8142d41a6b407d96$var$noop$1() {}
function $8142d41a6b407d96$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($8142d41a6b407d96$var$noop$1, $8142d41a6b407d96$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $8142d41a6b407d96$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $8142d41a6b407d96$var$REACT_ELEMENT_TYPE:
                case $8142d41a6b407d96$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $8142d41a6b407d96$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $8142d41a6b407d96$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $8142d41a6b407d96$var$getElementKey(children, 0) : nameSoFar, $8142d41a6b407d96$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($8142d41a6b407d96$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $8142d41a6b407d96$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($8142d41a6b407d96$var$isValidElement(callback) && (callback = $8142d41a6b407d96$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($8142d41a6b407d96$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($8142d41a6b407d96$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $8142d41a6b407d96$var$getElementKey(nameSoFar, i), invokeCallback += $8142d41a6b407d96$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $8142d41a6b407d96$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $8142d41a6b407d96$var$getElementKey(nameSoFar, i++), invokeCallback += $8142d41a6b407d96$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $8142d41a6b407d96$var$mapIntoArray($8142d41a6b407d96$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $8142d41a6b407d96$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $8142d41a6b407d96$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $8142d41a6b407d96$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $8142d41a6b407d96$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $8142d41a6b407d96$var$noop() {}
$8142d41a6b407d96$export$dca3b0875bd9a954 = {
    map: $8142d41a6b407d96$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $8142d41a6b407d96$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $8142d41a6b407d96$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $8142d41a6b407d96$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$8142d41a6b407d96$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$8142d41a6b407d96$export$16fa2f45be04daa8 = $8142d41a6b407d96$var$Component;
$8142d41a6b407d96$export$ffb0004e005737fa = $8142d41a6b407d96$var$REACT_FRAGMENT_TYPE;
$8142d41a6b407d96$export$e2c29f18771995cb = $8142d41a6b407d96$var$REACT_PROFILER_TYPE;
$8142d41a6b407d96$export$221d75b3f55bb0bd = $8142d41a6b407d96$var$PureComponent;
$8142d41a6b407d96$export$5f8d39834fd61797 = $8142d41a6b407d96$var$REACT_STRICT_MODE_TYPE;
$8142d41a6b407d96$export$74bf444e3cd11ea5 = $8142d41a6b407d96$var$REACT_SUSPENSE_TYPE;
$8142d41a6b407d96$export$1ced07cd6b1985ce = $8142d41a6b407d96$var$ReactSharedInternals;
$8142d41a6b407d96$export$3ba232387fd5d6dd = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$8142d41a6b407d96$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$8142d41a6b407d96$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $8142d41a6b407d96$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$8142d41a6b407d96$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $8142d41a6b407d96$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$8142d41a6b407d96$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $8142d41a6b407d96$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $8142d41a6b407d96$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$8142d41a6b407d96$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$8142d41a6b407d96$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $8142d41a6b407d96$var$ReactElement(type, key, void 0, void 0, null, props);
};
$8142d41a6b407d96$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$8142d41a6b407d96$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $8142d41a6b407d96$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$8142d41a6b407d96$export$a8257692ac88316c = $8142d41a6b407d96$var$isValidElement;
$8142d41a6b407d96$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $8142d41a6b407d96$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $8142d41a6b407d96$var$lazyInitializer
    };
};
$8142d41a6b407d96$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $8142d41a6b407d96$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$8142d41a6b407d96$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $8142d41a6b407d96$var$ReactSharedInternals.T, currentTransition = {};
    $8142d41a6b407d96$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $8142d41a6b407d96$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($8142d41a6b407d96$var$noop, $8142d41a6b407d96$var$reportGlobalError);
    } catch (error) {
        $8142d41a6b407d96$var$reportGlobalError(error);
    } finally{
        $8142d41a6b407d96$var$ReactSharedInternals.T = prevTransition;
    }
};
$8142d41a6b407d96$export$f93f40ac0ca7e3a8 = function() {
    return $8142d41a6b407d96$var$ReactSharedInternals.H.useCacheRefresh();
};
$8142d41a6b407d96$export$1f96ae73734a86cc = function(usable) {
    return $8142d41a6b407d96$var$ReactSharedInternals.H.use(usable);
};
$8142d41a6b407d96$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $8142d41a6b407d96$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$8142d41a6b407d96$export$35808ee640e87ca7 = function(callback, deps) {
    return $8142d41a6b407d96$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$8142d41a6b407d96$export$fae74005e78b1a27 = function(Context) {
    return $8142d41a6b407d96$var$ReactSharedInternals.H.useContext(Context);
};
$8142d41a6b407d96$export$dc8fbce3eb94dc1e = function() {};
$8142d41a6b407d96$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $8142d41a6b407d96$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$8142d41a6b407d96$export$6d9c69b0de29b591 = function(create, deps) {
    return $8142d41a6b407d96$var$ReactSharedInternals.H.useEffect(create, deps);
};
$8142d41a6b407d96$export$f680877a34711e37 = function() {
    return $8142d41a6b407d96$var$ReactSharedInternals.H.useId();
};
$8142d41a6b407d96$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $8142d41a6b407d96$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$8142d41a6b407d96$export$aaabe4eda9ed9969 = function(create, deps) {
    return $8142d41a6b407d96$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$8142d41a6b407d96$export$e5c5a5f917a5871c = function(create, deps) {
    return $8142d41a6b407d96$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$8142d41a6b407d96$export$1538c33de8887b59 = function(create, deps) {
    return $8142d41a6b407d96$var$ReactSharedInternals.H.useMemo(create, deps);
};
$8142d41a6b407d96$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $8142d41a6b407d96$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$8142d41a6b407d96$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $8142d41a6b407d96$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$8142d41a6b407d96$export$b8f5890fc79d6aca = function(initialValue) {
    return $8142d41a6b407d96$var$ReactSharedInternals.H.useRef(initialValue);
};
$8142d41a6b407d96$export$60241385465d0a34 = function(initialState) {
    return $8142d41a6b407d96$var$ReactSharedInternals.H.useState(initialState);
};
$8142d41a6b407d96$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $8142d41a6b407d96$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$8142d41a6b407d96$export$7b286972b8d8ccbf = function() {
    return $8142d41a6b407d96$var$ReactSharedInternals.H.useTransition();
};
$8142d41a6b407d96$export$83d89fbfd8236492 = "19.0.0";

});


parcelRegister("32Bah", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $236e632e8c7b0376$export$882461b6382ed46c; }, function (v) { return $236e632e8c7b0376$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $236e632e8c7b0376$export$757ceba2d55c277e; }, function (v) { return $236e632e8c7b0376$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $236e632e8c7b0376$export$83d89fbfd8236492; }, function (v) { return $236e632e8c7b0376$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $236e632e8c7b0376$export$882461b6382ed46c;
var $236e632e8c7b0376$export$757ceba2d55c277e;
var $236e632e8c7b0376$export$83d89fbfd8236492;
"use strict";

var $8TTSu = parcelRequire("8TTSu");

var $4RFnf = parcelRequire("4RFnf");

var $9lz36 = parcelRequire("9lz36");
function $236e632e8c7b0376$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $236e632e8c7b0376$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
var $236e632e8c7b0376$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $236e632e8c7b0376$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $236e632e8c7b0376$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $236e632e8c7b0376$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $236e632e8c7b0376$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $236e632e8c7b0376$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $236e632e8c7b0376$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $236e632e8c7b0376$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $236e632e8c7b0376$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $236e632e8c7b0376$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $236e632e8c7b0376$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $236e632e8c7b0376$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $236e632e8c7b0376$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $236e632e8c7b0376$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $236e632e8c7b0376$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $236e632e8c7b0376$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $236e632e8c7b0376$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $236e632e8c7b0376$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $236e632e8c7b0376$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$236e632e8c7b0376$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $236e632e8c7b0376$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $236e632e8c7b0376$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $236e632e8c7b0376$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $236e632e8c7b0376$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $236e632e8c7b0376$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $236e632e8c7b0376$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $236e632e8c7b0376$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $236e632e8c7b0376$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $236e632e8c7b0376$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $236e632e8c7b0376$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $236e632e8c7b0376$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $236e632e8c7b0376$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $236e632e8c7b0376$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $236e632e8c7b0376$var$getComponentNameFromType(type.type) || "Memo";
        case $236e632e8c7b0376$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $236e632e8c7b0376$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $236e632e8c7b0376$var$ReactSharedInternals = $4RFnf.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $236e632e8c7b0376$var$assign = Object.assign, $236e632e8c7b0376$var$prefix, $236e632e8c7b0376$var$suffix;
function $236e632e8c7b0376$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $236e632e8c7b0376$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $236e632e8c7b0376$var$prefix = match && match[1] || "";
        $236e632e8c7b0376$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $236e632e8c7b0376$var$prefix + name + $236e632e8c7b0376$var$suffix;
}
var $236e632e8c7b0376$var$reentry = !1;
function $236e632e8c7b0376$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $236e632e8c7b0376$var$reentry) return "";
    $236e632e8c7b0376$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$0) {
                                control = x$0;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$1) {
                            control = x$1;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $236e632e8c7b0376$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $236e632e8c7b0376$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $236e632e8c7b0376$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $236e632e8c7b0376$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $236e632e8c7b0376$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $236e632e8c7b0376$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $236e632e8c7b0376$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return fiber = $236e632e8c7b0376$var$describeNativeComponentFrame(fiber.type, !1), fiber;
        case 11:
            return fiber = $236e632e8c7b0376$var$describeNativeComponentFrame(fiber.type.render, !1), fiber;
        case 1:
            return fiber = $236e632e8c7b0376$var$describeNativeComponentFrame(fiber.type, !0), fiber;
        default:
            return "";
    }
}
function $236e632e8c7b0376$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $236e632e8c7b0376$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $236e632e8c7b0376$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $236e632e8c7b0376$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $236e632e8c7b0376$var$assertIsMounted(fiber) {
    if ($236e632e8c7b0376$var$getNearestMountedFiber(fiber) !== fiber) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(188));
}
function $236e632e8c7b0376$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $236e632e8c7b0376$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $236e632e8c7b0376$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $236e632e8c7b0376$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($236e632e8c7b0376$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                if (child$2 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$2 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$2 = child$2.sibling;
            }
            if (!didFindChild) {
                for(child$2 = parentB.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $236e632e8c7b0376$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $236e632e8c7b0376$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $236e632e8c7b0376$var$isArrayImpl = Array.isArray, $236e632e8c7b0376$var$ReactDOMSharedInternals = $9lz36.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $236e632e8c7b0376$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $236e632e8c7b0376$var$valueStack = [], $236e632e8c7b0376$var$index = -1;
function $236e632e8c7b0376$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $236e632e8c7b0376$var$pop(cursor) {
    0 > $236e632e8c7b0376$var$index || (cursor.current = $236e632e8c7b0376$var$valueStack[$236e632e8c7b0376$var$index], $236e632e8c7b0376$var$valueStack[$236e632e8c7b0376$var$index] = null, $236e632e8c7b0376$var$index--);
}
function $236e632e8c7b0376$var$push(cursor, value) {
    $236e632e8c7b0376$var$index++;
    $236e632e8c7b0376$var$valueStack[$236e632e8c7b0376$var$index] = cursor.current;
    cursor.current = value;
}
var $236e632e8c7b0376$var$contextStackCursor = $236e632e8c7b0376$var$createCursor(null), $236e632e8c7b0376$var$contextFiberStackCursor = $236e632e8c7b0376$var$createCursor(null), $236e632e8c7b0376$var$rootInstanceStackCursor = $236e632e8c7b0376$var$createCursor(null), $236e632e8c7b0376$var$hostTransitionProviderCursor = $236e632e8c7b0376$var$createCursor(null);
function $236e632e8c7b0376$var$pushHostContainer(fiber, nextRootInstance) {
    $236e632e8c7b0376$var$push($236e632e8c7b0376$var$rootInstanceStackCursor, nextRootInstance);
    $236e632e8c7b0376$var$push($236e632e8c7b0376$var$contextFiberStackCursor, fiber);
    $236e632e8c7b0376$var$push($236e632e8c7b0376$var$contextStackCursor, null);
    fiber = nextRootInstance.nodeType;
    switch(fiber){
        case 9:
        case 11:
            nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? $236e632e8c7b0376$var$getOwnHostContext(nextRootInstance) : 0 : 0;
            break;
        default:
            if (fiber = 8 === fiber ? nextRootInstance.parentNode : nextRootInstance, nextRootInstance = fiber.tagName, fiber = fiber.namespaceURI) fiber = $236e632e8c7b0376$var$getOwnHostContext(fiber), nextRootInstance = $236e632e8c7b0376$var$getChildHostContextProd(fiber, nextRootInstance);
            else switch(nextRootInstance){
                case "svg":
                    nextRootInstance = 1;
                    break;
                case "math":
                    nextRootInstance = 2;
                    break;
                default:
                    nextRootInstance = 0;
            }
    }
    $236e632e8c7b0376$var$pop($236e632e8c7b0376$var$contextStackCursor);
    $236e632e8c7b0376$var$push($236e632e8c7b0376$var$contextStackCursor, nextRootInstance);
}
function $236e632e8c7b0376$var$popHostContainer() {
    $236e632e8c7b0376$var$pop($236e632e8c7b0376$var$contextStackCursor);
    $236e632e8c7b0376$var$pop($236e632e8c7b0376$var$contextFiberStackCursor);
    $236e632e8c7b0376$var$pop($236e632e8c7b0376$var$rootInstanceStackCursor);
}
function $236e632e8c7b0376$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $236e632e8c7b0376$var$push($236e632e8c7b0376$var$hostTransitionProviderCursor, fiber);
    var context = $236e632e8c7b0376$var$contextStackCursor.current;
    var JSCompiler_inline_result = $236e632e8c7b0376$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($236e632e8c7b0376$var$push($236e632e8c7b0376$var$contextFiberStackCursor, fiber), $236e632e8c7b0376$var$push($236e632e8c7b0376$var$contextStackCursor, JSCompiler_inline_result));
}
function $236e632e8c7b0376$var$popHostContext(fiber) {
    $236e632e8c7b0376$var$contextFiberStackCursor.current === fiber && ($236e632e8c7b0376$var$pop($236e632e8c7b0376$var$contextStackCursor), $236e632e8c7b0376$var$pop($236e632e8c7b0376$var$contextFiberStackCursor));
    $236e632e8c7b0376$var$hostTransitionProviderCursor.current === fiber && ($236e632e8c7b0376$var$pop($236e632e8c7b0376$var$hostTransitionProviderCursor), $236e632e8c7b0376$var$HostTransitionContext._currentValue = $236e632e8c7b0376$var$sharedNotPendingObject);
}
var $236e632e8c7b0376$var$hasOwnProperty = Object.prototype.hasOwnProperty, $236e632e8c7b0376$var$scheduleCallback$3 = $8TTSu.unstable_scheduleCallback, $236e632e8c7b0376$var$cancelCallback$1 = $8TTSu.unstable_cancelCallback, $236e632e8c7b0376$var$shouldYield = $8TTSu.unstable_shouldYield, $236e632e8c7b0376$var$requestPaint = $8TTSu.unstable_requestPaint, $236e632e8c7b0376$var$now = $8TTSu.unstable_now, $236e632e8c7b0376$var$getCurrentPriorityLevel = $8TTSu.unstable_getCurrentPriorityLevel, $236e632e8c7b0376$var$ImmediatePriority = $8TTSu.unstable_ImmediatePriority, $236e632e8c7b0376$var$UserBlockingPriority = $8TTSu.unstable_UserBlockingPriority, $236e632e8c7b0376$var$NormalPriority$1 = $8TTSu.unstable_NormalPriority, $236e632e8c7b0376$var$LowPriority = $8TTSu.unstable_LowPriority, $236e632e8c7b0376$var$IdlePriority = $8TTSu.unstable_IdlePriority, $236e632e8c7b0376$var$log$1 = $8TTSu.log, $236e632e8c7b0376$var$unstable_setDisableYieldValue = $8TTSu.unstable_setDisableYieldValue, $236e632e8c7b0376$var$rendererID = null, $236e632e8c7b0376$var$injectedHook = null;
function $236e632e8c7b0376$var$onCommitRoot(root) {
    if ($236e632e8c7b0376$var$injectedHook && "function" === typeof $236e632e8c7b0376$var$injectedHook.onCommitFiberRoot) try {
        $236e632e8c7b0376$var$injectedHook.onCommitFiberRoot($236e632e8c7b0376$var$rendererID, root, void 0, 128 === (root.current.flags & 128));
    } catch (err) {}
}
function $236e632e8c7b0376$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $236e632e8c7b0376$var$log$1 && $236e632e8c7b0376$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($236e632e8c7b0376$var$injectedHook && "function" === typeof $236e632e8c7b0376$var$injectedHook.setStrictMode) try {
        $236e632e8c7b0376$var$injectedHook.setStrictMode($236e632e8c7b0376$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $236e632e8c7b0376$var$clz32 = Math.clz32 ? Math.clz32 : $236e632e8c7b0376$var$clz32Fallback, $236e632e8c7b0376$var$log = Math.log, $236e632e8c7b0376$var$LN2 = Math.LN2;
function $236e632e8c7b0376$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($236e632e8c7b0376$var$log(x) / $236e632e8c7b0376$var$LN2 | 0) | 0;
}
var $236e632e8c7b0376$var$nextTransitionLane = 128, $236e632e8c7b0376$var$nextRetryLane = 4194304;
function $236e632e8c7b0376$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194176;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $236e632e8c7b0376$var$getNextLanes(root, wipLanes) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
    root = 0 !== root.finishedLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $236e632e8c7b0376$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $236e632e8c7b0376$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $236e632e8c7b0376$var$getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $236e632e8c7b0376$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $236e632e8c7b0376$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $236e632e8c7b0376$var$getHighestPriorityLanes(warmLanes))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
}
function $236e632e8c7b0376$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $236e632e8c7b0376$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
            return currentTime + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $236e632e8c7b0376$var$claimNextTransitionLane() {
    var lane = $236e632e8c7b0376$var$nextTransitionLane;
    $236e632e8c7b0376$var$nextTransitionLane <<= 1;
    0 === ($236e632e8c7b0376$var$nextTransitionLane & 4194176) && ($236e632e8c7b0376$var$nextTransitionLane = 128);
    return lane;
}
function $236e632e8c7b0376$var$claimNextRetryLane() {
    var lane = $236e632e8c7b0376$var$nextRetryLane;
    $236e632e8c7b0376$var$nextRetryLane <<= 1;
    0 === ($236e632e8c7b0376$var$nextRetryLane & 62914560) && ($236e632e8c7b0376$var$nextRetryLane = 4194304);
    return lane;
}
function $236e632e8c7b0376$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $236e632e8c7b0376$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $236e632e8c7b0376$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $236e632e8c7b0376$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $236e632e8c7b0376$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $236e632e8c7b0376$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $236e632e8c7b0376$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
}
function $236e632e8c7b0376$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $236e632e8c7b0376$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $236e632e8c7b0376$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $236e632e8c7b0376$var$resolveUpdatePriority() {
    var updatePriority = $236e632e8c7b0376$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $236e632e8c7b0376$var$getEventPriority(updatePriority.type);
}
function $236e632e8c7b0376$var$runWithPriority(priority, fn) {
    var previousPriority = $236e632e8c7b0376$var$ReactDOMSharedInternals.p;
    try {
        return $236e632e8c7b0376$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $236e632e8c7b0376$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $236e632e8c7b0376$var$randomKey = Math.random().toString(36).slice(2), $236e632e8c7b0376$var$internalInstanceKey = "__reactFiber$" + $236e632e8c7b0376$var$randomKey, $236e632e8c7b0376$var$internalPropsKey = "__reactProps$" + $236e632e8c7b0376$var$randomKey, $236e632e8c7b0376$var$internalContainerInstanceKey = "__reactContainer$" + $236e632e8c7b0376$var$randomKey, $236e632e8c7b0376$var$internalEventHandlersKey = "__reactEvents$" + $236e632e8c7b0376$var$randomKey, $236e632e8c7b0376$var$internalEventHandlerListenersKey = "__reactListeners$" + $236e632e8c7b0376$var$randomKey, $236e632e8c7b0376$var$internalEventHandlesSetKey = "__reactHandles$" + $236e632e8c7b0376$var$randomKey, $236e632e8c7b0376$var$internalRootNodeResourcesKey = "__reactResources$" + $236e632e8c7b0376$var$randomKey, $236e632e8c7b0376$var$internalHoistableMarker = "__reactMarker$" + $236e632e8c7b0376$var$randomKey;
function $236e632e8c7b0376$var$detachDeletedInstance(node) {
    delete node[$236e632e8c7b0376$var$internalInstanceKey];
    delete node[$236e632e8c7b0376$var$internalPropsKey];
    delete node[$236e632e8c7b0376$var$internalEventHandlersKey];
    delete node[$236e632e8c7b0376$var$internalEventHandlerListenersKey];
    delete node[$236e632e8c7b0376$var$internalEventHandlesSetKey];
}
function $236e632e8c7b0376$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$236e632e8c7b0376$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$236e632e8c7b0376$var$internalContainerInstanceKey] || parentNode[$236e632e8c7b0376$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $236e632e8c7b0376$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$236e632e8c7b0376$var$internalInstanceKey]) return parentNode;
                targetNode = $236e632e8c7b0376$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $236e632e8c7b0376$var$getInstanceFromNode(node) {
    if (node = node[$236e632e8c7b0376$var$internalInstanceKey] || node[$236e632e8c7b0376$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $236e632e8c7b0376$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($236e632e8c7b0376$var$formatProdErrorMessage(33));
}
function $236e632e8c7b0376$var$getResourcesFromRoot(root) {
    var resources = root[$236e632e8c7b0376$var$internalRootNodeResourcesKey];
    resources || (resources = root[$236e632e8c7b0376$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $236e632e8c7b0376$var$markNodeAsHoistable(node) {
    node[$236e632e8c7b0376$var$internalHoistableMarker] = !0;
}
var $236e632e8c7b0376$var$allNativeEvents = new Set(), $236e632e8c7b0376$var$registrationNameDependencies = {};
function $236e632e8c7b0376$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $236e632e8c7b0376$var$registerDirectEvent(registrationName, dependencies);
    $236e632e8c7b0376$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $236e632e8c7b0376$var$registerDirectEvent(registrationName, dependencies) {
    $236e632e8c7b0376$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$236e632e8c7b0376$var$allNativeEvents.add(dependencies[registrationName]);
}
var $236e632e8c7b0376$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $236e632e8c7b0376$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $236e632e8c7b0376$var$illegalAttributeNameCache = {}, $236e632e8c7b0376$var$validatedAttributeNameCache = {};
function $236e632e8c7b0376$var$isAttributeNameSafe(attributeName) {
    if ($236e632e8c7b0376$var$hasOwnProperty.call($236e632e8c7b0376$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($236e632e8c7b0376$var$hasOwnProperty.call($236e632e8c7b0376$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($236e632e8c7b0376$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $236e632e8c7b0376$var$validatedAttributeNameCache[attributeName] = !0;
    $236e632e8c7b0376$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $236e632e8c7b0376$var$setValueForAttribute(node, name, value) {
    if ($236e632e8c7b0376$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $236e632e8c7b0376$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $236e632e8c7b0376$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $236e632e8c7b0376$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $236e632e8c7b0376$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $236e632e8c7b0376$var$trackValueOnNode(node) {
    var valueField = $236e632e8c7b0376$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $236e632e8c7b0376$var$track(node) {
    node._valueTracker || (node._valueTracker = $236e632e8c7b0376$var$trackValueOnNode(node));
}
function $236e632e8c7b0376$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $236e632e8c7b0376$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $236e632e8c7b0376$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $236e632e8c7b0376$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $236e632e8c7b0376$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($236e632e8c7b0376$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $236e632e8c7b0376$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $236e632e8c7b0376$var$getToStringValue(value);
        } else element.value !== "" + $236e632e8c7b0376$var$getToStringValue(value) && (element.value = "" + $236e632e8c7b0376$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $236e632e8c7b0376$var$setDefaultValue(element, type, $236e632e8c7b0376$var$getToStringValue(value)) : null != defaultValue ? $236e632e8c7b0376$var$setDefaultValue(element, type, $236e632e8c7b0376$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $236e632e8c7b0376$var$getToStringValue(name) : element.removeAttribute("name");
}
function $236e632e8c7b0376$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $236e632e8c7b0376$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $236e632e8c7b0376$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $236e632e8c7b0376$var$setDefaultValue(node, type, value) {
    "number" === type && $236e632e8c7b0376$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $236e632e8c7b0376$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $236e632e8c7b0376$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $236e632e8c7b0376$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $236e632e8c7b0376$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $236e632e8c7b0376$var$getToStringValue(defaultValue) : "";
}
function $236e632e8c7b0376$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(92));
            if ($236e632e8c7b0376$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $236e632e8c7b0376$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $236e632e8c7b0376$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $236e632e8c7b0376$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $236e632e8c7b0376$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $236e632e8c7b0376$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $236e632e8c7b0376$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $236e632e8c7b0376$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $236e632e8c7b0376$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $236e632e8c7b0376$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $236e632e8c7b0376$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $236e632e8c7b0376$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $236e632e8c7b0376$var$sanitizeURL(url) {
    return $236e632e8c7b0376$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $236e632e8c7b0376$var$currentReplayingEvent = null;
function $236e632e8c7b0376$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $236e632e8c7b0376$var$restoreTarget = null, $236e632e8c7b0376$var$restoreQueue = null;
function $236e632e8c7b0376$var$restoreStateOfTarget(target) {
    var internalInstance = $236e632e8c7b0376$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$236e632e8c7b0376$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $236e632e8c7b0376$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $236e632e8c7b0376$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$236e632e8c7b0376$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(90));
                            $236e632e8c7b0376$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $236e632e8c7b0376$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $236e632e8c7b0376$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $236e632e8c7b0376$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $236e632e8c7b0376$var$isInsideEventHandler = !1;
function $236e632e8c7b0376$var$batchedUpdates$1(fn, a, b) {
    if ($236e632e8c7b0376$var$isInsideEventHandler) return fn(a, b);
    $236e632e8c7b0376$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($236e632e8c7b0376$var$isInsideEventHandler = !1, null !== $236e632e8c7b0376$var$restoreTarget || null !== $236e632e8c7b0376$var$restoreQueue) {
            if ($236e632e8c7b0376$var$flushSyncWork$1(), $236e632e8c7b0376$var$restoreTarget && (a = $236e632e8c7b0376$var$restoreTarget, fn = $236e632e8c7b0376$var$restoreQueue, $236e632e8c7b0376$var$restoreQueue = $236e632e8c7b0376$var$restoreTarget = null, $236e632e8c7b0376$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$236e632e8c7b0376$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $236e632e8c7b0376$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$236e632e8c7b0376$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $236e632e8c7b0376$var$passiveBrowserEventsSupported = !1;
if ($236e632e8c7b0376$var$canUseDOM) try {
    var $236e632e8c7b0376$var$options = {};
    Object.defineProperty($236e632e8c7b0376$var$options, "passive", {
        get: function() {
            $236e632e8c7b0376$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $236e632e8c7b0376$var$options, $236e632e8c7b0376$var$options);
    window.removeEventListener("test", $236e632e8c7b0376$var$options, $236e632e8c7b0376$var$options);
} catch (e) {
    $236e632e8c7b0376$var$passiveBrowserEventsSupported = !1;
}
var $236e632e8c7b0376$var$root = null, $236e632e8c7b0376$var$startText = null, $236e632e8c7b0376$var$fallbackText = null;
function $236e632e8c7b0376$var$getData() {
    if ($236e632e8c7b0376$var$fallbackText) return $236e632e8c7b0376$var$fallbackText;
    var start, startValue = $236e632e8c7b0376$var$startText, startLength = startValue.length, end, endValue = "value" in $236e632e8c7b0376$var$root ? $236e632e8c7b0376$var$root.value : $236e632e8c7b0376$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $236e632e8c7b0376$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $236e632e8c7b0376$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $236e632e8c7b0376$var$functionThatReturnsTrue() {
    return !0;
}
function $236e632e8c7b0376$var$functionThatReturnsFalse() {
    return !1;
}
function $236e632e8c7b0376$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $236e632e8c7b0376$var$functionThatReturnsTrue : $236e632e8c7b0376$var$functionThatReturnsFalse;
        this.isPropagationStopped = $236e632e8c7b0376$var$functionThatReturnsFalse;
        return this;
    }
    $236e632e8c7b0376$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $236e632e8c7b0376$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $236e632e8c7b0376$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $236e632e8c7b0376$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $236e632e8c7b0376$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $236e632e8c7b0376$var$SyntheticEvent = $236e632e8c7b0376$var$createSyntheticEvent($236e632e8c7b0376$var$EventInterface), $236e632e8c7b0376$var$UIEventInterface = $236e632e8c7b0376$var$assign({}, $236e632e8c7b0376$var$EventInterface, {
    view: 0,
    detail: 0
}), $236e632e8c7b0376$var$SyntheticUIEvent = $236e632e8c7b0376$var$createSyntheticEvent($236e632e8c7b0376$var$UIEventInterface), $236e632e8c7b0376$var$lastMovementX, $236e632e8c7b0376$var$lastMovementY, $236e632e8c7b0376$var$lastMouseEvent, $236e632e8c7b0376$var$MouseEventInterface = $236e632e8c7b0376$var$assign({}, $236e632e8c7b0376$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $236e632e8c7b0376$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $236e632e8c7b0376$var$lastMouseEvent && ($236e632e8c7b0376$var$lastMouseEvent && "mousemove" === event.type ? ($236e632e8c7b0376$var$lastMovementX = event.screenX - $236e632e8c7b0376$var$lastMouseEvent.screenX, $236e632e8c7b0376$var$lastMovementY = event.screenY - $236e632e8c7b0376$var$lastMouseEvent.screenY) : $236e632e8c7b0376$var$lastMovementY = $236e632e8c7b0376$var$lastMovementX = 0, $236e632e8c7b0376$var$lastMouseEvent = event);
        return $236e632e8c7b0376$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $236e632e8c7b0376$var$lastMovementY;
    }
}), $236e632e8c7b0376$var$SyntheticMouseEvent = $236e632e8c7b0376$var$createSyntheticEvent($236e632e8c7b0376$var$MouseEventInterface), $236e632e8c7b0376$var$DragEventInterface = $236e632e8c7b0376$var$assign({}, $236e632e8c7b0376$var$MouseEventInterface, {
    dataTransfer: 0
}), $236e632e8c7b0376$var$SyntheticDragEvent = $236e632e8c7b0376$var$createSyntheticEvent($236e632e8c7b0376$var$DragEventInterface), $236e632e8c7b0376$var$FocusEventInterface = $236e632e8c7b0376$var$assign({}, $236e632e8c7b0376$var$UIEventInterface, {
    relatedTarget: 0
}), $236e632e8c7b0376$var$SyntheticFocusEvent = $236e632e8c7b0376$var$createSyntheticEvent($236e632e8c7b0376$var$FocusEventInterface), $236e632e8c7b0376$var$AnimationEventInterface = $236e632e8c7b0376$var$assign({}, $236e632e8c7b0376$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $236e632e8c7b0376$var$SyntheticAnimationEvent = $236e632e8c7b0376$var$createSyntheticEvent($236e632e8c7b0376$var$AnimationEventInterface), $236e632e8c7b0376$var$ClipboardEventInterface = $236e632e8c7b0376$var$assign({}, $236e632e8c7b0376$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $236e632e8c7b0376$var$SyntheticClipboardEvent = $236e632e8c7b0376$var$createSyntheticEvent($236e632e8c7b0376$var$ClipboardEventInterface), $236e632e8c7b0376$var$CompositionEventInterface = $236e632e8c7b0376$var$assign({}, $236e632e8c7b0376$var$EventInterface, {
    data: 0
}), $236e632e8c7b0376$var$SyntheticCompositionEvent = $236e632e8c7b0376$var$createSyntheticEvent($236e632e8c7b0376$var$CompositionEventInterface), $236e632e8c7b0376$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $236e632e8c7b0376$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $236e632e8c7b0376$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $236e632e8c7b0376$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $236e632e8c7b0376$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $236e632e8c7b0376$var$getEventModifierState() {
    return $236e632e8c7b0376$var$modifierStateGetter;
}
var $236e632e8c7b0376$var$KeyboardEventInterface = $236e632e8c7b0376$var$assign({}, $236e632e8c7b0376$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $236e632e8c7b0376$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $236e632e8c7b0376$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $236e632e8c7b0376$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $236e632e8c7b0376$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $236e632e8c7b0376$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $236e632e8c7b0376$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $236e632e8c7b0376$var$SyntheticKeyboardEvent = $236e632e8c7b0376$var$createSyntheticEvent($236e632e8c7b0376$var$KeyboardEventInterface), $236e632e8c7b0376$var$PointerEventInterface = $236e632e8c7b0376$var$assign({}, $236e632e8c7b0376$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $236e632e8c7b0376$var$SyntheticPointerEvent = $236e632e8c7b0376$var$createSyntheticEvent($236e632e8c7b0376$var$PointerEventInterface), $236e632e8c7b0376$var$TouchEventInterface = $236e632e8c7b0376$var$assign({}, $236e632e8c7b0376$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $236e632e8c7b0376$var$getEventModifierState
}), $236e632e8c7b0376$var$SyntheticTouchEvent = $236e632e8c7b0376$var$createSyntheticEvent($236e632e8c7b0376$var$TouchEventInterface), $236e632e8c7b0376$var$TransitionEventInterface = $236e632e8c7b0376$var$assign({}, $236e632e8c7b0376$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $236e632e8c7b0376$var$SyntheticTransitionEvent = $236e632e8c7b0376$var$createSyntheticEvent($236e632e8c7b0376$var$TransitionEventInterface), $236e632e8c7b0376$var$WheelEventInterface = $236e632e8c7b0376$var$assign({}, $236e632e8c7b0376$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $236e632e8c7b0376$var$SyntheticWheelEvent = $236e632e8c7b0376$var$createSyntheticEvent($236e632e8c7b0376$var$WheelEventInterface), $236e632e8c7b0376$var$ToggleEventInterface = $236e632e8c7b0376$var$assign({}, $236e632e8c7b0376$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $236e632e8c7b0376$var$SyntheticToggleEvent = $236e632e8c7b0376$var$createSyntheticEvent($236e632e8c7b0376$var$ToggleEventInterface), $236e632e8c7b0376$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $236e632e8c7b0376$var$canUseCompositionEvent = $236e632e8c7b0376$var$canUseDOM && "CompositionEvent" in window, $236e632e8c7b0376$var$documentMode = null;
$236e632e8c7b0376$var$canUseDOM && "documentMode" in document && ($236e632e8c7b0376$var$documentMode = document.documentMode);
var $236e632e8c7b0376$var$canUseTextInputEvent = $236e632e8c7b0376$var$canUseDOM && "TextEvent" in window && !$236e632e8c7b0376$var$documentMode, $236e632e8c7b0376$var$useFallbackCompositionData = $236e632e8c7b0376$var$canUseDOM && (!$236e632e8c7b0376$var$canUseCompositionEvent || $236e632e8c7b0376$var$documentMode && 8 < $236e632e8c7b0376$var$documentMode && 11 >= $236e632e8c7b0376$var$documentMode), $236e632e8c7b0376$var$SPACEBAR_CHAR = String.fromCharCode(32), $236e632e8c7b0376$var$hasSpaceKeypress = !1;
function $236e632e8c7b0376$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $236e632e8c7b0376$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $236e632e8c7b0376$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $236e632e8c7b0376$var$isComposing = !1;
function $236e632e8c7b0376$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $236e632e8c7b0376$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $236e632e8c7b0376$var$hasSpaceKeypress = !0;
            return $236e632e8c7b0376$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $236e632e8c7b0376$var$SPACEBAR_CHAR && $236e632e8c7b0376$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $236e632e8c7b0376$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($236e632e8c7b0376$var$isComposing) return "compositionend" === domEventName || !$236e632e8c7b0376$var$canUseCompositionEvent && $236e632e8c7b0376$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $236e632e8c7b0376$var$getData(), $236e632e8c7b0376$var$fallbackText = $236e632e8c7b0376$var$startText = $236e632e8c7b0376$var$root = null, $236e632e8c7b0376$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $236e632e8c7b0376$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $236e632e8c7b0376$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $236e632e8c7b0376$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$236e632e8c7b0376$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $236e632e8c7b0376$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $236e632e8c7b0376$var$restoreTarget ? $236e632e8c7b0376$var$restoreQueue ? $236e632e8c7b0376$var$restoreQueue.push(target) : $236e632e8c7b0376$var$restoreQueue = [
        target
    ] : $236e632e8c7b0376$var$restoreTarget = target;
    inst = $236e632e8c7b0376$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $236e632e8c7b0376$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $236e632e8c7b0376$var$activeElement$1 = null, $236e632e8c7b0376$var$activeElementInst$1 = null;
function $236e632e8c7b0376$var$runEventInBatch(dispatchQueue) {
    $236e632e8c7b0376$var$processDispatchQueue(dispatchQueue, 0);
}
function $236e632e8c7b0376$var$getInstIfValueChanged(targetInst) {
    var targetNode = $236e632e8c7b0376$var$getNodeFromInstance(targetInst);
    if ($236e632e8c7b0376$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $236e632e8c7b0376$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $236e632e8c7b0376$var$isInputEventSupported = !1;
if ($236e632e8c7b0376$var$canUseDOM) {
    var $236e632e8c7b0376$var$JSCompiler_inline_result$jscomp$283;
    if ($236e632e8c7b0376$var$canUseDOM) {
        var $236e632e8c7b0376$var$isSupported$jscomp$inline_418 = "oninput" in document;
        if (!$236e632e8c7b0376$var$isSupported$jscomp$inline_418) {
            var $236e632e8c7b0376$var$element$jscomp$inline_419 = document.createElement("div");
            $236e632e8c7b0376$var$element$jscomp$inline_419.setAttribute("oninput", "return;");
            $236e632e8c7b0376$var$isSupported$jscomp$inline_418 = "function" === typeof $236e632e8c7b0376$var$element$jscomp$inline_419.oninput;
        }
        $236e632e8c7b0376$var$JSCompiler_inline_result$jscomp$283 = $236e632e8c7b0376$var$isSupported$jscomp$inline_418;
    } else $236e632e8c7b0376$var$JSCompiler_inline_result$jscomp$283 = !1;
    $236e632e8c7b0376$var$isInputEventSupported = $236e632e8c7b0376$var$JSCompiler_inline_result$jscomp$283 && (!document.documentMode || 9 < document.documentMode);
}
function $236e632e8c7b0376$var$stopWatchingForValueChange() {
    $236e632e8c7b0376$var$activeElement$1 && ($236e632e8c7b0376$var$activeElement$1.detachEvent("onpropertychange", $236e632e8c7b0376$var$handlePropertyChange), $236e632e8c7b0376$var$activeElementInst$1 = $236e632e8c7b0376$var$activeElement$1 = null);
}
function $236e632e8c7b0376$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $236e632e8c7b0376$var$getInstIfValueChanged($236e632e8c7b0376$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $236e632e8c7b0376$var$createAndAccumulateChangeEvent(dispatchQueue, $236e632e8c7b0376$var$activeElementInst$1, nativeEvent, $236e632e8c7b0376$var$getEventTarget(nativeEvent));
        $236e632e8c7b0376$var$batchedUpdates$1($236e632e8c7b0376$var$runEventInBatch, dispatchQueue);
    }
}
function $236e632e8c7b0376$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($236e632e8c7b0376$var$stopWatchingForValueChange(), $236e632e8c7b0376$var$activeElement$1 = target, $236e632e8c7b0376$var$activeElementInst$1 = targetInst, $236e632e8c7b0376$var$activeElement$1.attachEvent("onpropertychange", $236e632e8c7b0376$var$handlePropertyChange)) : "focusout" === domEventName && $236e632e8c7b0376$var$stopWatchingForValueChange();
}
function $236e632e8c7b0376$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $236e632e8c7b0376$var$getInstIfValueChanged($236e632e8c7b0376$var$activeElementInst$1);
}
function $236e632e8c7b0376$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $236e632e8c7b0376$var$getInstIfValueChanged(targetInst);
}
function $236e632e8c7b0376$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $236e632e8c7b0376$var$getInstIfValueChanged(targetInst);
}
function $236e632e8c7b0376$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $236e632e8c7b0376$var$objectIs = "function" === typeof Object.is ? Object.is : $236e632e8c7b0376$var$is;
function $236e632e8c7b0376$var$shallowEqual(objA, objB) {
    if ($236e632e8c7b0376$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$236e632e8c7b0376$var$hasOwnProperty.call(objB, currentKey) || !$236e632e8c7b0376$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $236e632e8c7b0376$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $236e632e8c7b0376$var$getNodeForCharacterOffset(root, offset) {
    var node = $236e632e8c7b0376$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $236e632e8c7b0376$var$getLeafNode(node);
    }
}
function $236e632e8c7b0376$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $236e632e8c7b0376$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $236e632e8c7b0376$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $236e632e8c7b0376$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $236e632e8c7b0376$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $236e632e8c7b0376$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
function $236e632e8c7b0376$var$restoreSelection(priorSelectionInformation, containerInfo) {
    var curFocusedElem = $236e632e8c7b0376$var$getActiveElementDeep(containerInfo);
    containerInfo = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== containerInfo && containerInfo && containerInfo.ownerDocument && $236e632e8c7b0376$var$containsNode(containerInfo.ownerDocument.documentElement, containerInfo)) {
        if (null !== priorSelectionRange && $236e632e8c7b0376$var$hasSelectionCapabilities(containerInfo)) {
            if (priorSelectionInformation = priorSelectionRange.start, curFocusedElem = priorSelectionRange.end, void 0 === curFocusedElem && (curFocusedElem = priorSelectionInformation), "selectionStart" in containerInfo) containerInfo.selectionStart = priorSelectionInformation, containerInfo.selectionEnd = Math.min(curFocusedElem, containerInfo.value.length);
            else if (curFocusedElem = (priorSelectionInformation = containerInfo.ownerDocument || document) && priorSelectionInformation.defaultView || window, curFocusedElem.getSelection) {
                curFocusedElem = curFocusedElem.getSelection();
                var length = containerInfo.textContent.length, start = Math.min(priorSelectionRange.start, length);
                priorSelectionRange = void 0 === priorSelectionRange.end ? start : Math.min(priorSelectionRange.end, length);
                !curFocusedElem.extend && start > priorSelectionRange && (length = priorSelectionRange, priorSelectionRange = start, start = length);
                length = $236e632e8c7b0376$var$getNodeForCharacterOffset(containerInfo, start);
                var endMarker = $236e632e8c7b0376$var$getNodeForCharacterOffset(containerInfo, priorSelectionRange);
                length && endMarker && (1 !== curFocusedElem.rangeCount || curFocusedElem.anchorNode !== length.node || curFocusedElem.anchorOffset !== length.offset || curFocusedElem.focusNode !== endMarker.node || curFocusedElem.focusOffset !== endMarker.offset) && (priorSelectionInformation = priorSelectionInformation.createRange(), priorSelectionInformation.setStart(length.node, length.offset), curFocusedElem.removeAllRanges(), start > priorSelectionRange ? (curFocusedElem.addRange(priorSelectionInformation), curFocusedElem.extend(endMarker.node, endMarker.offset)) : (priorSelectionInformation.setEnd(endMarker.node, endMarker.offset), curFocusedElem.addRange(priorSelectionInformation)));
            }
        }
        priorSelectionInformation = [];
        for(curFocusedElem = containerInfo; curFocusedElem = curFocusedElem.parentNode;)1 === curFocusedElem.nodeType && priorSelectionInformation.push({
            element: curFocusedElem,
            left: curFocusedElem.scrollLeft,
            top: curFocusedElem.scrollTop
        });
        "function" === typeof containerInfo.focus && containerInfo.focus();
        for(containerInfo = 0; containerInfo < priorSelectionInformation.length; containerInfo++)curFocusedElem = priorSelectionInformation[containerInfo], curFocusedElem.element.scrollLeft = curFocusedElem.left, curFocusedElem.element.scrollTop = curFocusedElem.top;
    }
}
var $236e632e8c7b0376$var$skipSelectionChangeEvent = $236e632e8c7b0376$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $236e632e8c7b0376$var$activeElement = null, $236e632e8c7b0376$var$activeElementInst = null, $236e632e8c7b0376$var$lastSelection = null, $236e632e8c7b0376$var$mouseDown = !1;
function $236e632e8c7b0376$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $236e632e8c7b0376$var$mouseDown || null == $236e632e8c7b0376$var$activeElement || $236e632e8c7b0376$var$activeElement !== $236e632e8c7b0376$var$getActiveElement(doc) || (doc = $236e632e8c7b0376$var$activeElement, "selectionStart" in doc && $236e632e8c7b0376$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $236e632e8c7b0376$var$lastSelection && $236e632e8c7b0376$var$shallowEqual($236e632e8c7b0376$var$lastSelection, doc) || ($236e632e8c7b0376$var$lastSelection = doc, doc = $236e632e8c7b0376$var$accumulateTwoPhaseListeners($236e632e8c7b0376$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $236e632e8c7b0376$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $236e632e8c7b0376$var$activeElement)));
}
function $236e632e8c7b0376$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $236e632e8c7b0376$var$vendorPrefixes = {
    animationend: $236e632e8c7b0376$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $236e632e8c7b0376$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $236e632e8c7b0376$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $236e632e8c7b0376$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $236e632e8c7b0376$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $236e632e8c7b0376$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $236e632e8c7b0376$var$makePrefixMap("Transition", "TransitionEnd")
}, $236e632e8c7b0376$var$prefixedEventNames = {}, $236e632e8c7b0376$var$style = {};
$236e632e8c7b0376$var$canUseDOM && ($236e632e8c7b0376$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $236e632e8c7b0376$var$vendorPrefixes.animationend.animation, delete $236e632e8c7b0376$var$vendorPrefixes.animationiteration.animation, delete $236e632e8c7b0376$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $236e632e8c7b0376$var$vendorPrefixes.transitionend.transition);
function $236e632e8c7b0376$var$getVendorPrefixedEventName(eventName) {
    if ($236e632e8c7b0376$var$prefixedEventNames[eventName]) return $236e632e8c7b0376$var$prefixedEventNames[eventName];
    if (!$236e632e8c7b0376$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $236e632e8c7b0376$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $236e632e8c7b0376$var$style) return $236e632e8c7b0376$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $236e632e8c7b0376$var$ANIMATION_END = $236e632e8c7b0376$var$getVendorPrefixedEventName("animationend"), $236e632e8c7b0376$var$ANIMATION_ITERATION = $236e632e8c7b0376$var$getVendorPrefixedEventName("animationiteration"), $236e632e8c7b0376$var$ANIMATION_START = $236e632e8c7b0376$var$getVendorPrefixedEventName("animationstart"), $236e632e8c7b0376$var$TRANSITION_RUN = $236e632e8c7b0376$var$getVendorPrefixedEventName("transitionrun"), $236e632e8c7b0376$var$TRANSITION_START = $236e632e8c7b0376$var$getVendorPrefixedEventName("transitionstart"), $236e632e8c7b0376$var$TRANSITION_CANCEL = $236e632e8c7b0376$var$getVendorPrefixedEventName("transitioncancel"), $236e632e8c7b0376$var$TRANSITION_END = $236e632e8c7b0376$var$getVendorPrefixedEventName("transitionend"), $236e632e8c7b0376$var$topLevelEventsToReactNames = new Map(), $236e632e8c7b0376$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(" ");
function $236e632e8c7b0376$var$registerSimpleEvent(domEventName, reactName) {
    $236e632e8c7b0376$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $236e632e8c7b0376$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $236e632e8c7b0376$var$concurrentQueues = [], $236e632e8c7b0376$var$concurrentQueuesIndex = 0, $236e632e8c7b0376$var$concurrentlyUpdatedLanes = 0;
function $236e632e8c7b0376$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $236e632e8c7b0376$var$concurrentQueuesIndex, i = $236e632e8c7b0376$var$concurrentlyUpdatedLanes = $236e632e8c7b0376$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $236e632e8c7b0376$var$concurrentQueues[i];
        $236e632e8c7b0376$var$concurrentQueues[i++] = null;
        var queue = $236e632e8c7b0376$var$concurrentQueues[i];
        $236e632e8c7b0376$var$concurrentQueues[i++] = null;
        var update = $236e632e8c7b0376$var$concurrentQueues[i];
        $236e632e8c7b0376$var$concurrentQueues[i++] = null;
        var lane = $236e632e8c7b0376$var$concurrentQueues[i];
        $236e632e8c7b0376$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $236e632e8c7b0376$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $236e632e8c7b0376$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $236e632e8c7b0376$var$concurrentQueues[$236e632e8c7b0376$var$concurrentQueuesIndex++] = fiber;
    $236e632e8c7b0376$var$concurrentQueues[$236e632e8c7b0376$var$concurrentQueuesIndex++] = queue;
    $236e632e8c7b0376$var$concurrentQueues[$236e632e8c7b0376$var$concurrentQueuesIndex++] = update;
    $236e632e8c7b0376$var$concurrentQueues[$236e632e8c7b0376$var$concurrentQueuesIndex++] = lane;
    $236e632e8c7b0376$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $236e632e8c7b0376$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $236e632e8c7b0376$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $236e632e8c7b0376$var$getRootForUpdatedFiber(fiber);
}
function $236e632e8c7b0376$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $236e632e8c7b0376$var$enqueueUpdate$1(fiber, null, null, lane);
    return $236e632e8c7b0376$var$getRootForUpdatedFiber(fiber);
}
function $236e632e8c7b0376$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - $236e632e8c7b0376$var$clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
        update
    ] : sourceFiber.push(update), update.lane = lane | 536870912);
}
function $236e632e8c7b0376$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $236e632e8c7b0376$var$nestedUpdateCount) throw $236e632e8c7b0376$var$nestedUpdateCount = 0, $236e632e8c7b0376$var$rootWithNestedUpdates = null, Error($236e632e8c7b0376$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $236e632e8c7b0376$var$emptyContextObject = {}, $236e632e8c7b0376$var$CapturedStacks = new WeakMap();
function $236e632e8c7b0376$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $236e632e8c7b0376$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $236e632e8c7b0376$var$getStackByFiberInDevAndProd(source)
        };
        $236e632e8c7b0376$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $236e632e8c7b0376$var$getStackByFiberInDevAndProd(source)
    };
}
var $236e632e8c7b0376$var$forkStack = [], $236e632e8c7b0376$var$forkStackIndex = 0, $236e632e8c7b0376$var$treeForkProvider = null, $236e632e8c7b0376$var$treeForkCount = 0, $236e632e8c7b0376$var$idStack = [], $236e632e8c7b0376$var$idStackIndex = 0, $236e632e8c7b0376$var$treeContextProvider = null, $236e632e8c7b0376$var$treeContextId = 1, $236e632e8c7b0376$var$treeContextOverflow = "";
function $236e632e8c7b0376$var$pushTreeFork(workInProgress, totalChildren) {
    $236e632e8c7b0376$var$forkStack[$236e632e8c7b0376$var$forkStackIndex++] = $236e632e8c7b0376$var$treeForkCount;
    $236e632e8c7b0376$var$forkStack[$236e632e8c7b0376$var$forkStackIndex++] = $236e632e8c7b0376$var$treeForkProvider;
    $236e632e8c7b0376$var$treeForkProvider = workInProgress;
    $236e632e8c7b0376$var$treeForkCount = totalChildren;
}
function $236e632e8c7b0376$var$pushTreeId(workInProgress, totalChildren, index) {
    $236e632e8c7b0376$var$idStack[$236e632e8c7b0376$var$idStackIndex++] = $236e632e8c7b0376$var$treeContextId;
    $236e632e8c7b0376$var$idStack[$236e632e8c7b0376$var$idStackIndex++] = $236e632e8c7b0376$var$treeContextOverflow;
    $236e632e8c7b0376$var$idStack[$236e632e8c7b0376$var$idStackIndex++] = $236e632e8c7b0376$var$treeContextProvider;
    $236e632e8c7b0376$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $236e632e8c7b0376$var$treeContextId;
    workInProgress = $236e632e8c7b0376$var$treeContextOverflow;
    var baseLength = 32 - $236e632e8c7b0376$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $236e632e8c7b0376$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $236e632e8c7b0376$var$treeContextId = 1 << 32 - $236e632e8c7b0376$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $236e632e8c7b0376$var$treeContextOverflow = length + workInProgress;
    } else $236e632e8c7b0376$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $236e632e8c7b0376$var$treeContextOverflow = workInProgress;
}
function $236e632e8c7b0376$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($236e632e8c7b0376$var$pushTreeFork(workInProgress, 1), $236e632e8c7b0376$var$pushTreeId(workInProgress, 1, 0));
}
function $236e632e8c7b0376$var$popTreeContext(workInProgress) {
    for(; workInProgress === $236e632e8c7b0376$var$treeForkProvider;)$236e632e8c7b0376$var$treeForkProvider = $236e632e8c7b0376$var$forkStack[--$236e632e8c7b0376$var$forkStackIndex], $236e632e8c7b0376$var$forkStack[$236e632e8c7b0376$var$forkStackIndex] = null, $236e632e8c7b0376$var$treeForkCount = $236e632e8c7b0376$var$forkStack[--$236e632e8c7b0376$var$forkStackIndex], $236e632e8c7b0376$var$forkStack[$236e632e8c7b0376$var$forkStackIndex] = null;
    for(; workInProgress === $236e632e8c7b0376$var$treeContextProvider;)$236e632e8c7b0376$var$treeContextProvider = $236e632e8c7b0376$var$idStack[--$236e632e8c7b0376$var$idStackIndex], $236e632e8c7b0376$var$idStack[$236e632e8c7b0376$var$idStackIndex] = null, $236e632e8c7b0376$var$treeContextOverflow = $236e632e8c7b0376$var$idStack[--$236e632e8c7b0376$var$idStackIndex], $236e632e8c7b0376$var$idStack[$236e632e8c7b0376$var$idStackIndex] = null, $236e632e8c7b0376$var$treeContextId = $236e632e8c7b0376$var$idStack[--$236e632e8c7b0376$var$idStackIndex], $236e632e8c7b0376$var$idStack[$236e632e8c7b0376$var$idStackIndex] = null;
}
var $236e632e8c7b0376$var$hydrationParentFiber = null, $236e632e8c7b0376$var$nextHydratableInstance = null, $236e632e8c7b0376$var$isHydrating = !1, $236e632e8c7b0376$var$hydrationErrors = null, $236e632e8c7b0376$var$rootOrSingletonContext = !1, $236e632e8c7b0376$var$HydrationMismatchException = Error($236e632e8c7b0376$var$formatProdErrorMessage(519));
function $236e632e8c7b0376$var$throwOnHydrationMismatch(fiber) {
    var error = Error($236e632e8c7b0376$var$formatProdErrorMessage(418, ""));
    $236e632e8c7b0376$var$queueHydrationError($236e632e8c7b0376$var$createCapturedValueAtFiber(error, fiber));
    throw $236e632e8c7b0376$var$HydrationMismatchException;
}
function $236e632e8c7b0376$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$236e632e8c7b0376$var$internalInstanceKey] = fiber;
    instance[$236e632e8c7b0376$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("cancel", instance);
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $236e632e8c7b0376$var$mediaEventTypes.length; type++)$236e632e8c7b0376$var$listenToNonDelegatedEvent($236e632e8c7b0376$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("error", instance);
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("invalid", instance);
            $236e632e8c7b0376$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $236e632e8c7b0376$var$track(instance);
            break;
        case "select":
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("invalid", instance), $236e632e8c7b0376$var$initTextarea(instance, props.value, props.defaultValue, props.children), $236e632e8c7b0376$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $236e632e8c7b0376$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($236e632e8c7b0376$var$listenToNonDelegatedEvent("beforetoggle", instance), $236e632e8c7b0376$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $236e632e8c7b0376$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $236e632e8c7b0376$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $236e632e8c7b0376$var$noop$1), instance = !0) : instance = !1;
    instance || $236e632e8c7b0376$var$throwOnHydrationMismatch(fiber);
}
function $236e632e8c7b0376$var$popToNextHostParent(fiber) {
    for($236e632e8c7b0376$var$hydrationParentFiber = fiber.return; $236e632e8c7b0376$var$hydrationParentFiber;)switch($236e632e8c7b0376$var$hydrationParentFiber.tag){
        case 3:
        case 27:
            $236e632e8c7b0376$var$rootOrSingletonContext = !0;
            return;
        case 5:
        case 13:
            $236e632e8c7b0376$var$rootOrSingletonContext = !1;
            return;
        default:
            $236e632e8c7b0376$var$hydrationParentFiber = $236e632e8c7b0376$var$hydrationParentFiber.return;
    }
}
function $236e632e8c7b0376$var$popHydrationState(fiber) {
    if (fiber !== $236e632e8c7b0376$var$hydrationParentFiber) return !1;
    if (!$236e632e8c7b0376$var$isHydrating) return $236e632e8c7b0376$var$popToNextHostParent(fiber), $236e632e8c7b0376$var$isHydrating = !0, !1;
    var shouldClear = !1, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== fiber.tag && 27 !== fiber.tag) {
        if (JSCompiler_temp = 5 === fiber.tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $236e632e8c7b0376$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && (shouldClear = !0);
    shouldClear && $236e632e8c7b0376$var$nextHydratableInstance && $236e632e8c7b0376$var$throwOnHydrationMismatch(fiber);
    $236e632e8c7b0376$var$popToNextHostParent(fiber);
    if (13 === fiber.tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(shouldClear = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === shouldClear) {
                            $236e632e8c7b0376$var$nextHydratableInstance = $236e632e8c7b0376$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        shouldClear--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || shouldClear++;
                }
                fiber = fiber.nextSibling;
            }
            $236e632e8c7b0376$var$nextHydratableInstance = null;
        }
    } else $236e632e8c7b0376$var$nextHydratableInstance = $236e632e8c7b0376$var$hydrationParentFiber ? $236e632e8c7b0376$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $236e632e8c7b0376$var$resetHydrationState() {
    $236e632e8c7b0376$var$nextHydratableInstance = $236e632e8c7b0376$var$hydrationParentFiber = null;
    $236e632e8c7b0376$var$isHydrating = !1;
}
function $236e632e8c7b0376$var$queueHydrationError(error) {
    null === $236e632e8c7b0376$var$hydrationErrors ? $236e632e8c7b0376$var$hydrationErrors = [
        error
    ] : $236e632e8c7b0376$var$hydrationErrors.push(error);
}
var $236e632e8c7b0376$var$SuspenseException = Error($236e632e8c7b0376$var$formatProdErrorMessage(460)), $236e632e8c7b0376$var$SuspenseyCommitException = Error($236e632e8c7b0376$var$formatProdErrorMessage(474)), $236e632e8c7b0376$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $236e632e8c7b0376$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $236e632e8c7b0376$var$noop$3() {}
function $236e632e8c7b0376$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($236e632e8c7b0376$var$noop$3, $236e632e8c7b0376$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            if (thenableState === $236e632e8c7b0376$var$SuspenseException) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(483));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($236e632e8c7b0376$var$noop$3, $236e632e8c7b0376$var$noop$3);
            else {
                thenableState = $236e632e8c7b0376$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    thenableState = thenable.reason;
                    if (thenableState === $236e632e8c7b0376$var$SuspenseException) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(483));
                    throw thenableState;
            }
            $236e632e8c7b0376$var$suspendedThenable = thenable;
            throw $236e632e8c7b0376$var$SuspenseException;
    }
}
var $236e632e8c7b0376$var$suspendedThenable = null;
function $236e632e8c7b0376$var$getSuspendedThenable() {
    if (null === $236e632e8c7b0376$var$suspendedThenable) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(459));
    var thenable = $236e632e8c7b0376$var$suspendedThenable;
    $236e632e8c7b0376$var$suspendedThenable = null;
    return thenable;
}
var $236e632e8c7b0376$var$thenableState$1 = null, $236e632e8c7b0376$var$thenableIndexCounter$1 = 0;
function $236e632e8c7b0376$var$unwrapThenable(thenable) {
    var index = $236e632e8c7b0376$var$thenableIndexCounter$1;
    $236e632e8c7b0376$var$thenableIndexCounter$1 += 1;
    null === $236e632e8c7b0376$var$thenableState$1 && ($236e632e8c7b0376$var$thenableState$1 = []);
    return $236e632e8c7b0376$var$trackUsedThenable($236e632e8c7b0376$var$thenableState$1, thenable, index);
}
function $236e632e8c7b0376$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $236e632e8c7b0376$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $236e632e8c7b0376$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($236e632e8c7b0376$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $236e632e8c7b0376$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $236e632e8c7b0376$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $236e632e8c7b0376$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
        newFiber.flags |= 33554434;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $236e632e8c7b0376$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $236e632e8c7b0376$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $236e632e8c7b0376$var$REACT_LAZY_TYPE && $236e632e8c7b0376$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $236e632e8c7b0376$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $236e632e8c7b0376$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $236e632e8c7b0376$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $236e632e8c7b0376$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $236e632e8c7b0376$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $236e632e8c7b0376$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $236e632e8c7b0376$var$REACT_ELEMENT_TYPE:
                    return lanes = $236e632e8c7b0376$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $236e632e8c7b0376$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $236e632e8c7b0376$var$REACT_PORTAL_TYPE:
                    return newChild = $236e632e8c7b0376$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $236e632e8c7b0376$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($236e632e8c7b0376$var$isArrayImpl(newChild) || $236e632e8c7b0376$var$getIteratorFn(newChild)) return newChild = $236e632e8c7b0376$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $236e632e8c7b0376$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $236e632e8c7b0376$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $236e632e8c7b0376$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $236e632e8c7b0376$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $236e632e8c7b0376$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $236e632e8c7b0376$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $236e632e8c7b0376$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($236e632e8c7b0376$var$isArrayImpl(newChild) || $236e632e8c7b0376$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $236e632e8c7b0376$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $236e632e8c7b0376$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $236e632e8c7b0376$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $236e632e8c7b0376$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $236e632e8c7b0376$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $236e632e8c7b0376$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $236e632e8c7b0376$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($236e632e8c7b0376$var$isArrayImpl(newChild) || $236e632e8c7b0376$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $236e632e8c7b0376$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $236e632e8c7b0376$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $236e632e8c7b0376$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $236e632e8c7b0376$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $236e632e8c7b0376$var$isHydrating && $236e632e8c7b0376$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $236e632e8c7b0376$var$isHydrating && $236e632e8c7b0376$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $236e632e8c7b0376$var$isHydrating && $236e632e8c7b0376$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $236e632e8c7b0376$var$isHydrating && $236e632e8c7b0376$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $236e632e8c7b0376$var$isHydrating && $236e632e8c7b0376$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $236e632e8c7b0376$var$isHydrating && $236e632e8c7b0376$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $236e632e8c7b0376$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $236e632e8c7b0376$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $236e632e8c7b0376$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $236e632e8c7b0376$var$REACT_LAZY_TYPE && $236e632e8c7b0376$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $236e632e8c7b0376$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $236e632e8c7b0376$var$REACT_FRAGMENT_TYPE ? (lanes = $236e632e8c7b0376$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $236e632e8c7b0376$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $236e632e8c7b0376$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $236e632e8c7b0376$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $236e632e8c7b0376$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $236e632e8c7b0376$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($236e632e8c7b0376$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($236e632e8c7b0376$var$getIteratorFn(newChild)) {
                key = $236e632e8c7b0376$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $236e632e8c7b0376$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $236e632e8c7b0376$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $236e632e8c7b0376$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $236e632e8c7b0376$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $236e632e8c7b0376$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $236e632e8c7b0376$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $236e632e8c7b0376$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $236e632e8c7b0376$var$SuspenseException) throw x;
            var fiber = $236e632e8c7b0376$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $236e632e8c7b0376$var$reconcileChildFibers = $236e632e8c7b0376$var$createChildReconciler(!0), $236e632e8c7b0376$var$mountChildFibers = $236e632e8c7b0376$var$createChildReconciler(!1), $236e632e8c7b0376$var$currentTreeHiddenStackCursor = $236e632e8c7b0376$var$createCursor(null), $236e632e8c7b0376$var$prevEntangledRenderLanesCursor = $236e632e8c7b0376$var$createCursor(0);
function $236e632e8c7b0376$var$pushHiddenContext(fiber, context) {
    fiber = $236e632e8c7b0376$var$entangledRenderLanes;
    $236e632e8c7b0376$var$push($236e632e8c7b0376$var$prevEntangledRenderLanesCursor, fiber);
    $236e632e8c7b0376$var$push($236e632e8c7b0376$var$currentTreeHiddenStackCursor, context);
    $236e632e8c7b0376$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $236e632e8c7b0376$var$reuseHiddenContextOnStack() {
    $236e632e8c7b0376$var$push($236e632e8c7b0376$var$prevEntangledRenderLanesCursor, $236e632e8c7b0376$var$entangledRenderLanes);
    $236e632e8c7b0376$var$push($236e632e8c7b0376$var$currentTreeHiddenStackCursor, $236e632e8c7b0376$var$currentTreeHiddenStackCursor.current);
}
function $236e632e8c7b0376$var$popHiddenContext() {
    $236e632e8c7b0376$var$entangledRenderLanes = $236e632e8c7b0376$var$prevEntangledRenderLanesCursor.current;
    $236e632e8c7b0376$var$pop($236e632e8c7b0376$var$currentTreeHiddenStackCursor);
    $236e632e8c7b0376$var$pop($236e632e8c7b0376$var$prevEntangledRenderLanesCursor);
}
var $236e632e8c7b0376$var$suspenseHandlerStackCursor = $236e632e8c7b0376$var$createCursor(null), $236e632e8c7b0376$var$shellBoundary = null;
function $236e632e8c7b0376$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $236e632e8c7b0376$var$push($236e632e8c7b0376$var$suspenseStackCursor, $236e632e8c7b0376$var$suspenseStackCursor.current & 1);
    $236e632e8c7b0376$var$push($236e632e8c7b0376$var$suspenseHandlerStackCursor, handler);
    null === $236e632e8c7b0376$var$shellBoundary && (null === current || null !== $236e632e8c7b0376$var$currentTreeHiddenStackCursor.current ? $236e632e8c7b0376$var$shellBoundary = handler : null !== current.memoizedState && ($236e632e8c7b0376$var$shellBoundary = handler));
}
function $236e632e8c7b0376$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($236e632e8c7b0376$var$push($236e632e8c7b0376$var$suspenseStackCursor, $236e632e8c7b0376$var$suspenseStackCursor.current), $236e632e8c7b0376$var$push($236e632e8c7b0376$var$suspenseHandlerStackCursor, fiber), null === $236e632e8c7b0376$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($236e632e8c7b0376$var$shellBoundary = fiber);
        }
    } else $236e632e8c7b0376$var$reuseSuspenseHandlerOnStack(fiber);
}
function $236e632e8c7b0376$var$reuseSuspenseHandlerOnStack() {
    $236e632e8c7b0376$var$push($236e632e8c7b0376$var$suspenseStackCursor, $236e632e8c7b0376$var$suspenseStackCursor.current);
    $236e632e8c7b0376$var$push($236e632e8c7b0376$var$suspenseHandlerStackCursor, $236e632e8c7b0376$var$suspenseHandlerStackCursor.current);
}
function $236e632e8c7b0376$var$popSuspenseHandler(fiber) {
    $236e632e8c7b0376$var$pop($236e632e8c7b0376$var$suspenseHandlerStackCursor);
    $236e632e8c7b0376$var$shellBoundary === fiber && ($236e632e8c7b0376$var$shellBoundary = null);
    $236e632e8c7b0376$var$pop($236e632e8c7b0376$var$suspenseStackCursor);
}
var $236e632e8c7b0376$var$suspenseStackCursor = $236e632e8c7b0376$var$createCursor(0);
function $236e632e8c7b0376$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || "$!" === state.data)) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $236e632e8c7b0376$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $236e632e8c7b0376$var$scheduleCallback$2 = $8TTSu.unstable_scheduleCallback, $236e632e8c7b0376$var$NormalPriority = $8TTSu.unstable_NormalPriority, $236e632e8c7b0376$var$CacheContext = {
    $$typeof: $236e632e8c7b0376$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $236e632e8c7b0376$var$createCache() {
    return {
        controller: new $236e632e8c7b0376$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $236e632e8c7b0376$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $236e632e8c7b0376$var$scheduleCallback$2($236e632e8c7b0376$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $236e632e8c7b0376$var$currentEntangledListeners = null, $236e632e8c7b0376$var$currentEntangledPendingCount = 0, $236e632e8c7b0376$var$currentEntangledLane = 0, $236e632e8c7b0376$var$currentEntangledActionThenable = null;
function $236e632e8c7b0376$var$entangleAsyncAction(transition, thenable) {
    if (null === $236e632e8c7b0376$var$currentEntangledListeners) {
        var entangledListeners = $236e632e8c7b0376$var$currentEntangledListeners = [];
        $236e632e8c7b0376$var$currentEntangledPendingCount = 0;
        $236e632e8c7b0376$var$currentEntangledLane = $236e632e8c7b0376$var$requestTransitionLane();
        $236e632e8c7b0376$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $236e632e8c7b0376$var$currentEntangledPendingCount++;
    thenable.then($236e632e8c7b0376$var$pingEngtangledActionScope, $236e632e8c7b0376$var$pingEngtangledActionScope);
    return thenable;
}
function $236e632e8c7b0376$var$pingEngtangledActionScope() {
    if (0 === --$236e632e8c7b0376$var$currentEntangledPendingCount && null !== $236e632e8c7b0376$var$currentEntangledListeners) {
        null !== $236e632e8c7b0376$var$currentEntangledActionThenable && ($236e632e8c7b0376$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $236e632e8c7b0376$var$currentEntangledListeners;
        $236e632e8c7b0376$var$currentEntangledListeners = null;
        $236e632e8c7b0376$var$currentEntangledLane = 0;
        $236e632e8c7b0376$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $236e632e8c7b0376$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $236e632e8c7b0376$var$prevOnStartTransitionFinish = $236e632e8c7b0376$var$ReactSharedInternals.S;
$236e632e8c7b0376$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $236e632e8c7b0376$var$entangleAsyncAction(transition, returnValue);
    null !== $236e632e8c7b0376$var$prevOnStartTransitionFinish && $236e632e8c7b0376$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $236e632e8c7b0376$var$resumedCache = $236e632e8c7b0376$var$createCursor(null);
function $236e632e8c7b0376$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $236e632e8c7b0376$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $236e632e8c7b0376$var$workInProgressRoot.pooledCache;
}
function $236e632e8c7b0376$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $236e632e8c7b0376$var$push($236e632e8c7b0376$var$resumedCache, $236e632e8c7b0376$var$resumedCache.current) : $236e632e8c7b0376$var$push($236e632e8c7b0376$var$resumedCache, prevCachePool.pool);
}
function $236e632e8c7b0376$var$getSuspendedCache() {
    var cacheFromPool = $236e632e8c7b0376$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $236e632e8c7b0376$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $236e632e8c7b0376$var$renderLanes = 0, $236e632e8c7b0376$var$currentlyRenderingFiber$1 = null, $236e632e8c7b0376$var$currentHook = null, $236e632e8c7b0376$var$workInProgressHook = null, $236e632e8c7b0376$var$didScheduleRenderPhaseUpdate = !1, $236e632e8c7b0376$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $236e632e8c7b0376$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $236e632e8c7b0376$var$localIdCounter = 0, $236e632e8c7b0376$var$thenableIndexCounter = 0, $236e632e8c7b0376$var$thenableState = null, $236e632e8c7b0376$var$globalClientIdCounter = 0;
function $236e632e8c7b0376$var$throwInvalidHookError() {
    throw Error($236e632e8c7b0376$var$formatProdErrorMessage(321));
}
function $236e632e8c7b0376$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$236e632e8c7b0376$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $236e632e8c7b0376$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $236e632e8c7b0376$var$renderLanes = nextRenderLanes;
    $236e632e8c7b0376$var$currentlyRenderingFiber$1 = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $236e632e8c7b0376$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $236e632e8c7b0376$var$HooksDispatcherOnMount : $236e632e8c7b0376$var$HooksDispatcherOnUpdate;
    $236e632e8c7b0376$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $236e632e8c7b0376$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $236e632e8c7b0376$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $236e632e8c7b0376$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $236e632e8c7b0376$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $236e632e8c7b0376$var$finishRenderingHooks(current) {
    $236e632e8c7b0376$var$ReactSharedInternals.H = $236e632e8c7b0376$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $236e632e8c7b0376$var$currentHook && null !== $236e632e8c7b0376$var$currentHook.next;
    $236e632e8c7b0376$var$renderLanes = 0;
    $236e632e8c7b0376$var$workInProgressHook = $236e632e8c7b0376$var$currentHook = $236e632e8c7b0376$var$currentlyRenderingFiber$1 = null;
    $236e632e8c7b0376$var$didScheduleRenderPhaseUpdate = !1;
    $236e632e8c7b0376$var$thenableIndexCounter = 0;
    $236e632e8c7b0376$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(300));
    null === current || $236e632e8c7b0376$var$didReceiveUpdate || (current = current.dependencies, null !== current && $236e632e8c7b0376$var$checkIfContextChanged(current) && ($236e632e8c7b0376$var$didReceiveUpdate = !0));
}
function $236e632e8c7b0376$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $236e632e8c7b0376$var$currentlyRenderingFiber$1 = workInProgress;
    var numberOfReRenders = 0;
    do {
        $236e632e8c7b0376$var$didScheduleRenderPhaseUpdateDuringThisPass && ($236e632e8c7b0376$var$thenableState = null);
        $236e632e8c7b0376$var$thenableIndexCounter = 0;
        $236e632e8c7b0376$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $236e632e8c7b0376$var$workInProgressHook = $236e632e8c7b0376$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $236e632e8c7b0376$var$ReactSharedInternals.H = $236e632e8c7b0376$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($236e632e8c7b0376$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $236e632e8c7b0376$var$TransitionAwareHostComponent() {
    var dispatcher = $236e632e8c7b0376$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $236e632e8c7b0376$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $236e632e8c7b0376$var$currentHook ? $236e632e8c7b0376$var$currentHook.memoizedState : null) !== dispatcher && ($236e632e8c7b0376$var$currentlyRenderingFiber$1.flags |= 1024);
    return maybeThenable;
}
function $236e632e8c7b0376$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $236e632e8c7b0376$var$localIdCounter;
    $236e632e8c7b0376$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $236e632e8c7b0376$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $236e632e8c7b0376$var$resetHooksOnUnwind(workInProgress) {
    if ($236e632e8c7b0376$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $236e632e8c7b0376$var$didScheduleRenderPhaseUpdate = !1;
    }
    $236e632e8c7b0376$var$renderLanes = 0;
    $236e632e8c7b0376$var$workInProgressHook = $236e632e8c7b0376$var$currentHook = $236e632e8c7b0376$var$currentlyRenderingFiber$1 = null;
    $236e632e8c7b0376$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $236e632e8c7b0376$var$thenableIndexCounter = $236e632e8c7b0376$var$localIdCounter = 0;
    $236e632e8c7b0376$var$thenableState = null;
}
function $236e632e8c7b0376$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $236e632e8c7b0376$var$workInProgressHook ? $236e632e8c7b0376$var$currentlyRenderingFiber$1.memoizedState = $236e632e8c7b0376$var$workInProgressHook = hook : $236e632e8c7b0376$var$workInProgressHook = $236e632e8c7b0376$var$workInProgressHook.next = hook;
    return $236e632e8c7b0376$var$workInProgressHook;
}
function $236e632e8c7b0376$var$updateWorkInProgressHook() {
    if (null === $236e632e8c7b0376$var$currentHook) {
        var nextCurrentHook = $236e632e8c7b0376$var$currentlyRenderingFiber$1.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $236e632e8c7b0376$var$currentHook.next;
    var nextWorkInProgressHook = null === $236e632e8c7b0376$var$workInProgressHook ? $236e632e8c7b0376$var$currentlyRenderingFiber$1.memoizedState : $236e632e8c7b0376$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $236e632e8c7b0376$var$workInProgressHook = nextWorkInProgressHook, $236e632e8c7b0376$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $236e632e8c7b0376$var$currentlyRenderingFiber$1.alternate) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(467));
            throw Error($236e632e8c7b0376$var$formatProdErrorMessage(310));
        }
        $236e632e8c7b0376$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $236e632e8c7b0376$var$currentHook.memoizedState,
            baseState: $236e632e8c7b0376$var$currentHook.baseState,
            baseQueue: $236e632e8c7b0376$var$currentHook.baseQueue,
            queue: $236e632e8c7b0376$var$currentHook.queue,
            next: null
        };
        null === $236e632e8c7b0376$var$workInProgressHook ? $236e632e8c7b0376$var$currentlyRenderingFiber$1.memoizedState = $236e632e8c7b0376$var$workInProgressHook = nextCurrentHook : $236e632e8c7b0376$var$workInProgressHook = $236e632e8c7b0376$var$workInProgressHook.next = nextCurrentHook;
    }
    return $236e632e8c7b0376$var$workInProgressHook;
}
var $236e632e8c7b0376$var$createFunctionComponentUpdateQueue;
$236e632e8c7b0376$var$createFunctionComponentUpdateQueue = function() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function $236e632e8c7b0376$var$useThenable(thenable) {
    var index = $236e632e8c7b0376$var$thenableIndexCounter;
    $236e632e8c7b0376$var$thenableIndexCounter += 1;
    null === $236e632e8c7b0376$var$thenableState && ($236e632e8c7b0376$var$thenableState = []);
    thenable = $236e632e8c7b0376$var$trackUsedThenable($236e632e8c7b0376$var$thenableState, thenable, index);
    index = $236e632e8c7b0376$var$currentlyRenderingFiber$1;
    null === (null === $236e632e8c7b0376$var$workInProgressHook ? index.memoizedState : $236e632e8c7b0376$var$workInProgressHook.next) && (index = index.alternate, $236e632e8c7b0376$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $236e632e8c7b0376$var$HooksDispatcherOnMount : $236e632e8c7b0376$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $236e632e8c7b0376$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $236e632e8c7b0376$var$useThenable(usable);
        if (usable.$$typeof === $236e632e8c7b0376$var$REACT_CONTEXT_TYPE) return $236e632e8c7b0376$var$readContext(usable);
    }
    throw Error($236e632e8c7b0376$var$formatProdErrorMessage(438, String(usable)));
}
function $236e632e8c7b0376$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $236e632e8c7b0376$var$currentlyRenderingFiber$1.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $236e632e8c7b0376$var$currentlyRenderingFiber$1.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $236e632e8c7b0376$var$createFunctionComponentUpdateQueue(), $236e632e8c7b0376$var$currentlyRenderingFiber$1.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $236e632e8c7b0376$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $236e632e8c7b0376$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $236e632e8c7b0376$var$updateReducer(reducer) {
    var hook = $236e632e8c7b0376$var$updateWorkInProgressHook();
    return $236e632e8c7b0376$var$updateReducerImpl(hook, $236e632e8c7b0376$var$currentHook, reducer);
}
function $236e632e8c7b0376$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$54 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($236e632e8c7b0376$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($236e632e8c7b0376$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $236e632e8c7b0376$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                else if (($236e632e8c7b0376$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $236e632e8c7b0376$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $236e632e8c7b0376$var$currentlyRenderingFiber$1.lanes |= revertLane, $236e632e8c7b0376$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $236e632e8c7b0376$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $236e632e8c7b0376$var$currentlyRenderingFiber$1.lanes |= updateLane, $236e632e8c7b0376$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$236e632e8c7b0376$var$objectIs(pendingQueue, hook.memoizedState) && ($236e632e8c7b0376$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$54 && (reducer = $236e632e8c7b0376$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $236e632e8c7b0376$var$rerenderReducer(reducer) {
    var hook = $236e632e8c7b0376$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $236e632e8c7b0376$var$objectIs(newState, hook.memoizedState) || ($236e632e8c7b0376$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $236e632e8c7b0376$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $236e632e8c7b0376$var$currentlyRenderingFiber$1, hook = $236e632e8c7b0376$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $236e632e8c7b0376$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$236e632e8c7b0376$var$objectIs(($236e632e8c7b0376$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $236e632e8c7b0376$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $236e632e8c7b0376$var$updateEffect($236e632e8c7b0376$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $236e632e8c7b0376$var$workInProgressHook && $236e632e8c7b0376$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $236e632e8c7b0376$var$pushEffect(9, $236e632e8c7b0376$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        if (null === $236e632e8c7b0376$var$workInProgressRoot) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($236e632e8c7b0376$var$renderLanes & 60) || $236e632e8c7b0376$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $236e632e8c7b0376$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $236e632e8c7b0376$var$currentlyRenderingFiber$1.updateQueue;
    null === getSnapshot ? (getSnapshot = $236e632e8c7b0376$var$createFunctionComponentUpdateQueue(), $236e632e8c7b0376$var$currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $236e632e8c7b0376$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $236e632e8c7b0376$var$checkIfSnapshotChanged(inst) && $236e632e8c7b0376$var$forceStoreRerender(fiber);
}
function $236e632e8c7b0376$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $236e632e8c7b0376$var$checkIfSnapshotChanged(inst) && $236e632e8c7b0376$var$forceStoreRerender(fiber);
    });
}
function $236e632e8c7b0376$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$236e632e8c7b0376$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $236e632e8c7b0376$var$forceStoreRerender(fiber) {
    var root = $236e632e8c7b0376$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $236e632e8c7b0376$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $236e632e8c7b0376$var$mountStateImpl(initialState) {
    var hook = $236e632e8c7b0376$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($236e632e8c7b0376$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $236e632e8c7b0376$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $236e632e8c7b0376$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $236e632e8c7b0376$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $236e632e8c7b0376$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $236e632e8c7b0376$var$updateReducerImpl(hook, $236e632e8c7b0376$var$currentHook, "function" === typeof reducer ? reducer : $236e632e8c7b0376$var$basicStateReducer);
}
function $236e632e8c7b0376$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($236e632e8c7b0376$var$isRenderPhaseUpdate(fiber)) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $236e632e8c7b0376$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $236e632e8c7b0376$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $236e632e8c7b0376$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $236e632e8c7b0376$var$ReactSharedInternals.T, currentTransition = {};
        $236e632e8c7b0376$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $236e632e8c7b0376$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $236e632e8c7b0376$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $236e632e8c7b0376$var$onActionError(actionQueue, node, error);
        } finally{
            $236e632e8c7b0376$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $236e632e8c7b0376$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$60) {
        $236e632e8c7b0376$var$onActionError(actionQueue, node, error$60);
    }
}
function $236e632e8c7b0376$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $236e632e8c7b0376$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $236e632e8c7b0376$var$onActionError(actionQueue, node, error);
    }) : $236e632e8c7b0376$var$onActionSuccess(actionQueue, node, returnValue);
}
function $236e632e8c7b0376$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $236e632e8c7b0376$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $236e632e8c7b0376$var$runActionStateAction(actionQueue, nextState)));
}
function $236e632e8c7b0376$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $236e632e8c7b0376$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $236e632e8c7b0376$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $236e632e8c7b0376$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $236e632e8c7b0376$var$mountActionState(action, initialStateProp) {
    if ($236e632e8c7b0376$var$isHydrating) {
        var ssrFormState = $236e632e8c7b0376$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $236e632e8c7b0376$var$currentlyRenderingFiber$1;
                if ($236e632e8c7b0376$var$isHydrating) {
                    if ($236e632e8c7b0376$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $236e632e8c7b0376$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $236e632e8c7b0376$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $236e632e8c7b0376$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $236e632e8c7b0376$var$nextHydratableInstance = $236e632e8c7b0376$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $236e632e8c7b0376$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $236e632e8c7b0376$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $236e632e8c7b0376$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $236e632e8c7b0376$var$dispatchSetState.bind(null, $236e632e8c7b0376$var$currentlyRenderingFiber$1, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $236e632e8c7b0376$var$mountStateImpl(!1);
    inRootOrSingleton = $236e632e8c7b0376$var$dispatchOptimisticSetState.bind(null, $236e632e8c7b0376$var$currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $236e632e8c7b0376$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $236e632e8c7b0376$var$dispatchActionState.bind(null, $236e632e8c7b0376$var$currentlyRenderingFiber$1, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $236e632e8c7b0376$var$updateActionState(action) {
    var stateHook = $236e632e8c7b0376$var$updateWorkInProgressHook();
    return $236e632e8c7b0376$var$updateActionStateImpl(stateHook, $236e632e8c7b0376$var$currentHook, action);
}
function $236e632e8c7b0376$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $236e632e8c7b0376$var$updateReducerImpl(stateHook, currentStateHook, $236e632e8c7b0376$var$actionStateReducer)[0];
    stateHook = $236e632e8c7b0376$var$updateReducer($236e632e8c7b0376$var$basicStateReducer)[0];
    currentStateHook = "object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then ? $236e632e8c7b0376$var$useThenable(currentStateHook) : currentStateHook;
    var actionQueueHook = $236e632e8c7b0376$var$updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
    action !== actionQueueHook.memoizedState && ($236e632e8c7b0376$var$currentlyRenderingFiber$1.flags |= 2048, $236e632e8c7b0376$var$pushEffect(9, $236e632e8c7b0376$var$actionStateActionEffect.bind(null, actionQueue, action), {
        destroy: void 0
    }, null));
    return [
        currentStateHook,
        dispatch,
        stateHook
    ];
}
function $236e632e8c7b0376$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $236e632e8c7b0376$var$rerenderActionState(action) {
    var stateHook = $236e632e8c7b0376$var$updateWorkInProgressHook(), currentStateHook = $236e632e8c7b0376$var$currentHook;
    if (null !== currentStateHook) return $236e632e8c7b0376$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $236e632e8c7b0376$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $236e632e8c7b0376$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $236e632e8c7b0376$var$pushEffect(tag, create, inst, deps) {
    tag = {
        tag: tag,
        create: create,
        inst: inst,
        deps: deps,
        next: null
    };
    create = $236e632e8c7b0376$var$currentlyRenderingFiber$1.updateQueue;
    null === create && (create = $236e632e8c7b0376$var$createFunctionComponentUpdateQueue(), $236e632e8c7b0376$var$currentlyRenderingFiber$1.updateQueue = create);
    inst = create.lastEffect;
    null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
    return tag;
}
function $236e632e8c7b0376$var$updateRef() {
    return $236e632e8c7b0376$var$updateWorkInProgressHook().memoizedState;
}
function $236e632e8c7b0376$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $236e632e8c7b0376$var$mountWorkInProgressHook();
    $236e632e8c7b0376$var$currentlyRenderingFiber$1.flags |= fiberFlags;
    hook.memoizedState = $236e632e8c7b0376$var$pushEffect(1 | hookFlags, create, {
        destroy: void 0
    }, void 0 === deps ? null : deps);
}
function $236e632e8c7b0376$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $236e632e8c7b0376$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $236e632e8c7b0376$var$currentHook && null !== deps && $236e632e8c7b0376$var$areHookInputsEqual(deps, $236e632e8c7b0376$var$currentHook.memoizedState.deps) ? hook.memoizedState = $236e632e8c7b0376$var$pushEffect(hookFlags, create, inst, deps) : ($236e632e8c7b0376$var$currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = $236e632e8c7b0376$var$pushEffect(1 | hookFlags, create, inst, deps));
}
function $236e632e8c7b0376$var$mountEffect(create, deps) {
    $236e632e8c7b0376$var$mountEffectImpl(8390656, 8, create, deps);
}
function $236e632e8c7b0376$var$updateEffect(create, deps) {
    $236e632e8c7b0376$var$updateEffectImpl(2048, 8, create, deps);
}
function $236e632e8c7b0376$var$updateInsertionEffect(create, deps) {
    return $236e632e8c7b0376$var$updateEffectImpl(4, 2, create, deps);
}
function $236e632e8c7b0376$var$updateLayoutEffect(create, deps) {
    return $236e632e8c7b0376$var$updateEffectImpl(4, 4, create, deps);
}
function $236e632e8c7b0376$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $236e632e8c7b0376$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $236e632e8c7b0376$var$updateEffectImpl(4, 4, $236e632e8c7b0376$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $236e632e8c7b0376$var$mountDebugValue() {}
function $236e632e8c7b0376$var$updateCallback(callback, deps) {
    var hook = $236e632e8c7b0376$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $236e632e8c7b0376$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $236e632e8c7b0376$var$updateMemo(nextCreate, deps) {
    var hook = $236e632e8c7b0376$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $236e632e8c7b0376$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($236e632e8c7b0376$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $236e632e8c7b0376$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $236e632e8c7b0376$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $236e632e8c7b0376$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($236e632e8c7b0376$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $236e632e8c7b0376$var$requestDeferredLane();
    $236e632e8c7b0376$var$currentlyRenderingFiber$1.lanes |= hook;
    $236e632e8c7b0376$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $236e632e8c7b0376$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($236e632e8c7b0376$var$objectIs(value, prevValue)) return value;
    if (null !== $236e632e8c7b0376$var$currentTreeHiddenStackCursor.current) return hook = $236e632e8c7b0376$var$mountDeferredValueImpl(hook, value, initialValue), $236e632e8c7b0376$var$objectIs(hook, prevValue) || ($236e632e8c7b0376$var$didReceiveUpdate = !0), hook;
    if (0 === ($236e632e8c7b0376$var$renderLanes & 42)) return $236e632e8c7b0376$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $236e632e8c7b0376$var$requestDeferredLane();
    $236e632e8c7b0376$var$currentlyRenderingFiber$1.lanes |= hook;
    $236e632e8c7b0376$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $236e632e8c7b0376$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $236e632e8c7b0376$var$ReactDOMSharedInternals.p;
    $236e632e8c7b0376$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $236e632e8c7b0376$var$ReactSharedInternals.T, currentTransition = {};
    $236e632e8c7b0376$var$ReactSharedInternals.T = currentTransition;
    $236e632e8c7b0376$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $236e632e8c7b0376$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $236e632e8c7b0376$var$chainThenableValue(returnValue, finishedState);
            $236e632e8c7b0376$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $236e632e8c7b0376$var$requestUpdateLane(fiber));
        } else $236e632e8c7b0376$var$dispatchSetStateInternal(fiber, queue, finishedState, $236e632e8c7b0376$var$requestUpdateLane(fiber));
    } catch (error) {
        $236e632e8c7b0376$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $236e632e8c7b0376$var$requestUpdateLane());
    } finally{
        $236e632e8c7b0376$var$ReactDOMSharedInternals.p = previousPriority, $236e632e8c7b0376$var$ReactSharedInternals.T = prevTransition;
    }
}
function $236e632e8c7b0376$var$noop$2() {}
function $236e632e8c7b0376$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(476));
    var queue = $236e632e8c7b0376$var$ensureFormComponentIsStateful(formFiber).queue;
    $236e632e8c7b0376$var$startTransition(formFiber, queue, pendingState, $236e632e8c7b0376$var$sharedNotPendingObject, null === action ? $236e632e8c7b0376$var$noop$2 : function() {
        $236e632e8c7b0376$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $236e632e8c7b0376$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $236e632e8c7b0376$var$sharedNotPendingObject,
        baseState: $236e632e8c7b0376$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $236e632e8c7b0376$var$basicStateReducer,
            lastRenderedState: $236e632e8c7b0376$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $236e632e8c7b0376$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $236e632e8c7b0376$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $236e632e8c7b0376$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $236e632e8c7b0376$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $236e632e8c7b0376$var$requestUpdateLane());
}
function $236e632e8c7b0376$var$useHostTransitionStatus() {
    return $236e632e8c7b0376$var$readContext($236e632e8c7b0376$var$HostTransitionContext);
}
function $236e632e8c7b0376$var$updateId() {
    return $236e632e8c7b0376$var$updateWorkInProgressHook().memoizedState;
}
function $236e632e8c7b0376$var$updateRefresh() {
    return $236e632e8c7b0376$var$updateWorkInProgressHook().memoizedState;
}
function $236e632e8c7b0376$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $236e632e8c7b0376$var$requestUpdateLane();
                fiber = $236e632e8c7b0376$var$createUpdate(lane);
                var root$63 = $236e632e8c7b0376$var$enqueueUpdate(provider, fiber, lane);
                null !== root$63 && ($236e632e8c7b0376$var$scheduleUpdateOnFiber(root$63, provider, lane), $236e632e8c7b0376$var$entangleTransitions(root$63, provider, lane));
                provider = {
                    cache: $236e632e8c7b0376$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $236e632e8c7b0376$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $236e632e8c7b0376$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $236e632e8c7b0376$var$isRenderPhaseUpdate(fiber) ? $236e632e8c7b0376$var$enqueueRenderPhaseUpdate(queue, action) : (action = $236e632e8c7b0376$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($236e632e8c7b0376$var$scheduleUpdateOnFiber(action, fiber, lane), $236e632e8c7b0376$var$entangleTransitionUpdate(action, queue, lane)));
}
function $236e632e8c7b0376$var$dispatchSetState(fiber, queue, action) {
    var lane = $236e632e8c7b0376$var$requestUpdateLane();
    $236e632e8c7b0376$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $236e632e8c7b0376$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($236e632e8c7b0376$var$isRenderPhaseUpdate(fiber)) $236e632e8c7b0376$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($236e632e8c7b0376$var$objectIs(eagerState, currentState)) return $236e632e8c7b0376$var$enqueueUpdate$1(fiber, queue, update, 0), null === $236e632e8c7b0376$var$workInProgressRoot && $236e632e8c7b0376$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $236e632e8c7b0376$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $236e632e8c7b0376$var$scheduleUpdateOnFiber(action, fiber, lane), $236e632e8c7b0376$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $236e632e8c7b0376$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $236e632e8c7b0376$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($236e632e8c7b0376$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $236e632e8c7b0376$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $236e632e8c7b0376$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $236e632e8c7b0376$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $236e632e8c7b0376$var$currentlyRenderingFiber$1 || null !== alternate && alternate === $236e632e8c7b0376$var$currentlyRenderingFiber$1;
}
function $236e632e8c7b0376$var$enqueueRenderPhaseUpdate(queue, update) {
    $236e632e8c7b0376$var$didScheduleRenderPhaseUpdateDuringThisPass = $236e632e8c7b0376$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $236e632e8c7b0376$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194176)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $236e632e8c7b0376$var$markRootEntangled(root, lane);
    }
}
var $236e632e8c7b0376$var$ContextOnlyDispatcher = {
    readContext: $236e632e8c7b0376$var$readContext,
    use: $236e632e8c7b0376$var$use,
    useCallback: $236e632e8c7b0376$var$throwInvalidHookError,
    useContext: $236e632e8c7b0376$var$throwInvalidHookError,
    useEffect: $236e632e8c7b0376$var$throwInvalidHookError,
    useImperativeHandle: $236e632e8c7b0376$var$throwInvalidHookError,
    useLayoutEffect: $236e632e8c7b0376$var$throwInvalidHookError,
    useInsertionEffect: $236e632e8c7b0376$var$throwInvalidHookError,
    useMemo: $236e632e8c7b0376$var$throwInvalidHookError,
    useReducer: $236e632e8c7b0376$var$throwInvalidHookError,
    useRef: $236e632e8c7b0376$var$throwInvalidHookError,
    useState: $236e632e8c7b0376$var$throwInvalidHookError,
    useDebugValue: $236e632e8c7b0376$var$throwInvalidHookError,
    useDeferredValue: $236e632e8c7b0376$var$throwInvalidHookError,
    useTransition: $236e632e8c7b0376$var$throwInvalidHookError,
    useSyncExternalStore: $236e632e8c7b0376$var$throwInvalidHookError,
    useId: $236e632e8c7b0376$var$throwInvalidHookError
};
$236e632e8c7b0376$var$ContextOnlyDispatcher.useCacheRefresh = $236e632e8c7b0376$var$throwInvalidHookError;
$236e632e8c7b0376$var$ContextOnlyDispatcher.useMemoCache = $236e632e8c7b0376$var$throwInvalidHookError;
$236e632e8c7b0376$var$ContextOnlyDispatcher.useHostTransitionStatus = $236e632e8c7b0376$var$throwInvalidHookError;
$236e632e8c7b0376$var$ContextOnlyDispatcher.useFormState = $236e632e8c7b0376$var$throwInvalidHookError;
$236e632e8c7b0376$var$ContextOnlyDispatcher.useActionState = $236e632e8c7b0376$var$throwInvalidHookError;
$236e632e8c7b0376$var$ContextOnlyDispatcher.useOptimistic = $236e632e8c7b0376$var$throwInvalidHookError;
var $236e632e8c7b0376$var$HooksDispatcherOnMount = {
    readContext: $236e632e8c7b0376$var$readContext,
    use: $236e632e8c7b0376$var$use,
    useCallback: function(callback, deps) {
        $236e632e8c7b0376$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $236e632e8c7b0376$var$readContext,
    useEffect: $236e632e8c7b0376$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $236e632e8c7b0376$var$mountEffectImpl(4194308, 4, $236e632e8c7b0376$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $236e632e8c7b0376$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $236e632e8c7b0376$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $236e632e8c7b0376$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($236e632e8c7b0376$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $236e632e8c7b0376$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $236e632e8c7b0376$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $236e632e8c7b0376$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($236e632e8c7b0376$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $236e632e8c7b0376$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $236e632e8c7b0376$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $236e632e8c7b0376$var$dispatchReducerAction.bind(null, $236e632e8c7b0376$var$currentlyRenderingFiber$1, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $236e632e8c7b0376$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $236e632e8c7b0376$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $236e632e8c7b0376$var$dispatchSetState.bind(null, $236e632e8c7b0376$var$currentlyRenderingFiber$1, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $236e632e8c7b0376$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $236e632e8c7b0376$var$mountWorkInProgressHook();
        return $236e632e8c7b0376$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $236e632e8c7b0376$var$mountStateImpl(!1);
        stateHook = $236e632e8c7b0376$var$startTransition.bind(null, $236e632e8c7b0376$var$currentlyRenderingFiber$1, stateHook.queue, !0, !1);
        $236e632e8c7b0376$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $236e632e8c7b0376$var$currentlyRenderingFiber$1, hook = $236e632e8c7b0376$var$mountWorkInProgressHook();
        if ($236e632e8c7b0376$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $236e632e8c7b0376$var$workInProgressRoot) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(349));
            0 !== ($236e632e8c7b0376$var$workInProgressRootRenderLanes & 60) || $236e632e8c7b0376$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $236e632e8c7b0376$var$mountEffect($236e632e8c7b0376$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $236e632e8c7b0376$var$pushEffect(9, $236e632e8c7b0376$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $236e632e8c7b0376$var$mountWorkInProgressHook(), identifierPrefix = $236e632e8c7b0376$var$workInProgressRoot.identifierPrefix;
        if ($236e632e8c7b0376$var$isHydrating) {
            var JSCompiler_inline_result = $236e632e8c7b0376$var$treeContextOverflow;
            var idWithLeadingBit = $236e632e8c7b0376$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $236e632e8c7b0376$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $236e632e8c7b0376$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += ":";
        } else JSCompiler_inline_result = $236e632e8c7b0376$var$globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
        return hook.memoizedState = identifierPrefix;
    },
    useCacheRefresh: function() {
        return $236e632e8c7b0376$var$mountWorkInProgressHook().memoizedState = $236e632e8c7b0376$var$refreshCache.bind(null, $236e632e8c7b0376$var$currentlyRenderingFiber$1);
    }
};
$236e632e8c7b0376$var$HooksDispatcherOnMount.useMemoCache = $236e632e8c7b0376$var$useMemoCache;
$236e632e8c7b0376$var$HooksDispatcherOnMount.useHostTransitionStatus = $236e632e8c7b0376$var$useHostTransitionStatus;
$236e632e8c7b0376$var$HooksDispatcherOnMount.useFormState = $236e632e8c7b0376$var$mountActionState;
$236e632e8c7b0376$var$HooksDispatcherOnMount.useActionState = $236e632e8c7b0376$var$mountActionState;
$236e632e8c7b0376$var$HooksDispatcherOnMount.useOptimistic = function(passthrough) {
    var hook = $236e632e8c7b0376$var$mountWorkInProgressHook();
    hook.memoizedState = hook.baseState = passthrough;
    var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
    };
    hook.queue = queue;
    hook = $236e632e8c7b0376$var$dispatchOptimisticSetState.bind(null, $236e632e8c7b0376$var$currentlyRenderingFiber$1, !0, queue);
    queue.dispatch = hook;
    return [
        passthrough,
        hook
    ];
};
var $236e632e8c7b0376$var$HooksDispatcherOnUpdate = {
    readContext: $236e632e8c7b0376$var$readContext,
    use: $236e632e8c7b0376$var$use,
    useCallback: $236e632e8c7b0376$var$updateCallback,
    useContext: $236e632e8c7b0376$var$readContext,
    useEffect: $236e632e8c7b0376$var$updateEffect,
    useImperativeHandle: $236e632e8c7b0376$var$updateImperativeHandle,
    useInsertionEffect: $236e632e8c7b0376$var$updateInsertionEffect,
    useLayoutEffect: $236e632e8c7b0376$var$updateLayoutEffect,
    useMemo: $236e632e8c7b0376$var$updateMemo,
    useReducer: $236e632e8c7b0376$var$updateReducer,
    useRef: $236e632e8c7b0376$var$updateRef,
    useState: function() {
        return $236e632e8c7b0376$var$updateReducer($236e632e8c7b0376$var$basicStateReducer);
    },
    useDebugValue: $236e632e8c7b0376$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $236e632e8c7b0376$var$updateWorkInProgressHook();
        return $236e632e8c7b0376$var$updateDeferredValueImpl(hook, $236e632e8c7b0376$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $236e632e8c7b0376$var$updateReducer($236e632e8c7b0376$var$basicStateReducer)[0], start = $236e632e8c7b0376$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $236e632e8c7b0376$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $236e632e8c7b0376$var$updateSyncExternalStore,
    useId: $236e632e8c7b0376$var$updateId
};
$236e632e8c7b0376$var$HooksDispatcherOnUpdate.useCacheRefresh = $236e632e8c7b0376$var$updateRefresh;
$236e632e8c7b0376$var$HooksDispatcherOnUpdate.useMemoCache = $236e632e8c7b0376$var$useMemoCache;
$236e632e8c7b0376$var$HooksDispatcherOnUpdate.useHostTransitionStatus = $236e632e8c7b0376$var$useHostTransitionStatus;
$236e632e8c7b0376$var$HooksDispatcherOnUpdate.useFormState = $236e632e8c7b0376$var$updateActionState;
$236e632e8c7b0376$var$HooksDispatcherOnUpdate.useActionState = $236e632e8c7b0376$var$updateActionState;
$236e632e8c7b0376$var$HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
    var hook = $236e632e8c7b0376$var$updateWorkInProgressHook();
    return $236e632e8c7b0376$var$updateOptimisticImpl(hook, $236e632e8c7b0376$var$currentHook, passthrough, reducer);
};
var $236e632e8c7b0376$var$HooksDispatcherOnRerender = {
    readContext: $236e632e8c7b0376$var$readContext,
    use: $236e632e8c7b0376$var$use,
    useCallback: $236e632e8c7b0376$var$updateCallback,
    useContext: $236e632e8c7b0376$var$readContext,
    useEffect: $236e632e8c7b0376$var$updateEffect,
    useImperativeHandle: $236e632e8c7b0376$var$updateImperativeHandle,
    useInsertionEffect: $236e632e8c7b0376$var$updateInsertionEffect,
    useLayoutEffect: $236e632e8c7b0376$var$updateLayoutEffect,
    useMemo: $236e632e8c7b0376$var$updateMemo,
    useReducer: $236e632e8c7b0376$var$rerenderReducer,
    useRef: $236e632e8c7b0376$var$updateRef,
    useState: function() {
        return $236e632e8c7b0376$var$rerenderReducer($236e632e8c7b0376$var$basicStateReducer);
    },
    useDebugValue: $236e632e8c7b0376$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $236e632e8c7b0376$var$updateWorkInProgressHook();
        return null === $236e632e8c7b0376$var$currentHook ? $236e632e8c7b0376$var$mountDeferredValueImpl(hook, value, initialValue) : $236e632e8c7b0376$var$updateDeferredValueImpl(hook, $236e632e8c7b0376$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $236e632e8c7b0376$var$rerenderReducer($236e632e8c7b0376$var$basicStateReducer)[0], start = $236e632e8c7b0376$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $236e632e8c7b0376$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $236e632e8c7b0376$var$updateSyncExternalStore,
    useId: $236e632e8c7b0376$var$updateId
};
$236e632e8c7b0376$var$HooksDispatcherOnRerender.useCacheRefresh = $236e632e8c7b0376$var$updateRefresh;
$236e632e8c7b0376$var$HooksDispatcherOnRerender.useMemoCache = $236e632e8c7b0376$var$useMemoCache;
$236e632e8c7b0376$var$HooksDispatcherOnRerender.useHostTransitionStatus = $236e632e8c7b0376$var$useHostTransitionStatus;
$236e632e8c7b0376$var$HooksDispatcherOnRerender.useFormState = $236e632e8c7b0376$var$rerenderActionState;
$236e632e8c7b0376$var$HooksDispatcherOnRerender.useActionState = $236e632e8c7b0376$var$rerenderActionState;
$236e632e8c7b0376$var$HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
    var hook = $236e632e8c7b0376$var$updateWorkInProgressHook();
    if (null !== $236e632e8c7b0376$var$currentHook) return $236e632e8c7b0376$var$updateOptimisticImpl(hook, $236e632e8c7b0376$var$currentHook, passthrough, reducer);
    hook.baseState = passthrough;
    return [
        passthrough,
        hook.queue.dispatch
    ];
};
function $236e632e8c7b0376$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $236e632e8c7b0376$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $236e632e8c7b0376$var$classComponentUpdater = {
    isMounted: function(component) {
        return (component = component._reactInternals) ? $236e632e8c7b0376$var$getNearestMountedFiber(component) === component : !1;
    },
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $236e632e8c7b0376$var$requestUpdateLane(), update = $236e632e8c7b0376$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $236e632e8c7b0376$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($236e632e8c7b0376$var$scheduleUpdateOnFiber(payload, inst, lane), $236e632e8c7b0376$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $236e632e8c7b0376$var$requestUpdateLane(), update = $236e632e8c7b0376$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $236e632e8c7b0376$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($236e632e8c7b0376$var$scheduleUpdateOnFiber(payload, inst, lane), $236e632e8c7b0376$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $236e632e8c7b0376$var$requestUpdateLane(), update = $236e632e8c7b0376$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $236e632e8c7b0376$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($236e632e8c7b0376$var$scheduleUpdateOnFiber(callback, inst, lane), $236e632e8c7b0376$var$entangleTransitions(callback, inst, lane));
    }
};
function $236e632e8c7b0376$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$236e632e8c7b0376$var$shallowEqual(oldProps, newProps) || !$236e632e8c7b0376$var$shallowEqual(oldState, newState) : !0;
}
function $236e632e8c7b0376$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $236e632e8c7b0376$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $236e632e8c7b0376$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $236e632e8c7b0376$var$assign({}, newProps));
        for(var propName$67 in Component)void 0 === newProps[propName$67] && (newProps[propName$67] = Component[propName$67]);
    }
    return newProps;
}
var $236e632e8c7b0376$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $236e632e8c7b0376$var$defaultOnUncaughtError(error) {
    $236e632e8c7b0376$var$reportGlobalError(error);
}
function $236e632e8c7b0376$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $236e632e8c7b0376$var$defaultOnRecoverableError(error) {
    $236e632e8c7b0376$var$reportGlobalError(error);
}
function $236e632e8c7b0376$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$68) {
        setTimeout(function() {
            throw e$68;
        });
    }
}
function $236e632e8c7b0376$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$69) {
        setTimeout(function() {
            throw e$69;
        });
    }
}
function $236e632e8c7b0376$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $236e632e8c7b0376$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $236e632e8c7b0376$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $236e632e8c7b0376$var$createClassErrorUpdate(lane) {
    lane = $236e632e8c7b0376$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $236e632e8c7b0376$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $236e632e8c7b0376$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $236e632e8c7b0376$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $236e632e8c7b0376$var$legacyErrorBoundariesThatAlreadyFailed ? $236e632e8c7b0376$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $236e632e8c7b0376$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $236e632e8c7b0376$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $236e632e8c7b0376$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $236e632e8c7b0376$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $236e632e8c7b0376$var$shellBoundary ? $236e632e8c7b0376$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $236e632e8c7b0376$var$workInProgressRootExitStatus && ($236e632e8c7b0376$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $236e632e8c7b0376$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $236e632e8c7b0376$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $236e632e8c7b0376$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $236e632e8c7b0376$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($236e632e8c7b0376$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $236e632e8c7b0376$var$attachPingListener(root, value, rootRenderLanes);
        $236e632e8c7b0376$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($236e632e8c7b0376$var$isHydrating) return returnFiber = $236e632e8c7b0376$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $236e632e8c7b0376$var$HydrationMismatchException && (root = Error($236e632e8c7b0376$var$formatProdErrorMessage(422), {
        cause: value
    }), $236e632e8c7b0376$var$queueHydrationError($236e632e8c7b0376$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $236e632e8c7b0376$var$HydrationMismatchException && (returnFiber = Error($236e632e8c7b0376$var$formatProdErrorMessage(423), {
        cause: value
    }), $236e632e8c7b0376$var$queueHydrationError($236e632e8c7b0376$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $236e632e8c7b0376$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $236e632e8c7b0376$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $236e632e8c7b0376$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $236e632e8c7b0376$var$workInProgressRootExitStatus && ($236e632e8c7b0376$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($236e632e8c7b0376$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $236e632e8c7b0376$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $236e632e8c7b0376$var$workInProgressRootConcurrentErrors ? $236e632e8c7b0376$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $236e632e8c7b0376$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $236e632e8c7b0376$var$workInProgressRootExitStatus && ($236e632e8c7b0376$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $236e632e8c7b0376$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $236e632e8c7b0376$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $236e632e8c7b0376$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $236e632e8c7b0376$var$legacyErrorBoundariesThatAlreadyFailed || !$236e632e8c7b0376$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $236e632e8c7b0376$var$createClassErrorUpdate(rootRenderLanes), $236e632e8c7b0376$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $236e632e8c7b0376$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $236e632e8c7b0376$var$SelectiveHydrationException = Error($236e632e8c7b0376$var$formatProdErrorMessage(461)), $236e632e8c7b0376$var$didReceiveUpdate = !1;
function $236e632e8c7b0376$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $236e632e8c7b0376$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $236e632e8c7b0376$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $236e632e8c7b0376$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $236e632e8c7b0376$var$prepareToReadContext(workInProgress);
    nextProps = $236e632e8c7b0376$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $236e632e8c7b0376$var$checkDidRenderIdHook();
    if (null !== current && !$236e632e8c7b0376$var$didReceiveUpdate) return $236e632e8c7b0376$var$bailoutHooks(current, workInProgress, renderLanes), $236e632e8c7b0376$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $236e632e8c7b0376$var$isHydrating && key && $236e632e8c7b0376$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $236e632e8c7b0376$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $236e632e8c7b0376$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$236e632e8c7b0376$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $236e632e8c7b0376$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $236e632e8c7b0376$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$236e632e8c7b0376$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $236e632e8c7b0376$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $236e632e8c7b0376$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $236e632e8c7b0376$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $236e632e8c7b0376$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($236e632e8c7b0376$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($236e632e8c7b0376$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $236e632e8c7b0376$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($236e632e8c7b0376$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $236e632e8c7b0376$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $236e632e8c7b0376$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $236e632e8c7b0376$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
    $236e632e8c7b0376$var$markRef(current, workInProgress);
    if ("hidden" === nextProps.mode || nextIsDetached) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = nextIsDetached & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $236e632e8c7b0376$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $236e632e8c7b0376$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $236e632e8c7b0376$var$pushHiddenContext(workInProgress, prevState) : $236e632e8c7b0376$var$reuseHiddenContextOnStack(), $236e632e8c7b0376$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $236e632e8c7b0376$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($236e632e8c7b0376$var$pushTransition(workInProgress, prevState.cachePool), $236e632e8c7b0376$var$pushHiddenContext(workInProgress, prevState), $236e632e8c7b0376$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $236e632e8c7b0376$var$pushTransition(workInProgress, null), $236e632e8c7b0376$var$reuseHiddenContextOnStack(), $236e632e8c7b0376$var$reuseSuspenseHandlerOnStack(workInProgress));
    $236e632e8c7b0376$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $236e632e8c7b0376$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $236e632e8c7b0376$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $236e632e8c7b0376$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $236e632e8c7b0376$var$pushTransition(workInProgress, null);
    $236e632e8c7b0376$var$reuseHiddenContextOnStack();
    $236e632e8c7b0376$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $236e632e8c7b0376$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $236e632e8c7b0376$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
    }
}
function $236e632e8c7b0376$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $236e632e8c7b0376$var$prepareToReadContext(workInProgress);
    Component = $236e632e8c7b0376$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $236e632e8c7b0376$var$checkDidRenderIdHook();
    if (null !== current && !$236e632e8c7b0376$var$didReceiveUpdate) return $236e632e8c7b0376$var$bailoutHooks(current, workInProgress, renderLanes), $236e632e8c7b0376$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $236e632e8c7b0376$var$isHydrating && nextProps && $236e632e8c7b0376$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $236e632e8c7b0376$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $236e632e8c7b0376$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $236e632e8c7b0376$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $236e632e8c7b0376$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $236e632e8c7b0376$var$finishRenderingHooks(current);
    Component = $236e632e8c7b0376$var$checkDidRenderIdHook();
    if (null !== current && !$236e632e8c7b0376$var$didReceiveUpdate) return $236e632e8c7b0376$var$bailoutHooks(current, workInProgress, renderLanes), $236e632e8c7b0376$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $236e632e8c7b0376$var$isHydrating && Component && $236e632e8c7b0376$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $236e632e8c7b0376$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $236e632e8c7b0376$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $236e632e8c7b0376$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $236e632e8c7b0376$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $236e632e8c7b0376$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $236e632e8c7b0376$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $236e632e8c7b0376$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $236e632e8c7b0376$var$readContext(contextType) : $236e632e8c7b0376$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($236e632e8c7b0376$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $236e632e8c7b0376$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $236e632e8c7b0376$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $236e632e8c7b0376$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $236e632e8c7b0376$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $236e632e8c7b0376$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $236e632e8c7b0376$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $236e632e8c7b0376$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $236e632e8c7b0376$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $236e632e8c7b0376$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $236e632e8c7b0376$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $236e632e8c7b0376$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($236e632e8c7b0376$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $236e632e8c7b0376$var$hasForceUpdate || $236e632e8c7b0376$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $236e632e8c7b0376$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $236e632e8c7b0376$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $236e632e8c7b0376$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $236e632e8c7b0376$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $236e632e8c7b0376$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $236e632e8c7b0376$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $236e632e8c7b0376$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $236e632e8c7b0376$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $236e632e8c7b0376$var$hasForceUpdate || null !== current && null !== current.dependencies && $236e632e8c7b0376$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($236e632e8c7b0376$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $236e632e8c7b0376$var$hasForceUpdate || $236e632e8c7b0376$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $236e632e8c7b0376$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $236e632e8c7b0376$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $236e632e8c7b0376$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $236e632e8c7b0376$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $236e632e8c7b0376$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $236e632e8c7b0376$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $236e632e8c7b0376$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $236e632e8c7b0376$var$resetHydrationState();
    workInProgress.flags |= 256;
    $236e632e8c7b0376$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $236e632e8c7b0376$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $236e632e8c7b0376$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $236e632e8c7b0376$var$getSuspendedCache()
    };
}
function $236e632e8c7b0376$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $236e632e8c7b0376$var$workInProgressDeferredLane);
    return current;
}
function $236e632e8c7b0376$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($236e632e8c7b0376$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($236e632e8c7b0376$var$isHydrating) {
            showFallback ? $236e632e8c7b0376$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $236e632e8c7b0376$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($236e632e8c7b0376$var$isHydrating) {
                var nextInstance = $236e632e8c7b0376$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $236e632e8c7b0376$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $236e632e8c7b0376$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $236e632e8c7b0376$var$treeContextProvider ? {
                            id: $236e632e8c7b0376$var$treeContextId,
                            overflow: $236e632e8c7b0376$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = $236e632e8c7b0376$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $236e632e8c7b0376$var$hydrationParentFiber = workInProgress, $236e632e8c7b0376$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $236e632e8c7b0376$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return "$!" === nextInstance.data ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
            $236e632e8c7b0376$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $236e632e8c7b0376$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $236e632e8c7b0376$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $236e632e8c7b0376$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $236e632e8c7b0376$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $236e632e8c7b0376$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $236e632e8c7b0376$var$SUSPENDED_MARKER, nextProps;
        $236e632e8c7b0376$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $236e632e8c7b0376$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($236e632e8c7b0376$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $236e632e8c7b0376$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($236e632e8c7b0376$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($236e632e8c7b0376$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $236e632e8c7b0376$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $236e632e8c7b0376$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $236e632e8c7b0376$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $236e632e8c7b0376$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $236e632e8c7b0376$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $236e632e8c7b0376$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($236e632e8c7b0376$var$pushPrimaryTreeSuspenseHandler(workInProgress), "$!" === nextInstance.data) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($236e632e8c7b0376$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $236e632e8c7b0376$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $236e632e8c7b0376$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($236e632e8c7b0376$var$didReceiveUpdate || $236e632e8c7b0376$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $236e632e8c7b0376$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $236e632e8c7b0376$var$workInProgressRoot;
            if (null !== JSCompiler_temp) {
                nextProps = renderLanes & -renderLanes;
                if (0 !== (nextProps & 42)) nextProps = 1;
                else switch(nextProps){
                    case 2:
                        nextProps = 1;
                        break;
                    case 8:
                        nextProps = 4;
                        break;
                    case 32:
                        nextProps = 16;
                        break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        nextProps = 64;
                        break;
                    case 268435456:
                        nextProps = 134217728;
                        break;
                    default:
                        nextProps = 0;
                }
                nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $236e632e8c7b0376$var$enqueueConcurrentRenderForLane(current, nextProps), $236e632e8c7b0376$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $236e632e8c7b0376$var$SelectiveHydrationException;
            }
            "$?" === nextInstance.data || $236e632e8c7b0376$var$renderDidSuspendDelayIfPossible();
            workInProgress = $236e632e8c7b0376$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = $236e632e8c7b0376$var$retryDehydratedSuspenseBoundary.bind(null, current), nextInstance._reactRetry = workInProgress, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $236e632e8c7b0376$var$nextHydratableInstance = $236e632e8c7b0376$var$getNextHydratable(nextInstance.nextSibling), $236e632e8c7b0376$var$hydrationParentFiber = workInProgress, $236e632e8c7b0376$var$isHydrating = !0, $236e632e8c7b0376$var$hydrationErrors = null, $236e632e8c7b0376$var$rootOrSingletonContext = !1, null !== current && ($236e632e8c7b0376$var$idStack[$236e632e8c7b0376$var$idStackIndex++] = $236e632e8c7b0376$var$treeContextId, $236e632e8c7b0376$var$idStack[$236e632e8c7b0376$var$idStackIndex++] = $236e632e8c7b0376$var$treeContextOverflow, $236e632e8c7b0376$var$idStack[$236e632e8c7b0376$var$idStackIndex++] = $236e632e8c7b0376$var$treeContextProvider, $236e632e8c7b0376$var$treeContextId = current.id, $236e632e8c7b0376$var$treeContextOverflow = current.overflow, $236e632e8c7b0376$var$treeContextProvider = workInProgress), workInProgress = $236e632e8c7b0376$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $236e632e8c7b0376$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $236e632e8c7b0376$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== digest ? showFallback = $236e632e8c7b0376$var$createWorkInProgress(digest, showFallback) : (showFallback = $236e632e8c7b0376$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $236e632e8c7b0376$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $236e632e8c7b0376$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $236e632e8c7b0376$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $236e632e8c7b0376$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $236e632e8c7b0376$var$SUSPENDED_MARKER, nextProps;
    $236e632e8c7b0376$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $236e632e8c7b0376$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $236e632e8c7b0376$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $236e632e8c7b0376$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $236e632e8c7b0376$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    return $236e632e8c7b0376$var$createFiberFromOffscreen(offscreenProps, mode, 0, null);
}
function $236e632e8c7b0376$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $236e632e8c7b0376$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $236e632e8c7b0376$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $236e632e8c7b0376$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $236e632e8c7b0376$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $236e632e8c7b0376$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $236e632e8c7b0376$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $236e632e8c7b0376$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $236e632e8c7b0376$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $236e632e8c7b0376$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $236e632e8c7b0376$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $236e632e8c7b0376$var$push($236e632e8c7b0376$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $236e632e8c7b0376$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $236e632e8c7b0376$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $236e632e8c7b0376$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $236e632e8c7b0376$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $236e632e8c7b0376$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $236e632e8c7b0376$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $236e632e8c7b0376$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($236e632e8c7b0376$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $236e632e8c7b0376$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $236e632e8c7b0376$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $236e632e8c7b0376$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $236e632e8c7b0376$var$checkIfContextChanged(current) ? !0 : !1;
}
function $236e632e8c7b0376$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $236e632e8c7b0376$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $236e632e8c7b0376$var$pushProvider(workInProgress, $236e632e8c7b0376$var$CacheContext, current.memoizedState.cache);
            $236e632e8c7b0376$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $236e632e8c7b0376$var$pushHostContext(workInProgress);
            break;
        case 4:
            $236e632e8c7b0376$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $236e632e8c7b0376$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $236e632e8c7b0376$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $236e632e8c7b0376$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $236e632e8c7b0376$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $236e632e8c7b0376$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $236e632e8c7b0376$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($236e632e8c7b0376$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $236e632e8c7b0376$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $236e632e8c7b0376$var$push($236e632e8c7b0376$var$suspenseStackCursor, $236e632e8c7b0376$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $236e632e8c7b0376$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $236e632e8c7b0376$var$pushProvider(workInProgress, $236e632e8c7b0376$var$CacheContext, current.memoizedState.cache);
    }
    return $236e632e8c7b0376$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $236e632e8c7b0376$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $236e632e8c7b0376$var$didReceiveUpdate = !0;
        else {
            if (!$236e632e8c7b0376$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $236e632e8c7b0376$var$didReceiveUpdate = !1, $236e632e8c7b0376$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $236e632e8c7b0376$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $236e632e8c7b0376$var$didReceiveUpdate = !1, $236e632e8c7b0376$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $236e632e8c7b0376$var$pushTreeId(workInProgress, $236e632e8c7b0376$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $236e632e8c7b0376$var$shouldConstruct(lazyComponent) ? (current = $236e632e8c7b0376$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $236e632e8c7b0376$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $236e632e8c7b0376$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $236e632e8c7b0376$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $236e632e8c7b0376$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $236e632e8c7b0376$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $236e632e8c7b0376$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $236e632e8c7b0376$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($236e632e8c7b0376$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $236e632e8c7b0376$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $236e632e8c7b0376$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $236e632e8c7b0376$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $236e632e8c7b0376$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(387));
                var nextProps = workInProgress.pendingProps;
                init = workInProgress.memoizedState;
                lazyComponent = init.element;
                $236e632e8c7b0376$var$cloneUpdateQueue(current, workInProgress);
                $236e632e8c7b0376$var$processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                nextProps = nextState.cache;
                $236e632e8c7b0376$var$pushProvider(workInProgress, $236e632e8c7b0376$var$CacheContext, nextProps);
                nextProps !== init.cache && $236e632e8c7b0376$var$propagateContextChanges(workInProgress, [
                    $236e632e8c7b0376$var$CacheContext
                ], renderLanes, !0);
                $236e632e8c7b0376$var$suspendIfUpdateReadFromEntangledAsyncAction();
                nextProps = nextState.element;
                if (init.isDehydrated) {
                    if (init = {
                        element: nextProps,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                        workInProgress = $236e632e8c7b0376$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else if (nextProps !== lazyComponent) {
                        lazyComponent = $236e632e8c7b0376$var$createCapturedValueAtFiber(Error($236e632e8c7b0376$var$formatProdErrorMessage(424)), workInProgress);
                        $236e632e8c7b0376$var$queueHydrationError(lazyComponent);
                        workInProgress = $236e632e8c7b0376$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else for($236e632e8c7b0376$var$nextHydratableInstance = $236e632e8c7b0376$var$getNextHydratable(workInProgress.stateNode.containerInfo.firstChild), $236e632e8c7b0376$var$hydrationParentFiber = workInProgress, $236e632e8c7b0376$var$isHydrating = !0, $236e632e8c7b0376$var$hydrationErrors = null, $236e632e8c7b0376$var$rootOrSingletonContext = !0, renderLanes = $236e632e8c7b0376$var$mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                } else {
                    $236e632e8c7b0376$var$resetHydrationState();
                    if (nextProps === lazyComponent) {
                        workInProgress = $236e632e8c7b0376$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $236e632e8c7b0376$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $236e632e8c7b0376$var$markRef(current, workInProgress), null === current ? (renderLanes = $236e632e8c7b0376$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $236e632e8c7b0376$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $236e632e8c7b0376$var$getOwnerDocumentFromRootContainer($236e632e8c7b0376$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$236e632e8c7b0376$var$internalInstanceKey] = workInProgress, lazyComponent[$236e632e8c7b0376$var$internalPropsKey] = current, $236e632e8c7b0376$var$setInitialProperties(lazyComponent, renderLanes, current), $236e632e8c7b0376$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $236e632e8c7b0376$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $236e632e8c7b0376$var$pushHostContext(workInProgress), null === current && $236e632e8c7b0376$var$isHydrating && (lazyComponent = workInProgress.stateNode = $236e632e8c7b0376$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $236e632e8c7b0376$var$rootInstanceStackCursor.current), $236e632e8c7b0376$var$hydrationParentFiber = workInProgress, $236e632e8c7b0376$var$rootOrSingletonContext = !0, $236e632e8c7b0376$var$nextHydratableInstance = $236e632e8c7b0376$var$getNextHydratable(lazyComponent.firstChild)), lazyComponent = workInProgress.pendingProps.children, null !== current || $236e632e8c7b0376$var$isHydrating ? $236e632e8c7b0376$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = $236e632e8c7b0376$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), $236e632e8c7b0376$var$markRef(current, workInProgress), workInProgress.child;
        case 5:
            if (null === current && $236e632e8c7b0376$var$isHydrating) {
                if (init = lazyComponent = $236e632e8c7b0376$var$nextHydratableInstance) lazyComponent = $236e632e8c7b0376$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $236e632e8c7b0376$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $236e632e8c7b0376$var$hydrationParentFiber = workInProgress, $236e632e8c7b0376$var$nextHydratableInstance = $236e632e8c7b0376$var$getNextHydratable(lazyComponent.firstChild), $236e632e8c7b0376$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $236e632e8c7b0376$var$throwOnHydrationMismatch(workInProgress);
            }
            $236e632e8c7b0376$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            nextProps = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = nextProps.children;
            $236e632e8c7b0376$var$shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && $236e632e8c7b0376$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $236e632e8c7b0376$var$renderWithHooks(current, workInProgress, $236e632e8c7b0376$var$TransitionAwareHostComponent, null, null, renderLanes), $236e632e8c7b0376$var$HostTransitionContext._currentValue = init);
            $236e632e8c7b0376$var$markRef(current, workInProgress);
            $236e632e8c7b0376$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $236e632e8c7b0376$var$isHydrating) {
                if (current = renderLanes = $236e632e8c7b0376$var$nextHydratableInstance) renderLanes = $236e632e8c7b0376$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $236e632e8c7b0376$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $236e632e8c7b0376$var$hydrationParentFiber = workInProgress, $236e632e8c7b0376$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $236e632e8c7b0376$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $236e632e8c7b0376$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $236e632e8c7b0376$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $236e632e8c7b0376$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $236e632e8c7b0376$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $236e632e8c7b0376$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $236e632e8c7b0376$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $236e632e8c7b0376$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $236e632e8c7b0376$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $236e632e8c7b0376$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $236e632e8c7b0376$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $236e632e8c7b0376$var$prepareToReadContext(workInProgress), init = $236e632e8c7b0376$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $236e632e8c7b0376$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $236e632e8c7b0376$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $236e632e8c7b0376$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $236e632e8c7b0376$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 22:
            return $236e632e8c7b0376$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $236e632e8c7b0376$var$prepareToReadContext(workInProgress), lazyComponent = $236e632e8c7b0376$var$readContext($236e632e8c7b0376$var$CacheContext), null === current ? (init = $236e632e8c7b0376$var$peekCacheFromPool(), null === init && (init = $236e632e8c7b0376$var$workInProgressRoot, nextProps = $236e632e8c7b0376$var$createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $236e632e8c7b0376$var$initializeUpdateQueue(workInProgress), $236e632e8c7b0376$var$pushProvider(workInProgress, $236e632e8c7b0376$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($236e632e8c7b0376$var$cloneUpdateQueue(current, workInProgress), $236e632e8c7b0376$var$processUpdateQueue(workInProgress, null, null, renderLanes), $236e632e8c7b0376$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $236e632e8c7b0376$var$pushProvider(workInProgress, $236e632e8c7b0376$var$CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, $236e632e8c7b0376$var$pushProvider(workInProgress, $236e632e8c7b0376$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $236e632e8c7b0376$var$propagateContextChanges(workInProgress, [
                $236e632e8c7b0376$var$CacheContext
            ], renderLanes, !0))), $236e632e8c7b0376$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($236e632e8c7b0376$var$formatProdErrorMessage(156, workInProgress.tag));
}
var $236e632e8c7b0376$var$valueCursor = $236e632e8c7b0376$var$createCursor(null), $236e632e8c7b0376$var$currentlyRenderingFiber = null, $236e632e8c7b0376$var$lastContextDependency = null;
function $236e632e8c7b0376$var$pushProvider(providerFiber, context, nextValue) {
    $236e632e8c7b0376$var$push($236e632e8c7b0376$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $236e632e8c7b0376$var$popProvider(context) {
    context._currentValue = $236e632e8c7b0376$var$valueCursor.current;
    $236e632e8c7b0376$var$pop($236e632e8c7b0376$var$valueCursor);
}
function $236e632e8c7b0376$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $236e632e8c7b0376$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $236e632e8c7b0376$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $236e632e8c7b0376$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $236e632e8c7b0376$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $236e632e8c7b0376$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $236e632e8c7b0376$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($236e632e8c7b0376$var$HostTransitionContext) : current = [
                $236e632e8c7b0376$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $236e632e8c7b0376$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $236e632e8c7b0376$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$236e632e8c7b0376$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $236e632e8c7b0376$var$prepareToReadContext(workInProgress) {
    $236e632e8c7b0376$var$currentlyRenderingFiber = workInProgress;
    $236e632e8c7b0376$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $236e632e8c7b0376$var$readContext(context) {
    return $236e632e8c7b0376$var$readContextForConsumer($236e632e8c7b0376$var$currentlyRenderingFiber, context);
}
function $236e632e8c7b0376$var$readContextDuringReconciliation(consumer, context) {
    null === $236e632e8c7b0376$var$currentlyRenderingFiber && $236e632e8c7b0376$var$prepareToReadContext(consumer);
    return $236e632e8c7b0376$var$readContextForConsumer(consumer, context);
}
function $236e632e8c7b0376$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $236e632e8c7b0376$var$lastContextDependency) {
        if (null === consumer) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(308));
        $236e632e8c7b0376$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $236e632e8c7b0376$var$lastContextDependency = $236e632e8c7b0376$var$lastContextDependency.next = context;
    return value;
}
var $236e632e8c7b0376$var$hasForceUpdate = !1;
function $236e632e8c7b0376$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $236e632e8c7b0376$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $236e632e8c7b0376$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $236e632e8c7b0376$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($236e632e8c7b0376$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $236e632e8c7b0376$var$getRootForUpdatedFiber(fiber);
        $236e632e8c7b0376$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $236e632e8c7b0376$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $236e632e8c7b0376$var$getRootForUpdatedFiber(fiber);
}
function $236e632e8c7b0376$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $236e632e8c7b0376$var$markRootEntangled(root, lane);
    }
}
function $236e632e8c7b0376$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $236e632e8c7b0376$var$didReadFromEntangledAsyncAction = !1;
function $236e632e8c7b0376$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($236e632e8c7b0376$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $236e632e8c7b0376$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $236e632e8c7b0376$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $236e632e8c7b0376$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $236e632e8c7b0376$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($236e632e8c7b0376$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $236e632e8c7b0376$var$currentEntangledLane && ($236e632e8c7b0376$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $236e632e8c7b0376$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $236e632e8c7b0376$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $236e632e8c7b0376$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $236e632e8c7b0376$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $236e632e8c7b0376$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$236e632e8c7b0376$var$callCallback(callbacks[updateQueue], context);
}
function $236e632e8c7b0376$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $236e632e8c7b0376$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $236e632e8c7b0376$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                        try {
                            destroy();
                        } catch (error) {
                            $236e632e8c7b0376$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $236e632e8c7b0376$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $236e632e8c7b0376$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $236e632e8c7b0376$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $236e632e8c7b0376$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $236e632e8c7b0376$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $236e632e8c7b0376$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $236e632e8c7b0376$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $236e632e8c7b0376$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            var instance = current.stateNode;
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = instance;
                    break;
                default:
                    instanceToUse = instance;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $236e632e8c7b0376$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $236e632e8c7b0376$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $236e632e8c7b0376$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$112) {
            $236e632e8c7b0376$var$captureCommitPhaseError(current, nearestMountedAncestor, error$112);
        }
        else ref.current = null;
    }
}
function $236e632e8c7b0376$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $236e632e8c7b0376$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $236e632e8c7b0376$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $236e632e8c7b0376$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$236e632e8c7b0376$var$internalPropsKey] = newProps;
    } catch (error) {
        $236e632e8c7b0376$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $236e632e8c7b0376$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag || 4 === fiber.tag;
}
function $236e632e8c7b0376$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $236e632e8c7b0376$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 27 !== fiber.tag && 18 !== fiber.tag;){
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $236e632e8c7b0376$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? 8 === parent.nodeType ? parent.parentNode.insertBefore(node, before) : parent.insertBefore(node, before) : (8 === parent.nodeType ? (before = parent.parentNode, before.insertBefore(node, parent)) : (before = parent, before.appendChild(node)), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $236e632e8c7b0376$var$noop$1));
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($236e632e8c7b0376$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$236e632e8c7b0376$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $236e632e8c7b0376$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($236e632e8c7b0376$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$236e632e8c7b0376$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
var $236e632e8c7b0376$var$offscreenSubtreeIsHidden = !1, $236e632e8c7b0376$var$offscreenSubtreeWasHidden = !1, $236e632e8c7b0376$var$needsFormReset = !1, $236e632e8c7b0376$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $236e632e8c7b0376$var$nextEffect = null, $236e632e8c7b0376$var$shouldFireAfterActiveInstanceBlur = !1;
function $236e632e8c7b0376$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $236e632e8c7b0376$var$eventsEnabled = $236e632e8c7b0376$var$_enabled;
    root = $236e632e8c7b0376$var$getActiveElementDeep(root);
    if ($236e632e8c7b0376$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $236e632e8c7b0376$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $236e632e8c7b0376$var$_enabled = !1;
    for($236e632e8c7b0376$var$nextEffect = firstChild; null !== $236e632e8c7b0376$var$nextEffect;)if (firstChild = $236e632e8c7b0376$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $236e632e8c7b0376$var$nextEffect = root;
    else for(; null !== $236e632e8c7b0376$var$nextEffect;){
        firstChild = $236e632e8c7b0376$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $236e632e8c7b0376$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $236e632e8c7b0376$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $236e632e8c7b0376$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $236e632e8c7b0376$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $236e632e8c7b0376$var$nextEffect = root;
            break;
        }
        $236e632e8c7b0376$var$nextEffect = firstChild.return;
    }
    resolvedPrevProps = $236e632e8c7b0376$var$shouldFireAfterActiveInstanceBlur;
    $236e632e8c7b0376$var$shouldFireAfterActiveInstanceBlur = !1;
    return resolvedPrevProps;
}
function $236e632e8c7b0376$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $236e632e8c7b0376$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $236e632e8c7b0376$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $236e632e8c7b0376$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $236e632e8c7b0376$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $236e632e8c7b0376$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$111) {
                        $236e632e8c7b0376$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$111);
                    }
                }
            }
            flags & 64 && $236e632e8c7b0376$var$commitClassCallbacks(finishedWork);
            flags & 512 && $236e632e8c7b0376$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $236e632e8c7b0376$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                finishedRoot = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        finishedRoot = finishedWork.child.stateNode;
                        break;
                    case 1:
                        finishedRoot = finishedWork.child.stateNode;
                }
                try {
                    $236e632e8c7b0376$var$commitCallbacks(flags, finishedRoot);
                } catch (error) {
                    $236e632e8c7b0376$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 26:
            $236e632e8c7b0376$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $236e632e8c7b0376$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 27:
        case 5:
            $236e632e8c7b0376$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $236e632e8c7b0376$var$commitHostMount(finishedWork);
            flags & 512 && $236e632e8c7b0376$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $236e632e8c7b0376$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $236e632e8c7b0376$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $236e632e8c7b0376$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 22:
            prevProps = null !== finishedWork.memoizedState || $236e632e8c7b0376$var$offscreenSubtreeIsHidden;
            if (!prevProps) {
                current = null !== current && null !== current.memoizedState || $236e632e8c7b0376$var$offscreenSubtreeWasHidden;
                var prevOffscreenSubtreeIsHidden = $236e632e8c7b0376$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $236e632e8c7b0376$var$offscreenSubtreeWasHidden;
                $236e632e8c7b0376$var$offscreenSubtreeIsHidden = prevProps;
                ($236e632e8c7b0376$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $236e632e8c7b0376$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $236e632e8c7b0376$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $236e632e8c7b0376$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                $236e632e8c7b0376$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? $236e632e8c7b0376$var$safelyAttachRef(finishedWork, finishedWork.return) : $236e632e8c7b0376$var$safelyDetachRef(finishedWork, finishedWork.return));
            break;
        default:
            $236e632e8c7b0376$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $236e632e8c7b0376$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $236e632e8c7b0376$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $236e632e8c7b0376$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $236e632e8c7b0376$var$hostParent = null, $236e632e8c7b0376$var$hostParentIsContainer = !1;
function $236e632e8c7b0376$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$236e632e8c7b0376$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $236e632e8c7b0376$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($236e632e8c7b0376$var$injectedHook && "function" === typeof $236e632e8c7b0376$var$injectedHook.onCommitFiberUnmount) try {
        $236e632e8c7b0376$var$injectedHook.onCommitFiberUnmount($236e632e8c7b0376$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $236e632e8c7b0376$var$offscreenSubtreeWasHidden || $236e632e8c7b0376$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $236e632e8c7b0376$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $236e632e8c7b0376$var$offscreenSubtreeWasHidden || $236e632e8c7b0376$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $236e632e8c7b0376$var$hostParent, prevHostParentIsContainer = $236e632e8c7b0376$var$hostParentIsContainer;
            $236e632e8c7b0376$var$hostParent = deletedFiber.stateNode;
            $236e632e8c7b0376$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber = deletedFiber.stateNode;
            for(nearestMountedAncestor = deletedFiber.attributes; nearestMountedAncestor.length;)deletedFiber.removeAttributeNode(nearestMountedAncestor[0]);
            $236e632e8c7b0376$var$detachDeletedInstance(deletedFiber);
            $236e632e8c7b0376$var$hostParent = prevHostParent;
            $236e632e8c7b0376$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $236e632e8c7b0376$var$offscreenSubtreeWasHidden || $236e632e8c7b0376$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParentIsContainer = $236e632e8c7b0376$var$hostParent;
            var prevHostParentIsContainer$119 = $236e632e8c7b0376$var$hostParentIsContainer;
            $236e632e8c7b0376$var$hostParent = null;
            $236e632e8c7b0376$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $236e632e8c7b0376$var$hostParent = prevHostParentIsContainer;
            $236e632e8c7b0376$var$hostParentIsContainer = prevHostParentIsContainer$119;
            if (null !== $236e632e8c7b0376$var$hostParent) {
                if ($236e632e8c7b0376$var$hostParentIsContainer) try {
                    finishedRoot = $236e632e8c7b0376$var$hostParent, prevHostParent = deletedFiber.stateNode, 8 === finishedRoot.nodeType ? finishedRoot.parentNode.removeChild(prevHostParent) : finishedRoot.removeChild(prevHostParent);
                } catch (error) {
                    $236e632e8c7b0376$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $236e632e8c7b0376$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $236e632e8c7b0376$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $236e632e8c7b0376$var$hostParent && ($236e632e8c7b0376$var$hostParentIsContainer ? (nearestMountedAncestor = $236e632e8c7b0376$var$hostParent, deletedFiber = deletedFiber.stateNode, 8 === nearestMountedAncestor.nodeType ? $236e632e8c7b0376$var$clearSuspenseBoundary(nearestMountedAncestor.parentNode, deletedFiber) : 1 === nearestMountedAncestor.nodeType && $236e632e8c7b0376$var$clearSuspenseBoundary(nearestMountedAncestor, deletedFiber), $236e632e8c7b0376$var$retryIfBlockedOn(nearestMountedAncestor)) : $236e632e8c7b0376$var$clearSuspenseBoundary($236e632e8c7b0376$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $236e632e8c7b0376$var$hostParent;
            prevHostParentIsContainer = $236e632e8c7b0376$var$hostParentIsContainer;
            $236e632e8c7b0376$var$hostParent = deletedFiber.stateNode.containerInfo;
            $236e632e8c7b0376$var$hostParentIsContainer = !0;
            $236e632e8c7b0376$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $236e632e8c7b0376$var$hostParent = prevHostParent;
            $236e632e8c7b0376$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $236e632e8c7b0376$var$offscreenSubtreeWasHidden || $236e632e8c7b0376$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $236e632e8c7b0376$var$offscreenSubtreeWasHidden || $236e632e8c7b0376$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $236e632e8c7b0376$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $236e632e8c7b0376$var$offscreenSubtreeWasHidden || ($236e632e8c7b0376$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $236e632e8c7b0376$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $236e632e8c7b0376$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $236e632e8c7b0376$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $236e632e8c7b0376$var$offscreenSubtreeWasHidden || $236e632e8c7b0376$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $236e632e8c7b0376$var$offscreenSubtreeWasHidden = (prevHostParent = $236e632e8c7b0376$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $236e632e8c7b0376$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $236e632e8c7b0376$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $236e632e8c7b0376$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $236e632e8c7b0376$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $236e632e8c7b0376$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $236e632e8c7b0376$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $236e632e8c7b0376$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $236e632e8c7b0376$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $236e632e8c7b0376$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($236e632e8c7b0376$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $236e632e8c7b0376$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $236e632e8c7b0376$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $236e632e8c7b0376$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $236e632e8c7b0376$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                case 5:
                    $236e632e8c7b0376$var$hostParent = parent.stateNode;
                    $236e632e8c7b0376$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                    $236e632e8c7b0376$var$hostParent = parent.stateNode.containerInfo;
                    $236e632e8c7b0376$var$hostParentIsContainer = !0;
                    break a;
                case 4:
                    $236e632e8c7b0376$var$hostParent = parent.stateNode.containerInfo;
                    $236e632e8c7b0376$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $236e632e8c7b0376$var$hostParent) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(160));
        $236e632e8c7b0376$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $236e632e8c7b0376$var$hostParent = null;
        $236e632e8c7b0376$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$236e632e8c7b0376$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $236e632e8c7b0376$var$currentHoistableRoot = null;
function $236e632e8c7b0376$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $236e632e8c7b0376$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $236e632e8c7b0376$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($236e632e8c7b0376$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $236e632e8c7b0376$var$commitHookEffectListMount(3, finishedWork), $236e632e8c7b0376$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $236e632e8c7b0376$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $236e632e8c7b0376$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($236e632e8c7b0376$var$offscreenSubtreeWasHidden || null === current || $236e632e8c7b0376$var$safelyDetachRef(current, current.return));
            flags & 64 && $236e632e8c7b0376$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $236e632e8c7b0376$var$currentHoistableRoot;
            $236e632e8c7b0376$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $236e632e8c7b0376$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($236e632e8c7b0376$var$offscreenSubtreeWasHidden || null === current || $236e632e8c7b0376$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$236e632e8c7b0376$var$internalHoistableMarker] || currentResource[$236e632e8c7b0376$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $236e632e8c7b0376$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$236e632e8c7b0376$var$internalInstanceKey] = finishedWork;
                                        $236e632e8c7b0376$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $236e632e8c7b0376$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $236e632e8c7b0376$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $236e632e8c7b0376$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $236e632e8c7b0376$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($236e632e8c7b0376$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$236e632e8c7b0376$var$internalInstanceKey] = finishedWork;
                                $236e632e8c7b0376$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $236e632e8c7b0376$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $236e632e8c7b0376$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $236e632e8c7b0376$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $236e632e8c7b0376$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $236e632e8c7b0376$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            if (flags & 4 && null === finishedWork.alternate) {
                hoistableRoot = finishedWork.stateNode;
                currentResource = finishedWork.memoizedProps;
                try {
                    for(var node = hoistableRoot.firstChild; node;){
                        var nextNode = node.nextSibling, nodeName = node.nodeName;
                        node[$236e632e8c7b0376$var$internalHoistableMarker] || "HEAD" === nodeName || "BODY" === nodeName || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node.rel.toLowerCase() || hoistableRoot.removeChild(node);
                        node = nextNode;
                    }
                    for(var type = finishedWork.type, attributes = hoistableRoot.attributes; attributes.length;)hoistableRoot.removeAttributeNode(attributes[0]);
                    $236e632e8c7b0376$var$setInitialProperties(hoistableRoot, type, currentResource);
                    hoistableRoot[$236e632e8c7b0376$var$internalInstanceKey] = finishedWork;
                    hoistableRoot[$236e632e8c7b0376$var$internalPropsKey] = currentResource;
                } catch (error) {
                    $236e632e8c7b0376$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
        case 5:
            $236e632e8c7b0376$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $236e632e8c7b0376$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($236e632e8c7b0376$var$offscreenSubtreeWasHidden || null === current || $236e632e8c7b0376$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $236e632e8c7b0376$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $236e632e8c7b0376$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $236e632e8c7b0376$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($236e632e8c7b0376$var$needsFormReset = !0);
            break;
        case 6:
            $236e632e8c7b0376$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $236e632e8c7b0376$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $236e632e8c7b0376$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $236e632e8c7b0376$var$tagCaches = null;
            hoistableRoot = $236e632e8c7b0376$var$currentHoistableRoot;
            $236e632e8c7b0376$var$currentHoistableRoot = $236e632e8c7b0376$var$getHoistableRoot(root.containerInfo);
            $236e632e8c7b0376$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $236e632e8c7b0376$var$currentHoistableRoot = hoistableRoot;
            $236e632e8c7b0376$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $236e632e8c7b0376$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $236e632e8c7b0376$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $236e632e8c7b0376$var$needsFormReset && ($236e632e8c7b0376$var$needsFormReset = !1, $236e632e8c7b0376$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $236e632e8c7b0376$var$currentHoistableRoot;
            $236e632e8c7b0376$var$currentHoistableRoot = $236e632e8c7b0376$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $236e632e8c7b0376$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $236e632e8c7b0376$var$commitReconciliationEffects(finishedWork);
            $236e632e8c7b0376$var$currentHoistableRoot = flags;
            break;
        case 12:
            $236e632e8c7b0376$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $236e632e8c7b0376$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $236e632e8c7b0376$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $236e632e8c7b0376$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($236e632e8c7b0376$var$globalMostRecentFallbackTime = $236e632e8c7b0376$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $236e632e8c7b0376$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            flags & 512 && ($236e632e8c7b0376$var$offscreenSubtreeWasHidden || null === current || $236e632e8c7b0376$var$safelyDetachRef(current, current.return));
            node = null !== finishedWork.memoizedState;
            nextNode = null !== current && null !== current.memoizedState;
            nodeName = $236e632e8c7b0376$var$offscreenSubtreeIsHidden;
            type = $236e632e8c7b0376$var$offscreenSubtreeWasHidden;
            $236e632e8c7b0376$var$offscreenSubtreeIsHidden = nodeName || node;
            $236e632e8c7b0376$var$offscreenSubtreeWasHidden = type || nextNode;
            $236e632e8c7b0376$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $236e632e8c7b0376$var$offscreenSubtreeWasHidden = type;
            $236e632e8c7b0376$var$offscreenSubtreeIsHidden = nodeName;
            $236e632e8c7b0376$var$commitReconciliationEffects(finishedWork);
            root = finishedWork.stateNode;
            root._current = finishedWork;
            root._visibility &= -3;
            root._visibility |= root._pendingVisibility & 2;
            if (flags & 8192 && (root._visibility = node ? root._visibility & -2 : root._visibility | 1, node && (root = $236e632e8c7b0376$var$offscreenSubtreeIsHidden || $236e632e8c7b0376$var$offscreenSubtreeWasHidden, null === current || nextNode || root || $236e632e8c7b0376$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode)) a: for(current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag || 27 === root.tag) {
                    if (null === current) {
                        nextNode = current = root;
                        try {
                            if (hoistableRoot = nextNode.stateNode, node) currentResource = hoistableRoot.style, "function" === typeof currentResource.setProperty ? currentResource.setProperty("display", "none", "important") : currentResource.display = "none";
                            else {
                                maybeNodes = nextNode.stateNode;
                                i = nextNode.memoizedProps.style;
                                var display = void 0 !== i && null !== i && i.hasOwnProperty("display") ? i.display : null;
                                maybeNodes.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $236e632e8c7b0376$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        nextNode = root;
                        try {
                            nextNode.stateNode.nodeValue = node ? "" : nextNode.memoizedProps;
                        } catch (error) {
                            $236e632e8c7b0376$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $236e632e8c7b0376$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $236e632e8c7b0376$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $236e632e8c7b0376$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $236e632e8c7b0376$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 21:
            break;
        default:
            $236e632e8c7b0376$var$recursivelyTraverseMutationEffects(root, finishedWork), $236e632e8c7b0376$var$commitReconciliationEffects(finishedWork);
    }
}
function $236e632e8c7b0376$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            if (27 !== finishedWork.tag) {
                a: {
                    for(var parent = finishedWork.return; null !== parent;){
                        if ($236e632e8c7b0376$var$isHostParent(parent)) {
                            var JSCompiler_inline_result = parent;
                            break a;
                        }
                        parent = parent.return;
                    }
                    throw Error($236e632e8c7b0376$var$formatProdErrorMessage(160));
                }
                switch(JSCompiler_inline_result.tag){
                    case 27:
                        var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = $236e632e8c7b0376$var$getHostSibling(finishedWork);
                        $236e632e8c7b0376$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                        break;
                    case 5:
                        var parent$113 = JSCompiler_inline_result.stateNode;
                        JSCompiler_inline_result.flags & 32 && ($236e632e8c7b0376$var$setTextContent(parent$113, ""), JSCompiler_inline_result.flags &= -33);
                        var before$114 = $236e632e8c7b0376$var$getHostSibling(finishedWork);
                        $236e632e8c7b0376$var$insertOrAppendPlacementNode(finishedWork, before$114, parent$113);
                        break;
                    case 3:
                    case 4:
                        var parent$115 = JSCompiler_inline_result.stateNode.containerInfo, before$116 = $236e632e8c7b0376$var$getHostSibling(finishedWork);
                        $236e632e8c7b0376$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$116, parent$115);
                        break;
                    default:
                        throw Error($236e632e8c7b0376$var$formatProdErrorMessage(161));
                }
            }
        } catch (error) {
            $236e632e8c7b0376$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $236e632e8c7b0376$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $236e632e8c7b0376$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $236e632e8c7b0376$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$236e632e8c7b0376$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $236e632e8c7b0376$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $236e632e8c7b0376$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $236e632e8c7b0376$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $236e632e8c7b0376$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $236e632e8c7b0376$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $236e632e8c7b0376$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 26:
            case 27:
            case 5:
                $236e632e8c7b0376$var$safelyDetachRef(finishedWork, finishedWork.return);
                $236e632e8c7b0376$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                $236e632e8c7b0376$var$safelyDetachRef(finishedWork, finishedWork.return);
                null === finishedWork.memoizedState && $236e632e8c7b0376$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $236e632e8c7b0376$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $236e632e8c7b0376$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $236e632e8c7b0376$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $236e632e8c7b0376$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $236e632e8c7b0376$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $236e632e8c7b0376$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$236e632e8c7b0376$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $236e632e8c7b0376$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $236e632e8c7b0376$var$commitClassCallbacks(finishedWork);
                $236e632e8c7b0376$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 26:
            case 27:
            case 5:
                $236e632e8c7b0376$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $236e632e8c7b0376$var$commitHostMount(finishedWork);
                $236e632e8c7b0376$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $236e632e8c7b0376$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $236e632e8c7b0376$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $236e632e8c7b0376$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $236e632e8c7b0376$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $236e632e8c7b0376$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            default:
                $236e632e8c7b0376$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $236e632e8c7b0376$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $236e632e8c7b0376$var$releaseCache(previousCache));
}
function $236e632e8c7b0376$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $236e632e8c7b0376$var$releaseCache(current));
}
function $236e632e8c7b0376$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$236e632e8c7b0376$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $236e632e8c7b0376$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $236e632e8c7b0376$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $236e632e8c7b0376$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 3:
            $236e632e8c7b0376$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $236e632e8c7b0376$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $236e632e8c7b0376$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $236e632e8c7b0376$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $236e632e8c7b0376$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? $236e632e8c7b0376$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $236e632e8c7b0376$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? $236e632e8c7b0376$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, $236e632e8c7b0376$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $236e632e8c7b0376$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
            break;
        case 24:
            $236e632e8c7b0376$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $236e632e8c7b0376$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $236e632e8c7b0376$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $236e632e8c7b0376$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $236e632e8c7b0376$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $236e632e8c7b0376$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 4 ? $236e632e8c7b0376$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $236e632e8c7b0376$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, $236e632e8c7b0376$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $236e632e8c7b0376$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $236e632e8c7b0376$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $236e632e8c7b0376$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $236e632e8c7b0376$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $236e632e8c7b0376$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $236e632e8c7b0376$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $236e632e8c7b0376$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $236e632e8c7b0376$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $236e632e8c7b0376$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $236e632e8c7b0376$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $236e632e8c7b0376$var$suspenseyCommitFlag = 8192;
function $236e632e8c7b0376$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $236e632e8c7b0376$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$236e632e8c7b0376$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $236e632e8c7b0376$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $236e632e8c7b0376$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $236e632e8c7b0376$var$suspenseyCommitFlag && null !== fiber.memoizedState && $236e632e8c7b0376$var$suspendResource($236e632e8c7b0376$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $236e632e8c7b0376$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $236e632e8c7b0376$var$currentHoistableRoot;
            $236e632e8c7b0376$var$currentHoistableRoot = $236e632e8c7b0376$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $236e632e8c7b0376$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $236e632e8c7b0376$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $236e632e8c7b0376$var$suspenseyCommitFlag, $236e632e8c7b0376$var$suspenseyCommitFlag = 16777216, $236e632e8c7b0376$var$recursivelyAccumulateSuspenseyCommit(fiber), $236e632e8c7b0376$var$suspenseyCommitFlag = previousHoistableRoot) : $236e632e8c7b0376$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $236e632e8c7b0376$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $236e632e8c7b0376$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $236e632e8c7b0376$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $236e632e8c7b0376$var$nextEffect = childToDelete;
            $236e632e8c7b0376$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $236e632e8c7b0376$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$236e632e8c7b0376$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $236e632e8c7b0376$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $236e632e8c7b0376$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $236e632e8c7b0376$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $236e632e8c7b0376$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $236e632e8c7b0376$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, $236e632e8c7b0376$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $236e632e8c7b0376$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $236e632e8c7b0376$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $236e632e8c7b0376$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $236e632e8c7b0376$var$nextEffect = childToDelete;
            $236e632e8c7b0376$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $236e632e8c7b0376$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $236e632e8c7b0376$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $236e632e8c7b0376$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 4 && (i._visibility &= -5, $236e632e8c7b0376$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $236e632e8c7b0376$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $236e632e8c7b0376$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $236e632e8c7b0376$var$nextEffect;){
        var fiber = $236e632e8c7b0376$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $236e632e8c7b0376$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $236e632e8c7b0376$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $236e632e8c7b0376$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $236e632e8c7b0376$var$nextEffect;){
            cache = $236e632e8c7b0376$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $236e632e8c7b0376$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $236e632e8c7b0376$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $236e632e8c7b0376$var$nextEffect = sibling;
                break a;
            }
            $236e632e8c7b0376$var$nextEffect = returnFiber;
        }
    }
}
function $236e632e8c7b0376$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $236e632e8c7b0376$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $236e632e8c7b0376$var$FiberNode(tag, pendingProps, key, mode);
}
function $236e632e8c7b0376$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $236e632e8c7b0376$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $236e632e8c7b0376$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 31457280;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $236e632e8c7b0376$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 31457282;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $236e632e8c7b0376$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $236e632e8c7b0376$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $236e632e8c7b0376$var$isHostHoistableType(type, pendingProps, $236e632e8c7b0376$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $236e632e8c7b0376$var$REACT_FRAGMENT_TYPE:
            return $236e632e8c7b0376$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $236e632e8c7b0376$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $236e632e8c7b0376$var$REACT_PROFILER_TYPE:
            return type = $236e632e8c7b0376$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $236e632e8c7b0376$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $236e632e8c7b0376$var$REACT_SUSPENSE_TYPE:
            return type = $236e632e8c7b0376$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $236e632e8c7b0376$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $236e632e8c7b0376$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $236e632e8c7b0376$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $236e632e8c7b0376$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $236e632e8c7b0376$var$REACT_OFFSCREEN_TYPE:
            return $236e632e8c7b0376$var$createFiberFromOffscreen(pendingProps, mode, lanes, key);
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $236e632e8c7b0376$var$REACT_PROVIDER_TYPE:
                case $236e632e8c7b0376$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $236e632e8c7b0376$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $236e632e8c7b0376$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $236e632e8c7b0376$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $236e632e8c7b0376$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($236e632e8c7b0376$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $236e632e8c7b0376$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $236e632e8c7b0376$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $236e632e8c7b0376$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $236e632e8c7b0376$var$createFiberFromOffscreen(pendingProps, mode, lanes, key) {
    pendingProps = $236e632e8c7b0376$var$createFiberImplClass(22, pendingProps, key, mode);
    pendingProps.elementType = $236e632e8c7b0376$var$REACT_OFFSCREEN_TYPE;
    pendingProps.lanes = lanes;
    var primaryChildInstance = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(456));
            if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                var root = $236e632e8c7b0376$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility |= 2, $236e632e8c7b0376$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        },
        attach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(456));
            if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                var root = $236e632e8c7b0376$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility &= -3, $236e632e8c7b0376$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        }
    };
    pendingProps.stateNode = primaryChildInstance;
    return pendingProps;
}
function $236e632e8c7b0376$var$createFiberFromText(content, mode, lanes) {
    content = $236e632e8c7b0376$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $236e632e8c7b0376$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $236e632e8c7b0376$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
function $236e632e8c7b0376$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $236e632e8c7b0376$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$236e632e8c7b0376$var$preloadResource(resource)) {
        resource = $236e632e8c7b0376$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($236e632e8c7b0376$var$workInProgressRootRenderLanes & 4194176) === $236e632e8c7b0376$var$workInProgressRootRenderLanes ? null !== $236e632e8c7b0376$var$shellBoundary : ($236e632e8c7b0376$var$workInProgressRootRenderLanes & 62914560) !== $236e632e8c7b0376$var$workInProgressRootRenderLanes && 0 === ($236e632e8c7b0376$var$workInProgressRootRenderLanes & 536870912) || resource !== $236e632e8c7b0376$var$shellBoundary)) throw $236e632e8c7b0376$var$suspendedThenable = $236e632e8c7b0376$var$noopSuspenseyCommitThenable, $236e632e8c7b0376$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $236e632e8c7b0376$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $236e632e8c7b0376$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $236e632e8c7b0376$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $236e632e8c7b0376$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$236e632e8c7b0376$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$131 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$131 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$131 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$131.sibling = null;
    }
}
function $236e632e8c7b0376$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags & 31457280, subtreeFlags |= child$132.flags & 31457280, child$132.return = completedWork, child$132 = child$132.sibling;
    else for(child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags, subtreeFlags |= child$132.flags, child$132.return = completedWork, child$132 = child$132.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $236e632e8c7b0376$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $236e632e8c7b0376$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $236e632e8c7b0376$var$bubbleProperties(workInProgress), null;
        case 1:
            return $236e632e8c7b0376$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $236e632e8c7b0376$var$popProvider($236e632e8c7b0376$var$CacheContext);
            $236e632e8c7b0376$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $236e632e8c7b0376$var$popHydrationState(workInProgress) ? $236e632e8c7b0376$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== $236e632e8c7b0376$var$hydrationErrors && ($236e632e8c7b0376$var$queueRecoverableErrors($236e632e8c7b0376$var$hydrationErrors), $236e632e8c7b0376$var$hydrationErrors = null));
            $236e632e8c7b0376$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($236e632e8c7b0376$var$markUpdate(workInProgress), null !== renderLanes ? ($236e632e8c7b0376$var$bubbleProperties(workInProgress), $236e632e8c7b0376$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($236e632e8c7b0376$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($236e632e8c7b0376$var$markUpdate(workInProgress), $236e632e8c7b0376$var$bubbleProperties(workInProgress), $236e632e8c7b0376$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($236e632e8c7b0376$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $236e632e8c7b0376$var$markUpdate(workInProgress), $236e632e8c7b0376$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $236e632e8c7b0376$var$popHostContext(workInProgress);
            renderLanes = $236e632e8c7b0376$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $236e632e8c7b0376$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(166));
                    $236e632e8c7b0376$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $236e632e8c7b0376$var$contextStackCursor.current;
                $236e632e8c7b0376$var$popHydrationState(workInProgress) ? $236e632e8c7b0376$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $236e632e8c7b0376$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $236e632e8c7b0376$var$markUpdate(workInProgress));
            }
            $236e632e8c7b0376$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $236e632e8c7b0376$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $236e632e8c7b0376$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(166));
                    $236e632e8c7b0376$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $236e632e8c7b0376$var$contextStackCursor.current;
                if ($236e632e8c7b0376$var$popHydrationState(workInProgress)) $236e632e8c7b0376$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $236e632e8c7b0376$var$getOwnerDocumentFromRootContainer($236e632e8c7b0376$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$236e632e8c7b0376$var$internalInstanceKey] = workInProgress;
                    current[$236e632e8c7b0376$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($236e632e8c7b0376$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $236e632e8c7b0376$var$markUpdate(workInProgress);
                }
            }
            $236e632e8c7b0376$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $236e632e8c7b0376$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(166));
                current = $236e632e8c7b0376$var$rootInstanceStackCursor.current;
                if ($236e632e8c7b0376$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $236e632e8c7b0376$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$236e632e8c7b0376$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $236e632e8c7b0376$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $236e632e8c7b0376$var$throwOnHydrationMismatch(workInProgress);
                } else current = $236e632e8c7b0376$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$236e632e8c7b0376$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $236e632e8c7b0376$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $236e632e8c7b0376$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(317));
                        type[$236e632e8c7b0376$var$internalInstanceKey] = workInProgress;
                    } else $236e632e8c7b0376$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $236e632e8c7b0376$var$bubbleProperties(workInProgress);
                    type = !1;
                } else null !== $236e632e8c7b0376$var$hydrationErrors && ($236e632e8c7b0376$var$queueRecoverableErrors($236e632e8c7b0376$var$hydrationErrors), $236e632e8c7b0376$var$hydrationErrors = null), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $236e632e8c7b0376$var$popSuspenseHandler(workInProgress), workInProgress;
                    $236e632e8c7b0376$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $236e632e8c7b0376$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$144 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$144 = newProps.memoizedState.cachePool.pool);
                cache$144 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $236e632e8c7b0376$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $236e632e8c7b0376$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $236e632e8c7b0376$var$popHostContainer(), null === current && $236e632e8c7b0376$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $236e632e8c7b0376$var$bubbleProperties(workInProgress), null;
        case 10:
            return $236e632e8c7b0376$var$popProvider(workInProgress.type), $236e632e8c7b0376$var$bubbleProperties(workInProgress), null;
        case 19:
            $236e632e8c7b0376$var$pop($236e632e8c7b0376$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $236e632e8c7b0376$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$144 = type.rendering;
            if (null === cache$144) {
                if (newProps) $236e632e8c7b0376$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $236e632e8c7b0376$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$144 = $236e632e8c7b0376$var$findFirstSuspended(current);
                        if (null !== cache$144) {
                            workInProgress.flags |= 128;
                            $236e632e8c7b0376$var$cutOffTailIfNeeded(type, !1);
                            current = cache$144.updateQueue;
                            workInProgress.updateQueue = current;
                            $236e632e8c7b0376$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$236e632e8c7b0376$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $236e632e8c7b0376$var$push($236e632e8c7b0376$var$suspenseStackCursor, $236e632e8c7b0376$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $236e632e8c7b0376$var$now() > $236e632e8c7b0376$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $236e632e8c7b0376$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $236e632e8c7b0376$var$findFirstSuspended(cache$144), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $236e632e8c7b0376$var$scheduleRetryEffect(workInProgress, current), $236e632e8c7b0376$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$144.alternate && !$236e632e8c7b0376$var$isHydrating) return $236e632e8c7b0376$var$bubbleProperties(workInProgress), null;
                    } else 2 * $236e632e8c7b0376$var$now() - type.renderingStartTime > $236e632e8c7b0376$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $236e632e8c7b0376$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$144.sibling = workInProgress.child, workInProgress.child = cache$144) : (current = type.last, null !== current ? current.sibling = cache$144 : workInProgress.child = cache$144, type.last = cache$144);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $236e632e8c7b0376$var$now(), workInProgress.sibling = null, current = $236e632e8c7b0376$var$suspenseStackCursor.current, $236e632e8c7b0376$var$push($236e632e8c7b0376$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $236e632e8c7b0376$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $236e632e8c7b0376$var$popSuspenseHandler(workInProgress), $236e632e8c7b0376$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($236e632e8c7b0376$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $236e632e8c7b0376$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $236e632e8c7b0376$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $236e632e8c7b0376$var$pop($236e632e8c7b0376$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $236e632e8c7b0376$var$popProvider($236e632e8c7b0376$var$CacheContext), $236e632e8c7b0376$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
    }
    throw Error($236e632e8c7b0376$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $236e632e8c7b0376$var$unwindWork(current, workInProgress) {
    $236e632e8c7b0376$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $236e632e8c7b0376$var$popProvider($236e632e8c7b0376$var$CacheContext), $236e632e8c7b0376$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $236e632e8c7b0376$var$popHostContext(workInProgress), null;
        case 13:
            $236e632e8c7b0376$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(340));
                $236e632e8c7b0376$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $236e632e8c7b0376$var$pop($236e632e8c7b0376$var$suspenseStackCursor), null;
        case 4:
            return $236e632e8c7b0376$var$popHostContainer(), null;
        case 10:
            return $236e632e8c7b0376$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $236e632e8c7b0376$var$popSuspenseHandler(workInProgress), $236e632e8c7b0376$var$popHiddenContext(), null !== current && $236e632e8c7b0376$var$pop($236e632e8c7b0376$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $236e632e8c7b0376$var$popProvider($236e632e8c7b0376$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $236e632e8c7b0376$var$unwindInterruptedWork(current, interruptedWork) {
    $236e632e8c7b0376$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $236e632e8c7b0376$var$popProvider($236e632e8c7b0376$var$CacheContext);
            $236e632e8c7b0376$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $236e632e8c7b0376$var$popHostContext(interruptedWork);
            break;
        case 4:
            $236e632e8c7b0376$var$popHostContainer();
            break;
        case 13:
            $236e632e8c7b0376$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $236e632e8c7b0376$var$pop($236e632e8c7b0376$var$suspenseStackCursor);
            break;
        case 10:
            $236e632e8c7b0376$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $236e632e8c7b0376$var$popSuspenseHandler(interruptedWork);
            $236e632e8c7b0376$var$popHiddenContext();
            null !== current && $236e632e8c7b0376$var$pop($236e632e8c7b0376$var$resumedCache);
            break;
        case 24:
            $236e632e8c7b0376$var$popProvider($236e632e8c7b0376$var$CacheContext);
    }
}
var $236e632e8c7b0376$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $236e632e8c7b0376$var$readContext($236e632e8c7b0376$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $236e632e8c7b0376$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $236e632e8c7b0376$var$executionContext = 0, $236e632e8c7b0376$var$workInProgressRoot = null, $236e632e8c7b0376$var$workInProgress = null, $236e632e8c7b0376$var$workInProgressRootRenderLanes = 0, $236e632e8c7b0376$var$workInProgressSuspendedReason = 0, $236e632e8c7b0376$var$workInProgressThrownValue = null, $236e632e8c7b0376$var$workInProgressRootDidSkipSuspendedSiblings = !1, $236e632e8c7b0376$var$workInProgressRootIsPrerendering = !1, $236e632e8c7b0376$var$workInProgressRootDidAttachPingListener = !1, $236e632e8c7b0376$var$entangledRenderLanes = 0, $236e632e8c7b0376$var$workInProgressRootExitStatus = 0, $236e632e8c7b0376$var$workInProgressRootSkippedLanes = 0, $236e632e8c7b0376$var$workInProgressRootInterleavedUpdatedLanes = 0, $236e632e8c7b0376$var$workInProgressRootPingedLanes = 0, $236e632e8c7b0376$var$workInProgressDeferredLane = 0, $236e632e8c7b0376$var$workInProgressSuspendedRetryLanes = 0, $236e632e8c7b0376$var$workInProgressRootConcurrentErrors = null, $236e632e8c7b0376$var$workInProgressRootRecoverableErrors = null, $236e632e8c7b0376$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $236e632e8c7b0376$var$globalMostRecentFallbackTime = 0, $236e632e8c7b0376$var$workInProgressRootRenderTargetTime = Infinity, $236e632e8c7b0376$var$workInProgressTransitions = null, $236e632e8c7b0376$var$legacyErrorBoundariesThatAlreadyFailed = null, $236e632e8c7b0376$var$rootDoesHavePassiveEffects = !1, $236e632e8c7b0376$var$rootWithPendingPassiveEffects = null, $236e632e8c7b0376$var$pendingPassiveEffectsLanes = 0, $236e632e8c7b0376$var$pendingPassiveEffectsRemainingLanes = 0, $236e632e8c7b0376$var$pendingPassiveTransitions = null, $236e632e8c7b0376$var$nestedUpdateCount = 0, $236e632e8c7b0376$var$rootWithNestedUpdates = null;
function $236e632e8c7b0376$var$requestUpdateLane() {
    if (0 !== ($236e632e8c7b0376$var$executionContext & 2) && 0 !== $236e632e8c7b0376$var$workInProgressRootRenderLanes) return $236e632e8c7b0376$var$workInProgressRootRenderLanes & -$236e632e8c7b0376$var$workInProgressRootRenderLanes;
    if (null !== $236e632e8c7b0376$var$ReactSharedInternals.T) {
        var actionScopeLane = $236e632e8c7b0376$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $236e632e8c7b0376$var$requestTransitionLane();
    }
    return $236e632e8c7b0376$var$resolveUpdatePriority();
}
function $236e632e8c7b0376$var$requestDeferredLane() {
    0 === $236e632e8c7b0376$var$workInProgressDeferredLane && ($236e632e8c7b0376$var$workInProgressDeferredLane = 0 === ($236e632e8c7b0376$var$workInProgressRootRenderLanes & 536870912) || $236e632e8c7b0376$var$isHydrating ? $236e632e8c7b0376$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $236e632e8c7b0376$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $236e632e8c7b0376$var$workInProgressDeferredLane;
}
function $236e632e8c7b0376$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $236e632e8c7b0376$var$workInProgressRoot && 2 === $236e632e8c7b0376$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) $236e632e8c7b0376$var$prepareFreshStack(root, 0), $236e632e8c7b0376$var$markRootSuspended(root, $236e632e8c7b0376$var$workInProgressRootRenderLanes, $236e632e8c7b0376$var$workInProgressDeferredLane, !1);
    $236e632e8c7b0376$var$markRootUpdated$1(root, lane);
    if (0 === ($236e632e8c7b0376$var$executionContext & 2) || root !== $236e632e8c7b0376$var$workInProgressRoot) root === $236e632e8c7b0376$var$workInProgressRoot && (0 === ($236e632e8c7b0376$var$executionContext & 2) && ($236e632e8c7b0376$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $236e632e8c7b0376$var$workInProgressRootExitStatus && $236e632e8c7b0376$var$markRootSuspended(root, $236e632e8c7b0376$var$workInProgressRootRenderLanes, $236e632e8c7b0376$var$workInProgressDeferredLane, !1)), $236e632e8c7b0376$var$ensureRootIsScheduled(root);
}
function $236e632e8c7b0376$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($236e632e8c7b0376$var$executionContext & 6)) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || $236e632e8c7b0376$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $236e632e8c7b0376$var$renderRootConcurrent(root$jscomp$0, lanes) : $236e632e8c7b0376$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $236e632e8c7b0376$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $236e632e8c7b0376$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else if (6 === exitStatus) $236e632e8c7b0376$var$markRootSuspended(root$jscomp$0, lanes, 0, !$236e632e8c7b0376$var$workInProgressRootDidSkipSuspendedSiblings);
        else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$236e632e8c7b0376$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $236e632e8c7b0376$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $236e632e8c7b0376$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($236e632e8c7b0376$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $236e632e8c7b0376$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($236e632e8c7b0376$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $236e632e8c7b0376$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $236e632e8c7b0376$var$workInProgressRootRecoverableErrors;
                            $236e632e8c7b0376$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && $236e632e8c7b0376$var$queueRecoverableErrors(renderWasConcurrent);
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $236e632e8c7b0376$var$prepareFreshStack(root$jscomp$0, 0);
                $236e632e8c7b0376$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                switch(exitStatus){
                    case 0:
                    case 1:
                        throw Error($236e632e8c7b0376$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194176) === lanes) {
                            $236e632e8c7b0376$var$markRootSuspended(shouldTimeSlice, lanes, $236e632e8c7b0376$var$workInProgressDeferredLane, !$236e632e8c7b0376$var$workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        }
                        break;
                    case 2:
                        $236e632e8c7b0376$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($236e632e8c7b0376$var$formatProdErrorMessage(329));
                }
                shouldTimeSlice.finishedWork = forceSync;
                shouldTimeSlice.finishedLanes = lanes;
                if ((lanes & 62914560) === lanes && (renderWasConcurrent = $236e632e8c7b0376$var$globalMostRecentFallbackTime + 300 - $236e632e8c7b0376$var$now(), 10 < renderWasConcurrent)) {
                    $236e632e8c7b0376$var$markRootSuspended(shouldTimeSlice, lanes, $236e632e8c7b0376$var$workInProgressDeferredLane, !$236e632e8c7b0376$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $236e632e8c7b0376$var$getNextLanes(shouldTimeSlice, 0)) break a;
                    shouldTimeSlice.timeoutHandle = $236e632e8c7b0376$var$scheduleTimeout($236e632e8c7b0376$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $236e632e8c7b0376$var$workInProgressRootRecoverableErrors, $236e632e8c7b0376$var$workInProgressTransitions, $236e632e8c7b0376$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $236e632e8c7b0376$var$workInProgressDeferredLane, $236e632e8c7b0376$var$workInProgressRootInterleavedUpdatedLanes, $236e632e8c7b0376$var$workInProgressSuspendedRetryLanes, $236e632e8c7b0376$var$workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                    break a;
                }
                $236e632e8c7b0376$var$commitRootWhenReady(shouldTimeSlice, forceSync, $236e632e8c7b0376$var$workInProgressRootRecoverableErrors, $236e632e8c7b0376$var$workInProgressTransitions, $236e632e8c7b0376$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $236e632e8c7b0376$var$workInProgressDeferredLane, $236e632e8c7b0376$var$workInProgressRootInterleavedUpdatedLanes, $236e632e8c7b0376$var$workInProgressSuspendedRetryLanes, $236e632e8c7b0376$var$workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $236e632e8c7b0376$var$ensureRootIsScheduled(root$jscomp$0);
}
function $236e632e8c7b0376$var$queueRecoverableErrors(errors) {
    null === $236e632e8c7b0376$var$workInProgressRootRecoverableErrors ? $236e632e8c7b0376$var$workInProgressRootRecoverableErrors = errors : $236e632e8c7b0376$var$workInProgressRootRecoverableErrors.push.apply($236e632e8c7b0376$var$workInProgressRootRecoverableErrors, errors);
}
function $236e632e8c7b0376$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var subtreeFlags = finishedWork.subtreeFlags;
    if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if ($236e632e8c7b0376$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $236e632e8c7b0376$var$noop
        }, $236e632e8c7b0376$var$accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = $236e632e8c7b0376$var$waitForCommitToBeReady(), null !== finishedWork) {
            root.cancelPendingCommit = finishedWork($236e632e8c7b0376$var$commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
            $236e632e8c7b0376$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $236e632e8c7b0376$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
}
function $236e632e8c7b0376$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$236e632e8c7b0376$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $236e632e8c7b0376$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$236e632e8c7b0376$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$236e632e8c7b0376$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $236e632e8c7b0376$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $236e632e8c7b0376$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $236e632e8c7b0376$var$flushSyncWork$1() {
    return 0 === ($236e632e8c7b0376$var$executionContext & 6) ? ($236e632e8c7b0376$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $236e632e8c7b0376$var$resetWorkInProgressStack() {
    if (null !== $236e632e8c7b0376$var$workInProgress) {
        if (0 === $236e632e8c7b0376$var$workInProgressSuspendedReason) var interruptedWork = $236e632e8c7b0376$var$workInProgress.return;
        else interruptedWork = $236e632e8c7b0376$var$workInProgress, $236e632e8c7b0376$var$lastContextDependency = $236e632e8c7b0376$var$currentlyRenderingFiber = null, $236e632e8c7b0376$var$resetHooksOnUnwind(interruptedWork), $236e632e8c7b0376$var$thenableState$1 = null, $236e632e8c7b0376$var$thenableIndexCounter$1 = 0, interruptedWork = $236e632e8c7b0376$var$workInProgress;
        for(; null !== interruptedWork;)$236e632e8c7b0376$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $236e632e8c7b0376$var$workInProgress = null;
    }
}
function $236e632e8c7b0376$var$prepareFreshStack(root, lanes) {
    root.finishedWork = null;
    root.finishedLanes = 0;
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $236e632e8c7b0376$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $236e632e8c7b0376$var$resetWorkInProgressStack();
    $236e632e8c7b0376$var$workInProgressRoot = root;
    $236e632e8c7b0376$var$workInProgress = timeoutHandle = $236e632e8c7b0376$var$createWorkInProgress(root.current, null);
    $236e632e8c7b0376$var$workInProgressRootRenderLanes = lanes;
    $236e632e8c7b0376$var$workInProgressSuspendedReason = 0;
    $236e632e8c7b0376$var$workInProgressThrownValue = null;
    $236e632e8c7b0376$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $236e632e8c7b0376$var$workInProgressRootIsPrerendering = $236e632e8c7b0376$var$checkIfRootIsPrerendering(root, lanes);
    $236e632e8c7b0376$var$workInProgressRootDidAttachPingListener = !1;
    $236e632e8c7b0376$var$workInProgressSuspendedRetryLanes = $236e632e8c7b0376$var$workInProgressDeferredLane = $236e632e8c7b0376$var$workInProgressRootPingedLanes = $236e632e8c7b0376$var$workInProgressRootInterleavedUpdatedLanes = $236e632e8c7b0376$var$workInProgressRootSkippedLanes = $236e632e8c7b0376$var$workInProgressRootExitStatus = 0;
    $236e632e8c7b0376$var$workInProgressRootRecoverableErrors = $236e632e8c7b0376$var$workInProgressRootConcurrentErrors = null;
    $236e632e8c7b0376$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $236e632e8c7b0376$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $236e632e8c7b0376$var$entangledRenderLanes = lanes;
    $236e632e8c7b0376$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $236e632e8c7b0376$var$handleThrow(root, thrownValue) {
    $236e632e8c7b0376$var$currentlyRenderingFiber$1 = null;
    $236e632e8c7b0376$var$ReactSharedInternals.H = $236e632e8c7b0376$var$ContextOnlyDispatcher;
    thrownValue === $236e632e8c7b0376$var$SuspenseException ? (thrownValue = $236e632e8c7b0376$var$getSuspendedThenable(), $236e632e8c7b0376$var$workInProgressSuspendedReason = 3) : thrownValue === $236e632e8c7b0376$var$SuspenseyCommitException ? (thrownValue = $236e632e8c7b0376$var$getSuspendedThenable(), $236e632e8c7b0376$var$workInProgressSuspendedReason = 4) : $236e632e8c7b0376$var$workInProgressSuspendedReason = thrownValue === $236e632e8c7b0376$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $236e632e8c7b0376$var$workInProgressThrownValue = thrownValue;
    null === $236e632e8c7b0376$var$workInProgress && ($236e632e8c7b0376$var$workInProgressRootExitStatus = 1, $236e632e8c7b0376$var$logUncaughtError(root, $236e632e8c7b0376$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $236e632e8c7b0376$var$pushDispatcher() {
    var prevDispatcher = $236e632e8c7b0376$var$ReactSharedInternals.H;
    $236e632e8c7b0376$var$ReactSharedInternals.H = $236e632e8c7b0376$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $236e632e8c7b0376$var$ContextOnlyDispatcher : prevDispatcher;
}
function $236e632e8c7b0376$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $236e632e8c7b0376$var$ReactSharedInternals.A;
    $236e632e8c7b0376$var$ReactSharedInternals.A = $236e632e8c7b0376$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $236e632e8c7b0376$var$renderDidSuspendDelayIfPossible() {
    $236e632e8c7b0376$var$workInProgressRootExitStatus = 4;
    $236e632e8c7b0376$var$workInProgressRootDidSkipSuspendedSiblings || ($236e632e8c7b0376$var$workInProgressRootRenderLanes & 4194176) !== $236e632e8c7b0376$var$workInProgressRootRenderLanes && null !== $236e632e8c7b0376$var$suspenseHandlerStackCursor.current || ($236e632e8c7b0376$var$workInProgressRootIsPrerendering = !0);
    0 === ($236e632e8c7b0376$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($236e632e8c7b0376$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $236e632e8c7b0376$var$workInProgressRoot || $236e632e8c7b0376$var$markRootSuspended($236e632e8c7b0376$var$workInProgressRoot, $236e632e8c7b0376$var$workInProgressRootRenderLanes, $236e632e8c7b0376$var$workInProgressDeferredLane, !1);
}
function $236e632e8c7b0376$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $236e632e8c7b0376$var$executionContext;
    $236e632e8c7b0376$var$executionContext |= 2;
    var prevDispatcher = $236e632e8c7b0376$var$pushDispatcher(), prevAsyncDispatcher = $236e632e8c7b0376$var$pushAsyncDispatcher();
    if ($236e632e8c7b0376$var$workInProgressRoot !== root || $236e632e8c7b0376$var$workInProgressRootRenderLanes !== lanes) $236e632e8c7b0376$var$workInProgressTransitions = null, $236e632e8c7b0376$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $236e632e8c7b0376$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $236e632e8c7b0376$var$workInProgressSuspendedReason && null !== $236e632e8c7b0376$var$workInProgress) {
            var unitOfWork = $236e632e8c7b0376$var$workInProgress, thrownValue = $236e632e8c7b0376$var$workInProgressThrownValue;
            switch($236e632e8c7b0376$var$workInProgressSuspendedReason){
                case 8:
                    $236e632e8c7b0376$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 6:
                    null === $236e632e8c7b0376$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $236e632e8c7b0376$var$workInProgressSuspendedReason;
                    $236e632e8c7b0376$var$workInProgressSuspendedReason = 0;
                    $236e632e8c7b0376$var$workInProgressThrownValue = null;
                    $236e632e8c7b0376$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $236e632e8c7b0376$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $236e632e8c7b0376$var$workInProgressSuspendedReason, $236e632e8c7b0376$var$workInProgressSuspendedReason = 0, $236e632e8c7b0376$var$workInProgressThrownValue = null, $236e632e8c7b0376$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $236e632e8c7b0376$var$workLoopSync();
        exitStatus = $236e632e8c7b0376$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$164) {
        $236e632e8c7b0376$var$handleThrow(root, thrownValue$164);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $236e632e8c7b0376$var$lastContextDependency = $236e632e8c7b0376$var$currentlyRenderingFiber = null;
    $236e632e8c7b0376$var$executionContext = prevExecutionContext;
    $236e632e8c7b0376$var$ReactSharedInternals.H = prevDispatcher;
    $236e632e8c7b0376$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $236e632e8c7b0376$var$workInProgress && ($236e632e8c7b0376$var$workInProgressRoot = null, $236e632e8c7b0376$var$workInProgressRootRenderLanes = 0, $236e632e8c7b0376$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $236e632e8c7b0376$var$workLoopSync() {
    for(; null !== $236e632e8c7b0376$var$workInProgress;)$236e632e8c7b0376$var$performUnitOfWork($236e632e8c7b0376$var$workInProgress);
}
function $236e632e8c7b0376$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $236e632e8c7b0376$var$executionContext;
    $236e632e8c7b0376$var$executionContext |= 2;
    var prevDispatcher = $236e632e8c7b0376$var$pushDispatcher(), prevAsyncDispatcher = $236e632e8c7b0376$var$pushAsyncDispatcher();
    $236e632e8c7b0376$var$workInProgressRoot !== root || $236e632e8c7b0376$var$workInProgressRootRenderLanes !== lanes ? ($236e632e8c7b0376$var$workInProgressTransitions = null, $236e632e8c7b0376$var$workInProgressRootRenderTargetTime = $236e632e8c7b0376$var$now() + 500, $236e632e8c7b0376$var$prepareFreshStack(root, lanes)) : $236e632e8c7b0376$var$workInProgressRootIsPrerendering = $236e632e8c7b0376$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $236e632e8c7b0376$var$workInProgressSuspendedReason && null !== $236e632e8c7b0376$var$workInProgress) {
            lanes = $236e632e8c7b0376$var$workInProgress;
            var thrownValue = $236e632e8c7b0376$var$workInProgressThrownValue;
            b: switch($236e632e8c7b0376$var$workInProgressSuspendedReason){
                case 1:
                    $236e632e8c7b0376$var$workInProgressSuspendedReason = 0;
                    $236e632e8c7b0376$var$workInProgressThrownValue = null;
                    $236e632e8c7b0376$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                    if ($236e632e8c7b0376$var$isThenableResolved(thrownValue)) {
                        $236e632e8c7b0376$var$workInProgressSuspendedReason = 0;
                        $236e632e8c7b0376$var$workInProgressThrownValue = null;
                        $236e632e8c7b0376$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 === $236e632e8c7b0376$var$workInProgressSuspendedReason && $236e632e8c7b0376$var$workInProgressRoot === root && ($236e632e8c7b0376$var$workInProgressSuspendedReason = 7);
                        $236e632e8c7b0376$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $236e632e8c7b0376$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $236e632e8c7b0376$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $236e632e8c7b0376$var$isThenableResolved(thrownValue) ? ($236e632e8c7b0376$var$workInProgressSuspendedReason = 0, $236e632e8c7b0376$var$workInProgressThrownValue = null, $236e632e8c7b0376$var$replaySuspendedUnitOfWork(lanes)) : ($236e632e8c7b0376$var$workInProgressSuspendedReason = 0, $236e632e8c7b0376$var$workInProgressThrownValue = null, $236e632e8c7b0376$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($236e632e8c7b0376$var$workInProgress.tag){
                        case 26:
                            resource = $236e632e8c7b0376$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $236e632e8c7b0376$var$workInProgress;
                            if (resource ? $236e632e8c7b0376$var$preloadResource(resource) : 1) {
                                $236e632e8c7b0376$var$workInProgressSuspendedReason = 0;
                                $236e632e8c7b0376$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $236e632e8c7b0376$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($236e632e8c7b0376$var$workInProgress = returnFiber, $236e632e8c7b0376$var$completeUnitOfWork(returnFiber)) : $236e632e8c7b0376$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $236e632e8c7b0376$var$workInProgressSuspendedReason = 0;
                    $236e632e8c7b0376$var$workInProgressThrownValue = null;
                    $236e632e8c7b0376$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $236e632e8c7b0376$var$workInProgressSuspendedReason = 0;
                    $236e632e8c7b0376$var$workInProgressThrownValue = null;
                    $236e632e8c7b0376$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $236e632e8c7b0376$var$resetWorkInProgressStack();
                    $236e632e8c7b0376$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($236e632e8c7b0376$var$formatProdErrorMessage(462));
            }
        }
        $236e632e8c7b0376$var$workLoopConcurrent();
        break;
    } catch (thrownValue$166) {
        $236e632e8c7b0376$var$handleThrow(root, thrownValue$166);
    }
    while (1);
    $236e632e8c7b0376$var$lastContextDependency = $236e632e8c7b0376$var$currentlyRenderingFiber = null;
    $236e632e8c7b0376$var$ReactSharedInternals.H = prevDispatcher;
    $236e632e8c7b0376$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $236e632e8c7b0376$var$executionContext = prevExecutionContext;
    if (null !== $236e632e8c7b0376$var$workInProgress) return 0;
    $236e632e8c7b0376$var$workInProgressRoot = null;
    $236e632e8c7b0376$var$workInProgressRootRenderLanes = 0;
    $236e632e8c7b0376$var$finishQueueingConcurrentUpdates();
    return $236e632e8c7b0376$var$workInProgressRootExitStatus;
}
function $236e632e8c7b0376$var$workLoopConcurrent() {
    for(; null !== $236e632e8c7b0376$var$workInProgress && !$236e632e8c7b0376$var$shouldYield();)$236e632e8c7b0376$var$performUnitOfWork($236e632e8c7b0376$var$workInProgress);
}
function $236e632e8c7b0376$var$performUnitOfWork(unitOfWork) {
    var next = $236e632e8c7b0376$var$beginWork(unitOfWork.alternate, unitOfWork, $236e632e8c7b0376$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $236e632e8c7b0376$var$completeUnitOfWork(unitOfWork) : $236e632e8c7b0376$var$workInProgress = next;
}
function $236e632e8c7b0376$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $236e632e8c7b0376$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $236e632e8c7b0376$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $236e632e8c7b0376$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $236e632e8c7b0376$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $236e632e8c7b0376$var$resetHooksOnUnwind(next);
        default:
            $236e632e8c7b0376$var$unwindInterruptedWork(current, next), next = $236e632e8c7b0376$var$workInProgress = $236e632e8c7b0376$var$resetWorkInProgress(next, $236e632e8c7b0376$var$entangledRenderLanes), next = $236e632e8c7b0376$var$beginWork(current, next, $236e632e8c7b0376$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $236e632e8c7b0376$var$completeUnitOfWork(unitOfWork) : $236e632e8c7b0376$var$workInProgress = next;
}
function $236e632e8c7b0376$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $236e632e8c7b0376$var$lastContextDependency = $236e632e8c7b0376$var$currentlyRenderingFiber = null;
    $236e632e8c7b0376$var$resetHooksOnUnwind(unitOfWork);
    $236e632e8c7b0376$var$thenableState$1 = null;
    $236e632e8c7b0376$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($236e632e8c7b0376$var$throwException(root, returnFiber, unitOfWork, thrownValue, $236e632e8c7b0376$var$workInProgressRootRenderLanes)) {
            $236e632e8c7b0376$var$workInProgressRootExitStatus = 1;
            $236e632e8c7b0376$var$logUncaughtError(root, $236e632e8c7b0376$var$createCapturedValueAtFiber(thrownValue, root.current));
            $236e632e8c7b0376$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $236e632e8c7b0376$var$workInProgress = returnFiber, error;
        $236e632e8c7b0376$var$workInProgressRootExitStatus = 1;
        $236e632e8c7b0376$var$logUncaughtError(root, $236e632e8c7b0376$var$createCapturedValueAtFiber(thrownValue, root.current));
        $236e632e8c7b0376$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($236e632e8c7b0376$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($236e632e8c7b0376$var$workInProgressRootIsPrerendering || 0 !== ($236e632e8c7b0376$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($236e632e8c7b0376$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $236e632e8c7b0376$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $236e632e8c7b0376$var$unwindUnitOfWork(unitOfWork, root);
    } else $236e632e8c7b0376$var$completeUnitOfWork(unitOfWork);
}
function $236e632e8c7b0376$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $236e632e8c7b0376$var$unwindUnitOfWork(completedWork, $236e632e8c7b0376$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $236e632e8c7b0376$var$completeWork(completedWork.alternate, completedWork, $236e632e8c7b0376$var$entangledRenderLanes);
        if (null !== next) {
            $236e632e8c7b0376$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $236e632e8c7b0376$var$workInProgress = completedWork;
            return;
        }
        $236e632e8c7b0376$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $236e632e8c7b0376$var$workInProgressRootExitStatus && ($236e632e8c7b0376$var$workInProgressRootExitStatus = 5);
}
function $236e632e8c7b0376$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $236e632e8c7b0376$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $236e632e8c7b0376$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $236e632e8c7b0376$var$workInProgress = unitOfWork;
            return;
        }
        $236e632e8c7b0376$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $236e632e8c7b0376$var$workInProgressRootExitStatus = 6;
    $236e632e8c7b0376$var$workInProgress = null;
}
function $236e632e8c7b0376$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var prevTransition = $236e632e8c7b0376$var$ReactSharedInternals.T, previousUpdateLanePriority = $236e632e8c7b0376$var$ReactDOMSharedInternals.p;
    try {
        $236e632e8c7b0376$var$ReactDOMSharedInternals.p = 2, $236e632e8c7b0376$var$ReactSharedInternals.T = null, $236e632e8c7b0376$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    } finally{
        $236e632e8c7b0376$var$ReactSharedInternals.T = prevTransition, $236e632e8c7b0376$var$ReactDOMSharedInternals.p = previousUpdateLanePriority;
    }
}
function $236e632e8c7b0376$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
    do $236e632e8c7b0376$var$flushPassiveEffects();
    while (null !== $236e632e8c7b0376$var$rootWithPendingPassiveEffects);
    if (0 !== ($236e632e8c7b0376$var$executionContext & 6)) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(327));
    var finishedWork = root.finishedWork;
    didIncludeRenderPhaseUpdate = root.finishedLanes;
    if (null === finishedWork) return null;
    root.finishedWork = null;
    root.finishedLanes = 0;
    if (finishedWork === root.current) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(177));
    root.callbackNode = null;
    root.callbackPriority = 0;
    root.cancelPendingCommit = null;
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    remainingLanes |= $236e632e8c7b0376$var$concurrentlyUpdatedLanes;
    $236e632e8c7b0376$var$markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    root === $236e632e8c7b0376$var$workInProgressRoot && ($236e632e8c7b0376$var$workInProgress = $236e632e8c7b0376$var$workInProgressRoot = null, $236e632e8c7b0376$var$workInProgressRootRenderLanes = 0);
    0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || $236e632e8c7b0376$var$rootDoesHavePassiveEffects || ($236e632e8c7b0376$var$rootDoesHavePassiveEffects = !0, $236e632e8c7b0376$var$pendingPassiveEffectsRemainingLanes = remainingLanes, $236e632e8c7b0376$var$pendingPassiveTransitions = transitions, $236e632e8c7b0376$var$scheduleCallback$1($236e632e8c7b0376$var$NormalPriority$1, function() {
        $236e632e8c7b0376$var$flushPassiveEffects(!0);
        return null;
    }));
    transitions = 0 !== (finishedWork.flags & 15990);
    0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = $236e632e8c7b0376$var$ReactSharedInternals.T, $236e632e8c7b0376$var$ReactSharedInternals.T = null, spawnedLane = $236e632e8c7b0376$var$ReactDOMSharedInternals.p, $236e632e8c7b0376$var$ReactDOMSharedInternals.p = 2, updatedLanes = $236e632e8c7b0376$var$executionContext, $236e632e8c7b0376$var$executionContext |= 4, $236e632e8c7b0376$var$commitBeforeMutationEffects(root, finishedWork), $236e632e8c7b0376$var$commitMutationEffectsOnFiber(finishedWork, root), $236e632e8c7b0376$var$restoreSelection($236e632e8c7b0376$var$selectionInformation, root.containerInfo), $236e632e8c7b0376$var$_enabled = !!$236e632e8c7b0376$var$eventsEnabled, $236e632e8c7b0376$var$selectionInformation = $236e632e8c7b0376$var$eventsEnabled = null, root.current = finishedWork, $236e632e8c7b0376$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), $236e632e8c7b0376$var$requestPaint(), $236e632e8c7b0376$var$executionContext = updatedLanes, $236e632e8c7b0376$var$ReactDOMSharedInternals.p = spawnedLane, $236e632e8c7b0376$var$ReactSharedInternals.T = transitions) : root.current = finishedWork;
    $236e632e8c7b0376$var$rootDoesHavePassiveEffects ? ($236e632e8c7b0376$var$rootDoesHavePassiveEffects = !1, $236e632e8c7b0376$var$rootWithPendingPassiveEffects = root, $236e632e8c7b0376$var$pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : $236e632e8c7b0376$var$releaseRootPooledCache(root, remainingLanes);
    remainingLanes = root.pendingLanes;
    0 === remainingLanes && ($236e632e8c7b0376$var$legacyErrorBoundariesThatAlreadyFailed = null);
    $236e632e8c7b0376$var$onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
    $236e632e8c7b0376$var$ensureRootIsScheduled(root);
    if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
        componentStack: remainingLanes.stack
    });
    0 !== ($236e632e8c7b0376$var$pendingPassiveEffectsLanes & 3) && $236e632e8c7b0376$var$flushPassiveEffects();
    remainingLanes = root.pendingLanes;
    0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === $236e632e8c7b0376$var$rootWithNestedUpdates ? $236e632e8c7b0376$var$nestedUpdateCount++ : ($236e632e8c7b0376$var$nestedUpdateCount = 0, $236e632e8c7b0376$var$rootWithNestedUpdates = root) : $236e632e8c7b0376$var$nestedUpdateCount = 0;
    $236e632e8c7b0376$var$flushSyncWorkAcrossRoots_impl(0, !1);
    return null;
}
function $236e632e8c7b0376$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $236e632e8c7b0376$var$releaseCache(remainingLanes)));
}
function $236e632e8c7b0376$var$flushPassiveEffects() {
    if (null !== $236e632e8c7b0376$var$rootWithPendingPassiveEffects) {
        var root$170 = $236e632e8c7b0376$var$rootWithPendingPassiveEffects, remainingLanes = $236e632e8c7b0376$var$pendingPassiveEffectsRemainingLanes;
        $236e632e8c7b0376$var$pendingPassiveEffectsRemainingLanes = 0;
        var renderPriority = $236e632e8c7b0376$var$lanesToEventPriority($236e632e8c7b0376$var$pendingPassiveEffectsLanes), prevTransition = $236e632e8c7b0376$var$ReactSharedInternals.T, previousPriority = $236e632e8c7b0376$var$ReactDOMSharedInternals.p;
        try {
            $236e632e8c7b0376$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
            $236e632e8c7b0376$var$ReactSharedInternals.T = null;
            if (null === $236e632e8c7b0376$var$rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
            else {
                renderPriority = $236e632e8c7b0376$var$pendingPassiveTransitions;
                $236e632e8c7b0376$var$pendingPassiveTransitions = null;
                var root = $236e632e8c7b0376$var$rootWithPendingPassiveEffects, lanes = $236e632e8c7b0376$var$pendingPassiveEffectsLanes;
                $236e632e8c7b0376$var$rootWithPendingPassiveEffects = null;
                $236e632e8c7b0376$var$pendingPassiveEffectsLanes = 0;
                if (0 !== ($236e632e8c7b0376$var$executionContext & 6)) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(331));
                var prevExecutionContext = $236e632e8c7b0376$var$executionContext;
                $236e632e8c7b0376$var$executionContext |= 4;
                $236e632e8c7b0376$var$commitPassiveUnmountOnFiber(root.current);
                $236e632e8c7b0376$var$commitPassiveMountOnFiber(root, root.current, lanes, renderPriority);
                $236e632e8c7b0376$var$executionContext = prevExecutionContext;
                $236e632e8c7b0376$var$flushSyncWorkAcrossRoots_impl(0, !1);
                if ($236e632e8c7b0376$var$injectedHook && "function" === typeof $236e632e8c7b0376$var$injectedHook.onPostCommitFiberRoot) try {
                    $236e632e8c7b0376$var$injectedHook.onPostCommitFiberRoot($236e632e8c7b0376$var$rendererID, root);
                } catch (err) {}
                JSCompiler_inline_result = !0;
            }
            return JSCompiler_inline_result;
        } finally{
            $236e632e8c7b0376$var$ReactDOMSharedInternals.p = previousPriority, $236e632e8c7b0376$var$ReactSharedInternals.T = prevTransition, $236e632e8c7b0376$var$releaseRootPooledCache(root$170, remainingLanes);
        }
    }
    return !1;
}
function $236e632e8c7b0376$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $236e632e8c7b0376$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $236e632e8c7b0376$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $236e632e8c7b0376$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($236e632e8c7b0376$var$markRootUpdated$1(rootFiber, 2), $236e632e8c7b0376$var$ensureRootIsScheduled(rootFiber));
}
function $236e632e8c7b0376$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $236e632e8c7b0376$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $236e632e8c7b0376$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $236e632e8c7b0376$var$legacyErrorBoundariesThatAlreadyFailed || !$236e632e8c7b0376$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $236e632e8c7b0376$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $236e632e8c7b0376$var$createClassErrorUpdate(2);
                instance = $236e632e8c7b0376$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($236e632e8c7b0376$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $236e632e8c7b0376$var$markRootUpdated$1(instance, 2), $236e632e8c7b0376$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $236e632e8c7b0376$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $236e632e8c7b0376$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($236e632e8c7b0376$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $236e632e8c7b0376$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $236e632e8c7b0376$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $236e632e8c7b0376$var$workInProgressRoot === root && ($236e632e8c7b0376$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $236e632e8c7b0376$var$workInProgressRootExitStatus || 3 === $236e632e8c7b0376$var$workInProgressRootExitStatus && ($236e632e8c7b0376$var$workInProgressRootRenderLanes & 62914560) === $236e632e8c7b0376$var$workInProgressRootRenderLanes && 300 > $236e632e8c7b0376$var$now() - $236e632e8c7b0376$var$globalMostRecentFallbackTime ? 0 === ($236e632e8c7b0376$var$executionContext & 2) && $236e632e8c7b0376$var$prepareFreshStack(root, 0) : $236e632e8c7b0376$var$workInProgressRootPingedLanes |= pingedLanes, $236e632e8c7b0376$var$workInProgressSuspendedRetryLanes === $236e632e8c7b0376$var$workInProgressRootRenderLanes && ($236e632e8c7b0376$var$workInProgressSuspendedRetryLanes = 0));
    $236e632e8c7b0376$var$ensureRootIsScheduled(root);
}
function $236e632e8c7b0376$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $236e632e8c7b0376$var$claimNextRetryLane());
    boundaryFiber = $236e632e8c7b0376$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($236e632e8c7b0376$var$markRootUpdated$1(boundaryFiber, retryLane), $236e632e8c7b0376$var$ensureRootIsScheduled(boundaryFiber));
}
function $236e632e8c7b0376$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $236e632e8c7b0376$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $236e632e8c7b0376$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($236e632e8c7b0376$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $236e632e8c7b0376$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $236e632e8c7b0376$var$scheduleCallback$1(priorityLevel, callback) {
    return $236e632e8c7b0376$var$scheduleCallback$3(priorityLevel, callback);
}
var $236e632e8c7b0376$var$firstScheduledRoot = null, $236e632e8c7b0376$var$lastScheduledRoot = null, $236e632e8c7b0376$var$didScheduleMicrotask = !1, $236e632e8c7b0376$var$mightHavePendingSyncWork = !1, $236e632e8c7b0376$var$isFlushingWork = !1, $236e632e8c7b0376$var$currentEventTransitionLane = 0;
function $236e632e8c7b0376$var$ensureRootIsScheduled(root) {
    root !== $236e632e8c7b0376$var$lastScheduledRoot && null === root.next && (null === $236e632e8c7b0376$var$lastScheduledRoot ? $236e632e8c7b0376$var$firstScheduledRoot = $236e632e8c7b0376$var$lastScheduledRoot = root : $236e632e8c7b0376$var$lastScheduledRoot = $236e632e8c7b0376$var$lastScheduledRoot.next = root);
    $236e632e8c7b0376$var$mightHavePendingSyncWork = !0;
    $236e632e8c7b0376$var$didScheduleMicrotask || ($236e632e8c7b0376$var$didScheduleMicrotask = !0, $236e632e8c7b0376$var$scheduleImmediateTask($236e632e8c7b0376$var$processRootScheduleInMicrotask));
}
function $236e632e8c7b0376$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$236e632e8c7b0376$var$isFlushingWork && $236e632e8c7b0376$var$mightHavePendingSyncWork) {
        $236e632e8c7b0376$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$172 = $236e632e8c7b0376$var$firstScheduledRoot; null !== root$172;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$172.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$172.suspendedLanes, pingedLanes = root$172.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $236e632e8c7b0376$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $236e632e8c7b0376$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $236e632e8c7b0376$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $236e632e8c7b0376$var$getNextLanes(root$172, root$172 === $236e632e8c7b0376$var$workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || $236e632e8c7b0376$var$checkIfRootIsPrerendering(root$172, JSCompiler_inline_result) || (didPerformSomeWork = !0, $236e632e8c7b0376$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                }
                root$172 = root$172.next;
            }
        }while (didPerformSomeWork);
        $236e632e8c7b0376$var$isFlushingWork = !1;
    }
}
function $236e632e8c7b0376$var$processRootScheduleInMicrotask() {
    $236e632e8c7b0376$var$mightHavePendingSyncWork = $236e632e8c7b0376$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $236e632e8c7b0376$var$currentEventTransitionLane && ($236e632e8c7b0376$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $236e632e8c7b0376$var$currentEventTransitionLane), $236e632e8c7b0376$var$currentEventTransitionLane = 0);
    for(var currentTime = $236e632e8c7b0376$var$now(), prev = null, root = $236e632e8c7b0376$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $236e632e8c7b0376$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $236e632e8c7b0376$var$firstScheduledRoot = next : prev.next = next, null === next && ($236e632e8c7b0376$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $236e632e8c7b0376$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $236e632e8c7b0376$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $236e632e8c7b0376$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $236e632e8c7b0376$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $236e632e8c7b0376$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $236e632e8c7b0376$var$workInProgressRoot;
    suspendedLanes = $236e632e8c7b0376$var$workInProgressRootRenderLanes;
    suspendedLanes = $236e632e8c7b0376$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && 2 === $236e632e8c7b0376$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $236e632e8c7b0376$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $236e632e8c7b0376$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $236e632e8c7b0376$var$cancelCallback$1(pingedLanes);
        switch($236e632e8c7b0376$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $236e632e8c7b0376$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $236e632e8c7b0376$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $236e632e8c7b0376$var$IdlePriority;
                break;
            default:
                suspendedLanes = $236e632e8c7b0376$var$NormalPriority$1;
        }
        pingedLanes = $236e632e8c7b0376$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $236e632e8c7b0376$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $236e632e8c7b0376$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $236e632e8c7b0376$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    var originalCallbackNode = root.callbackNode;
    if ($236e632e8c7b0376$var$flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $236e632e8c7b0376$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $236e632e8c7b0376$var$getNextLanes(root, root === $236e632e8c7b0376$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $236e632e8c7b0376$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $236e632e8c7b0376$var$scheduleTaskForRootDuringMicrotask(root, $236e632e8c7b0376$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $236e632e8c7b0376$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $236e632e8c7b0376$var$performSyncWorkOnRoot(root, lanes) {
    if ($236e632e8c7b0376$var$flushPassiveEffects()) return null;
    $236e632e8c7b0376$var$performWorkOnRoot(root, lanes, !0);
}
function $236e632e8c7b0376$var$scheduleImmediateTask(cb) {
    $236e632e8c7b0376$var$scheduleMicrotask(function() {
        0 !== ($236e632e8c7b0376$var$executionContext & 6) ? $236e632e8c7b0376$var$scheduleCallback$3($236e632e8c7b0376$var$ImmediatePriority, cb) : cb();
    });
}
function $236e632e8c7b0376$var$requestTransitionLane() {
    0 === $236e632e8c7b0376$var$currentEventTransitionLane && ($236e632e8c7b0376$var$currentEventTransitionLane = $236e632e8c7b0376$var$claimNextTransitionLane());
    return $236e632e8c7b0376$var$currentEventTransitionLane;
}
function $236e632e8c7b0376$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $236e632e8c7b0376$var$sanitizeURL("" + actionProp);
}
function $236e632e8c7b0376$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $236e632e8c7b0376$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $236e632e8c7b0376$var$coerceFormActionProp((nativeEventTarget[$236e632e8c7b0376$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$236e632e8c7b0376$var$internalPropsKey] || null) ? $236e632e8c7b0376$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $236e632e8c7b0376$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $236e632e8c7b0376$var$currentEventTransitionLane) {
                                var formData = submitter ? $236e632e8c7b0376$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $236e632e8c7b0376$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $236e632e8c7b0376$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $236e632e8c7b0376$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $236e632e8c7b0376$var$i$jscomp$inline_1439 = 0; $236e632e8c7b0376$var$i$jscomp$inline_1439 < $236e632e8c7b0376$var$simpleEventPluginEvents.length; $236e632e8c7b0376$var$i$jscomp$inline_1439++){
    var $236e632e8c7b0376$var$eventName$jscomp$inline_1440 = $236e632e8c7b0376$var$simpleEventPluginEvents[$236e632e8c7b0376$var$i$jscomp$inline_1439], $236e632e8c7b0376$var$domEventName$jscomp$inline_1441 = $236e632e8c7b0376$var$eventName$jscomp$inline_1440.toLowerCase(), $236e632e8c7b0376$var$capitalizedEvent$jscomp$inline_1442 = $236e632e8c7b0376$var$eventName$jscomp$inline_1440[0].toUpperCase() + $236e632e8c7b0376$var$eventName$jscomp$inline_1440.slice(1);
    $236e632e8c7b0376$var$registerSimpleEvent($236e632e8c7b0376$var$domEventName$jscomp$inline_1441, "on" + $236e632e8c7b0376$var$capitalizedEvent$jscomp$inline_1442);
}
$236e632e8c7b0376$var$registerSimpleEvent($236e632e8c7b0376$var$ANIMATION_END, "onAnimationEnd");
$236e632e8c7b0376$var$registerSimpleEvent($236e632e8c7b0376$var$ANIMATION_ITERATION, "onAnimationIteration");
$236e632e8c7b0376$var$registerSimpleEvent($236e632e8c7b0376$var$ANIMATION_START, "onAnimationStart");
$236e632e8c7b0376$var$registerSimpleEvent("dblclick", "onDoubleClick");
$236e632e8c7b0376$var$registerSimpleEvent("focusin", "onFocus");
$236e632e8c7b0376$var$registerSimpleEvent("focusout", "onBlur");
$236e632e8c7b0376$var$registerSimpleEvent($236e632e8c7b0376$var$TRANSITION_RUN, "onTransitionRun");
$236e632e8c7b0376$var$registerSimpleEvent($236e632e8c7b0376$var$TRANSITION_START, "onTransitionStart");
$236e632e8c7b0376$var$registerSimpleEvent($236e632e8c7b0376$var$TRANSITION_CANCEL, "onTransitionCancel");
$236e632e8c7b0376$var$registerSimpleEvent($236e632e8c7b0376$var$TRANSITION_END, "onTransitionEnd");
$236e632e8c7b0376$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$236e632e8c7b0376$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$236e632e8c7b0376$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$236e632e8c7b0376$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$236e632e8c7b0376$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$236e632e8c7b0376$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$236e632e8c7b0376$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$236e632e8c7b0376$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$236e632e8c7b0376$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$236e632e8c7b0376$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $236e632e8c7b0376$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $236e632e8c7b0376$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($236e632e8c7b0376$var$mediaEventTypes));
function $236e632e8c7b0376$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $236e632e8c7b0376$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $236e632e8c7b0376$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $236e632e8c7b0376$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$236e632e8c7b0376$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$236e632e8c7b0376$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($236e632e8c7b0376$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $236e632e8c7b0376$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $236e632e8c7b0376$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $236e632e8c7b0376$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $236e632e8c7b0376$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$236e632e8c7b0376$var$listeningMarker]) {
        rootContainerElement[$236e632e8c7b0376$var$listeningMarker] = !0;
        $236e632e8c7b0376$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($236e632e8c7b0376$var$nonDelegatedEvents.has(domEventName) || $236e632e8c7b0376$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $236e632e8c7b0376$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$236e632e8c7b0376$var$listeningMarker] || (ownerDocument[$236e632e8c7b0376$var$listeningMarker] = !0, $236e632e8c7b0376$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $236e632e8c7b0376$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($236e632e8c7b0376$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $236e632e8c7b0376$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $236e632e8c7b0376$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $236e632e8c7b0376$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$236e632e8c7b0376$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $236e632e8c7b0376$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer || 8 === container.nodeType && container.parentNode === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if (3 === grandTag || 4 === grandTag) {
                    if (grandTag = nodeTag.stateNode.containerInfo, grandTag === targetContainer || 8 === grandTag.nodeType && grandTag.parentNode === targetContainer) return;
                }
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $236e632e8c7b0376$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $236e632e8c7b0376$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $236e632e8c7b0376$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $236e632e8c7b0376$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $236e632e8c7b0376$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $236e632e8c7b0376$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $236e632e8c7b0376$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $236e632e8c7b0376$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $236e632e8c7b0376$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $236e632e8c7b0376$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $236e632e8c7b0376$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $236e632e8c7b0376$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $236e632e8c7b0376$var$SyntheticTouchEvent;
                        break;
                    case $236e632e8c7b0376$var$ANIMATION_END:
                    case $236e632e8c7b0376$var$ANIMATION_ITERATION:
                    case $236e632e8c7b0376$var$ANIMATION_START:
                        SyntheticEventCtor = $236e632e8c7b0376$var$SyntheticAnimationEvent;
                        break;
                    case $236e632e8c7b0376$var$TRANSITION_END:
                        SyntheticEventCtor = $236e632e8c7b0376$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $236e632e8c7b0376$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $236e632e8c7b0376$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $236e632e8c7b0376$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $236e632e8c7b0376$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $236e632e8c7b0376$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $236e632e8c7b0376$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($236e632e8c7b0376$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $236e632e8c7b0376$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($236e632e8c7b0376$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$236e632e8c7b0376$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $236e632e8c7b0376$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $236e632e8c7b0376$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $236e632e8c7b0376$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $236e632e8c7b0376$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $236e632e8c7b0376$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $236e632e8c7b0376$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $236e632e8c7b0376$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $236e632e8c7b0376$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $236e632e8c7b0376$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $236e632e8c7b0376$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $236e632e8c7b0376$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $236e632e8c7b0376$var$getParent(inCapturePhase);
                                reactEventName = $236e632e8c7b0376$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $236e632e8c7b0376$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $236e632e8c7b0376$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $236e632e8c7b0376$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $236e632e8c7b0376$var$getTargetInstForChangeEvent;
                else if ($236e632e8c7b0376$var$isTextInputElement(reactName)) {
                    if ($236e632e8c7b0376$var$isInputEventSupported) getTargetInstFunc = $236e632e8c7b0376$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $236e632e8c7b0376$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $236e632e8c7b0376$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $236e632e8c7b0376$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $236e632e8c7b0376$var$getTargetInstForChangeEvent) : getTargetInstFunc = $236e632e8c7b0376$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $236e632e8c7b0376$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $236e632e8c7b0376$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $236e632e8c7b0376$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($236e632e8c7b0376$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $236e632e8c7b0376$var$activeElement = handleEventFunc, $236e632e8c7b0376$var$activeElementInst = targetInst, $236e632e8c7b0376$var$lastSelection = null;
                    break;
                case "focusout":
                    $236e632e8c7b0376$var$lastSelection = $236e632e8c7b0376$var$activeElementInst = $236e632e8c7b0376$var$activeElement = null;
                    break;
                case "mousedown":
                    $236e632e8c7b0376$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $236e632e8c7b0376$var$mouseDown = !1;
                    $236e632e8c7b0376$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($236e632e8c7b0376$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $236e632e8c7b0376$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($236e632e8c7b0376$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $236e632e8c7b0376$var$isComposing ? $236e632e8c7b0376$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($236e632e8c7b0376$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($236e632e8c7b0376$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $236e632e8c7b0376$var$isComposing && (fallbackData = $236e632e8c7b0376$var$getData()) : ($236e632e8c7b0376$var$root = nativeEventTarget, $236e632e8c7b0376$var$startText = "value" in $236e632e8c7b0376$var$root ? $236e632e8c7b0376$var$root.value : $236e632e8c7b0376$var$root.textContent, $236e632e8c7b0376$var$isComposing = !0)), handleEventFunc = $236e632e8c7b0376$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $236e632e8c7b0376$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $236e632e8c7b0376$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $236e632e8c7b0376$var$canUseTextInputEvent ? $236e632e8c7b0376$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $236e632e8c7b0376$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $236e632e8c7b0376$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $236e632e8c7b0376$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $236e632e8c7b0376$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $236e632e8c7b0376$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $236e632e8c7b0376$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $236e632e8c7b0376$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $236e632e8c7b0376$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($236e632e8c7b0376$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $236e632e8c7b0376$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($236e632e8c7b0376$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        targetFiber = targetFiber.return;
    }
    return listeners;
}
function $236e632e8c7b0376$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $236e632e8c7b0376$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $236e632e8c7b0376$var$getListener(target, registrationName), null != stateNode && listeners.unshift($236e632e8c7b0376$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $236e632e8c7b0376$var$getListener(target, registrationName), null != stateNode && listeners.push($236e632e8c7b0376$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $236e632e8c7b0376$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $236e632e8c7b0376$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $236e632e8c7b0376$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($236e632e8c7b0376$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($236e632e8c7b0376$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $236e632e8c7b0376$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $236e632e8c7b0376$var$normalizeMarkupForTextOrAttribute(clientText);
    return $236e632e8c7b0376$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $236e632e8c7b0376$var$noop$1() {}
function $236e632e8c7b0376$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $236e632e8c7b0376$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $236e632e8c7b0376$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $236e632e8c7b0376$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $236e632e8c7b0376$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $236e632e8c7b0376$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $236e632e8c7b0376$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $236e632e8c7b0376$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $236e632e8c7b0376$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $236e632e8c7b0376$var$setProp(domElement, tag, "name", props.name, props, null), $236e632e8c7b0376$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $236e632e8c7b0376$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $236e632e8c7b0376$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($236e632e8c7b0376$var$setProp(domElement, tag, "encType", props.encType, props, null), $236e632e8c7b0376$var$setProp(domElement, tag, "method", props.method, props, null), $236e632e8c7b0376$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $236e632e8c7b0376$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $236e632e8c7b0376$var$noop$1);
            break;
        case "onScroll":
            null != value && $236e632e8c7b0376$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $236e632e8c7b0376$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $236e632e8c7b0376$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("toggle", domElement);
            $236e632e8c7b0376$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $236e632e8c7b0376$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $236e632e8c7b0376$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $236e632e8c7b0376$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $236e632e8c7b0376$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $236e632e8c7b0376$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $236e632e8c7b0376$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $236e632e8c7b0376$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $236e632e8c7b0376$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $236e632e8c7b0376$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $236e632e8c7b0376$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $236e632e8c7b0376$var$aliases.get(key) || key, $236e632e8c7b0376$var$setValueForAttribute(domElement, key, value);
    }
}
function $236e632e8c7b0376$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $236e632e8c7b0376$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $236e632e8c7b0376$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $236e632e8c7b0376$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $236e632e8c7b0376$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $236e632e8c7b0376$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $236e632e8c7b0376$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$236e632e8c7b0376$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$236e632e8c7b0376$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $236e632e8c7b0376$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $236e632e8c7b0376$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("error", domElement);
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($236e632e8c7b0376$var$formatProdErrorMessage(137, tag));
                    default:
                        $236e632e8c7b0376$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $236e632e8c7b0376$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $236e632e8c7b0376$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$186 = props[hasSrc];
                if (null != propValue$186) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$186;
                        break;
                    case "type":
                        propValue = propValue$186;
                        break;
                    case "checked":
                        checked = propValue$186;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$186;
                        break;
                    case "value":
                        propKey = propValue$186;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$186;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$186) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $236e632e8c7b0376$var$setProp(domElement, tag, hasSrc, propValue$186, props, null);
                }
            }
            $236e632e8c7b0376$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $236e632e8c7b0376$var$track(domElement);
            return;
        case "select":
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $236e632e8c7b0376$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $236e632e8c7b0376$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $236e632e8c7b0376$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(91));
                    break;
                default:
                    $236e632e8c7b0376$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $236e632e8c7b0376$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $236e632e8c7b0376$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $236e632e8c7b0376$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("cancel", domElement);
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $236e632e8c7b0376$var$mediaEventTypes.length; hasSrc++)$236e632e8c7b0376$var$listenToNonDelegatedEvent($236e632e8c7b0376$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("error", domElement);
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $236e632e8c7b0376$var$listenToNonDelegatedEvent("error", domElement), $236e632e8c7b0376$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($236e632e8c7b0376$var$formatProdErrorMessage(137, tag));
                default:
                    $236e632e8c7b0376$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($236e632e8c7b0376$var$isCustomElement(tag)) {
                for(propValue$186 in props)props.hasOwnProperty(propValue$186) && (hasSrc = props[propValue$186], void 0 !== hasSrc && $236e632e8c7b0376$var$setPropOnCustomElement(domElement, tag, propValue$186, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $236e632e8c7b0376$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $236e632e8c7b0376$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $236e632e8c7b0376$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$203 in nextProps){
                var propKey = nextProps[propKey$203];
                lastProp = lastProps[propKey$203];
                if (nextProps.hasOwnProperty(propKey$203) && (null != propKey || null != lastProp)) switch(propKey$203){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $236e632e8c7b0376$var$setProp(domElement, tag, propKey$203, propKey, nextProps, lastProp);
                }
            }
            $236e632e8c7b0376$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$203 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $236e632e8c7b0376$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$203 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $236e632e8c7b0376$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$203 ? $236e632e8c7b0376$var$updateOptions(domElement, !!lastProps, propKey$203, !1) : !!nextProps !== !!lastProps && (null != tag ? $236e632e8c7b0376$var$updateOptions(domElement, !!lastProps, tag, !0) : $236e632e8c7b0376$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$203 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $236e632e8c7b0376$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$203 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $236e632e8c7b0376$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $236e632e8c7b0376$var$updateTextarea(domElement, propKey$203, propKey);
            return;
        case "option":
            for(var propKey$219 in lastProps)if (propKey$203 = lastProps[propKey$219], lastProps.hasOwnProperty(propKey$219) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$219)) switch(propKey$219){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $236e632e8c7b0376$var$setProp(domElement, tag, propKey$219, null, nextProps, propKey$203);
            }
            for(lastDefaultValue in nextProps)if (propKey$203 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$203 && "function" !== typeof propKey$203 && "symbol" !== typeof propKey$203;
                    break;
                default:
                    $236e632e8c7b0376$var$setProp(domElement, tag, lastDefaultValue, propKey$203, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$224 in lastProps)propKey$203 = lastProps[propKey$224], lastProps.hasOwnProperty(propKey$224) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$224) && $236e632e8c7b0376$var$setProp(domElement, tag, propKey$224, null, nextProps, propKey$203);
            for(checked in nextProps)if (propKey$203 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$203) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $236e632e8c7b0376$var$setProp(domElement, tag, checked, propKey$203, nextProps, propKey);
            }
            return;
        default:
            if ($236e632e8c7b0376$var$isCustomElement(tag)) {
                for(var propKey$229 in lastProps)propKey$203 = lastProps[propKey$229], lastProps.hasOwnProperty(propKey$229) && void 0 !== propKey$203 && !nextProps.hasOwnProperty(propKey$229) && $236e632e8c7b0376$var$setPropOnCustomElement(domElement, tag, propKey$229, void 0, nextProps, propKey$203);
                for(defaultChecked in nextProps)propKey$203 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$203 === propKey || void 0 === propKey$203 && void 0 === propKey || $236e632e8c7b0376$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$203, nextProps, propKey);
                return;
            }
    }
    for(var propKey$234 in lastProps)propKey$203 = lastProps[propKey$234], lastProps.hasOwnProperty(propKey$234) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$234) && $236e632e8c7b0376$var$setProp(domElement, tag, propKey$234, null, nextProps, propKey$203);
    for(lastProp in nextProps)propKey$203 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$203 === propKey || null == propKey$203 && null == propKey || $236e632e8c7b0376$var$setProp(domElement, tag, lastProp, propKey$203, nextProps, propKey);
}
var $236e632e8c7b0376$var$eventsEnabled = null, $236e632e8c7b0376$var$selectionInformation = null;
function $236e632e8c7b0376$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $236e632e8c7b0376$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $236e632e8c7b0376$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $236e632e8c7b0376$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $236e632e8c7b0376$var$currentPopstateTransitionEvent = null;
function $236e632e8c7b0376$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $236e632e8c7b0376$var$currentPopstateTransitionEvent) return !1;
        $236e632e8c7b0376$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $236e632e8c7b0376$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $236e632e8c7b0376$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $236e632e8c7b0376$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $236e632e8c7b0376$var$localPromise = "function" === typeof Promise ? Promise : void 0, $236e632e8c7b0376$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $236e632e8c7b0376$var$localPromise ? function(callback) {
    return $236e632e8c7b0376$var$localPromise.resolve(null).then(callback).catch($236e632e8c7b0376$var$handleErrorInNextTick);
} : $236e632e8c7b0376$var$scheduleTimeout;
function $236e632e8c7b0376$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $236e632e8c7b0376$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $236e632e8c7b0376$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" !== node && "$?" !== node && "$!" !== node || depth++;
        }
        node = nextNode;
    }while (node);
    $236e632e8c7b0376$var$retryIfBlockedOn(suspenseInstance);
}
function $236e632e8c7b0376$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $236e632e8c7b0376$var$clearContainerSparingly(node);
                $236e632e8c7b0376$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $236e632e8c7b0376$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$236e632e8c7b0376$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $236e632e8c7b0376$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $236e632e8c7b0376$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $236e632e8c7b0376$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $236e632e8c7b0376$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
function $236e632e8c7b0376$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $236e632e8c7b0376$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $236e632e8c7b0376$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($236e632e8c7b0376$var$formatProdErrorMessage(451));
    }
}
var $236e632e8c7b0376$var$preloadPropsMap = new Map(), $236e632e8c7b0376$var$preconnectsSet = new Set();
function $236e632e8c7b0376$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : container.ownerDocument;
}
var $236e632e8c7b0376$var$previousDispatcher = $236e632e8c7b0376$var$ReactDOMSharedInternals.d;
$236e632e8c7b0376$var$ReactDOMSharedInternals.d = {
    f: $236e632e8c7b0376$var$flushSyncWork,
    r: $236e632e8c7b0376$var$requestFormReset,
    D: $236e632e8c7b0376$var$prefetchDNS,
    C: $236e632e8c7b0376$var$preconnect,
    L: $236e632e8c7b0376$var$preload,
    m: $236e632e8c7b0376$var$preloadModule,
    X: $236e632e8c7b0376$var$preinitScript,
    S: $236e632e8c7b0376$var$preinitStyle,
    M: $236e632e8c7b0376$var$preinitModuleScript
};
function $236e632e8c7b0376$var$flushSyncWork() {
    var previousWasRendering = $236e632e8c7b0376$var$previousDispatcher.f(), wasRendering = $236e632e8c7b0376$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $236e632e8c7b0376$var$requestFormReset(form) {
    var formInst = $236e632e8c7b0376$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $236e632e8c7b0376$var$requestFormReset$1(formInst) : $236e632e8c7b0376$var$previousDispatcher.r(form);
}
var $236e632e8c7b0376$var$globalDocument = "undefined" === typeof document ? null : document;
function $236e632e8c7b0376$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $236e632e8c7b0376$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $236e632e8c7b0376$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $236e632e8c7b0376$var$preconnectsSet.has(limitedEscapedHref) || ($236e632e8c7b0376$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $236e632e8c7b0376$var$setInitialProperties(href, "link", rel), $236e632e8c7b0376$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $236e632e8c7b0376$var$prefetchDNS(href) {
    $236e632e8c7b0376$var$previousDispatcher.D(href);
    $236e632e8c7b0376$var$preconnectAs("dns-prefetch", href, null);
}
function $236e632e8c7b0376$var$preconnect(href, crossOrigin) {
    $236e632e8c7b0376$var$previousDispatcher.C(href, crossOrigin);
    $236e632e8c7b0376$var$preconnectAs("preconnect", href, crossOrigin);
}
function $236e632e8c7b0376$var$preload(href, as, options) {
    $236e632e8c7b0376$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $236e632e8c7b0376$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $236e632e8c7b0376$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $236e632e8c7b0376$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $236e632e8c7b0376$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $236e632e8c7b0376$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $236e632e8c7b0376$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $236e632e8c7b0376$var$getStyleKey(href);
                break;
            case "script":
                key = $236e632e8c7b0376$var$getScriptKey(href);
        }
        $236e632e8c7b0376$var$preloadPropsMap.has(key) || (href = $236e632e8c7b0376$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $236e632e8c7b0376$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($236e632e8c7b0376$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($236e632e8c7b0376$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $236e632e8c7b0376$var$setInitialProperties(as, "link", href), $236e632e8c7b0376$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $236e632e8c7b0376$var$preloadModule(href, options) {
    $236e632e8c7b0376$var$previousDispatcher.m(href, options);
    var ownerDocument = $236e632e8c7b0376$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $236e632e8c7b0376$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $236e632e8c7b0376$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $236e632e8c7b0376$var$getScriptKey(href);
        }
        if (!$236e632e8c7b0376$var$preloadPropsMap.has(key) && (href = $236e632e8c7b0376$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $236e632e8c7b0376$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($236e632e8c7b0376$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $236e632e8c7b0376$var$setInitialProperties(as, "link", href);
            $236e632e8c7b0376$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $236e632e8c7b0376$var$preinitStyle(href, precedence, options) {
    $236e632e8c7b0376$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $236e632e8c7b0376$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $236e632e8c7b0376$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $236e632e8c7b0376$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($236e632e8c7b0376$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $236e632e8c7b0376$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $236e632e8c7b0376$var$preloadPropsMap.get(key)) && $236e632e8c7b0376$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $236e632e8c7b0376$var$markNodeAsHoistable(link);
                $236e632e8c7b0376$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $236e632e8c7b0376$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $236e632e8c7b0376$var$preinitScript(src, options) {
    $236e632e8c7b0376$var$previousDispatcher.X(src, options);
    var ownerDocument = $236e632e8c7b0376$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $236e632e8c7b0376$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $236e632e8c7b0376$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($236e632e8c7b0376$var$getScriptSelectorFromKey(key)), resource || (src = $236e632e8c7b0376$var$assign({
            src: src,
            async: !0
        }, options), (options = $236e632e8c7b0376$var$preloadPropsMap.get(key)) && $236e632e8c7b0376$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $236e632e8c7b0376$var$markNodeAsHoistable(resource), $236e632e8c7b0376$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $236e632e8c7b0376$var$preinitModuleScript(src, options) {
    $236e632e8c7b0376$var$previousDispatcher.M(src, options);
    var ownerDocument = $236e632e8c7b0376$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $236e632e8c7b0376$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $236e632e8c7b0376$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($236e632e8c7b0376$var$getScriptSelectorFromKey(key)), resource || (src = $236e632e8c7b0376$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $236e632e8c7b0376$var$preloadPropsMap.get(key)) && $236e632e8c7b0376$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $236e632e8c7b0376$var$markNodeAsHoistable(resource), $236e632e8c7b0376$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $236e632e8c7b0376$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $236e632e8c7b0376$var$rootInstanceStackCursor.current) ? $236e632e8c7b0376$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $236e632e8c7b0376$var$getStyleKey(pendingProps.href), pendingProps = $236e632e8c7b0376$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $236e632e8c7b0376$var$getStyleKey(pendingProps.href);
                var styles$242 = $236e632e8c7b0376$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$243 = styles$242.get(type);
                resource$243 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$243 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$242.set(type, resource$243), (styles$242 = JSCompiler_inline_result.querySelector($236e632e8c7b0376$var$getStylesheetSelectorFromKey(type))) && !styles$242._p && (resource$243.instance = styles$242, resource$243.state.loading = 5), $236e632e8c7b0376$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $236e632e8c7b0376$var$preloadPropsMap.set(type, pendingProps), styles$242 || $236e632e8c7b0376$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$243.state)));
                if (currentProps && null === currentResource) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(528, ""));
                return resource$243;
            }
            if (currentProps && null !== currentResource) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $236e632e8c7b0376$var$getScriptKey(pendingProps), pendingProps = $236e632e8c7b0376$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($236e632e8c7b0376$var$formatProdErrorMessage(444, type));
    }
}
function $236e632e8c7b0376$var$getStyleKey(href) {
    return 'href="' + $236e632e8c7b0376$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $236e632e8c7b0376$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $236e632e8c7b0376$var$stylesheetPropsFromRawProps(rawProps) {
    return $236e632e8c7b0376$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $236e632e8c7b0376$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $236e632e8c7b0376$var$setInitialProperties(key, "link", preloadProps), $236e632e8c7b0376$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $236e632e8c7b0376$var$getScriptKey(src) {
    return '[src="' + $236e632e8c7b0376$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $236e632e8c7b0376$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $236e632e8c7b0376$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $236e632e8c7b0376$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $236e632e8c7b0376$var$markNodeAsHoistable(instance), instance;
            var styleProps = $236e632e8c7b0376$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $236e632e8c7b0376$var$markNodeAsHoistable(instance);
            $236e632e8c7b0376$var$setInitialProperties(instance, "style", styleProps);
            $236e632e8c7b0376$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $236e632e8c7b0376$var$getStyleKey(props.href);
            var instance$248 = hoistableRoot.querySelector($236e632e8c7b0376$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$248) return resource.state.loading |= 4, resource.instance = instance$248, $236e632e8c7b0376$var$markNodeAsHoistable(instance$248), instance$248;
            instance = $236e632e8c7b0376$var$stylesheetPropsFromRawProps(props);
            (styleProps = $236e632e8c7b0376$var$preloadPropsMap.get(styleProps)) && $236e632e8c7b0376$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$248 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $236e632e8c7b0376$var$markNodeAsHoistable(instance$248);
            var linkInstance = instance$248;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $236e632e8c7b0376$var$setInitialProperties(instance$248, "link", instance);
            resource.state.loading |= 4;
            $236e632e8c7b0376$var$insertStylesheet(instance$248, props.precedence, hoistableRoot);
            return resource.instance = instance$248;
        case "script":
            instance$248 = $236e632e8c7b0376$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($236e632e8c7b0376$var$getScriptSelectorFromKey(instance$248))) return resource.instance = styleProps, $236e632e8c7b0376$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $236e632e8c7b0376$var$preloadPropsMap.get(instance$248)) instance = $236e632e8c7b0376$var$assign({}, props), $236e632e8c7b0376$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $236e632e8c7b0376$var$markNodeAsHoistable(styleProps);
            $236e632e8c7b0376$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($236e632e8c7b0376$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $236e632e8c7b0376$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $236e632e8c7b0376$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $236e632e8c7b0376$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $236e632e8c7b0376$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $236e632e8c7b0376$var$tagCaches = null;
function $236e632e8c7b0376$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $236e632e8c7b0376$var$tagCaches) {
        var cache = new Map();
        var caches = $236e632e8c7b0376$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $236e632e8c7b0376$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$236e632e8c7b0376$var$internalHoistableMarker] || node[$236e632e8c7b0376$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $236e632e8c7b0376$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $236e632e8c7b0376$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $236e632e8c7b0376$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $236e632e8c7b0376$var$suspendedState = null;
function $236e632e8c7b0376$var$noop() {}
function $236e632e8c7b0376$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $236e632e8c7b0376$var$suspendedState) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(475));
    var state = $236e632e8c7b0376$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $236e632e8c7b0376$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($236e632e8c7b0376$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $236e632e8c7b0376$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $236e632e8c7b0376$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $236e632e8c7b0376$var$stylesheetPropsFromRawProps(props);
            (key = $236e632e8c7b0376$var$preloadPropsMap.get(key)) && $236e632e8c7b0376$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $236e632e8c7b0376$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $236e632e8c7b0376$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $236e632e8c7b0376$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $236e632e8c7b0376$var$waitForCommitToBeReady() {
    if (null === $236e632e8c7b0376$var$suspendedState) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(475));
    var state = $236e632e8c7b0376$var$suspendedState;
    state.stylesheets && 0 === state.count && $236e632e8c7b0376$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $236e632e8c7b0376$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $236e632e8c7b0376$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $236e632e8c7b0376$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $236e632e8c7b0376$var$precedencesByRoot = null;
function $236e632e8c7b0376$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $236e632e8c7b0376$var$precedencesByRoot = new Map(), resources.forEach($236e632e8c7b0376$var$insertStylesheetIntoRoot, state), $236e632e8c7b0376$var$precedencesByRoot = null, $236e632e8c7b0376$var$onUnsuspend.call(state));
}
function $236e632e8c7b0376$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $236e632e8c7b0376$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $236e632e8c7b0376$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $236e632e8c7b0376$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $236e632e8c7b0376$var$HostTransitionContext = {
    $$typeof: $236e632e8c7b0376$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $236e632e8c7b0376$var$sharedNotPendingObject,
    _currentValue2: $236e632e8c7b0376$var$sharedNotPendingObject,
    _threadCount: 0
};
function $236e632e8c7b0376$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $236e632e8c7b0376$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $236e632e8c7b0376$var$createLaneMap(0);
    this.hiddenUpdates = $236e632e8c7b0376$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $236e632e8c7b0376$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $236e632e8c7b0376$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $236e632e8c7b0376$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $236e632e8c7b0376$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $236e632e8c7b0376$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $236e632e8c7b0376$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $236e632e8c7b0376$var$emptyContextObject;
    parentComponent = $236e632e8c7b0376$var$emptyContextObject;
    return parentComponent;
}
function $236e632e8c7b0376$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $236e632e8c7b0376$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $236e632e8c7b0376$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $236e632e8c7b0376$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($236e632e8c7b0376$var$scheduleUpdateOnFiber(element, rootFiber, lane), $236e632e8c7b0376$var$entangleTransitions(element, rootFiber, lane));
}
function $236e632e8c7b0376$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $236e632e8c7b0376$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $236e632e8c7b0376$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $236e632e8c7b0376$var$markRetryLaneImpl(fiber, retryLane);
}
function $236e632e8c7b0376$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $236e632e8c7b0376$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $236e632e8c7b0376$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $236e632e8c7b0376$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $236e632e8c7b0376$var$_enabled = !0;
function $236e632e8c7b0376$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $236e632e8c7b0376$var$ReactSharedInternals.T;
    $236e632e8c7b0376$var$ReactSharedInternals.T = null;
    var previousPriority = $236e632e8c7b0376$var$ReactDOMSharedInternals.p;
    try {
        $236e632e8c7b0376$var$ReactDOMSharedInternals.p = 2, $236e632e8c7b0376$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $236e632e8c7b0376$var$ReactDOMSharedInternals.p = previousPriority, $236e632e8c7b0376$var$ReactSharedInternals.T = prevTransition;
    }
}
function $236e632e8c7b0376$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $236e632e8c7b0376$var$ReactSharedInternals.T;
    $236e632e8c7b0376$var$ReactSharedInternals.T = null;
    var previousPriority = $236e632e8c7b0376$var$ReactDOMSharedInternals.p;
    try {
        $236e632e8c7b0376$var$ReactDOMSharedInternals.p = 8, $236e632e8c7b0376$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $236e632e8c7b0376$var$ReactDOMSharedInternals.p = previousPriority, $236e632e8c7b0376$var$ReactSharedInternals.T = prevTransition;
    }
}
function $236e632e8c7b0376$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($236e632e8c7b0376$var$_enabled) {
        var blockedOn = $236e632e8c7b0376$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $236e632e8c7b0376$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $236e632e8c7b0376$var$return_targetInst, targetContainer), $236e632e8c7b0376$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($236e632e8c7b0376$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($236e632e8c7b0376$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $236e632e8c7b0376$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $236e632e8c7b0376$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $236e632e8c7b0376$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $236e632e8c7b0376$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $236e632e8c7b0376$var$ensureRootIsScheduled(fiber);
                                0 === ($236e632e8c7b0376$var$executionContext & 6) && ($236e632e8c7b0376$var$workInProgressRootRenderTargetTime = $236e632e8c7b0376$var$now() + 500, $236e632e8c7b0376$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $236e632e8c7b0376$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $236e632e8c7b0376$var$scheduleUpdateOnFiber(root, fiber, 2), $236e632e8c7b0376$var$flushSyncWork$1(), $236e632e8c7b0376$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $236e632e8c7b0376$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $236e632e8c7b0376$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $236e632e8c7b0376$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $236e632e8c7b0376$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $236e632e8c7b0376$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $236e632e8c7b0376$var$getEventTarget(nativeEvent);
    return $236e632e8c7b0376$var$findInstanceBlockingTarget(nativeEvent);
}
var $236e632e8c7b0376$var$return_targetInst = null;
function $236e632e8c7b0376$var$findInstanceBlockingTarget(targetNode) {
    $236e632e8c7b0376$var$return_targetInst = null;
    targetNode = $236e632e8c7b0376$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $236e632e8c7b0376$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $236e632e8c7b0376$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $236e632e8c7b0376$var$return_targetInst = targetNode;
    return null;
}
function $236e632e8c7b0376$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($236e632e8c7b0376$var$getCurrentPriorityLevel()){
                case $236e632e8c7b0376$var$ImmediatePriority:
                    return 2;
                case $236e632e8c7b0376$var$UserBlockingPriority:
                    return 8;
                case $236e632e8c7b0376$var$NormalPriority$1:
                case $236e632e8c7b0376$var$LowPriority:
                    return 32;
                case $236e632e8c7b0376$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $236e632e8c7b0376$var$hasScheduledReplayAttempt = !1, $236e632e8c7b0376$var$queuedFocus = null, $236e632e8c7b0376$var$queuedDrag = null, $236e632e8c7b0376$var$queuedMouse = null, $236e632e8c7b0376$var$queuedPointers = new Map(), $236e632e8c7b0376$var$queuedPointerCaptures = new Map(), $236e632e8c7b0376$var$queuedExplicitHydrationTargets = [], $236e632e8c7b0376$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $236e632e8c7b0376$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $236e632e8c7b0376$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $236e632e8c7b0376$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $236e632e8c7b0376$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $236e632e8c7b0376$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $236e632e8c7b0376$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $236e632e8c7b0376$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $236e632e8c7b0376$var$getInstanceFromNode(blockedOn), null !== blockedOn && $236e632e8c7b0376$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $236e632e8c7b0376$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $236e632e8c7b0376$var$queuedFocus = $236e632e8c7b0376$var$accumulateOrCreateContinuousQueuedReplayableEvent($236e632e8c7b0376$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $236e632e8c7b0376$var$queuedDrag = $236e632e8c7b0376$var$accumulateOrCreateContinuousQueuedReplayableEvent($236e632e8c7b0376$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $236e632e8c7b0376$var$queuedMouse = $236e632e8c7b0376$var$accumulateOrCreateContinuousQueuedReplayableEvent($236e632e8c7b0376$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $236e632e8c7b0376$var$queuedPointers.set(pointerId, $236e632e8c7b0376$var$accumulateOrCreateContinuousQueuedReplayableEvent($236e632e8c7b0376$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $236e632e8c7b0376$var$queuedPointerCaptures.set(pointerId, $236e632e8c7b0376$var$accumulateOrCreateContinuousQueuedReplayableEvent($236e632e8c7b0376$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $236e632e8c7b0376$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $236e632e8c7b0376$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $236e632e8c7b0376$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $236e632e8c7b0376$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $236e632e8c7b0376$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $236e632e8c7b0376$var$requestUpdateLane(), root = $236e632e8c7b0376$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $236e632e8c7b0376$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $236e632e8c7b0376$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $236e632e8c7b0376$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $236e632e8c7b0376$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $236e632e8c7b0376$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $236e632e8c7b0376$var$currentReplayingEvent = null;
        } else return targetContainers = $236e632e8c7b0376$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $236e632e8c7b0376$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $236e632e8c7b0376$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $236e632e8c7b0376$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $236e632e8c7b0376$var$replayUnblockedEvents() {
    $236e632e8c7b0376$var$hasScheduledReplayAttempt = !1;
    null !== $236e632e8c7b0376$var$queuedFocus && $236e632e8c7b0376$var$attemptReplayContinuousQueuedEvent($236e632e8c7b0376$var$queuedFocus) && ($236e632e8c7b0376$var$queuedFocus = null);
    null !== $236e632e8c7b0376$var$queuedDrag && $236e632e8c7b0376$var$attemptReplayContinuousQueuedEvent($236e632e8c7b0376$var$queuedDrag) && ($236e632e8c7b0376$var$queuedDrag = null);
    null !== $236e632e8c7b0376$var$queuedMouse && $236e632e8c7b0376$var$attemptReplayContinuousQueuedEvent($236e632e8c7b0376$var$queuedMouse) && ($236e632e8c7b0376$var$queuedMouse = null);
    $236e632e8c7b0376$var$queuedPointers.forEach($236e632e8c7b0376$var$attemptReplayContinuousQueuedEventInMap);
    $236e632e8c7b0376$var$queuedPointerCaptures.forEach($236e632e8c7b0376$var$attemptReplayContinuousQueuedEventInMap);
}
function $236e632e8c7b0376$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $236e632e8c7b0376$var$hasScheduledReplayAttempt || ($236e632e8c7b0376$var$hasScheduledReplayAttempt = !0, $8TTSu.unstable_scheduleCallback($8TTSu.unstable_NormalPriority, $236e632e8c7b0376$var$replayUnblockedEvents)));
}
var $236e632e8c7b0376$var$lastScheduledReplayQueue = null;
function $236e632e8c7b0376$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $236e632e8c7b0376$var$lastScheduledReplayQueue !== formReplayingQueue && ($236e632e8c7b0376$var$lastScheduledReplayQueue = formReplayingQueue, $8TTSu.unstable_scheduleCallback($8TTSu.unstable_NormalPriority, function() {
        $236e632e8c7b0376$var$lastScheduledReplayQueue === formReplayingQueue && ($236e632e8c7b0376$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $236e632e8c7b0376$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $236e632e8c7b0376$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $236e632e8c7b0376$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $236e632e8c7b0376$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $236e632e8c7b0376$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $236e632e8c7b0376$var$queuedFocus && $236e632e8c7b0376$var$scheduleCallbackIfUnblocked($236e632e8c7b0376$var$queuedFocus, unblocked);
    null !== $236e632e8c7b0376$var$queuedDrag && $236e632e8c7b0376$var$scheduleCallbackIfUnblocked($236e632e8c7b0376$var$queuedDrag, unblocked);
    null !== $236e632e8c7b0376$var$queuedMouse && $236e632e8c7b0376$var$scheduleCallbackIfUnblocked($236e632e8c7b0376$var$queuedMouse, unblocked);
    $236e632e8c7b0376$var$queuedPointers.forEach(unblock);
    $236e632e8c7b0376$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $236e632e8c7b0376$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $236e632e8c7b0376$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $236e632e8c7b0376$var$queuedExplicitHydrationTargets.length && (i = $236e632e8c7b0376$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$236e632e8c7b0376$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $236e632e8c7b0376$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$236e632e8c7b0376$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $236e632e8c7b0376$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$236e632e8c7b0376$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $236e632e8c7b0376$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $236e632e8c7b0376$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $236e632e8c7b0376$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$236e632e8c7b0376$var$ReactDOMHydrationRoot.prototype.render = $236e632e8c7b0376$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(409));
    var current = root.current, lane = $236e632e8c7b0376$var$requestUpdateLane();
    $236e632e8c7b0376$var$updateContainerImpl(current, lane, children, root, null, null);
};
$236e632e8c7b0376$var$ReactDOMHydrationRoot.prototype.unmount = $236e632e8c7b0376$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        0 === root.tag && $236e632e8c7b0376$var$flushPassiveEffects();
        $236e632e8c7b0376$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $236e632e8c7b0376$var$flushSyncWork$1();
        container[$236e632e8c7b0376$var$internalContainerInstanceKey] = null;
    }
};
function $236e632e8c7b0376$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$236e632e8c7b0376$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $236e632e8c7b0376$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $236e632e8c7b0376$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $236e632e8c7b0376$var$queuedExplicitHydrationTargets[i].priority; i++);
        $236e632e8c7b0376$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $236e632e8c7b0376$var$attemptExplicitHydrationTarget(target);
    }
};
var $236e632e8c7b0376$var$isomorphicReactPackageVersion$jscomp$inline_1686 = $4RFnf.version;
if ("19.0.0" !== $236e632e8c7b0376$var$isomorphicReactPackageVersion$jscomp$inline_1686) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(527, $236e632e8c7b0376$var$isomorphicReactPackageVersion$jscomp$inline_1686, "19.0.0"));
$236e632e8c7b0376$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($236e632e8c7b0376$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $236e632e8c7b0376$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $236e632e8c7b0376$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $236e632e8c7b0376$var$internals$jscomp$inline_2165 = {
    bundleType: 0,
    version: "19.0.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $236e632e8c7b0376$var$ReactSharedInternals,
    findFiberByHostInstance: $236e632e8c7b0376$var$getClosestInstanceFromNode,
    reconcilerVersion: "19.0.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $236e632e8c7b0376$var$hook$jscomp$inline_2166 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$236e632e8c7b0376$var$hook$jscomp$inline_2166.isDisabled && $236e632e8c7b0376$var$hook$jscomp$inline_2166.supportsFiber) try {
        $236e632e8c7b0376$var$rendererID = $236e632e8c7b0376$var$hook$jscomp$inline_2166.inject($236e632e8c7b0376$var$internals$jscomp$inline_2165), $236e632e8c7b0376$var$injectedHook = $236e632e8c7b0376$var$hook$jscomp$inline_2166;
    } catch (err) {}
}
$236e632e8c7b0376$export$882461b6382ed46c = function(container, options) {
    if (!$236e632e8c7b0376$var$isValidContainer(container)) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $236e632e8c7b0376$var$defaultOnUncaughtError, onCaughtError = $236e632e8c7b0376$var$defaultOnCaughtError, onRecoverableError = $236e632e8c7b0376$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $236e632e8c7b0376$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$236e632e8c7b0376$var$internalContainerInstanceKey] = options.current;
    $236e632e8c7b0376$var$listenToAllSupportedEvents(8 === container.nodeType ? container.parentNode : container);
    return new $236e632e8c7b0376$var$ReactDOMRoot(options);
};
$236e632e8c7b0376$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$236e632e8c7b0376$var$isValidContainer(container)) throw Error($236e632e8c7b0376$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $236e632e8c7b0376$var$defaultOnUncaughtError, onCaughtError = $236e632e8c7b0376$var$defaultOnCaughtError, onRecoverableError = $236e632e8c7b0376$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $236e632e8c7b0376$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $236e632e8c7b0376$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $236e632e8c7b0376$var$requestUpdateLane();
    identifierPrefix = $236e632e8c7b0376$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $236e632e8c7b0376$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    initialChildren.current.lanes = isStrictMode;
    $236e632e8c7b0376$var$markRootUpdated$1(initialChildren, isStrictMode);
    $236e632e8c7b0376$var$ensureRootIsScheduled(initialChildren);
    container[$236e632e8c7b0376$var$internalContainerInstanceKey] = initialChildren.current;
    $236e632e8c7b0376$var$listenToAllSupportedEvents(container);
    return new $236e632e8c7b0376$var$ReactDOMHydrationRoot(initialChildren);
};
$236e632e8c7b0376$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("8TTSu", function(module, exports) {
'use strict';

module.exports = (parcelRequire("znfym"));

});
parcelRegister("znfym", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $06a54defb6908d0e$export$c4744153514ff05d; }, function (v) { return $06a54defb6908d0e$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $06a54defb6908d0e$export$3e506c1ccc9cc1a7; }, function (v) { return $06a54defb6908d0e$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $06a54defb6908d0e$export$e26fe2ed2fa76875; }, function (v) { return $06a54defb6908d0e$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $06a54defb6908d0e$export$502329bbf4b505b1; }, function (v) { return $06a54defb6908d0e$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $06a54defb6908d0e$export$6e3807111c4874c4; }, function (v) { return $06a54defb6908d0e$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $06a54defb6908d0e$export$c27134553091fb3a; }, function (v) { return $06a54defb6908d0e$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $06a54defb6908d0e$export$33ee1acdc04fd2a2; }, function (v) { return $06a54defb6908d0e$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $06a54defb6908d0e$export$b00a404bbd5edef2; }, function (v) { return $06a54defb6908d0e$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $06a54defb6908d0e$export$8352ce38b91d0c62; }, function (v) { return $06a54defb6908d0e$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $06a54defb6908d0e$export$d66a1c1c77bd778b; }, function (v) { return $06a54defb6908d0e$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $06a54defb6908d0e$export$d3dfb8e4810cb555; }, function (v) { return $06a54defb6908d0e$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $06a54defb6908d0e$export$839f9183b0465a69; }, function (v) { return $06a54defb6908d0e$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $06a54defb6908d0e$export$72fdf0e06517287b; }, function (v) { return $06a54defb6908d0e$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $06a54defb6908d0e$export$4b844e58a3e414b4; }, function (v) { return $06a54defb6908d0e$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $06a54defb6908d0e$export$816d2913ae6b83b1; }, function (v) { return $06a54defb6908d0e$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $06a54defb6908d0e$export$61bcfe829111a1d0; }, function (v) { return $06a54defb6908d0e$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $06a54defb6908d0e$export$7ee8c9beb337bc3f; }, function (v) { return $06a54defb6908d0e$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $06a54defb6908d0e$export$b5836b71941fa3ed; }, function (v) { return $06a54defb6908d0e$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $06a54defb6908d0e$export$cf845f2c119da08a; }, function (v) { return $06a54defb6908d0e$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $06a54defb6908d0e$export$c4744153514ff05d;
var $06a54defb6908d0e$export$3e506c1ccc9cc1a7;
var $06a54defb6908d0e$export$e26fe2ed2fa76875;
var $06a54defb6908d0e$export$502329bbf4b505b1;
var $06a54defb6908d0e$export$6e3807111c4874c4;
var $06a54defb6908d0e$export$c27134553091fb3a;
var $06a54defb6908d0e$export$33ee1acdc04fd2a2;
var $06a54defb6908d0e$export$b00a404bbd5edef2;
var $06a54defb6908d0e$export$8352ce38b91d0c62;
var $06a54defb6908d0e$export$d66a1c1c77bd778b;
var $06a54defb6908d0e$export$d3dfb8e4810cb555;
var $06a54defb6908d0e$export$839f9183b0465a69;
var $06a54defb6908d0e$export$72fdf0e06517287b;
var $06a54defb6908d0e$export$4b844e58a3e414b4;
var $06a54defb6908d0e$export$816d2913ae6b83b1;
var $06a54defb6908d0e$export$61bcfe829111a1d0;
var $06a54defb6908d0e$export$7ee8c9beb337bc3f;
var $06a54defb6908d0e$export$b5836b71941fa3ed;
var $06a54defb6908d0e$export$cf845f2c119da08a;
"use strict";
function $06a54defb6908d0e$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $06a54defb6908d0e$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $06a54defb6908d0e$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $06a54defb6908d0e$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $06a54defb6908d0e$var$compare(left, last)) rightIndex < length && 0 > $06a54defb6908d0e$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $06a54defb6908d0e$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $06a54defb6908d0e$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$06a54defb6908d0e$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $06a54defb6908d0e$var$localPerformance = performance;
    $06a54defb6908d0e$export$c4744153514ff05d = function() {
        return $06a54defb6908d0e$var$localPerformance.now();
    };
} else {
    var $06a54defb6908d0e$var$localDate = Date, $06a54defb6908d0e$var$initialTime = $06a54defb6908d0e$var$localDate.now();
    $06a54defb6908d0e$export$c4744153514ff05d = function() {
        return $06a54defb6908d0e$var$localDate.now() - $06a54defb6908d0e$var$initialTime;
    };
}
var $06a54defb6908d0e$var$taskQueue = [], $06a54defb6908d0e$var$timerQueue = [], $06a54defb6908d0e$var$taskIdCounter = 1, $06a54defb6908d0e$var$currentTask = null, $06a54defb6908d0e$var$currentPriorityLevel = 3, $06a54defb6908d0e$var$isPerformingWork = !1, $06a54defb6908d0e$var$isHostCallbackScheduled = !1, $06a54defb6908d0e$var$isHostTimeoutScheduled = !1, $06a54defb6908d0e$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $06a54defb6908d0e$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $06a54defb6908d0e$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $06a54defb6908d0e$var$advanceTimers(currentTime) {
    for(var timer = $06a54defb6908d0e$var$peek($06a54defb6908d0e$var$timerQueue); null !== timer;){
        if (null === timer.callback) $06a54defb6908d0e$var$pop($06a54defb6908d0e$var$timerQueue);
        else if (timer.startTime <= currentTime) $06a54defb6908d0e$var$pop($06a54defb6908d0e$var$timerQueue), timer.sortIndex = timer.expirationTime, $06a54defb6908d0e$var$push($06a54defb6908d0e$var$taskQueue, timer);
        else break;
        timer = $06a54defb6908d0e$var$peek($06a54defb6908d0e$var$timerQueue);
    }
}
function $06a54defb6908d0e$var$handleTimeout(currentTime) {
    $06a54defb6908d0e$var$isHostTimeoutScheduled = !1;
    $06a54defb6908d0e$var$advanceTimers(currentTime);
    if (!$06a54defb6908d0e$var$isHostCallbackScheduled) {
        if (null !== $06a54defb6908d0e$var$peek($06a54defb6908d0e$var$taskQueue)) $06a54defb6908d0e$var$isHostCallbackScheduled = !0, $06a54defb6908d0e$var$requestHostCallback();
        else {
            var firstTimer = $06a54defb6908d0e$var$peek($06a54defb6908d0e$var$timerQueue);
            null !== firstTimer && $06a54defb6908d0e$var$requestHostTimeout($06a54defb6908d0e$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $06a54defb6908d0e$var$isMessageLoopRunning = !1, $06a54defb6908d0e$var$taskTimeoutID = -1, $06a54defb6908d0e$var$frameInterval = 5, $06a54defb6908d0e$var$startTime = -1;
function $06a54defb6908d0e$var$shouldYieldToHost() {
    return $06a54defb6908d0e$export$c4744153514ff05d() - $06a54defb6908d0e$var$startTime < $06a54defb6908d0e$var$frameInterval ? !1 : !0;
}
function $06a54defb6908d0e$var$performWorkUntilDeadline() {
    if ($06a54defb6908d0e$var$isMessageLoopRunning) {
        var currentTime = $06a54defb6908d0e$export$c4744153514ff05d();
        $06a54defb6908d0e$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $06a54defb6908d0e$var$isHostCallbackScheduled = !1;
                $06a54defb6908d0e$var$isHostTimeoutScheduled && ($06a54defb6908d0e$var$isHostTimeoutScheduled = !1, $06a54defb6908d0e$var$localClearTimeout($06a54defb6908d0e$var$taskTimeoutID), $06a54defb6908d0e$var$taskTimeoutID = -1);
                $06a54defb6908d0e$var$isPerformingWork = !0;
                var previousPriorityLevel = $06a54defb6908d0e$var$currentPriorityLevel;
                try {
                    b: {
                        $06a54defb6908d0e$var$advanceTimers(currentTime);
                        for($06a54defb6908d0e$var$currentTask = $06a54defb6908d0e$var$peek($06a54defb6908d0e$var$taskQueue); null !== $06a54defb6908d0e$var$currentTask && !($06a54defb6908d0e$var$currentTask.expirationTime > currentTime && $06a54defb6908d0e$var$shouldYieldToHost());){
                            var callback = $06a54defb6908d0e$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $06a54defb6908d0e$var$currentTask.callback = null;
                                $06a54defb6908d0e$var$currentPriorityLevel = $06a54defb6908d0e$var$currentTask.priorityLevel;
                                var continuationCallback = callback($06a54defb6908d0e$var$currentTask.expirationTime <= currentTime);
                                currentTime = $06a54defb6908d0e$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $06a54defb6908d0e$var$currentTask.callback = continuationCallback;
                                    $06a54defb6908d0e$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $06a54defb6908d0e$var$currentTask === $06a54defb6908d0e$var$peek($06a54defb6908d0e$var$taskQueue) && $06a54defb6908d0e$var$pop($06a54defb6908d0e$var$taskQueue);
                                $06a54defb6908d0e$var$advanceTimers(currentTime);
                            } else $06a54defb6908d0e$var$pop($06a54defb6908d0e$var$taskQueue);
                            $06a54defb6908d0e$var$currentTask = $06a54defb6908d0e$var$peek($06a54defb6908d0e$var$taskQueue);
                        }
                        if (null !== $06a54defb6908d0e$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $06a54defb6908d0e$var$peek($06a54defb6908d0e$var$timerQueue);
                            null !== firstTimer && $06a54defb6908d0e$var$requestHostTimeout($06a54defb6908d0e$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $06a54defb6908d0e$var$currentTask = null, $06a54defb6908d0e$var$currentPriorityLevel = previousPriorityLevel, $06a54defb6908d0e$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $06a54defb6908d0e$var$schedulePerformWorkUntilDeadline() : $06a54defb6908d0e$var$isMessageLoopRunning = !1;
        }
    }
}
var $06a54defb6908d0e$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $06a54defb6908d0e$var$localSetImmediate) $06a54defb6908d0e$var$schedulePerformWorkUntilDeadline = function() {
    $06a54defb6908d0e$var$localSetImmediate($06a54defb6908d0e$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $06a54defb6908d0e$var$channel = new MessageChannel(), $06a54defb6908d0e$var$port = $06a54defb6908d0e$var$channel.port2;
    $06a54defb6908d0e$var$channel.port1.onmessage = $06a54defb6908d0e$var$performWorkUntilDeadline;
    $06a54defb6908d0e$var$schedulePerformWorkUntilDeadline = function() {
        $06a54defb6908d0e$var$port.postMessage(null);
    };
} else $06a54defb6908d0e$var$schedulePerformWorkUntilDeadline = function() {
    $06a54defb6908d0e$var$localSetTimeout($06a54defb6908d0e$var$performWorkUntilDeadline, 0);
};
function $06a54defb6908d0e$var$requestHostCallback() {
    $06a54defb6908d0e$var$isMessageLoopRunning || ($06a54defb6908d0e$var$isMessageLoopRunning = !0, $06a54defb6908d0e$var$schedulePerformWorkUntilDeadline());
}
function $06a54defb6908d0e$var$requestHostTimeout(callback, ms) {
    $06a54defb6908d0e$var$taskTimeoutID = $06a54defb6908d0e$var$localSetTimeout(function() {
        callback($06a54defb6908d0e$export$c4744153514ff05d());
    }, ms);
}
$06a54defb6908d0e$export$3e506c1ccc9cc1a7 = 5;
$06a54defb6908d0e$export$e26fe2ed2fa76875 = 1;
$06a54defb6908d0e$export$502329bbf4b505b1 = 4;
$06a54defb6908d0e$export$6e3807111c4874c4 = 3;
$06a54defb6908d0e$export$c27134553091fb3a = null;
$06a54defb6908d0e$export$33ee1acdc04fd2a2 = 2;
$06a54defb6908d0e$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$06a54defb6908d0e$export$8352ce38b91d0c62 = function() {
    $06a54defb6908d0e$var$isHostCallbackScheduled || $06a54defb6908d0e$var$isPerformingWork || ($06a54defb6908d0e$var$isHostCallbackScheduled = !0, $06a54defb6908d0e$var$requestHostCallback());
};
$06a54defb6908d0e$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $06a54defb6908d0e$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$06a54defb6908d0e$export$d3dfb8e4810cb555 = function() {
    return $06a54defb6908d0e$var$currentPriorityLevel;
};
$06a54defb6908d0e$export$839f9183b0465a69 = function() {
    return $06a54defb6908d0e$var$peek($06a54defb6908d0e$var$taskQueue);
};
$06a54defb6908d0e$export$72fdf0e06517287b = function(eventHandler) {
    switch($06a54defb6908d0e$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $06a54defb6908d0e$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $06a54defb6908d0e$var$currentPriorityLevel;
    $06a54defb6908d0e$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $06a54defb6908d0e$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$06a54defb6908d0e$export$4b844e58a3e414b4 = function() {};
$06a54defb6908d0e$export$816d2913ae6b83b1 = function() {};
$06a54defb6908d0e$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $06a54defb6908d0e$var$currentPriorityLevel;
    $06a54defb6908d0e$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $06a54defb6908d0e$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$06a54defb6908d0e$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $06a54defb6908d0e$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $06a54defb6908d0e$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $06a54defb6908d0e$var$push($06a54defb6908d0e$var$timerQueue, priorityLevel), null === $06a54defb6908d0e$var$peek($06a54defb6908d0e$var$taskQueue) && priorityLevel === $06a54defb6908d0e$var$peek($06a54defb6908d0e$var$timerQueue) && ($06a54defb6908d0e$var$isHostTimeoutScheduled ? ($06a54defb6908d0e$var$localClearTimeout($06a54defb6908d0e$var$taskTimeoutID), $06a54defb6908d0e$var$taskTimeoutID = -1) : $06a54defb6908d0e$var$isHostTimeoutScheduled = !0, $06a54defb6908d0e$var$requestHostTimeout($06a54defb6908d0e$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $06a54defb6908d0e$var$push($06a54defb6908d0e$var$taskQueue, priorityLevel), $06a54defb6908d0e$var$isHostCallbackScheduled || $06a54defb6908d0e$var$isPerformingWork || ($06a54defb6908d0e$var$isHostCallbackScheduled = !0, $06a54defb6908d0e$var$requestHostCallback()));
    return priorityLevel;
};
$06a54defb6908d0e$export$b5836b71941fa3ed = $06a54defb6908d0e$var$shouldYieldToHost;
$06a54defb6908d0e$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $06a54defb6908d0e$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $06a54defb6908d0e$var$currentPriorityLevel;
        $06a54defb6908d0e$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $06a54defb6908d0e$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("9lz36", function(module, exports) {
'use strict';
function $6ce1434187f7101c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6ce1434187f7101c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6ce1434187f7101c$var$checkDCE();

module.exports = (parcelRequire("2eeqd"));

});
parcelRegister("2eeqd", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $19f813733aef8f0b$export$69ce8ef3fe5cead0; }, function (v) { return $19f813733aef8f0b$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $19f813733aef8f0b$export$d39a5bbd09211389; }, function (v) { return $19f813733aef8f0b$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $19f813733aef8f0b$export$cd75ccfd720a3cd4; }, function (v) { return $19f813733aef8f0b$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $19f813733aef8f0b$export$a0816fa17a9e79be; }, function (v) { return $19f813733aef8f0b$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $19f813733aef8f0b$export$7292efcadded39f3; }, function (v) { return $19f813733aef8f0b$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $19f813733aef8f0b$export$da407abadb9b8f86; }, function (v) { return $19f813733aef8f0b$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $19f813733aef8f0b$export$314cfea32580671c; }, function (v) { return $19f813733aef8f0b$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $19f813733aef8f0b$export$513ccb98c53b8039; }, function (v) { return $19f813733aef8f0b$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $19f813733aef8f0b$export$dbca993bc2d264a; }, function (v) { return $19f813733aef8f0b$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $19f813733aef8f0b$export$4797a8006f0655d0; }, function (v) { return $19f813733aef8f0b$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $19f813733aef8f0b$export$c78a37762a8d58e1; }, function (v) { return $19f813733aef8f0b$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $19f813733aef8f0b$export$606f11b2eb45ecc6; }, function (v) { return $19f813733aef8f0b$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $19f813733aef8f0b$export$f7e8a0bf92324b1e; }, function (v) { return $19f813733aef8f0b$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $19f813733aef8f0b$export$83d89fbfd8236492; }, function (v) { return $19f813733aef8f0b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $19f813733aef8f0b$export$69ce8ef3fe5cead0;
var $19f813733aef8f0b$export$d39a5bbd09211389;
var $19f813733aef8f0b$export$cd75ccfd720a3cd4;
var $19f813733aef8f0b$export$a0816fa17a9e79be;
var $19f813733aef8f0b$export$7292efcadded39f3;
var $19f813733aef8f0b$export$da407abadb9b8f86;
var $19f813733aef8f0b$export$314cfea32580671c;
var $19f813733aef8f0b$export$513ccb98c53b8039;
var $19f813733aef8f0b$export$dbca993bc2d264a;
var $19f813733aef8f0b$export$4797a8006f0655d0;
var $19f813733aef8f0b$export$c78a37762a8d58e1;
var $19f813733aef8f0b$export$606f11b2eb45ecc6;
var $19f813733aef8f0b$export$f7e8a0bf92324b1e;
var $19f813733aef8f0b$export$83d89fbfd8236492;
"use strict";

var $4RFnf = parcelRequire("4RFnf");
function $19f813733aef8f0b$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $19f813733aef8f0b$var$noop() {}
var $19f813733aef8f0b$var$Internals = {
    d: {
        f: $19f813733aef8f0b$var$noop,
        r: function() {
            throw Error($19f813733aef8f0b$var$formatProdErrorMessage(522));
        },
        D: $19f813733aef8f0b$var$noop,
        C: $19f813733aef8f0b$var$noop,
        L: $19f813733aef8f0b$var$noop,
        m: $19f813733aef8f0b$var$noop,
        X: $19f813733aef8f0b$var$noop,
        S: $19f813733aef8f0b$var$noop,
        M: $19f813733aef8f0b$var$noop
    },
    p: 0,
    findDOMNode: null
}, $19f813733aef8f0b$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $19f813733aef8f0b$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $19f813733aef8f0b$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $19f813733aef8f0b$var$ReactSharedInternals = $4RFnf.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $19f813733aef8f0b$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$19f813733aef8f0b$export$69ce8ef3fe5cead0 = $19f813733aef8f0b$var$Internals;
$19f813733aef8f0b$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($19f813733aef8f0b$var$formatProdErrorMessage(299));
    return $19f813733aef8f0b$var$createPortal$1(children, container, null, key);
};
$19f813733aef8f0b$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $19f813733aef8f0b$var$ReactSharedInternals.T, previousUpdatePriority = $19f813733aef8f0b$var$Internals.p;
    try {
        if ($19f813733aef8f0b$var$ReactSharedInternals.T = null, $19f813733aef8f0b$var$Internals.p = 2, fn) return fn();
    } finally{
        $19f813733aef8f0b$var$ReactSharedInternals.T = previousTransition, $19f813733aef8f0b$var$Internals.p = previousUpdatePriority, $19f813733aef8f0b$var$Internals.d.f();
    }
};
$19f813733aef8f0b$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $19f813733aef8f0b$var$Internals.d.C(href, options));
};
$19f813733aef8f0b$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $19f813733aef8f0b$var$Internals.d.D(href);
};
$19f813733aef8f0b$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $19f813733aef8f0b$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $19f813733aef8f0b$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $19f813733aef8f0b$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$19f813733aef8f0b$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $19f813733aef8f0b$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $19f813733aef8f0b$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $19f813733aef8f0b$var$Internals.d.M(href);
    }
};
$19f813733aef8f0b$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $19f813733aef8f0b$var$getCrossOriginStringAs(as, options.crossOrigin);
        $19f813733aef8f0b$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$19f813733aef8f0b$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $19f813733aef8f0b$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $19f813733aef8f0b$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $19f813733aef8f0b$var$Internals.d.m(href);
    }
};
$19f813733aef8f0b$export$4797a8006f0655d0 = function(form) {
    $19f813733aef8f0b$var$Internals.d.r(form);
};
$19f813733aef8f0b$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$19f813733aef8f0b$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $19f813733aef8f0b$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$19f813733aef8f0b$export$f7e8a0bf92324b1e = function() {
    return $19f813733aef8f0b$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$19f813733aef8f0b$export$83d89fbfd8236492 = "19.0.0";

});



parcelRegister("eGOwh", function(module, exports) {

$parcel$export(module.exports, "createBrowserRouter", function () { return $ab1c2d1a5ff1b7e8$export$1f3f55432a00e06d; });
$parcel$export(module.exports, "RouterProvider", function () { return $ab1c2d1a5ff1b7e8$export$323e4fc2fa4753fb; });
$parcel$export(module.exports, "Link", function () { return $ab1c2d1a5ff1b7e8$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "NavLink", function () { return $ab1c2d1a5ff1b7e8$export$b0d92dbee9b5b60d; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("3W4eU")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("3W4eU")).useNavigate; });
/**
 * React Router DOM v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4RFnf = parcelRequire("4RFnf");

var $9lz36 = parcelRequire("9lz36");

var $jw2qW = parcelRequire("jw2qW");
var $3W4eU = parcelRequire("3W4eU");

var $jw2qW = parcelRequire("jw2qW");
function $ab1c2d1a5ff1b7e8$var$_extends() {
    $ab1c2d1a5ff1b7e8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ab1c2d1a5ff1b7e8$var$_extends.apply(this, arguments);
}
function $ab1c2d1a5ff1b7e8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $ab1c2d1a5ff1b7e8$var$defaultMethod = "get";
const $ab1c2d1a5ff1b7e8$var$defaultEncType = "application/x-www-form-urlencoded";
function $ab1c2d1a5ff1b7e8$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $ab1c2d1a5ff1b7e8$var$isButtonElement(object) {
    return $ab1c2d1a5ff1b7e8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $ab1c2d1a5ff1b7e8$var$isFormElement(object) {
    return $ab1c2d1a5ff1b7e8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $ab1c2d1a5ff1b7e8$var$isInputElement(object) {
    return $ab1c2d1a5ff1b7e8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $ab1c2d1a5ff1b7e8$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $ab1c2d1a5ff1b7e8$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$ab1c2d1a5ff1b7e8$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $ab1c2d1a5ff1b7e8$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $ab1c2d1a5ff1b7e8$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $ab1c2d1a5ff1b7e8$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $ab1c2d1a5ff1b7e8$var$_formDataSupportsSubmitter = null;
function $ab1c2d1a5ff1b7e8$var$isFormDataSubmitterSupported() {
    if ($ab1c2d1a5ff1b7e8$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $ab1c2d1a5ff1b7e8$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $ab1c2d1a5ff1b7e8$var$_formDataSupportsSubmitter = true;
    }
    return $ab1c2d1a5ff1b7e8$var$_formDataSupportsSubmitter;
}
const $ab1c2d1a5ff1b7e8$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $ab1c2d1a5ff1b7e8$var$getFormEncType(encType) {
    if (encType != null && !$ab1c2d1a5ff1b7e8$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $ab1c2d1a5ff1b7e8$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($ab1c2d1a5ff1b7e8$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $jw2qW.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $ab1c2d1a5ff1b7e8$var$defaultMethod;
        encType = $ab1c2d1a5ff1b7e8$var$getFormEncType(target.getAttribute("enctype")) || $ab1c2d1a5ff1b7e8$var$defaultEncType;
        formData = new FormData(target);
    } else if ($ab1c2d1a5ff1b7e8$var$isButtonElement(target) || $ab1c2d1a5ff1b7e8$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $jw2qW.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $ab1c2d1a5ff1b7e8$var$defaultMethod;
        encType = $ab1c2d1a5ff1b7e8$var$getFormEncType(target.getAttribute("formenctype")) || $ab1c2d1a5ff1b7e8$var$getFormEncType(form.getAttribute("enctype")) || $ab1c2d1a5ff1b7e8$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$ab1c2d1a5ff1b7e8$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($ab1c2d1a5ff1b7e8$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $ab1c2d1a5ff1b7e8$var$defaultMethod;
        action = null;
        encType = $ab1c2d1a5ff1b7e8$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $ab1c2d1a5ff1b7e8$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $ab1c2d1a5ff1b7e8$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $ab1c2d1a5ff1b7e8$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $ab1c2d1a5ff1b7e8$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $ab1c2d1a5ff1b7e8$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $ab1c2d1a5ff1b7e8$export$1f3f55432a00e06d(routes, opts) {
    return (0, $jw2qW.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $ab1c2d1a5ff1b7e8$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $jw2qW.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $ab1c2d1a5ff1b7e8$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $3W4eU.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $ab1c2d1a5ff1b7e8$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $jw2qW.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $ab1c2d1a5ff1b7e8$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $jw2qW.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $ab1c2d1a5ff1b7e8$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $3W4eU.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $ab1c2d1a5ff1b7e8$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $ab1c2d1a5ff1b7e8$var$_extends({}, state, {
        errors: $ab1c2d1a5ff1b7e8$var$deserializeErrors(state.errors)
    });
    return state;
}
function $ab1c2d1a5ff1b7e8$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $jw2qW.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $ab1c2d1a5ff1b7e8$export$7ad602f0e94e62d1 = /*#__PURE__*/ $4RFnf.createContext({
    isTransitioning: false
});
const $ab1c2d1a5ff1b7e8$export$148fd98d095596d4 = /*#__PURE__*/ $4RFnf.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $ab1c2d1a5ff1b7e8$var$START_TRANSITION = "startTransition";
const $ab1c2d1a5ff1b7e8$var$startTransitionImpl = $4RFnf[$ab1c2d1a5ff1b7e8$var$START_TRANSITION];
const $ab1c2d1a5ff1b7e8$var$FLUSH_SYNC = "flushSync";
const $ab1c2d1a5ff1b7e8$var$flushSyncImpl = $9lz36[$ab1c2d1a5ff1b7e8$var$FLUSH_SYNC];
const $ab1c2d1a5ff1b7e8$var$USE_ID = "useId";
const $ab1c2d1a5ff1b7e8$var$useIdImpl = $4RFnf[$ab1c2d1a5ff1b7e8$var$USE_ID];
function $ab1c2d1a5ff1b7e8$var$startTransitionSafe(cb) {
    if ($ab1c2d1a5ff1b7e8$var$startTransitionImpl) $ab1c2d1a5ff1b7e8$var$startTransitionImpl(cb);
    else cb();
}
function $ab1c2d1a5ff1b7e8$var$flushSyncSafe(cb) {
    if ($ab1c2d1a5ff1b7e8$var$flushSyncImpl) $ab1c2d1a5ff1b7e8$var$flushSyncImpl(cb);
    else cb();
}
class $ab1c2d1a5ff1b7e8$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $ab1c2d1a5ff1b7e8$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $4RFnf.useState(router.state);
    let [pendingState, setPendingState] = $4RFnf.useState();
    let [vtContext, setVtContext] = $4RFnf.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $4RFnf.useState();
    let [transition, setTransition] = $4RFnf.useState();
    let [interruption, setInterruption] = $4RFnf.useState();
    let fetcherData = $4RFnf.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $4RFnf.useCallback((cb)=>{
        if (v7_startTransition) $ab1c2d1a5ff1b7e8$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $4RFnf.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $ab1c2d1a5ff1b7e8$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $ab1c2d1a5ff1b7e8$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $ab1c2d1a5ff1b7e8$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $ab1c2d1a5ff1b7e8$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $ab1c2d1a5ff1b7e8$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $4RFnf.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $4RFnf.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $ab1c2d1a5ff1b7e8$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $4RFnf.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $4RFnf.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $4RFnf.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $4RFnf.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $4RFnf.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4RFnf.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $4RFnf.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $4RFnf.useEffect(()=>(0, $3W4eU.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4RFnf.createElement($4RFnf.Fragment, null, /*#__PURE__*/ $4RFnf.createElement((0, $3W4eU.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4RFnf.createElement((0, $3W4eU.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $4RFnf.createElement($ab1c2d1a5ff1b7e8$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $4RFnf.createElement($ab1c2d1a5ff1b7e8$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $4RFnf.createElement((0, $3W4eU.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $4RFnf.createElement($ab1c2d1a5ff1b7e8$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $ab1c2d1a5ff1b7e8$var$MemoizedDataRoutes = /*#__PURE__*/ $4RFnf.memo($ab1c2d1a5ff1b7e8$var$DataRoutes);
function $ab1c2d1a5ff1b7e8$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $3W4eU.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $ab1c2d1a5ff1b7e8$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $4RFnf.useRef();
    if (historyRef.current == null) historyRef.current = (0, $jw2qW.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4RFnf.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4RFnf.useCallback((newState)=>{
        v7_startTransition && $ab1c2d1a5ff1b7e8$var$startTransitionImpl ? $ab1c2d1a5ff1b7e8$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4RFnf.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $4RFnf.useEffect(()=>(0, $3W4eU.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $4RFnf.createElement((0, $3W4eU.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $ab1c2d1a5ff1b7e8$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $4RFnf.useRef();
    if (historyRef.current == null) historyRef.current = (0, $jw2qW.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4RFnf.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4RFnf.useCallback((newState)=>{
        v7_startTransition && $ab1c2d1a5ff1b7e8$var$startTransitionImpl ? $ab1c2d1a5ff1b7e8$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4RFnf.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $4RFnf.useEffect(()=>(0, $3W4eU.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $4RFnf.createElement((0, $3W4eU.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $ab1c2d1a5ff1b7e8$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $4RFnf.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4RFnf.useCallback((newState)=>{
        v7_startTransition && $ab1c2d1a5ff1b7e8$var$startTransitionImpl ? $ab1c2d1a5ff1b7e8$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4RFnf.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $4RFnf.useEffect(()=>(0, $3W4eU.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $4RFnf.createElement((0, $3W4eU.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $ab1c2d1a5ff1b7e8$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $ab1c2d1a5ff1b7e8$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $ab1c2d1a5ff1b7e8$export$a6c7ac8248d6e38a = /*#__PURE__*/ $4RFnf.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $ab1c2d1a5ff1b7e8$var$_objectWithoutPropertiesLoose(_ref7, $ab1c2d1a5ff1b7e8$var$_excluded);
    let { basename: basename } = $4RFnf.useContext((0, $3W4eU.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $ab1c2d1a5ff1b7e8$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($ab1c2d1a5ff1b7e8$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $jw2qW.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $3W4eU.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $ab1c2d1a5ff1b7e8$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $4RFnf.createElement("a", $ab1c2d1a5ff1b7e8$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $ab1c2d1a5ff1b7e8$export$b0d92dbee9b5b60d = /*#__PURE__*/ $4RFnf.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $ab1c2d1a5ff1b7e8$var$_objectWithoutPropertiesLoose(_ref8, $ab1c2d1a5ff1b7e8$var$_excluded2);
    let path = (0, $3W4eU.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $3W4eU.useLocation)();
    let routerState = $4RFnf.useContext((0, $3W4eU.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $4RFnf.useContext((0, $3W4eU.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $ab1c2d1a5ff1b7e8$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $jw2qW.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $4RFnf.createElement($ab1c2d1a5ff1b7e8$export$a6c7ac8248d6e38a, $ab1c2d1a5ff1b7e8$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $ab1c2d1a5ff1b7e8$export$a7fed597f4b8afd8 = /*#__PURE__*/ $4RFnf.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $ab1c2d1a5ff1b7e8$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $ab1c2d1a5ff1b7e8$var$_objectWithoutPropertiesLoose(_ref9, $ab1c2d1a5ff1b7e8$var$_excluded3);
    let submit = $ab1c2d1a5ff1b7e8$export$47c85c6e3a081d3();
    let formAction = $ab1c2d1a5ff1b7e8$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $4RFnf.createElement("form", $ab1c2d1a5ff1b7e8$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $ab1c2d1a5ff1b7e8$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $ab1c2d1a5ff1b7e8$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $ab1c2d1a5ff1b7e8$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($ab1c2d1a5ff1b7e8$var$DataRouterHook || ($ab1c2d1a5ff1b7e8$var$DataRouterHook = {}));
var $ab1c2d1a5ff1b7e8$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($ab1c2d1a5ff1b7e8$var$DataRouterStateHook || ($ab1c2d1a5ff1b7e8$var$DataRouterStateHook = {}));
// Internal hooks
function $ab1c2d1a5ff1b7e8$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $ab1c2d1a5ff1b7e8$var$useDataRouterContext(hookName) {
    let ctx = $4RFnf.useContext((0, $3W4eU.UNSAFE_DataRouterContext));
    !ctx && (0, $jw2qW.UNSAFE_invariant)(false);
    return ctx;
}
function $ab1c2d1a5ff1b7e8$var$useDataRouterState(hookName) {
    let state = $4RFnf.useContext((0, $3W4eU.UNSAFE_DataRouterStateContext));
    !state && (0, $jw2qW.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $ab1c2d1a5ff1b7e8$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $3W4eU.useNavigate)();
    let location = (0, $3W4eU.useLocation)();
    let path = (0, $3W4eU.useResolvedPath)(to, {
        relative: relative
    });
    return $4RFnf.useCallback((event)=>{
        if ($ab1c2d1a5ff1b7e8$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $jw2qW.createPath)(location) === (0, $jw2qW.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $ab1c2d1a5ff1b7e8$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $4RFnf.useRef($ab1c2d1a5ff1b7e8$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $4RFnf.useRef(false);
    let location = (0, $3W4eU.useLocation)();
    let searchParams = $4RFnf.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $ab1c2d1a5ff1b7e8$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $3W4eU.useNavigate)();
    let setSearchParams = $4RFnf.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $ab1c2d1a5ff1b7e8$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $ab1c2d1a5ff1b7e8$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $ab1c2d1a5ff1b7e8$var$fetcherId = 0;
let $ab1c2d1a5ff1b7e8$var$getUniqueFetcherId = ()=>"__" + String(++$ab1c2d1a5ff1b7e8$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $ab1c2d1a5ff1b7e8$export$47c85c6e3a081d3() {
    let { router: router } = $ab1c2d1a5ff1b7e8$var$useDataRouterContext($ab1c2d1a5ff1b7e8$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $4RFnf.useContext((0, $3W4eU.UNSAFE_NavigationContext));
    let currentRouteId = (0, $3W4eU.UNSAFE_useRouteId)();
    return $4RFnf.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $ab1c2d1a5ff1b7e8$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $ab1c2d1a5ff1b7e8$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $ab1c2d1a5ff1b7e8$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $ab1c2d1a5ff1b7e8$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $4RFnf.useContext((0, $3W4eU.UNSAFE_NavigationContext));
    let routeContext = $4RFnf.useContext((0, $3W4eU.UNSAFE_RouteContext));
    !routeContext && (0, $jw2qW.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $ab1c2d1a5ff1b7e8$var$_extends({}, (0, $3W4eU.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $3W4eU.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $jw2qW.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $jw2qW.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $ab1c2d1a5ff1b7e8$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $ab1c2d1a5ff1b7e8$var$useDataRouterContext($ab1c2d1a5ff1b7e8$var$DataRouterHook.UseFetcher);
    let state = $ab1c2d1a5ff1b7e8$var$useDataRouterState($ab1c2d1a5ff1b7e8$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $4RFnf.useContext($ab1c2d1a5ff1b7e8$export$148fd98d095596d4);
    let route = $4RFnf.useContext((0, $3W4eU.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $jw2qW.UNSAFE_invariant)(false);
    !route && (0, $jw2qW.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $jw2qW.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $ab1c2d1a5ff1b7e8$var$useIdImpl ? $ab1c2d1a5ff1b7e8$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $4RFnf.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($ab1c2d1a5ff1b7e8$var$getUniqueFetcherId());
    // Registration/cleanup
    $4RFnf.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $4RFnf.useCallback((href, opts)=>{
        !routeId && (0, $jw2qW.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $ab1c2d1a5ff1b7e8$export$47c85c6e3a081d3();
    let submit = $4RFnf.useCallback((target, opts)=>{
        submitImpl(target, $ab1c2d1a5ff1b7e8$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $4RFnf.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $4RFnf.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $4RFnf.createElement($ab1c2d1a5ff1b7e8$export$a7fed597f4b8afd8, $ab1c2d1a5ff1b7e8$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $jw2qW.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $4RFnf.useMemo(()=>$ab1c2d1a5ff1b7e8$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $ab1c2d1a5ff1b7e8$export$fa996778a3a31087() {
    let state = $ab1c2d1a5ff1b7e8$var$useDataRouterState($ab1c2d1a5ff1b7e8$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $ab1c2d1a5ff1b7e8$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $ab1c2d1a5ff1b7e8$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $ab1c2d1a5ff1b7e8$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $ab1c2d1a5ff1b7e8$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $ab1c2d1a5ff1b7e8$var$useDataRouterContext($ab1c2d1a5ff1b7e8$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $ab1c2d1a5ff1b7e8$var$useDataRouterState($ab1c2d1a5ff1b7e8$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $4RFnf.useContext((0, $3W4eU.UNSAFE_NavigationContext));
    let location = (0, $3W4eU.useLocation)();
    let matches = (0, $3W4eU.useMatches)();
    let navigation = (0, $3W4eU.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $4RFnf.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $ab1c2d1a5ff1b7e8$var$usePageHide($4RFnf.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $ab1c2d1a5ff1b7e8$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $ab1c2d1a5ff1b7e8$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($ab1c2d1a5ff1b7e8$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4RFnf.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $ab1c2d1a5ff1b7e8$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $ab1c2d1a5ff1b7e8$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4RFnf.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($ab1c2d1a5ff1b7e8$var$_extends({}, location, {
                    pathname: (0, $jw2qW.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($ab1c2d1a5ff1b7e8$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4RFnf.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $ab1c2d1a5ff1b7e8$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $4RFnf.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $ab1c2d1a5ff1b7e8$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $4RFnf.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $ab1c2d1a5ff1b7e8$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $3W4eU.useBlocker)(when);
    $4RFnf.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $4RFnf.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $ab1c2d1a5ff1b7e8$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $4RFnf.useContext($ab1c2d1a5ff1b7e8$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $jw2qW.UNSAFE_invariant)(false);
    let { basename: basename } = $ab1c2d1a5ff1b7e8$var$useDataRouterContext($ab1c2d1a5ff1b7e8$var$DataRouterHook.useViewTransitionState);
    let path = (0, $3W4eU.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $jw2qW.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $jw2qW.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $jw2qW.matchPath)(path.pathname, nextPath) != null || (0, $jw2qW.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("jw2qW", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $e352e4bbcb5a39c7$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $e352e4bbcb5a39c7$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $e352e4bbcb5a39c7$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $e352e4bbcb5a39c7$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $e352e4bbcb5a39c7$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $e352e4bbcb5a39c7$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $e352e4bbcb5a39c7$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $e352e4bbcb5a39c7$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $e352e4bbcb5a39c7$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return $e352e4bbcb5a39c7$export$30d21fd6d7295f52; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $e352e4bbcb5a39c7$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $e352e4bbcb5a39c7$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $e352e4bbcb5a39c7$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return $e352e4bbcb5a39c7$export$a5784978eca585fa; });
$parcel$export(module.exports, "resolveTo", function () { return $e352e4bbcb5a39c7$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $e352e4bbcb5a39c7$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $e352e4bbcb5a39c7$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $e352e4bbcb5a39c7$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $e352e4bbcb5a39c7$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $e352e4bbcb5a39c7$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $e352e4bbcb5a39c7$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $e352e4bbcb5a39c7$var$_extends() {
    $e352e4bbcb5a39c7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e352e4bbcb5a39c7$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $e352e4bbcb5a39c7$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($e352e4bbcb5a39c7$export$e19cd5f9376f8cee || ($e352e4bbcb5a39c7$export$e19cd5f9376f8cee = {}));
const $e352e4bbcb5a39c7$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $e352e4bbcb5a39c7$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $e352e4bbcb5a39c7$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $e352e4bbcb5a39c7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $e352e4bbcb5a39c7$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $e352e4bbcb5a39c7$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $e352e4bbcb5a39c7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $e352e4bbcb5a39c7$export$fe53371bee54353d(to);
    }
    return $e352e4bbcb5a39c7$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $e352e4bbcb5a39c7$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $e352e4bbcb5a39c7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $e352e4bbcb5a39c7$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $e352e4bbcb5a39c7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $e352e4bbcb5a39c7$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $e352e4bbcb5a39c7$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $e352e4bbcb5a39c7$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $e352e4bbcb5a39c7$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $e352e4bbcb5a39c7$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $e352e4bbcb5a39c7$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $e352e4bbcb5a39c7$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $e352e4bbcb5a39c7$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $e352e4bbcb5a39c7$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $e352e4bbcb5a39c7$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($e352e4bbcb5a39c7$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Push;
        let location = $e352e4bbcb5a39c7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $e352e4bbcb5a39c7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Replace;
        let location = $e352e4bbcb5a39c7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $e352e4bbcb5a39c7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $e352e4bbcb5a39c7$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($e352e4bbcb5a39c7$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($e352e4bbcb5a39c7$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $e352e4bbcb5a39c7$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($e352e4bbcb5a39c7$var$ResultType || ($e352e4bbcb5a39c7$var$ResultType = {}));
const $e352e4bbcb5a39c7$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $e352e4bbcb5a39c7$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $e352e4bbcb5a39c7$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($e352e4bbcb5a39c7$var$isIndexRoute(route)) {
            let indexRoute = $e352e4bbcb5a39c7$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $e352e4bbcb5a39c7$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $e352e4bbcb5a39c7$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $e352e4bbcb5a39c7$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $e352e4bbcb5a39c7$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $e352e4bbcb5a39c7$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $e352e4bbcb5a39c7$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $e352e4bbcb5a39c7$var$flattenRoutes(routes);
    $e352e4bbcb5a39c7$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $e352e4bbcb5a39c7$export$30d21fd6d7295f52(pathname);
        matches = $e352e4bbcb5a39c7$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $e352e4bbcb5a39c7$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $e352e4bbcb5a39c7$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $e352e4bbcb5a39c7$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $e352e4bbcb5a39c7$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $e352e4bbcb5a39c7$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $e352e4bbcb5a39c7$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $e352e4bbcb5a39c7$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $e352e4bbcb5a39c7$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $e352e4bbcb5a39c7$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $e352e4bbcb5a39c7$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $e352e4bbcb5a39c7$var$paramRe = /^:[\w-]+$/;
const $e352e4bbcb5a39c7$var$dynamicSegmentValue = 3;
const $e352e4bbcb5a39c7$var$indexRouteValue = 2;
const $e352e4bbcb5a39c7$var$emptySegmentValue = 1;
const $e352e4bbcb5a39c7$var$staticSegmentValue = 10;
const $e352e4bbcb5a39c7$var$splatPenalty = -2;
const $e352e4bbcb5a39c7$var$isSplat = (s)=>s === "*";
function $e352e4bbcb5a39c7$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($e352e4bbcb5a39c7$var$isSplat)) initialScore += $e352e4bbcb5a39c7$var$splatPenalty;
    if (index) initialScore += $e352e4bbcb5a39c7$var$indexRouteValue;
    return segments.filter((s)=>!$e352e4bbcb5a39c7$var$isSplat(s)).reduce((score, segment)=>score + ($e352e4bbcb5a39c7$var$paramRe.test(segment) ? $e352e4bbcb5a39c7$var$dynamicSegmentValue : segment === "" ? $e352e4bbcb5a39c7$var$emptySegmentValue : $e352e4bbcb5a39c7$var$staticSegmentValue), initialScore);
}
function $e352e4bbcb5a39c7$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $e352e4bbcb5a39c7$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $e352e4bbcb5a39c7$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $e352e4bbcb5a39c7$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $e352e4bbcb5a39c7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $e352e4bbcb5a39c7$export$a5c6d149b50c1d86($e352e4bbcb5a39c7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $e352e4bbcb5a39c7$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $e352e4bbcb5a39c7$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $e352e4bbcb5a39c7$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $e352e4bbcb5a39c7$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $e352e4bbcb5a39c7$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $e352e4bbcb5a39c7$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $e352e4bbcb5a39c7$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $e352e4bbcb5a39c7$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $e352e4bbcb5a39c7$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $e352e4bbcb5a39c7$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $e352e4bbcb5a39c7$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $e352e4bbcb5a39c7$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $e352e4bbcb5a39c7$var$normalizeSearch(search),
        hash: $e352e4bbcb5a39c7$var$normalizeHash(hash)
    };
}
function $e352e4bbcb5a39c7$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $e352e4bbcb5a39c7$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $e352e4bbcb5a39c7$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $e352e4bbcb5a39c7$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $e352e4bbcb5a39c7$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $e352e4bbcb5a39c7$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(toArg);
    else {
        to = $e352e4bbcb5a39c7$var$_extends({}, toArg);
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $e352e4bbcb5a39c7$var$getInvalidPathError("?", "pathname", "search", to));
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $e352e4bbcb5a39c7$var$getInvalidPathError("#", "pathname", "hash", to));
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $e352e4bbcb5a39c7$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $e352e4bbcb5a39c7$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $e352e4bbcb5a39c7$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $e352e4bbcb5a39c7$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $e352e4bbcb5a39c7$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $e352e4bbcb5a39c7$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $e352e4bbcb5a39c7$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $e352e4bbcb5a39c7$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $e352e4bbcb5a39c7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $e352e4bbcb5a39c7$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $e352e4bbcb5a39c7$export$4051a07651545597(data, init) {
    return new $e352e4bbcb5a39c7$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $e352e4bbcb5a39c7$export$42a99a7a4bc0e76a extends Error {
}
class $e352e4bbcb5a39c7$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $e352e4bbcb5a39c7$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $e352e4bbcb5a39c7$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $e352e4bbcb5a39c7$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $e352e4bbcb5a39c7$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $e352e4bbcb5a39c7$var$unwrapTrackedPromise(value) {
    if (!$e352e4bbcb5a39c7$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $e352e4bbcb5a39c7$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $e352e4bbcb5a39c7$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e352e4bbcb5a39c7$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $e352e4bbcb5a39c7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e352e4bbcb5a39c7$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $e352e4bbcb5a39c7$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e352e4bbcb5a39c7$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $e352e4bbcb5a39c7$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $e352e4bbcb5a39c7$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $e352e4bbcb5a39c7$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $e352e4bbcb5a39c7$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $e352e4bbcb5a39c7$var$validMutationMethods = new Set($e352e4bbcb5a39c7$var$validMutationMethodsArr);
const $e352e4bbcb5a39c7$var$validRequestMethodsArr = [
    "get",
    ...$e352e4bbcb5a39c7$var$validMutationMethodsArr
];
const $e352e4bbcb5a39c7$var$validRequestMethods = new Set($e352e4bbcb5a39c7$var$validRequestMethodsArr);
const $e352e4bbcb5a39c7$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $e352e4bbcb5a39c7$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $e352e4bbcb5a39c7$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $e352e4bbcb5a39c7$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $e352e4bbcb5a39c7$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $e352e4bbcb5a39c7$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $e352e4bbcb5a39c7$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $e352e4bbcb5a39c7$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $e352e4bbcb5a39c7$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $e352e4bbcb5a39c7$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $e352e4bbcb5a39c7$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $e352e4bbcb5a39c7$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $e352e4bbcb5a39c7$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $e352e4bbcb5a39c7$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $e352e4bbcb5a39c7$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $e352e4bbcb5a39c7$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$e352e4bbcb5a39c7$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$e352e4bbcb5a39c7$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $e352e4bbcb5a39c7$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $e352e4bbcb5a39c7$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $e352e4bbcb5a39c7$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $e352e4bbcb5a39c7$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$e352e4bbcb5a39c7$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $e352e4bbcb5a39c7$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $e352e4bbcb5a39c7$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $e352e4bbcb5a39c7$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $e352e4bbcb5a39c7$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $e352e4bbcb5a39c7$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($e352e4bbcb5a39c7$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $e352e4bbcb5a39c7$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $e352e4bbcb5a39c7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $e352e4bbcb5a39c7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $e352e4bbcb5a39c7$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $e352e4bbcb5a39c7$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $e352e4bbcb5a39c7$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $e352e4bbcb5a39c7$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $e352e4bbcb5a39c7$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $e352e4bbcb5a39c7$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $e352e4bbcb5a39c7$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $e352e4bbcb5a39c7$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $e352e4bbcb5a39c7$var$findNearestBoundary(matches).route.id,
            {
                type: $e352e4bbcb5a39c7$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $e352e4bbcb5a39c7$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($e352e4bbcb5a39c7$var$isErrorResult(result) && $e352e4bbcb5a39c7$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $e352e4bbcb5a39c7$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $e352e4bbcb5a39c7$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $e352e4bbcb5a39c7$var$_extends({
            matches: updatedMatches || matches
        }, $e352e4bbcb5a39c7$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $e352e4bbcb5a39c7$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $e352e4bbcb5a39c7$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $e352e4bbcb5a39c7$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $e352e4bbcb5a39c7$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $e352e4bbcb5a39c7$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $e352e4bbcb5a39c7$var$ResultType.error,
            error: $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($e352e4bbcb5a39c7$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $e352e4bbcb5a39c7$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($e352e4bbcb5a39c7$var$isDeferredResult(result)) throw $e352e4bbcb5a39c7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($e352e4bbcb5a39c7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $e352e4bbcb5a39c7$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $e352e4bbcb5a39c7$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $e352e4bbcb5a39c7$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($e352e4bbcb5a39c7$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $e352e4bbcb5a39c7$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $e352e4bbcb5a39c7$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $e352e4bbcb5a39c7$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $e352e4bbcb5a39c7$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $e352e4bbcb5a39c7$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $e352e4bbcb5a39c7$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $e352e4bbcb5a39c7$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $e352e4bbcb5a39c7$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $e352e4bbcb5a39c7$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $e352e4bbcb5a39c7$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $e352e4bbcb5a39c7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $e352e4bbcb5a39c7$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $e352e4bbcb5a39c7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $e352e4bbcb5a39c7$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $e352e4bbcb5a39c7$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $e352e4bbcb5a39c7$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $e352e4bbcb5a39c7$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $e352e4bbcb5a39c7$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($e352e4bbcb5a39c7$var$isRedirectResult(actionResult) || $e352e4bbcb5a39c7$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $e352e4bbcb5a39c7$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($e352e4bbcb5a39c7$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $e352e4bbcb5a39c7$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $e352e4bbcb5a39c7$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($e352e4bbcb5a39c7$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($e352e4bbcb5a39c7$var$isDeferredResult(actionResult)) throw $e352e4bbcb5a39c7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $e352e4bbcb5a39c7$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $e352e4bbcb5a39c7$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $e352e4bbcb5a39c7$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $e352e4bbcb5a39c7$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $e352e4bbcb5a39c7$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $e352e4bbcb5a39c7$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $e352e4bbcb5a39c7$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $e352e4bbcb5a39c7$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $e352e4bbcb5a39c7$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $e352e4bbcb5a39c7$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $e352e4bbcb5a39c7$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $e352e4bbcb5a39c7$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $e352e4bbcb5a39c7$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($e352e4bbcb5a39c7$var$isDeferredResult(result)) result = await $e352e4bbcb5a39c7$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $e352e4bbcb5a39c7$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($e352e4bbcb5a39c7$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $e352e4bbcb5a39c7$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($e352e4bbcb5a39c7$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(!$e352e4bbcb5a39c7$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $e352e4bbcb5a39c7$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $e352e4bbcb5a39c7$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $e352e4bbcb5a39c7$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($e352e4bbcb5a39c7$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $e352e4bbcb5a39c7$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Replace : $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $e352e4bbcb5a39c7$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($e352e4bbcb5a39c7$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $e352e4bbcb5a39c7$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $e352e4bbcb5a39c7$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $e352e4bbcb5a39c7$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $e352e4bbcb5a39c7$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $e352e4bbcb5a39c7$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($e352e4bbcb5a39c7$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $e352e4bbcb5a39c7$var$ResultType.redirect,
                response: $e352e4bbcb5a39c7$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $e352e4bbcb5a39c7$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $e352e4bbcb5a39c7$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $e352e4bbcb5a39c7$var$ResultType.error,
                    error: $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $e352e4bbcb5a39c7$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $e352e4bbcb5a39c7$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $e352e4bbcb5a39c7$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $e352e4bbcb5a39c7$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $e352e4bbcb5a39c7$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $e352e4bbcb5a39c7$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $e352e4bbcb5a39c7$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $e352e4bbcb5a39c7$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $e352e4bbcb5a39c7$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $e352e4bbcb5a39c7$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$e352e4bbcb5a39c7$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $e352e4bbcb5a39c7$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $e352e4bbcb5a39c7$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $e352e4bbcb5a39c7$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $e352e4bbcb5a39c7$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $e352e4bbcb5a39c7$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $e352e4bbcb5a39c7$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $e352e4bbcb5a39c7$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $e352e4bbcb5a39c7$export$4d0306f8f6a4585b = Symbol("deferred");
function $e352e4bbcb5a39c7$export$3336b097a6fbc59a(routes, opts) {
    $e352e4bbcb5a39c7$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $e352e4bbcb5a39c7$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $e352e4bbcb5a39c7$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $e352e4bbcb5a39c7$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $e352e4bbcb5a39c7$var$createLocation("", $e352e4bbcb5a39c7$export$fe53371bee54353d(url), null, "default");
        let matches = $e352e4bbcb5a39c7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$e352e4bbcb5a39c7$var$isValidMethod(method) && method !== "HEAD") {
            let error = $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $e352e4bbcb5a39c7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $e352e4bbcb5a39c7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($e352e4bbcb5a39c7$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $e352e4bbcb5a39c7$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $e352e4bbcb5a39c7$var$createLocation("", $e352e4bbcb5a39c7$export$fe53371bee54353d(url), null, "default");
        let matches = $e352e4bbcb5a39c7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$e352e4bbcb5a39c7$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $e352e4bbcb5a39c7$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $e352e4bbcb5a39c7$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($e352e4bbcb5a39c7$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$e352e4bbcb5a39c7$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($e352e4bbcb5a39c7$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $e352e4bbcb5a39c7$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $e352e4bbcb5a39c7$var$isResponse(result) ? result : $e352e4bbcb5a39c7$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($e352e4bbcb5a39c7$var$isDataStrategyResult(e) && $e352e4bbcb5a39c7$var$isResponse(e.result)) {
                if (e.type === $e352e4bbcb5a39c7$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($e352e4bbcb5a39c7$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $e352e4bbcb5a39c7$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $e352e4bbcb5a39c7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($e352e4bbcb5a39c7$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($e352e4bbcb5a39c7$var$isDeferredResult(result)) {
            let error = $e352e4bbcb5a39c7$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $e352e4bbcb5a39c7$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($e352e4bbcb5a39c7$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($e352e4bbcb5a39c7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $e352e4bbcb5a39c7$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $e352e4bbcb5a39c7$var$_extends({}, context, {
                statusCode: $e352e4bbcb5a39c7$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $e352e4bbcb5a39c7$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $e352e4bbcb5a39c7$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $e352e4bbcb5a39c7$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1]) ? $e352e4bbcb5a39c7$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $e352e4bbcb5a39c7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $e352e4bbcb5a39c7$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $e352e4bbcb5a39c7$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $e352e4bbcb5a39c7$var$callDataStrategyImpl(dataStrategy || $e352e4bbcb5a39c7$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($e352e4bbcb5a39c7$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $e352e4bbcb5a39c7$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($e352e4bbcb5a39c7$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $e352e4bbcb5a39c7$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $e352e4bbcb5a39c7$export$fec11da027c70692(routes, context, error) {
    let newContext = $e352e4bbcb5a39c7$var$_extends({}, context, {
        statusCode: $e352e4bbcb5a39c7$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $e352e4bbcb5a39c7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $e352e4bbcb5a39c7$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $e352e4bbcb5a39c7$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $e352e4bbcb5a39c7$export$cae722b0cc860f13(to ? to : ".", $e352e4bbcb5a39c7$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $e352e4bbcb5a39c7$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $e352e4bbcb5a39c7$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $e352e4bbcb5a39c7$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $e352e4bbcb5a39c7$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $e352e4bbcb5a39c7$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$e352e4bbcb5a39c7$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$e352e4bbcb5a39c7$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $e352e4bbcb5a39c7$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $e352e4bbcb5a39c7$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$e352e4bbcb5a39c7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$e352e4bbcb5a39c7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $e352e4bbcb5a39c7$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $e352e4bbcb5a39c7$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $e352e4bbcb5a39c7$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $e352e4bbcb5a39c7$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $e352e4bbcb5a39c7$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($e352e4bbcb5a39c7$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $e352e4bbcb5a39c7$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $e352e4bbcb5a39c7$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $e352e4bbcb5a39c7$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $e352e4bbcb5a39c7$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $e352e4bbcb5a39c7$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $e352e4bbcb5a39c7$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $e352e4bbcb5a39c7$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($e352e4bbcb5a39c7$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $e352e4bbcb5a39c7$var$shouldRevalidateLoader(match, $e352e4bbcb5a39c7$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $e352e4bbcb5a39c7$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $e352e4bbcb5a39c7$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $e352e4bbcb5a39c7$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $e352e4bbcb5a39c7$var$shouldRevalidateLoader(fetcherMatch, $e352e4bbcb5a39c7$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $e352e4bbcb5a39c7$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $e352e4bbcb5a39c7$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $e352e4bbcb5a39c7$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $e352e4bbcb5a39c7$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $e352e4bbcb5a39c7$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$e352e4bbcb5a39c7$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $e352e4bbcb5a39c7$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $e352e4bbcb5a39c7$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$e352e4bbcb5a39c7$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $e352e4bbcb5a39c7$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $e352e4bbcb5a39c7$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $e352e4bbcb5a39c7$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$e352e4bbcb5a39c7$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $e352e4bbcb5a39c7$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $e352e4bbcb5a39c7$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $e352e4bbcb5a39c7$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $e352e4bbcb5a39c7$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $e352e4bbcb5a39c7$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $e352e4bbcb5a39c7$var$ResultType.data,
                result: undefined
            });
        };
        return $e352e4bbcb5a39c7$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $e352e4bbcb5a39c7$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $e352e4bbcb5a39c7$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $e352e4bbcb5a39c7$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $e352e4bbcb5a39c7$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($e352e4bbcb5a39c7$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $e352e4bbcb5a39c7$var$ResultType.error,
                error: e
            };
        }
        if (type === $e352e4bbcb5a39c7$var$ResultType.error) return {
            type: $e352e4bbcb5a39c7$var$ResultType.error,
            error: new $e352e4bbcb5a39c7$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $e352e4bbcb5a39c7$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $e352e4bbcb5a39c7$var$ResultType.error) {
        if ($e352e4bbcb5a39c7$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $e352e4bbcb5a39c7$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $e352e4bbcb5a39c7$var$ResultType.error,
                error: new $e352e4bbcb5a39c7$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $e352e4bbcb5a39c7$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $e352e4bbcb5a39c7$var$ResultType.error,
            error: result,
            statusCode: $e352e4bbcb5a39c7$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($e352e4bbcb5a39c7$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $e352e4bbcb5a39c7$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($e352e4bbcb5a39c7$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $e352e4bbcb5a39c7$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $e352e4bbcb5a39c7$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $e352e4bbcb5a39c7$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $e352e4bbcb5a39c7$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$e352e4bbcb5a39c7$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $e352e4bbcb5a39c7$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $e352e4bbcb5a39c7$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($e352e4bbcb5a39c7$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $e352e4bbcb5a39c7$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $e352e4bbcb5a39c7$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($e352e4bbcb5a39c7$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $e352e4bbcb5a39c7$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $e352e4bbcb5a39c7$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $e352e4bbcb5a39c7$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $e352e4bbcb5a39c7$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $e352e4bbcb5a39c7$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(!$e352e4bbcb5a39c7$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($e352e4bbcb5a39c7$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $e352e4bbcb5a39c7$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $e352e4bbcb5a39c7$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($e352e4bbcb5a39c7$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $e352e4bbcb5a39c7$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $e352e4bbcb5a39c7$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($e352e4bbcb5a39c7$var$isErrorResult(result)) {
            let boundaryMatch = $e352e4bbcb5a39c7$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $e352e4bbcb5a39c7$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($e352e4bbcb5a39c7$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($e352e4bbcb5a39c7$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $e352e4bbcb5a39c7$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $e352e4bbcb5a39c7$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $e352e4bbcb5a39c7$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $e352e4bbcb5a39c7$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $e352e4bbcb5a39c7$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $e352e4bbcb5a39c7$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $e352e4bbcb5a39c7$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $e352e4bbcb5a39c7$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $e352e4bbcb5a39c7$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($e352e4bbcb5a39c7$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $e352e4bbcb5a39c7$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(path) : path;
    return $e352e4bbcb5a39c7$export$fe53371bee54353d($e352e4bbcb5a39c7$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $e352e4bbcb5a39c7$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $e352e4bbcb5a39c7$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $e352e4bbcb5a39c7$var$ResultType.data || result.type === $e352e4bbcb5a39c7$var$ResultType.error);
}
function $e352e4bbcb5a39c7$var$isRedirectDataStrategyResultResult(result) {
    return $e352e4bbcb5a39c7$var$isResponse(result.result) && $e352e4bbcb5a39c7$var$redirectStatusCodes.has(result.result.status);
}
function $e352e4bbcb5a39c7$var$isDeferredResult(result) {
    return result.type === $e352e4bbcb5a39c7$var$ResultType.deferred;
}
function $e352e4bbcb5a39c7$var$isErrorResult(result) {
    return result.type === $e352e4bbcb5a39c7$var$ResultType.error;
}
function $e352e4bbcb5a39c7$var$isRedirectResult(result) {
    return (result && result.type) === $e352e4bbcb5a39c7$var$ResultType.redirect;
}
function $e352e4bbcb5a39c7$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $e352e4bbcb5a39c7$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $e352e4bbcb5a39c7$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $e352e4bbcb5a39c7$var$isRedirectResponse(result) {
    if (!$e352e4bbcb5a39c7$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $e352e4bbcb5a39c7$var$isValidMethod(method) {
    return $e352e4bbcb5a39c7$var$validRequestMethods.has(method.toLowerCase());
}
function $e352e4bbcb5a39c7$var$isMutationMethod(method) {
    return $e352e4bbcb5a39c7$var$validMutationMethods.has(method.toLowerCase());
}
async function $e352e4bbcb5a39c7$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$e352e4bbcb5a39c7$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($e352e4bbcb5a39c7$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $e352e4bbcb5a39c7$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $e352e4bbcb5a39c7$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($e352e4bbcb5a39c7$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $e352e4bbcb5a39c7$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $e352e4bbcb5a39c7$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $e352e4bbcb5a39c7$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $e352e4bbcb5a39c7$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $e352e4bbcb5a39c7$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $e352e4bbcb5a39c7$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $e352e4bbcb5a39c7$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $e352e4bbcb5a39c7$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $e352e4bbcb5a39c7$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $e352e4bbcb5a39c7$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $e352e4bbcb5a39c7$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $e352e4bbcb5a39c7$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $e352e4bbcb5a39c7$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $e352e4bbcb5a39c7$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $e352e4bbcb5a39c7$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $e352e4bbcb5a39c7$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($e352e4bbcb5a39c7$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $e352e4bbcb5a39c7$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($e352e4bbcb5a39c7$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $e352e4bbcb5a39c7$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("3W4eU", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $2dda13c5d6544900$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $2dda13c5d6544900$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $2dda13c5d6544900$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $2dda13c5d6544900$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $2dda13c5d6544900$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $2dda13c5d6544900$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $2dda13c5d6544900$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $2dda13c5d6544900$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $2dda13c5d6544900$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $2dda13c5d6544900$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "useRouteError", function () { return $2dda13c5d6544900$export$ed527bf60f6e05f2; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $2dda13c5d6544900$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $2dda13c5d6544900$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $2dda13c5d6544900$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useBlocker", function () { return $2dda13c5d6544900$export$b273b3273281a049; });
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", function () { return $2dda13c5d6544900$export$db5148ec97d6af7a; });
$parcel$export(module.exports, "Router", function () { return $2dda13c5d6544900$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Outlet", function () { return $2dda13c5d6544900$export$910ae8079b2c2852; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $2dda13c5d6544900$export$52b333d321859367; });
/**
 * React Router v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4RFnf = parcelRequire("4RFnf");

var $jw2qW = parcelRequire("jw2qW");
function $2dda13c5d6544900$var$_extends() {
    $2dda13c5d6544900$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2dda13c5d6544900$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $2dda13c5d6544900$export$3add0d5dce533e2e = /*#__PURE__*/ $4RFnf.createContext(null);
const $2dda13c5d6544900$export$145dfa71566a64dc = /*#__PURE__*/ $4RFnf.createContext(null);
const $2dda13c5d6544900$var$AwaitContext = /*#__PURE__*/ $4RFnf.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $2dda13c5d6544900$export$26749e8557646306 = /*#__PURE__*/ $4RFnf.createContext(null);
const $2dda13c5d6544900$export$c7914228fb69b0f5 = /*#__PURE__*/ $4RFnf.createContext(null);
const $2dda13c5d6544900$export$9072aa6dd1f93057 = /*#__PURE__*/ $4RFnf.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $2dda13c5d6544900$var$RouteErrorContext = /*#__PURE__*/ $4RFnf.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $2dda13c5d6544900$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $jw2qW.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $4RFnf.useContext($2dda13c5d6544900$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $2dda13c5d6544900$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $jw2qW.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $2dda13c5d6544900$export$9c954a9d03d32f4a() {
    return $4RFnf.useContext($2dda13c5d6544900$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $2dda13c5d6544900$export$45d76561a5302f2b() {
    !$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $jw2qW.UNSAFE_invariant)(false);
    return $4RFnf.useContext($2dda13c5d6544900$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $2dda13c5d6544900$export$1b3f31771c5d07c() {
    return $4RFnf.useContext($2dda13c5d6544900$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $2dda13c5d6544900$export$6c330e8992e8a295(pattern) {
    !$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $jw2qW.UNSAFE_invariant)(false);
    let { pathname: pathname } = $2dda13c5d6544900$export$45d76561a5302f2b();
    return $4RFnf.useMemo(()=>(0, $jw2qW.matchPath)(pattern, (0, $jw2qW.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $2dda13c5d6544900$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $2dda13c5d6544900$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $4RFnf.useContext($2dda13c5d6544900$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $4RFnf.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $2dda13c5d6544900$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $2dda13c5d6544900$var$useNavigateStable() : $2dda13c5d6544900$var$useNavigateUnstable();
}
function $2dda13c5d6544900$var$useNavigateUnstable() {
    !$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $jw2qW.UNSAFE_invariant)(false);
    let dataRouterContext = $4RFnf.useContext($2dda13c5d6544900$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $4RFnf.useContext($2dda13c5d6544900$export$26749e8557646306);
    let { matches: matches } = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2dda13c5d6544900$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $jw2qW.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $4RFnf.useRef(false);
    $2dda13c5d6544900$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4RFnf.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $jw2qW.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $jw2qW.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $2dda13c5d6544900$var$OutletContext = /*#__PURE__*/ $4RFnf.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $2dda13c5d6544900$export$4138103a3ae699cc() {
    return $4RFnf.useContext($2dda13c5d6544900$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $2dda13c5d6544900$export$a3be3530d8e40d0b(context) {
    let outlet = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $2dda13c5d6544900$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $2dda13c5d6544900$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $4RFnf.useContext($2dda13c5d6544900$export$26749e8557646306);
    let { matches: matches } = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2dda13c5d6544900$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $jw2qW.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $4RFnf.useMemo(()=>(0, $jw2qW.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $2dda13c5d6544900$export$5d3fca4a98652595(routes, locationArg) {
    return $2dda13c5d6544900$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $2dda13c5d6544900$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $jw2qW.UNSAFE_invariant)(false);
    let { navigator: navigator, static: isStatic } = $4RFnf.useContext($2dda13c5d6544900$export$26749e8557646306);
    let { matches: parentMatches } = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $2dda13c5d6544900$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $jw2qW.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $jw2qW.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, $jw2qW.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $2dda13c5d6544900$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $jw2qW.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $jw2qW.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $2dda13c5d6544900$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $jw2qW.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $2dda13c5d6544900$var$DefaultErrorComponent() {
    let error = $2dda13c5d6544900$export$ed527bf60f6e05f2();
    let message = (0, $jw2qW.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $4RFnf.createElement($4RFnf.Fragment, null, /*#__PURE__*/ $4RFnf.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $4RFnf.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $4RFnf.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $2dda13c5d6544900$var$defaultErrorElement = /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$DefaultErrorComponent, null);
class $2dda13c5d6544900$var$RenderErrorBoundary extends $4RFnf.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $2dda13c5d6544900$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $4RFnf.useContext($2dda13c5d6544900$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $2dda13c5d6544900$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $jw2qW.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $2dda13c5d6544900$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $2dda13c5d6544900$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $4RFnf.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $2dda13c5d6544900$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($2dda13c5d6544900$var$DataRouterHook || {});
var $2dda13c5d6544900$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($2dda13c5d6544900$var$DataRouterStateHook || {});
function $2dda13c5d6544900$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $2dda13c5d6544900$var$useDataRouterContext(hookName) {
    let ctx = $4RFnf.useContext($2dda13c5d6544900$export$3add0d5dce533e2e);
    !ctx && (0, $jw2qW.UNSAFE_invariant)(false);
    return ctx;
}
function $2dda13c5d6544900$var$useDataRouterState(hookName) {
    let state = $4RFnf.useContext($2dda13c5d6544900$export$145dfa71566a64dc);
    !state && (0, $jw2qW.UNSAFE_invariant)(false);
    return state;
}
function $2dda13c5d6544900$var$useRouteContext(hookName) {
    let route = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    !route && (0, $jw2qW.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $2dda13c5d6544900$var$useCurrentRouteId(hookName) {
    let route = $2dda13c5d6544900$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $jw2qW.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $2dda13c5d6544900$export$5fc8298006ad9e58() {
    return $2dda13c5d6544900$var$useCurrentRouteId($2dda13c5d6544900$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $2dda13c5d6544900$export$d0fd4b7106de2769() {
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $2dda13c5d6544900$export$600dc272ed516c15() {
    let dataRouterContext = $2dda13c5d6544900$var$useDataRouterContext($2dda13c5d6544900$var$DataRouterHook.UseRevalidator);
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseRevalidator);
    return $4RFnf.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $2dda13c5d6544900$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseMatches);
    return $4RFnf.useMemo(()=>matches.map((m)=>(0, $jw2qW.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $2dda13c5d6544900$export$1448a5050d252c4d() {
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseLoaderData);
    let routeId = $2dda13c5d6544900$var$useCurrentRouteId($2dda13c5d6544900$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $2dda13c5d6544900$export$fd5d37484eab868d(routeId) {
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $2dda13c5d6544900$export$fdc00f3f26066d5e() {
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseActionData);
    let routeId = $2dda13c5d6544900$var$useCurrentRouteId($2dda13c5d6544900$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $2dda13c5d6544900$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $4RFnf.useContext($2dda13c5d6544900$var$RouteErrorContext);
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseRouteError);
    let routeId = $2dda13c5d6544900$var$useCurrentRouteId($2dda13c5d6544900$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $2dda13c5d6544900$export$78a72ddb39bdd145() {
    let value = $4RFnf.useContext($2dda13c5d6544900$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $2dda13c5d6544900$export$17f53340677d5831() {
    let value = $4RFnf.useContext($2dda13c5d6544900$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $2dda13c5d6544900$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $2dda13c5d6544900$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $2dda13c5d6544900$var$useDataRouterContext($2dda13c5d6544900$var$DataRouterHook.UseBlocker);
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $4RFnf.useState("");
    let blockerFunction = $4RFnf.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $2dda13c5d6544900$var$_extends({}, currentLocation, {
                pathname: (0, $jw2qW.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $2dda13c5d6544900$var$_extends({}, nextLocation, {
                pathname: (0, $jw2qW.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $4RFnf.useEffect(()=>{
        let key = String(++$2dda13c5d6544900$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $4RFnf.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $jw2qW.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $2dda13c5d6544900$var$useNavigateStable() {
    let { router: router } = $2dda13c5d6544900$var$useDataRouterContext($2dda13c5d6544900$var$DataRouterHook.UseNavigateStable);
    let id = $2dda13c5d6544900$var$useCurrentRouteId($2dda13c5d6544900$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $4RFnf.useRef(false);
    $2dda13c5d6544900$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4RFnf.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $2dda13c5d6544900$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $2dda13c5d6544900$var$alreadyWarned$1 = {};
function $2dda13c5d6544900$var$warningOnce(key, cond, message) {
    if (!cond && !$2dda13c5d6544900$var$alreadyWarned$1[key]) $2dda13c5d6544900$var$alreadyWarned$1[key] = true;
}
const $2dda13c5d6544900$var$alreadyWarned = {};
function $2dda13c5d6544900$var$warnOnce(key, message) {}
const $2dda13c5d6544900$var$logDeprecation = (flag, msg, link)=>$2dda13c5d6544900$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $2dda13c5d6544900$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $2dda13c5d6544900$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $2dda13c5d6544900$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $2dda13c5d6544900$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $2dda13c5d6544900$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $2dda13c5d6544900$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $2dda13c5d6544900$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $2dda13c5d6544900$var$START_TRANSITION = "startTransition";
const $2dda13c5d6544900$var$startTransitionImpl = $4RFnf[$2dda13c5d6544900$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $2dda13c5d6544900$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $4RFnf.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4RFnf.useCallback((newState)=>{
        if (v7_startTransition && $2dda13c5d6544900$var$startTransitionImpl) $2dda13c5d6544900$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $4RFnf.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $4RFnf.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $4RFnf.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4RFnf.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $4RFnf.useEffect(()=>$2dda13c5d6544900$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4RFnf.createElement($4RFnf.Fragment, null, /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $2dda13c5d6544900$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $2dda13c5d6544900$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $2dda13c5d6544900$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $4RFnf.useRef();
    if (historyRef.current == null) historyRef.current = (0, $jw2qW.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4RFnf.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4RFnf.useCallback((newState)=>{
        v7_startTransition && $2dda13c5d6544900$var$startTransitionImpl ? $2dda13c5d6544900$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4RFnf.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $4RFnf.useEffect(()=>$2dda13c5d6544900$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $2dda13c5d6544900$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $jw2qW.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $4RFnf.useContext($2dda13c5d6544900$export$26749e8557646306);
    let { matches: matches } = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2dda13c5d6544900$export$45d76561a5302f2b();
    let navigate = $2dda13c5d6544900$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $jw2qW.resolveTo)(to, (0, $jw2qW.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $4RFnf.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $2dda13c5d6544900$export$910ae8079b2c2852(props) {
    return $2dda13c5d6544900$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $2dda13c5d6544900$export$e7b0ac011bb776c6(_props) {
    (0, $jw2qW.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $2dda13c5d6544900$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $jw2qW.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $jw2qW.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $4RFnf.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $2dda13c5d6544900$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $jw2qW.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $4RFnf.useMemo(()=>{
        let trailingPathname = (0, $jw2qW.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $2dda13c5d6544900$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $2dda13c5d6544900$export$5d3fca4a98652595($2dda13c5d6544900$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $2dda13c5d6544900$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$ResolveAwait, null, children));
}
var $2dda13c5d6544900$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($2dda13c5d6544900$var$AwaitRenderStatus || {});
const $2dda13c5d6544900$var$neverSettledPromise = new Promise(()=>{});
class $2dda13c5d6544900$var$AwaitErrorBoundary extends $4RFnf.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $2dda13c5d6544900$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $2dda13c5d6544900$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $2dda13c5d6544900$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $2dda13c5d6544900$var$AwaitRenderStatus.error : "_data" in promise ? $2dda13c5d6544900$var$AwaitRenderStatus.success : $2dda13c5d6544900$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $2dda13c5d6544900$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $2dda13c5d6544900$var$AwaitRenderStatus.error && promise._error instanceof (0, $jw2qW.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $2dda13c5d6544900$var$neverSettledPromise;
        if (status === $2dda13c5d6544900$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $2dda13c5d6544900$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $2dda13c5d6544900$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $2dda13c5d6544900$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $2dda13c5d6544900$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $4RFnf.createElement($4RFnf.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $2dda13c5d6544900$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $4RFnf.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $4RFnf.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $4RFnf.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $2dda13c5d6544900$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $2dda13c5d6544900$export$e7b0ac011bb776c6) && (0, $jw2qW.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $jw2qW.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $2dda13c5d6544900$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $2dda13c5d6544900$export$daf73786167a7f72(matches) {
    return $2dda13c5d6544900$var$_renderMatches(matches);
}
function $2dda13c5d6544900$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $4RFnf.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $4RFnf.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $4RFnf.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $2dda13c5d6544900$export$f30f7e456d254e83(routes, opts) {
    return (0, $jw2qW.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2dda13c5d6544900$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $jw2qW.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $2dda13c5d6544900$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});


parcelRegister("j11Is", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $dd7f711204de761b$export$bf730a2d8bf68b42; }, function (v) { return $dd7f711204de761b$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd7f711204de761b$export$bf730a2d8bf68b42;
"use strict";

var $4RFnf = parcelRequire("4RFnf");
function $dd7f711204de761b$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dd7f711204de761b$var$objectIs = "function" === typeof Object.is ? Object.is : $dd7f711204de761b$var$is, $dd7f711204de761b$var$useSyncExternalStore = $4RFnf.useSyncExternalStore, $dd7f711204de761b$var$useRef = $4RFnf.useRef, $dd7f711204de761b$var$useEffect = $4RFnf.useEffect, $dd7f711204de761b$var$useMemo = $4RFnf.useMemo, $dd7f711204de761b$var$useDebugValue = $4RFnf.useDebugValue;
$dd7f711204de761b$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $dd7f711204de761b$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $dd7f711204de761b$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($dd7f711204de761b$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $dd7f711204de761b$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $dd7f711204de761b$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $dd7f711204de761b$var$useDebugValue(value);
    return value;
};

});

parcelRegister("cLzjP", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("kngSS"))($parcel$resolve("4qvyV")),
    $parcel$import("8FHNt")
]).then(()=>parcelRequire('gwkW7'));

});
parcelRegister("kngSS", function(module, exports) {
"use strict";

var $aMc8M = parcelRequire("aMc8M");
module.exports = $aMc8M(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("aMc8M", function(module, exports) {
"use strict";
var $7d87cdf98e13af35$var$cachedBundles = {};
var $7d87cdf98e13af35$var$cachedPreloads = {};
var $7d87cdf98e13af35$var$cachedPrefetches = {};
function $7d87cdf98e13af35$var$getCache(type) {
    switch(type){
        case 'preload':
            return $7d87cdf98e13af35$var$cachedPreloads;
        case 'prefetch':
            return $7d87cdf98e13af35$var$cachedPrefetches;
        default:
            return $7d87cdf98e13af35$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $7d87cdf98e13af35$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $1a69109f8092e4b8$exports = {};
$parcel$extendImportMap({
    "8FHNt": "Grocery.ad00a5aa.js",
    "4qvyV": "Grocery.3b31caa5.css"
});


var $jk232 = parcelRequire("jk232");

var $4RFnf = parcelRequire("4RFnf");
var $e6901a497e5ba7f6$exports = {};
'use strict';
function $e6901a497e5ba7f6$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($e6901a497e5ba7f6$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$e6901a497e5ba7f6$var$checkDCE();

$e6901a497e5ba7f6$exports = (parcelRequire("32Bah"));



var $jk232 = parcelRequire("jk232");

var $4RFnf = parcelRequire("4RFnf");

var $eGOwh = parcelRequire("eGOwh");
var $3W4eU = parcelRequire("3W4eU");

var $4RFnf = parcelRequire("4RFnf");
var $bd80854d1f7ebeed$exports = {};
'use strict';

$bd80854d1f7ebeed$exports = (parcelRequire("j11Is"));


var $99aed3ab2dc6c7d9$var$__defProp = Object.defineProperty;
var $99aed3ab2dc6c7d9$var$__defProps = Object.defineProperties;
var $99aed3ab2dc6c7d9$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $99aed3ab2dc6c7d9$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $99aed3ab2dc6c7d9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $99aed3ab2dc6c7d9$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $99aed3ab2dc6c7d9$var$__defNormalProp = (obj, key, value)=>key in obj ? $99aed3ab2dc6c7d9$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $99aed3ab2dc6c7d9$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($99aed3ab2dc6c7d9$var$__hasOwnProp.call(b, prop)) $99aed3ab2dc6c7d9$var$__defNormalProp(a, prop, b[prop]);
    if ($99aed3ab2dc6c7d9$var$__getOwnPropSymbols) {
        for (var prop of $99aed3ab2dc6c7d9$var$__getOwnPropSymbols(b))if ($99aed3ab2dc6c7d9$var$__propIsEnum.call(b, prop)) $99aed3ab2dc6c7d9$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $99aed3ab2dc6c7d9$var$__spreadProps = (a, b)=>$99aed3ab2dc6c7d9$var$__defProps(a, $99aed3ab2dc6c7d9$var$__getOwnPropDescs(b));
var $99aed3ab2dc6c7d9$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($99aed3ab2dc6c7d9$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $99aed3ab2dc6c7d9$var$__getOwnPropSymbols) {
        for (var prop of $99aed3ab2dc6c7d9$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $99aed3ab2dc6c7d9$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $99aed3ab2dc6c7d9$var$IS_REACT_19 = /* @__PURE__ */ $4RFnf.version.startsWith("19");
var $99aed3ab2dc6c7d9$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($99aed3ab2dc6c7d9$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $99aed3ab2dc6c7d9$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $99aed3ab2dc6c7d9$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $99aed3ab2dc6c7d9$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $99aed3ab2dc6c7d9$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $99aed3ab2dc6c7d9$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $99aed3ab2dc6c7d9$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $99aed3ab2dc6c7d9$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $99aed3ab2dc6c7d9$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $99aed3ab2dc6c7d9$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $99aed3ab2dc6c7d9$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $99aed3ab2dc6c7d9$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $99aed3ab2dc6c7d9$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $99aed3ab2dc6c7d9$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $99aed3ab2dc6c7d9$var$ForwardRef = $99aed3ab2dc6c7d9$var$REACT_FORWARD_REF_TYPE;
var $99aed3ab2dc6c7d9$var$Memo = $99aed3ab2dc6c7d9$var$REACT_MEMO_TYPE;
function $99aed3ab2dc6c7d9$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $99aed3ab2dc6c7d9$var$REACT_FRAGMENT_TYPE || type === $99aed3ab2dc6c7d9$var$REACT_PROFILER_TYPE || type === $99aed3ab2dc6c7d9$var$REACT_STRICT_MODE_TYPE || type === $99aed3ab2dc6c7d9$var$REACT_SUSPENSE_TYPE || type === $99aed3ab2dc6c7d9$var$REACT_SUSPENSE_LIST_TYPE || type === $99aed3ab2dc6c7d9$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $99aed3ab2dc6c7d9$var$REACT_LAZY_TYPE || type.$$typeof === $99aed3ab2dc6c7d9$var$REACT_MEMO_TYPE || type.$$typeof === $99aed3ab2dc6c7d9$var$REACT_CONTEXT_TYPE || type.$$typeof === $99aed3ab2dc6c7d9$var$REACT_CONSUMER_TYPE || type.$$typeof === $99aed3ab2dc6c7d9$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $99aed3ab2dc6c7d9$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $99aed3ab2dc6c7d9$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $99aed3ab2dc6c7d9$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $99aed3ab2dc6c7d9$var$REACT_FRAGMENT_TYPE:
                    case $99aed3ab2dc6c7d9$var$REACT_PROFILER_TYPE:
                    case $99aed3ab2dc6c7d9$var$REACT_STRICT_MODE_TYPE:
                    case $99aed3ab2dc6c7d9$var$REACT_SUSPENSE_TYPE:
                    case $99aed3ab2dc6c7d9$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $99aed3ab2dc6c7d9$var$REACT_CONTEXT_TYPE:
                            case $99aed3ab2dc6c7d9$var$REACT_FORWARD_REF_TYPE:
                            case $99aed3ab2dc6c7d9$var$REACT_LAZY_TYPE:
                            case $99aed3ab2dc6c7d9$var$REACT_MEMO_TYPE:
                                return object;
                            case $99aed3ab2dc6c7d9$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $99aed3ab2dc6c7d9$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $99aed3ab2dc6c7d9$var$isContextConsumer(object) {
    return $99aed3ab2dc6c7d9$var$IS_REACT_19 ? $99aed3ab2dc6c7d9$var$typeOf(object) === $99aed3ab2dc6c7d9$var$REACT_CONSUMER_TYPE : $99aed3ab2dc6c7d9$var$typeOf(object) === $99aed3ab2dc6c7d9$var$REACT_CONTEXT_TYPE;
}
function $99aed3ab2dc6c7d9$var$isMemo(object) {
    return $99aed3ab2dc6c7d9$var$typeOf(object) === $99aed3ab2dc6c7d9$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $99aed3ab2dc6c7d9$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $99aed3ab2dc6c7d9$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $99aed3ab2dc6c7d9$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $99aed3ab2dc6c7d9$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $99aed3ab2dc6c7d9$var$verify(mapStateToProps, "mapStateToProps");
    $99aed3ab2dc6c7d9$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $99aed3ab2dc6c7d9$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $99aed3ab2dc6c7d9$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $99aed3ab2dc6c7d9$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $99aed3ab2dc6c7d9$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $99aed3ab2dc6c7d9$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $99aed3ab2dc6c7d9$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $99aed3ab2dc6c7d9$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $99aed3ab2dc6c7d9$var$verifyPlainObject(value, displayName, methodName) {
    if (!$99aed3ab2dc6c7d9$var$isPlainObject(value)) $99aed3ab2dc6c7d9$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $99aed3ab2dc6c7d9$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $99aed3ab2dc6c7d9$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $99aed3ab2dc6c7d9$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $99aed3ab2dc6c7d9$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $99aed3ab2dc6c7d9$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $99aed3ab2dc6c7d9$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $99aed3ab2dc6c7d9$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $99aed3ab2dc6c7d9$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $99aed3ab2dc6c7d9$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $99aed3ab2dc6c7d9$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $99aed3ab2dc6c7d9$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $99aed3ab2dc6c7d9$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $99aed3ab2dc6c7d9$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $99aed3ab2dc6c7d9$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $99aed3ab2dc6c7d9$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $99aed3ab2dc6c7d9$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $99aed3ab2dc6c7d9$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $99aed3ab2dc6c7d9$var$__spreadValues($99aed3ab2dc6c7d9$var$__spreadValues($99aed3ab2dc6c7d9$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $99aed3ab2dc6c7d9$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $99aed3ab2dc6c7d9$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$99aed3ab2dc6c7d9$var$defaultMergeProps : typeof mergeProps === "function" ? $99aed3ab2dc6c7d9$var$wrapMergePropsFunc(mergeProps) : $99aed3ab2dc6c7d9$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $99aed3ab2dc6c7d9$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $99aed3ab2dc6c7d9$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $99aed3ab2dc6c7d9$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $99aed3ab2dc6c7d9$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $99aed3ab2dc6c7d9$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $99aed3ab2dc6c7d9$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $99aed3ab2dc6c7d9$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $99aed3ab2dc6c7d9$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $99aed3ab2dc6c7d9$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $99aed3ab2dc6c7d9$var$isDOM = /* @__PURE__ */ $99aed3ab2dc6c7d9$var$canUseDOM();
var $99aed3ab2dc6c7d9$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $99aed3ab2dc6c7d9$var$isReactNative = /* @__PURE__ */ $99aed3ab2dc6c7d9$var$isRunningInReactNative();
var $99aed3ab2dc6c7d9$var$getUseIsomorphicLayoutEffect = ()=>$99aed3ab2dc6c7d9$var$isDOM || $99aed3ab2dc6c7d9$var$isReactNative ? $4RFnf.useLayoutEffect : $4RFnf.useEffect;
var $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $99aed3ab2dc6c7d9$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $99aed3ab2dc6c7d9$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $99aed3ab2dc6c7d9$export$d36bdfa510afb180(objA, objB) {
    if ($99aed3ab2dc6c7d9$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$99aed3ab2dc6c7d9$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $99aed3ab2dc6c7d9$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $99aed3ab2dc6c7d9$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $99aed3ab2dc6c7d9$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $99aed3ab2dc6c7d9$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $99aed3ab2dc6c7d9$var$TYPE_STATICS = {
    [$99aed3ab2dc6c7d9$var$ForwardRef]: $99aed3ab2dc6c7d9$var$FORWARD_REF_STATICS,
    [$99aed3ab2dc6c7d9$var$Memo]: $99aed3ab2dc6c7d9$var$MEMO_STATICS
};
function $99aed3ab2dc6c7d9$var$getStatics(component) {
    if ($99aed3ab2dc6c7d9$var$isMemo(component)) return $99aed3ab2dc6c7d9$var$MEMO_STATICS;
    return $99aed3ab2dc6c7d9$var$TYPE_STATICS[component["$$typeof"]] || $99aed3ab2dc6c7d9$var$REACT_STATICS;
}
var $99aed3ab2dc6c7d9$var$defineProperty = Object.defineProperty;
var $99aed3ab2dc6c7d9$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $99aed3ab2dc6c7d9$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $99aed3ab2dc6c7d9$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $99aed3ab2dc6c7d9$var$getPrototypeOf = Object.getPrototypeOf;
var $99aed3ab2dc6c7d9$var$objectPrototype = Object.prototype;
function $99aed3ab2dc6c7d9$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($99aed3ab2dc6c7d9$var$objectPrototype) {
            const inheritedComponent = $99aed3ab2dc6c7d9$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $99aed3ab2dc6c7d9$var$objectPrototype) $99aed3ab2dc6c7d9$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $99aed3ab2dc6c7d9$var$getOwnPropertyNames(sourceComponent);
        if ($99aed3ab2dc6c7d9$var$getOwnPropertySymbols) keys = keys.concat($99aed3ab2dc6c7d9$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $99aed3ab2dc6c7d9$var$getStatics(targetComponent);
        const sourceStatics = $99aed3ab2dc6c7d9$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$99aed3ab2dc6c7d9$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $99aed3ab2dc6c7d9$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $99aed3ab2dc6c7d9$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $99aed3ab2dc6c7d9$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $99aed3ab2dc6c7d9$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $99aed3ab2dc6c7d9$var$getContext() {
    var _a;
    if (!$4RFnf.createContext) return {};
    const contextMap = (_a = $99aed3ab2dc6c7d9$var$gT[$99aed3ab2dc6c7d9$var$ContextKey]) != null ? _a : $99aed3ab2dc6c7d9$var$gT[$99aed3ab2dc6c7d9$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($4RFnf.createContext);
    if (!realContext) {
        realContext = $4RFnf.createContext(null);
        contextMap.set($4RFnf.createContext, realContext);
    }
    return realContext;
}
var $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00 = /* @__PURE__ */ $99aed3ab2dc6c7d9$var$getContext();
// src/components/connect.tsx
var $99aed3ab2dc6c7d9$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $99aed3ab2dc6c7d9$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $99aed3ab2dc6c7d9$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $99aed3ab2dc6c7d9$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $99aed3ab2dc6c7d9$var$strictEqual(a, b) {
    return a === b;
}
var $99aed3ab2dc6c7d9$var$hasWarnedAboutDeprecatedPureOption = false;
function $99aed3ab2dc6c7d9$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $99aed3ab2dc6c7d9$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $99aed3ab2dc6c7d9$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $99aed3ab2dc6c7d9$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $99aed3ab2dc6c7d9$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $99aed3ab2dc6c7d9$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $99aed3ab2dc6c7d9$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $99aed3ab2dc6c7d9$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $4RFnf.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $99aed3ab2dc6c7d9$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $4RFnf.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $4RFnf.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $4RFnf.useMemo(()=>{
                return $99aed3ab2dc6c7d9$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $4RFnf.useMemo(()=>{
                if (!shouldHandleStateChanges) return $99aed3ab2dc6c7d9$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $99aed3ab2dc6c7d9$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $4RFnf.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $99aed3ab2dc6c7d9$var$__spreadProps($99aed3ab2dc6c7d9$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $4RFnf.useRef(void 0);
            const lastWrapperProps = $4RFnf.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $4RFnf.useRef(void 0);
            const renderIsScheduled = $4RFnf.useRef(false);
            const isMounted = $4RFnf.useRef(false);
            const latestSubscriptionCallbackError = $4RFnf.useRef(void 0);
            $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $4RFnf.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $4RFnf.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $99aed3ab2dc6c7d9$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffectWithArgs($99aed3ab2dc6c7d9$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $4RFnf.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $4RFnf.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $4RFnf.createElement(WrappedComponent, $99aed3ab2dc6c7d9$var$__spreadProps($99aed3ab2dc6c7d9$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $4RFnf.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $4RFnf.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $4RFnf.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $4RFnf.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $4RFnf.createElement(Connect, $99aed3ab2dc6c7d9$var$__spreadProps($99aed3ab2dc6c7d9$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $99aed3ab2dc6c7d9$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $99aed3ab2dc6c7d9$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $99aed3ab2dc6c7d9$export$64605811ab45167f = $99aed3ab2dc6c7d9$var$connect;
// src/components/Provider.tsx
function $99aed3ab2dc6c7d9$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $4RFnf.useMemo(()=>{
        const subscription = $99aed3ab2dc6c7d9$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $4RFnf.useMemo(()=>store.getState(), [
        store
    ]);
    $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $4RFnf.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $99aed3ab2dc6c7d9$export$2881499e37b75b9a = $99aed3ab2dc6c7d9$var$Provider;
// src/hooks/useReduxContext.ts
function $99aed3ab2dc6c7d9$var$createReduxContextHook(context = $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $4RFnf.useContext(context);
        return contextValue;
    };
}
var $99aed3ab2dc6c7d9$var$useReduxContext = /* @__PURE__ */ $99aed3ab2dc6c7d9$var$createReduxContextHook();
// src/hooks/useStore.ts
function $99aed3ab2dc6c7d9$export$671dba69185d0304(context = $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00 ? $99aed3ab2dc6c7d9$var$useReduxContext : // @ts-ignore
    $99aed3ab2dc6c7d9$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $99aed3ab2dc6c7d9$export$6ccbb43953eebf8 = /* @__PURE__ */ $99aed3ab2dc6c7d9$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $99aed3ab2dc6c7d9$export$bc9b55530897c558(context = $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00) {
    const useStore2 = context === $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00 ? $99aed3ab2dc6c7d9$export$6ccbb43953eebf8 : $99aed3ab2dc6c7d9$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $99aed3ab2dc6c7d9$export$8ad76b76a4c905f8 = /* @__PURE__ */ $99aed3ab2dc6c7d9$export$bc9b55530897c558();
var $99aed3ab2dc6c7d9$var$refEquality = (a, b)=>a === b;
function $99aed3ab2dc6c7d9$export$2b53f90d2bd1cbfb(context = $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00 ? $99aed3ab2dc6c7d9$var$useReduxContext : $99aed3ab2dc6c7d9$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $99aed3ab2dc6c7d9$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $4RFnf.useRef(true);
        const wrappedSelector = $4RFnf.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $bd80854d1f7ebeed$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $4RFnf.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $99aed3ab2dc6c7d9$export$2105062e25df4afe = /* @__PURE__ */ $99aed3ab2dc6c7d9$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $99aed3ab2dc6c7d9$export$712ea50be43a7858 = $99aed3ab2dc6c7d9$var$defaultNoopBatch;


/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $4RFnf = parcelRequire("4RFnf");
/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $1e6dfb573284ef69$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();


/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $60c9d177757578c4$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();


/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $d43218d9a078de84$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());


const $0f4a07726cc908d9$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = (0, $d43218d9a078de84$export$86f54f62aa7a7514)(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};



var $4RFnf = parcelRequire("4RFnf");
/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $131fcb24e616767b$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};


/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $54602b5bfcc2e580$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
    return false;
};




var $4RFnf = parcelRequire("4RFnf");
"use strict";
"use client";
const $6de2207e8282c0f5$var$LucideContext = (0, $4RFnf.createContext)({});
function $6de2207e8282c0f5$export$f4a5ae9d8b2d8a16({ children: children, size: size, color: color, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, className: className }) {
    const value = (0, $4RFnf.useMemo)(()=>({
            size: size,
            color: color,
            strokeWidth: strokeWidth,
            absoluteStrokeWidth: absoluteStrokeWidth,
            className: className
        }), [
        size,
        color,
        strokeWidth,
        absoluteStrokeWidth,
        className
    ]);
    return (0, $4RFnf.createElement)($6de2207e8282c0f5$var$LucideContext.Provider, {
        value: value
    }, children);
}
const $6de2207e8282c0f5$export$52ee7576b6cde767 = ()=>(0, $4RFnf.useContext)($6de2207e8282c0f5$var$LucideContext);


"use strict";
"use client";
const $8def53df3526a463$export$2e2bcd8739ae039 = (0, $4RFnf.forwardRef)(({ color: color, size: size, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>{
    const { size: contextSize = 24, strokeWidth: contextStrokeWidth = 2, absoluteStrokeWidth: contextAbsoluteStrokeWidth = false, color: contextColor = "currentColor", className: contextClass = "" } = (0, $6de2207e8282c0f5$export$52ee7576b6cde767)() ?? {};
    const calculatedStrokeWidth = absoluteStrokeWidth ?? contextAbsoluteStrokeWidth ? Number(strokeWidth ?? contextStrokeWidth) * 24 / Number(size ?? contextSize) : strokeWidth ?? contextStrokeWidth;
    return (0, $4RFnf.createElement)("svg", {
        ref: ref,
        ...(0, $131fcb24e616767b$export$2e2bcd8739ae039),
        width: size ?? contextSize ?? (0, $131fcb24e616767b$export$2e2bcd8739ae039).width,
        height: size ?? contextSize ?? (0, $131fcb24e616767b$export$2e2bcd8739ae039).height,
        stroke: color ?? contextColor,
        strokeWidth: calculatedStrokeWidth,
        className: (0, $1e6dfb573284ef69$export$3d46f4579dba46e5)("lucide", contextClass, className),
        ...!children && !(0, $54602b5bfcc2e580$export$ab365959aa6deed0)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $4RFnf.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});


const $e81754e696bcea24$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $4RFnf.forwardRef)(({ className: className, ...props }, ref)=>(0, $4RFnf.createElement)((0, $8def53df3526a463$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $1e6dfb573284ef69$export$3d46f4579dba46e5)(`lucide-${(0, $60c9d177757578c4$export$73bda83cddbc7187)((0, $0f4a07726cc908d9$export$6fb43ff9addf7357)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $0f4a07726cc908d9$export$6fb43ff9addf7357)(iconName);
    return Component;
};


const $f2ee27b28a47667a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 5h16",
            key: "1tepv9"
        }
    ],
    [
        "path",
        {
            d: "M4 12h16",
            key: "1lakjw"
        }
    ],
    [
        "path",
        {
            d: "M4 19h16",
            key: "1djgab"
        }
    ]
];
const $f2ee27b28a47667a$export$2e2bcd8739ae039 = (0, $e81754e696bcea24$export$2e2bcd8739ae039)("menu", $f2ee27b28a47667a$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $272d6dd242682224$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "8",
            cy: "21",
            r: "1",
            key: "jimo8o"
        }
    ],
    [
        "circle",
        {
            cx: "19",
            cy: "21",
            r: "1",
            key: "13723u"
        }
    ],
    [
        "path",
        {
            d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
            key: "9zh506"
        }
    ]
];
const $272d6dd242682224$export$2e2bcd8739ae039 = (0, $e81754e696bcea24$export$2e2bcd8739ae039)("shopping-cart", $272d6dd242682224$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ee865572a14312f4$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const $ee865572a14312f4$export$2e2bcd8739ae039 = (0, $e81754e696bcea24$export$2e2bcd8739ae039)("x", $ee865572a14312f4$export$3efd853dbb351e94);


const $2082b37973b7af43$var$Header = ()=>{
    const [scrolled, setScrolled] = (0, $4RFnf.useState)(false);
    const [menuOpen, setMenuOpen] = (0, $4RFnf.useState)(false);
    const [loggedIn, setLoggedIn] = (0, $4RFnf.useState)(false);
    const cartItems = (0, $99aed3ab2dc6c7d9$export$2105062e25df4afe)((store)=>store.cart.items);
    const cartCount = cartItems.reduce((sum, item)=>sum + item.quantity, 0);
    const location = (0, $3W4eU.useLocation)();
    // Adds a hairline shadow once the page scrolls past the top
    (0, $4RFnf.useEffect)(()=>{
        const onScroll = ()=>setScrolled(window.scrollY > 60);
        window.addEventListener('scroll', onScroll, {
            passive: true
        });
        return ()=>window.removeEventListener('scroll', onScroll);
    }, []);
    // Close mobile menu on route change
    (0, $4RFnf.useEffect)(()=>{
        setMenuOpen(false);
    }, [
        location
    ]);
    const navLinkClass = ({ isActive: isActive })=>`nav-link ${isActive ? 'nav-link-active' : ''}`;
    return /*#__PURE__*/ (0, $jk232.jsxs)("header", {
        className: `navbar ${scrolled ? 'navbar-scrolled' : ''}`,
        children: [
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "navbar-inner",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsxs)((0, $eGOwh.Link), {
                        to: "/",
                        className: "navbar-logo",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                className: "logo-icon",
                                children: "\uD83C\uDF7D\uFE0F"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                className: "logo-text",
                                children: [
                                    "Bite",
                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        className: "logo-accent",
                                        children: "Swift"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsxs)("nav", {
                        className: "navbar-nav",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)((0, $eGOwh.NavLink), {
                                end: true,
                                to: "/",
                                className: navLinkClass,
                                children: "Home"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)((0, $eGOwh.NavLink), {
                                to: "/grocery",
                                className: navLinkClass,
                                children: "Grocery"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)((0, $eGOwh.NavLink), {
                                to: "/about",
                                className: navLinkClass,
                                children: "About"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)((0, $eGOwh.NavLink), {
                                to: "/contact",
                                className: navLinkClass,
                                children: "Contact"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "navbar-right",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsxs)((0, $eGOwh.Link), {
                                to: "/cart",
                                className: "cart-btn",
                                "aria-label": "Cart",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsx)((0, $272d6dd242682224$export$2e2bcd8739ae039), {
                                        size: 20
                                    }),
                                    cartCount > 0 && /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        className: "cart-badge",
                                        children: cartCount
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("button", {
                                className: `auth-btn ${loggedIn ? 'auth-btn-outline' : ''}`,
                                onClick: ()=>setLoggedIn((p)=>!p),
                                children: loggedIn ? 'Logout' : 'Login'
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("button", {
                                className: "hamburger",
                                onClick: ()=>setMenuOpen((p)=>!p),
                                "aria-label": "Toggle menu",
                                children: menuOpen ? /*#__PURE__*/ (0, $jk232.jsx)((0, $ee865572a14312f4$export$2e2bcd8739ae039), {
                                    size: 22
                                }) : /*#__PURE__*/ (0, $jk232.jsx)((0, $f2ee27b28a47667a$export$2e2bcd8739ae039), {
                                    size: 22
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: `mobile-drawer ${menuOpen ? 'drawer-open' : ''}`,
                children: [
                    /*#__PURE__*/ (0, $jk232.jsxs)("nav", {
                        className: "drawer-nav",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)((0, $eGOwh.NavLink), {
                                end: true,
                                to: "/",
                                className: navLinkClass,
                                children: "Home"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)((0, $eGOwh.NavLink), {
                                to: "/grocery",
                                className: navLinkClass,
                                children: "Grocery"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)((0, $eGOwh.NavLink), {
                                to: "/about",
                                className: navLinkClass,
                                children: "About"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)((0, $eGOwh.NavLink), {
                                to: "/contact",
                                className: navLinkClass,
                                children: "Contact"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)((0, $eGOwh.NavLink), {
                                to: "/cart",
                                className: navLinkClass,
                                children: [
                                    "Cart ",
                                    cartCount > 0 && `(${cartCount})`
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("button", {
                        className: `auth-btn drawer-auth-btn ${loggedIn ? 'auth-btn-outline' : ''}`,
                        onClick: ()=>setLoggedIn((p)=>!p),
                        children: loggedIn ? 'Logout' : 'Login'
                    })
                ]
            })
        ]
    });
};
var $2082b37973b7af43$export$2e2bcd8739ae039 = $2082b37973b7af43$var$Header;



var $jk232 = parcelRequire("jk232");

var $jk232 = parcelRequire("jk232");
const $d39effcf12df3fc5$export$2c4e825dc9120f87 = "https://www.swiggy.com/dapi/restaurants/list/v5?lat=12.9046136&lng=77.614948&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";
const $d39effcf12df3fc5$export$3c67ec6258c4a827 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
const $d39effcf12df3fc5$export$a91f4fe650c27642 = "https://png.pngtree.com/png-clipart/20241114/original/pngtree-fast-food-meal-clipart-illustration-burgers-fries-and-soda-png-image_17060160.png";
const $d39effcf12df3fc5$export$8878ead86ed0da0b = "https://static.vecteezy.com/system/resources/previews/050/585/647/non_2x/a-hamburger-and-a-drink-are-shown-in-a-line-free-vector.jpg";
const $d39effcf12df3fc5$export$b77c1aa4fb57bd1c = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=" // we won't be using default export
 //! named export
;



const $c2f90b08ce5e36f9$var$FALLBACK_IMAGES = [
    'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=660&q=80',
    'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=660&q=80',
    'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=660&q=80',
    'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=660&q=80',
    'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=660&q=80'
];
const $c2f90b08ce5e36f9$var$ratingColor = (rating)=>{
    if (rating >= 4.3) return 'var(--bs-success)';
    if (rating >= 3.8) return 'var(--bs-warn)';
    return 'var(--bs-danger)';
};
const $c2f90b08ce5e36f9$var$RestaurantCard = ({ resData: resData })=>{
    const { cloudinaryImageId: cloudinaryImageId, name: name, avgRating: avgRating, costForTwo: costForTwo, cuisines: cuisines, areaName: areaName, sla: sla, aggregatedDiscountInfoV3: aggregatedDiscountInfoV3, veg: veg } = resData.info;
    const deliveryTime = sla?.slaString ?? sla?.deliveryTime + ' mins' ?? "\u2014";
    return /*#__PURE__*/ (0, $jk232.jsxs)("div", {
        className: "res-card",
        children: [
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "res-card-img-wrap",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsx)("img", {
                        className: "res-card-img",
                        src: cloudinaryImageId?.startsWith('http') ? cloudinaryImageId : (0, $d39effcf12df3fc5$export$3c67ec6258c4a827) + cloudinaryImageId,
                        alt: name,
                        loading: "lazy",
                        onError: (e)=>{
                            e.target.onerror = null;
                            e.target.src = $c2f90b08ce5e36f9$var$FALLBACK_IMAGES[Math.floor(Math.random() * $c2f90b08ce5e36f9$var$FALLBACK_IMAGES.length)];
                        }
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("div", {
                        className: "res-card-img-overlay"
                    }),
                    aggregatedDiscountInfoV3 && /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "res-discount-badge",
                        children: [
                            aggregatedDiscountInfoV3.header,
                            aggregatedDiscountInfoV3.subHeader ? ` ${aggregatedDiscountInfoV3.subHeader}` : ''
                        ]
                    }),
                    veg && /*#__PURE__*/ (0, $jk232.jsx)("span", {
                        className: "res-veg-dot",
                        title: "Pure Veg",
                        children: "\uD83E\uDD66"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "res-card-body",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsx)("h3", {
                        className: "res-card-name",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "res-card-meta",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                className: "res-card-rating",
                                style: {
                                    background: $c2f90b08ce5e36f9$var$ratingColor(avgRating)
                                },
                                children: [
                                    "\u2605 ",
                                    avgRating
                                ]
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                className: "res-card-dot",
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                className: "res-card-time",
                                children: deliveryTime
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                className: "res-card-dot",
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                className: "res-card-price",
                                children: costForTwo
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsxs)("p", {
                        className: "res-card-cuisine",
                        children: [
                            cuisines?.slice(0, 3).join(', '),
                            cuisines?.length > 3 ? ` +${cuisines.length - 3}` : ''
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsxs)("p", {
                        className: "res-card-area",
                        children: [
                            "\uD83D\uDCCD ",
                            areaName
                        ]
                    })
                ]
            })
        ]
    });
};
const $c2f90b08ce5e36f9$export$69fb0609e92726e3 = (WrappedCard)=>{
    return (props)=>{
        const { aggregatedDiscountInfoV3: aggregatedDiscountInfoV3 } = props.resData.info;
        if (!aggregatedDiscountInfoV3) return /*#__PURE__*/ (0, $jk232.jsx)(WrappedCard, {
            ...props
        });
        return /*#__PURE__*/ (0, $jk232.jsx)("div", {
            className: "res-card-hoc-wrap",
            children: /*#__PURE__*/ (0, $jk232.jsx)(WrappedCard, {
                ...props
            })
        });
    };
};
var $c2f90b08ce5e36f9$export$2e2bcd8739ae039 = $c2f90b08ce5e36f9$var$RestaurantCard;



var $4RFnf = parcelRequire("4RFnf");

var $jk232 = parcelRequire("jk232");

const $7967c36430cc139a$var$ShimmerCard = ()=>/*#__PURE__*/ (0, $jk232.jsxs)("div", {
        className: "shimmer-card",
        children: [
            /*#__PURE__*/ (0, $jk232.jsx)("div", {
                className: "shimmer-img-wrap",
                children: /*#__PURE__*/ (0, $jk232.jsx)("div", {
                    className: "shimmer-pulse shimmer-img"
                })
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "shimmer-body",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsx)("div", {
                        className: "shimmer-pulse shimmer-line w-75"
                    }),
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "shimmer-meta-row",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)("div", {
                                className: "shimmer-pulse shimmer-badge"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("div", {
                                className: "shimmer-pulse shimmer-line w-40"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("div", {
                                className: "shimmer-pulse shimmer-line w-30"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("div", {
                        className: "shimmer-pulse shimmer-line w-85"
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("div", {
                        className: "shimmer-pulse shimmer-line w-50"
                    })
                ]
            })
        ]
    });
const $7967c36430cc139a$var$Shimmer = ()=>/*#__PURE__*/ (0, $jk232.jsx)("div", {
        className: "shimmer-grid",
        children: Array(8).fill('').map((_, i)=>/*#__PURE__*/ (0, $jk232.jsx)($7967c36430cc139a$var$ShimmerCard, {}, i))
    });
var $7967c36430cc139a$export$2e2bcd8739ae039 = $7967c36430cc139a$var$Shimmer;



var $eGOwh = parcelRequire("eGOwh");
var $3W4eU = parcelRequire("3W4eU");

var $4RFnf = parcelRequire("4RFnf");
const $e22dc6f67fcc7750$var$useOnlineStatus = ()=>{
    const [onlineStatus, setOnlineStatus] = (0, $4RFnf.useState)(true);
    // check if online
    (0, $4RFnf.useEffect)(()=>{
        window.addEventListener('offline', ()=>{
            setOnlineStatus(false);
        });
        window.addEventListener('online', ()=>{
            setOnlineStatus(true);
        });
    }, []) // dependency array to make sure it runs only once
    ;
    // boolean value
    return onlineStatus;
};
var $e22dc6f67fcc7750$export$2e2bcd8739ae039 //! creating custom hook to check if user is online/offline
 // we will be using addEventListener... window's online and offline events
 = $e22dc6f67fcc7750$var$useOnlineStatus;


// All collection IDs verified from Swiggy network tab (Bangalore — lat=12.97530, lng=77.59100)
const $7094f95aa1680fa7$export$a513ea61a7bee91c = [
    {
        emoji: "\uD83C\uDF55",
        label: 'Pizza',
        slug: 'pizza',
        collection: '83631',
        tags: 'layout_CCS_Pizza',
        color: [
            '#FF6B35',
            '#F7443E'
        ]
    },
    {
        emoji: "\uD83C\uDF57",
        label: 'Biryani',
        slug: 'biryani',
        collection: '83639',
        tags: 'layout_CCS_Biryani',
        color: [
            '#F7B731',
            '#F0932B'
        ]
    },
    {
        emoji: "\uD83C\uDF5B",
        label: 'South Indian',
        slug: 'south-indian',
        collection: '83634',
        tags: 'layout_CCS_SouthIndian',
        color: [
            '#20BF6B',
            '#0FB9B1'
        ]
    },
    {
        emoji: "\uD83E\uDD5E",
        label: 'Dosa',
        slug: 'dosa',
        collection: '80424',
        tags: 'layout_CCS_Dosa',
        color: [
            '#F7971E',
            '#FFD200'
        ]
    },
    {
        emoji: "\uD83C\uDF54",
        label: 'Burgers',
        slug: 'burgers',
        collection: '83637',
        tags: 'layout_CCS_Burger',
        color: [
            '#FF416C',
            '#FF4B2B'
        ]
    },
    {
        emoji: "\uD83E\uDD61",
        label: 'Chinese',
        slug: 'chinese',
        collection: '83636',
        tags: 'layout_CCS_Chinese',
        color: [
            '#c94b4b',
            '#4b134f'
        ]
    },
    {
        emoji: "\uD83C\uDF2F",
        label: 'Rolls',
        slug: 'rolls',
        collection: '83669',
        tags: 'layout_CCS_Rolls',
        color: [
            '#A18CD1',
            '#FBC2EB'
        ]
    },
    {
        emoji: "\uD83C\uDF70",
        label: 'Desserts',
        slug: 'desserts',
        collection: '83661',
        tags: 'layout_CCS_Desserts',
        color: [
            '#FD79A8',
            '#D63031'
        ]
    },
    {
        emoji: "\uD83E\uDD5F",
        label: 'Momos',
        slug: 'momos',
        collection: '80461',
        tags: 'layout_CCS_Momos',
        color: [
            '#4facfe',
            '#00f2fe'
        ]
    },
    {
        emoji: "\uD83E\uDD57",
        label: 'Salad',
        slug: 'salad',
        collection: '80394',
        tags: 'layout_CCS_Salad',
        color: [
            '#43E97B',
            '#38F9D7'
        ]
    },
    {
        emoji: "\uD83C\uDF82",
        label: 'Cakes',
        slug: 'cakes',
        collection: '83655',
        tags: 'layout_CCS_Cake',
        color: [
            '#f093fb',
            '#f5576c'
        ]
    },
    {
        emoji: "\uD83C\uDF5A",
        label: 'Idli',
        slug: 'idli',
        collection: '80440',
        tags: 'layout_CCS_Idli',
        color: [
            '#FDDB92',
            '#D1FDFF'
        ]
    },
    {
        emoji: "\uD83C\uDF5C",
        label: 'Noodles',
        slug: 'noodles',
        collection: '80463',
        tags: 'layout_ux4',
        color: [
            '#f7971e',
            '#ffd200'
        ]
    },
    {
        emoji: "\uD83E\uDD59",
        label: 'Shawarma',
        slug: 'shawarma',
        collection: '80402',
        tags: 'layout_Shawarma_Contextual',
        color: [
            '#c79081',
            '#dfa579'
        ]
    },
    {
        emoji: "\uD83C\uDF5D",
        label: 'Pasta',
        slug: 'pasta',
        collection: '80479',
        tags: 'layout_CCS_Pasta',
        color: [
            '#f953c6',
            '#b91d73'
        ]
    },
    {
        emoji: "\uD83E\uDD64",
        label: 'Shakes',
        slug: 'shakes',
        collection: '83673',
        tags: 'layout_CCS_Shakes',
        color: [
            '#4776E6',
            '#8E54E9'
        ]
    },
    {
        emoji: "\uD83E\uDD50",
        label: 'Samosa',
        slug: 'samosa',
        collection: '80396',
        tags: '',
        color: [
            '#F2994A',
            '#F2C94C'
        ]
    },
    {
        emoji: "\u2615",
        label: 'Coffee',
        slug: 'coffee',
        collection: '83907',
        tags: 'layout_CCS_Coffee',
        color: [
            '#6F4E37',
            '#C9A96E'
        ]
    },
    {
        emoji: "\uD83E\uDDC1",
        label: 'Pastry',
        slug: 'pastry',
        collection: '80355',
        tags: 'layout_ux4',
        color: [
            '#FC5C7D',
            '#6A82FB'
        ]
    },
    {
        emoji: "\uD83C\uDF79",
        label: 'Juices',
        slug: 'juices',
        collection: '80445',
        tags: 'layout_Juices_Contextual',
        color: [
            '#56AB2F',
            '#A8E063'
        ]
    }
];



const $22ed7a426ac2c232$var$SWIGGY_LIST_URL = '/.netlify/functions/swiggy-list';
const $22ed7a426ac2c232$var$SWIGGY_UPDATE_URL = '/.netlify/functions/swiggy-update';
// Search every card for the restaurant grid — Swiggy's index shifts between responses
const $22ed7a426ac2c232$var$extractRestaurants = (cards = [])=>{
    for (const card of cards){
        const list = card?.card?.card?.gridElements?.infoWithStyle?.restaurants;
        if (list?.length) return list;
    }
    return [];
};
const $22ed7a426ac2c232$var$FILTERS = [
    {
        id: 'all',
        label: 'All'
    },
    {
        id: 'rating',
        label: "\u2B50  Rating 4.0+"
    },
    {
        id: 'fast',
        label: "\u26A1  Under 30 min"
    },
    {
        id: 'veg',
        label: "\uD83E\uDD66  Pure Veg"
    },
    {
        id: 'offers',
        label: "\uD83C\uDF81  Offers"
    }
];
const $22ed7a426ac2c232$var$applyFilters = (list, filter, search)=>{
    let result = [
        ...list
    ];
    if (search.trim()) result = result.filter((r)=>r.info.name.toLowerCase().includes(search.toLowerCase()));
    switch(filter){
        case 'rating':
            result = result.filter((r)=>r.info.avgRating >= 4.0);
            break;
        case 'fast':
            result = result.filter((r)=>(r.info.sla?.deliveryTime ?? 99) <= 30);
            break;
        case 'veg':
            result = result.filter((r)=>r.info.veg);
            break;
        case 'offers':
            result = result.filter((r)=>r.info.aggregatedDiscountInfoV3);
            break;
        default:
            break;
    }
    return result;
};
const $22ed7a426ac2c232$var$Body = ()=>{
    const [allRestaurants, setAllRestaurants] = (0, $4RFnf.useState)([]);
    const [filteredRestaurants, setFilteredRestaurants] = (0, $4RFnf.useState)([]);
    const [searchText, setSearchText] = (0, $4RFnf.useState)('');
    const [activeFilter, setActiveFilter] = (0, $4RFnf.useState)('all');
    const [isLoading, setIsLoading] = (0, $4RFnf.useState)(true);
    const [isFetchingMore, setIsFetchingMore] = (0, $4RFnf.useState)(false);
    const [hasMore, setHasMore] = (0, $4RFnf.useState)(false);
    // Swiggy pagination tokens
    const [nextOffset, setNextOffset] = (0, $4RFnf.useState)(null);
    const [widgetOffset, setWidgetOffset] = (0, $4RFnf.useState)({});
    const swiggySessionRef = (0, $4RFnf.useRef)('') // Swiggy session cookies forwarded on pagination
    ;
    // Infinite scroll
    const observerRef = (0, $4RFnf.useRef)(null) // holds the IntersectionObserver instance
    ;
    const loadMoreRef = (0, $4RFnf.useRef)(null) // always points to the latest loadMore
    ;
    const fetchingRef = (0, $4RFnf.useRef)(false) // prevents double-fire from observer
    ;
    const navigate = (0, $3W4eU.useNavigate)();
    const RestaurantCardWithDiscount = (0, $c2f90b08ce5e36f9$export$69fb0609e92726e3)((0, $c2f90b08ce5e36f9$export$2e2bcd8739ae039));
    const onlineStatus = (0, $e22dc6f67fcc7750$export$2e2bcd8739ae039)();
    // ── Initial fetch ──────────────────────────────────────────────────────────
    (0, $4RFnf.useEffect)(()=>{
        fetchData();
    }, []);
    const fetchData = async ()=>{
        setIsLoading(true);
        try {
            const res = await fetch($22ed7a426ac2c232$var$SWIGGY_LIST_URL);
            const json = await res.json();
            const restaurants = $22ed7a426ac2c232$var$extractRestaurants(json?.data?.cards);
            console.log("[BiteSwift] initial load \u2014 restaurants:", restaurants.length, '| pageOffset:', json?.data?.pageOffset);
            setAllRestaurants(restaurants);
            swiggySessionRef.current = json?.__cookies || '';
            const pageOffset = json?.data?.pageOffset;
            setNextOffset(pageOffset?.nextOffset ?? null);
            setWidgetOffset(pageOffset?.widgetOffset ?? {});
            setHasMore(!!pageOffset?.nextOffset);
        } catch (e) {
            console.log('[BiteSwift] Swiggy fetch failed:', e.message);
            setAllRestaurants([]);
            setHasMore(false);
        } finally{
            setIsLoading(false);
        }
    };
    // ── Load more (called by intersection observer) ────────────────────────────
    const loadMore = async ()=>{
        if (fetchingRef.current || !hasMore) return;
        fetchingRef.current = true;
        setIsFetchingMore(true);
        try {
            const res = await fetch($22ed7a426ac2c232$var$SWIGGY_UPDATE_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-swiggy-cookies': swiggySessionRef.current
                },
                body: JSON.stringify({
                    lat: 12.9046136,
                    lng: 77.614948,
                    nextOffset: nextOffset,
                    widgetOffset: widgetOffset,
                    filters: {},
                    seoParams: {
                        seoUrl: 'https://www.swiggy.com/',
                        pageType: 'DESKTOP_WEB_LISTING',
                        apiName: 'FoodHomePage'
                    },
                    pageType: 'DESKTOP_WEB_LISTING',
                    type: 'DESKTOP_WEB_LISTING'
                })
            });
            const json = await res.json();
            const more = $22ed7a426ac2c232$var$extractRestaurants(json?.data?.cards);
            const pageOffset = json?.data?.pageOffset;
            console.log("[BiteSwift] pagination \u2014 got:", more.length, '| nextOffset:', pageOffset?.nextOffset);
            setAllRestaurants((prev)=>[
                    ...prev,
                    ...more
                ]);
            setNextOffset(pageOffset?.nextOffset ?? null);
            setWidgetOffset(pageOffset?.widgetOffset ?? {});
            setHasMore(!!pageOffset?.nextOffset);
        } catch (e) {
            console.log('[BiteSwift] pagination failed:', e.message);
            setHasMore(false);
        } finally{
            fetchingRef.current = false;
            setIsFetchingMore(false);
        }
    };
    // Keep ref current every render so the observer always calls the latest version
    loadMoreRef.current = loadMore;
    // Callback ref — fires when the sentinel mounts/unmounts (after data loads),
    // so the observer always attaches to a real DOM node.
    const sentinelRef = (0, $4RFnf.useCallback)((node)=>{
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = null;
        }
        if (!node) return;
        observerRef.current = new IntersectionObserver((entries)=>{
            if (entries[0].isIntersecting) loadMoreRef.current();
        }, {
            rootMargin: '0px'
        });
        observerRef.current.observe(node);
    }, []);
    // ── Re-filter whenever search / filter / category / allRestaurants changes ─
    (0, $4RFnf.useEffect)(()=>{
        setFilteredRestaurants($22ed7a426ac2c232$var$applyFilters(allRestaurants, activeFilter, searchText));
    }, [
        searchText,
        activeFilter,
        allRestaurants
    ]);
    const handleFilterClick = (id)=>setActiveFilter((prev)=>prev === id ? 'all' : id);
    if (onlineStatus === false) return /*#__PURE__*/ (0, $jk232.jsxs)("div", {
        className: "offline-screen",
        children: [
            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                className: "offline-icon",
                children: "\uD83D\uDCE1"
            }),
            /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                children: "You're offline"
            }),
            /*#__PURE__*/ (0, $jk232.jsx)("p", {
                children: "Check your internet connection and try again."
            })
        ]
    });
    return /*#__PURE__*/ (0, $jk232.jsxs)("div", {
        className: "home-page",
        children: [
            /*#__PURE__*/ (0, $jk232.jsx)("section", {
                className: "hero",
                children: /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                    className: "hero-content",
                    children: [
                        /*#__PURE__*/ (0, $jk232.jsx)("span", {
                            className: "hero-badge",
                            children: "\uD83D\uDD25 Hot & fresh, always"
                        }),
                        /*#__PURE__*/ (0, $jk232.jsxs)("h1", {
                            className: "hero-headline",
                            children: [
                                "HUNGRY?",
                                /*#__PURE__*/ (0, $jk232.jsx)("br", {}),
                                /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                    className: "hero-accent",
                                    children: "WE'VE GOT YOU."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $jk232.jsx)("p", {
                            className: "hero-sub",
                            children: "200+ restaurants. One tap. Delivered fast."
                        }),
                        /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                            className: "hero-search",
                            children: [
                                /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                    className: "hero-search-icon",
                                    children: "\uD83D\uDD0D"
                                }),
                                /*#__PURE__*/ (0, $jk232.jsx)("input", {
                                    className: "hero-search-input",
                                    type: "text",
                                    placeholder: "Search restaurants, cuisines...",
                                    value: searchText,
                                    onChange: (e)=>setSearchText(e.target.value)
                                }),
                                searchText && /*#__PURE__*/ (0, $jk232.jsx)("button", {
                                    className: "hero-search-clear",
                                    onClick: ()=>setSearchText(''),
                                    children: "\u2715"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                            className: "hero-stats",
                            children: [
                                /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                    className: "hstat",
                                    children: [
                                        /*#__PURE__*/ (0, $jk232.jsx)("strong", {
                                            children: "200+"
                                        }),
                                        /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                            children: "Restaurants"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $jk232.jsx)("div", {
                                    className: "hstat-sep"
                                }),
                                /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                    className: "hstat",
                                    children: [
                                        /*#__PURE__*/ (0, $jk232.jsx)("strong", {
                                            children: "30 min"
                                        }),
                                        /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                            children: "Avg delivery"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $jk232.jsx)("div", {
                                    className: "hstat-sep"
                                }),
                                /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                    className: "hstat",
                                    children: [
                                        /*#__PURE__*/ (0, $jk232.jsx)("strong", {
                                            children: "4.8 \u2605"
                                        }),
                                        /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                            children: "Avg rating"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "how-strip",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "how-item",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)("div", {
                                className: "how-icon-wrap",
                                children: "\uD83D\uDDFA\uFE0F"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "how-text",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsx)("strong", {
                                        children: "Browse restaurants"
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        children: "200+ local spots near you"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("div", {
                        className: "how-divider"
                    }),
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "how-item",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)("div", {
                                className: "how-icon-wrap",
                                children: "\uD83D\uDED2"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "how-text",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsx)("strong", {
                                        children: "Build your order"
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        children: "Customize every item your way"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("div", {
                        className: "how-divider"
                    }),
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "how-item",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)("div", {
                                className: "how-icon-wrap",
                                children: "\uD83D\uDEF5"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "how-text",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsx)("strong", {
                                        children: "Track live"
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        children: "Door-to-door, in real time"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jk232.jsx)("section", {
                className: "feature-row",
                children: /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                    className: "feature-row__inner",
                    children: [
                        /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                            className: "feature-row__text",
                            children: [
                                /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Fast. Every time."
                                }),
                                /*#__PURE__*/ (0, $jk232.jsxs)("h2", {
                                    className: "feature-row__heading",
                                    children: [
                                        "Your food,",
                                        /*#__PURE__*/ (0, $jk232.jsx)("br", {}),
                                        "in 30 minutes."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                    className: "feature-row__desc",
                                    children: "We've optimized every step so your food arrives hot, fast, and exactly as you ordered it."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $jk232.jsx)("div", {
                            className: "feature-row__visual",
                            children: /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "fvisual-card",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                        className: "fvc-label",
                                        children: "Your order"
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                        className: "fvc-steps",
                                        children: [
                                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                                className: "fvc-step fvc-step--done",
                                                children: [
                                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                        className: "fvcs-dot"
                                                    }),
                                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                        className: "fvcs-name",
                                                        children: "Order received"
                                                    }),
                                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                        className: "fvcs-time",
                                                        children: "0:00"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                                className: "fvc-step fvc-step--done",
                                                children: [
                                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                        className: "fvcs-dot"
                                                    }),
                                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                        className: "fvcs-name",
                                                        children: "Kitchen preparing"
                                                    }),
                                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                        className: "fvcs-time",
                                                        children: "5:12"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                                className: "fvc-step fvc-step--active",
                                                children: [
                                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                        className: "fvcs-dot"
                                                    }),
                                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                        className: "fvcs-name",
                                                        children: "On the way"
                                                    }),
                                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                        className: "fvcs-time",
                                                        children: "18:30"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                                className: "fvc-step",
                                                children: [
                                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                        className: "fvcs-dot"
                                                    }),
                                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                        className: "fvcs-name",
                                                        children: "Delivered"
                                                    }),
                                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                        className: "fvcs-time",
                                                        children: "~28 min"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                        className: "fvc-eta",
                                        children: [
                                            "Estimated arrival ",
                                            /*#__PURE__*/ (0, $jk232.jsx)("strong", {
                                                children: "28 min"
                                            }),
                                            " \uD83D\uDEF5"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $jk232.jsx)("section", {
                className: "feature-row feature-row--alt",
                children: /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                    className: "feature-row__inner feature-row__inner--reverse",
                    children: [
                        /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                            className: "feature-row__text",
                            children: [
                                /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Every craving covered"
                                }),
                                /*#__PURE__*/ (0, $jk232.jsxs)("h2", {
                                    className: "feature-row__heading",
                                    children: [
                                        "Whatever you're",
                                        /*#__PURE__*/ (0, $jk232.jsx)("br", {}),
                                        "in the mood for."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                    className: "feature-row__desc",
                                    children: "Late-night biryani. Weekend brunch. Midnight dessert. 20 cuisines across 200+ restaurants \u2014 all in one place."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $jk232.jsx)("div", {
                            className: "feature-row__visual",
                            children: /*#__PURE__*/ (0, $jk232.jsx)("div", {
                                className: "fvisual-cravings",
                                children: (0, $7094f95aa1680fa7$export$a513ea61a7bee91c).slice(0, 6).map((cat)=>/*#__PURE__*/ (0, $jk232.jsxs)("button", {
                                        className: "fvc-craving",
                                        style: {
                                            background: `linear-gradient(135deg, ${cat.color[0]}, ${cat.color[1]})`
                                        },
                                        onClick: ()=>navigate(`/collection/${cat.slug}`),
                                        children: [
                                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                className: "fvc-craving-emoji",
                                                children: cat.emoji
                                            }),
                                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                className: "fvc-craving-label",
                                                children: cat.label
                                            })
                                        ]
                                    }, cat.slug))
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("section", {
                className: "categories-section",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "section-inner",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                className: "eyebrow",
                                children: "Explore by craving"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                                className: "section-heading",
                                children: "What are you in the mood for?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("div", {
                        className: "category-scroll-wrapper",
                        children: /*#__PURE__*/ (0, $jk232.jsx)("div", {
                            className: "category-scroll",
                            children: (0, $7094f95aa1680fa7$export$a513ea61a7bee91c).map((cat)=>/*#__PURE__*/ (0, $jk232.jsxs)("button", {
                                    className: "category-pill",
                                    style: {
                                        background: `linear-gradient(145deg, ${cat.color[0]}, ${cat.color[1]})`
                                    },
                                    onClick: ()=>navigate(`/collection/${cat.slug}`),
                                    children: [
                                        /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                            className: "cat-emoji",
                                            children: cat.emoji
                                        }),
                                        /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                            className: "cat-label",
                                            children: cat.label
                                        })
                                    ]
                                }, cat.slug))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "filter-bar",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsx)("div", {
                        className: "filter-chips",
                        children: $22ed7a426ac2c232$var$FILTERS.map((f)=>/*#__PURE__*/ (0, $jk232.jsx)("button", {
                                className: `filter-chip ${activeFilter === f.id ? 'active' : ''}`,
                                onClick: ()=>handleFilterClick(f.id),
                                children: f.label
                            }, f.id))
                    }),
                    !isLoading && /*#__PURE__*/ (0, $jk232.jsxs)("p", {
                        className: "results-count",
                        children: [
                            filteredRestaurants.length,
                            " restaurant",
                            filteredRestaurants.length !== 1 ? 's' : ''
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jk232.jsx)("section", {
                className: "restaurants-section",
                children: isLoading ? /*#__PURE__*/ (0, $jk232.jsx)((0, $7967c36430cc139a$export$2e2bcd8739ae039), {}) : allRestaurants.length === 0 ? /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                    className: "empty-state",
                    children: [
                        /*#__PURE__*/ (0, $jk232.jsx)("span", {
                            children: "\uD83D\uDCE1"
                        }),
                        /*#__PURE__*/ (0, $jk232.jsx)("h3", {
                            children: "Couldn't load restaurants"
                        }),
                        /*#__PURE__*/ (0, $jk232.jsx)("p", {
                            children: "Something went wrong reaching Swiggy. Please try again."
                        }),
                        /*#__PURE__*/ (0, $jk232.jsx)("button", {
                            onClick: fetchData,
                            children: "Retry"
                        })
                    ]
                }) : filteredRestaurants.length === 0 ? /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                    className: "empty-state",
                    children: [
                        /*#__PURE__*/ (0, $jk232.jsx)("span", {
                            children: "\uD83C\uDF7D\uFE0F"
                        }),
                        /*#__PURE__*/ (0, $jk232.jsx)("h3", {
                            children: "No restaurants found"
                        }),
                        /*#__PURE__*/ (0, $jk232.jsx)("p", {
                            children: "Try a different search or clear your filters."
                        }),
                        /*#__PURE__*/ (0, $jk232.jsx)("button", {
                            onClick: ()=>{
                                setSearchText('');
                                setActiveFilter('all');
                            },
                            children: "Clear all filters"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $jk232.jsxs)((0, $jk232.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                            className: "section-title",
                            children: searchText ? `Results for "${searchText}"` : 'Restaurants near you'
                        }),
                        /*#__PURE__*/ (0, $jk232.jsx)("div", {
                            className: "restaurant-grid",
                            children: filteredRestaurants.map((restaurant)=>/*#__PURE__*/ (0, $jk232.jsx)((0, $eGOwh.Link), {
                                    to: '/restaurant/' + restaurant.info.id,
                                    className: "card-link",
                                    children: restaurant.info.aggregatedDiscountInfoV3 ? /*#__PURE__*/ (0, $jk232.jsx)(RestaurantCardWithDiscount, {
                                        resData: restaurant
                                    }) : /*#__PURE__*/ (0, $jk232.jsx)((0, $c2f90b08ce5e36f9$export$2e2bcd8739ae039), {
                                        resData: restaurant
                                    })
                                }, restaurant.info.id))
                        }),
                        /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                            ref: sentinelRef,
                            className: "scroll-sentinel",
                            children: [
                                isFetchingMore && /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                    className: "fetching-more",
                                    children: [
                                        /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                            className: "fetching-spinner"
                                        }),
                                        /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                            children: "Loading more restaurants\u2026"
                                        })
                                    ]
                                }),
                                !hasMore && allRestaurants.length > 0 && /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                    className: "end-of-list",
                                    children: "You've seen all restaurants nearby \uD83C\uDF7D\uFE0F"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $22ed7a426ac2c232$export$2e2bcd8739ae039 = $22ed7a426ac2c232$var$Body;



var $jk232 = parcelRequire("jk232");

var $eGOwh = parcelRequire("eGOwh");

var $4RFnf = parcelRequire("4RFnf");
'use client';
/**
* Resolve icon set icons
*
* Returns parent icon for each icon
*/ function $4216fe18cda7ab89$var$getIconsTree(data, names) {
    const icons = data.icons;
    const aliases = data.aliases || Object.create(null);
    const resolved = Object.create(null);
    function resolve(name) {
        if (icons[name]) return resolved[name] = [];
        if (!(name in resolved)) {
            resolved[name] = null;
            const parent = aliases[name] && aliases[name].parent;
            const value = parent && resolve(parent);
            if (value) resolved[name] = [
                parent
            ].concat(value);
        }
        return resolved[name];
    }
    Object.keys(icons).concat(Object.keys(aliases)).forEach(resolve);
    return resolved;
}
/**
* Default values for dimensions
*/ const $4216fe18cda7ab89$var$defaultIconDimensions = Object.freeze({
    left: 0,
    top: 0,
    width: 16,
    height: 16
});
/**
* Default values for transformations
*/ const $4216fe18cda7ab89$var$defaultIconTransformations = Object.freeze({
    rotate: 0,
    vFlip: false,
    hFlip: false
});
/**
* Default values for all optional IconifyIcon properties
*/ const $4216fe18cda7ab89$var$defaultIconProps = Object.freeze({
    ...$4216fe18cda7ab89$var$defaultIconDimensions,
    ...$4216fe18cda7ab89$var$defaultIconTransformations
});
/**
* Default values for all properties used in ExtendedIconifyIcon
*/ const $4216fe18cda7ab89$var$defaultExtendedIconProps = Object.freeze({
    ...$4216fe18cda7ab89$var$defaultIconProps,
    body: "",
    hidden: false
});
/**
* Merge transformations
*/ function $4216fe18cda7ab89$var$mergeIconTransformations(obj1, obj2) {
    const result = {};
    if (!obj1.hFlip !== !obj2.hFlip) result.hFlip = true;
    if (!obj1.vFlip !== !obj2.vFlip) result.vFlip = true;
    const rotate = ((obj1.rotate || 0) + (obj2.rotate || 0)) % 4;
    if (rotate) result.rotate = rotate;
    return result;
}
/**
* Merge icon and alias
*
* Can also be used to merge default values and icon
*/ function $4216fe18cda7ab89$var$mergeIconData(parent, child) {
    const result = $4216fe18cda7ab89$var$mergeIconTransformations(parent, child);
    for(const key in $4216fe18cda7ab89$var$defaultExtendedIconProps)if (key in $4216fe18cda7ab89$var$defaultIconTransformations) {
        if (key in parent && !(key in result)) result[key] = $4216fe18cda7ab89$var$defaultIconTransformations[key];
    } else if (key in child) result[key] = child[key];
    else if (key in parent) result[key] = parent[key];
    return result;
}
/**
* Get icon data, using prepared aliases tree
*/ function $4216fe18cda7ab89$var$internalGetIconData(data, name, tree) {
    const icons = data.icons;
    const aliases = data.aliases || Object.create(null);
    let currentProps = {};
    function parse(name$1) {
        currentProps = $4216fe18cda7ab89$var$mergeIconData(icons[name$1] || aliases[name$1], currentProps);
    }
    parse(name);
    tree.forEach(parse);
    return $4216fe18cda7ab89$var$mergeIconData(data, currentProps);
}
/**
* Extract icons from an icon set
*
* Returns list of icons that were found in icon set
*/ function $4216fe18cda7ab89$var$parseIconSet(data, callback) {
    const names = [];
    if (typeof data !== "object" || typeof data.icons !== "object") return names;
    if (data.not_found instanceof Array) data.not_found.forEach((name)=>{
        callback(name, null);
        names.push(name);
    });
    const tree = $4216fe18cda7ab89$var$getIconsTree(data);
    for(const name in tree){
        const item = tree[name];
        if (item) {
            callback(name, $4216fe18cda7ab89$var$internalGetIconData(data, name, item));
            names.push(name);
        }
    }
    return names;
}
/**
* Optional properties
*/ const $4216fe18cda7ab89$var$optionalPropertyDefaults = {
    provider: "",
    aliases: {},
    not_found: {},
    ...$4216fe18cda7ab89$var$defaultIconDimensions
};
/**
* Check props
*/ function $4216fe18cda7ab89$var$checkOptionalProps(item, defaults) {
    for(const prop in defaults)if (prop in item && typeof item[prop] !== typeof defaults[prop]) return false;
    return true;
}
/**
* Validate icon set, return it as IconifyJSON on success, null on failure
*
* Unlike validateIconSet(), this function is very basic.
* It does not throw exceptions, it does not check metadata, it does not fix stuff.
*/ function $4216fe18cda7ab89$var$quicklyValidateIconSet(obj) {
    if (typeof obj !== "object" || obj === null) return null;
    const data = obj;
    if (typeof data.prefix !== "string" || !obj.icons || typeof obj.icons !== "object") return null;
    if (!$4216fe18cda7ab89$var$checkOptionalProps(obj, $4216fe18cda7ab89$var$optionalPropertyDefaults)) return null;
    const icons = data.icons;
    for(const name in icons){
        const icon = icons[name];
        if (!name || typeof icon.body !== "string" || !$4216fe18cda7ab89$var$checkOptionalProps(icon, $4216fe18cda7ab89$var$defaultExtendedIconProps)) return null;
    }
    const aliases = data.aliases || Object.create(null);
    for(const name in aliases){
        const icon = aliases[name];
        const parent = icon.parent;
        if (!name || typeof parent !== "string" || !icons[parent] && !aliases[parent] || !$4216fe18cda7ab89$var$checkOptionalProps(icon, $4216fe18cda7ab89$var$defaultExtendedIconProps)) return null;
    }
    return data;
}
/**
* Storage by provider and prefix
*/ const $4216fe18cda7ab89$var$dataStorage = Object.create(null);
/**
* Create new storage
*/ function $4216fe18cda7ab89$var$newStorage(provider, prefix) {
    return {
        provider: provider,
        prefix: prefix,
        icons: Object.create(null),
        missing: /* @__PURE__ */ new Set()
    };
}
/**
* Get storage for provider and prefix
*/ function $4216fe18cda7ab89$var$getStorage(provider, prefix) {
    const providerStorage = $4216fe18cda7ab89$var$dataStorage[provider] || ($4216fe18cda7ab89$var$dataStorage[provider] = Object.create(null));
    return providerStorage[prefix] || (providerStorage[prefix] = $4216fe18cda7ab89$var$newStorage(provider, prefix));
}
/**
* Add icon set to storage
*
* Returns array of added icons
*/ function $4216fe18cda7ab89$var$addIconSet(storage, data) {
    if (!$4216fe18cda7ab89$var$quicklyValidateIconSet(data)) return [];
    return $4216fe18cda7ab89$var$parseIconSet(data, (name, icon)=>{
        if (icon) storage.icons[name] = icon;
        else storage.missing.add(name);
    });
}
/**
* Add icon to storage
*/ function $4216fe18cda7ab89$var$addIconToStorage(storage, name, icon) {
    try {
        if (typeof icon.body === "string") {
            storage.icons[name] = {
                ...icon
            };
            return true;
        }
    } catch (err) {}
    return false;
}
/**
* List available icons
*/ function $4216fe18cda7ab89$export$a598a3910899291f(provider, prefix) {
    let allIcons = [];
    const providers = typeof provider === "string" ? [
        provider
    ] : Object.keys($4216fe18cda7ab89$var$dataStorage);
    providers.forEach((provider$1)=>{
        const prefixes = typeof provider$1 === "string" && typeof prefix === "string" ? [
            prefix
        ] : Object.keys($4216fe18cda7ab89$var$dataStorage[provider$1] || {});
        prefixes.forEach((prefix$1)=>{
            const storage = $4216fe18cda7ab89$var$getStorage(provider$1, prefix$1);
            allIcons = allIcons.concat(Object.keys(storage.icons).map((name)=>(provider$1 !== "" ? "@" + provider$1 + ":" : "") + prefix$1 + ":" + name));
        });
    });
    return allIcons;
}
/**
* Expression to test part of icon name.
*
* Used when loading icons from Iconify API due to project naming convension.
* Ignored when using custom icon sets - convension does not apply.
*/ const $4216fe18cda7ab89$var$matchIconName = /^[a-z0-9]+(-[a-z0-9]+)*$/;
/**
* Convert string icon name to IconifyIconName object.
*/ const $4216fe18cda7ab89$var$stringToIcon = (value, validate, allowSimpleName, provider = "")=>{
    const colonSeparated = value.split(":");
    if (value.slice(0, 1) === "@") {
        if (colonSeparated.length < 2 || colonSeparated.length > 3) return null;
        provider = colonSeparated.shift().slice(1);
    }
    if (colonSeparated.length > 3 || !colonSeparated.length) return null;
    if (colonSeparated.length > 1) {
        const name$1 = colonSeparated.pop();
        const prefix = colonSeparated.pop();
        const result = {
            provider: colonSeparated.length > 0 ? colonSeparated[0] : provider,
            prefix: prefix,
            name: name$1
        };
        return validate && !$4216fe18cda7ab89$var$validateIconName(result) ? null : result;
    }
    const name = colonSeparated[0];
    const dashSeparated = name.split("-");
    if (dashSeparated.length > 1) {
        const result = {
            provider: provider,
            prefix: dashSeparated.shift(),
            name: dashSeparated.join("-")
        };
        return validate && !$4216fe18cda7ab89$var$validateIconName(result) ? null : result;
    }
    if (allowSimpleName && provider === "") {
        const result = {
            provider: provider,
            prefix: "",
            name: name
        };
        return validate && !$4216fe18cda7ab89$var$validateIconName(result, allowSimpleName) ? null : result;
    }
    return null;
};
/**
* Check if icon is valid.
*
* This function is not part of stringToIcon because validation is not needed for most code.
*/ const $4216fe18cda7ab89$var$validateIconName = (icon, allowSimpleName)=>{
    if (!icon) return false;
    return !!((allowSimpleName && icon.prefix === "" || !!icon.prefix) && !!icon.name);
};
/**
* Allow storing icons without provider or prefix, making it possible to store icons like "home"
*/ let $4216fe18cda7ab89$var$simpleNames = false;
function $4216fe18cda7ab89$var$allowSimpleNames(allow) {
    if (typeof allow === "boolean") $4216fe18cda7ab89$var$simpleNames = allow;
    return $4216fe18cda7ab89$var$simpleNames;
}
/**
* Get icon data
*
* Returns:
* - IconifyIcon on success, object directly from storage so don't modify it
* - null if icon is marked as missing (returned in `not_found` property from API, so don't bother sending API requests)
* - undefined if icon is missing in storage
*/ function $4216fe18cda7ab89$var$getIconData(name) {
    const icon = typeof name === "string" ? $4216fe18cda7ab89$var$stringToIcon(name, true, $4216fe18cda7ab89$var$simpleNames) : name;
    if (icon) {
        const storage = $4216fe18cda7ab89$var$getStorage(icon.provider, icon.prefix);
        const iconName = icon.name;
        return storage.icons[iconName] || (storage.missing.has(iconName) ? null : void 0);
    }
}
/**
* Add one icon
*/ function $4216fe18cda7ab89$export$3488242433cbedb(name, data) {
    const icon = $4216fe18cda7ab89$var$stringToIcon(name, true, $4216fe18cda7ab89$var$simpleNames);
    if (!icon) return false;
    const storage = $4216fe18cda7ab89$var$getStorage(icon.provider, icon.prefix);
    if (data) return $4216fe18cda7ab89$var$addIconToStorage(storage, icon.name, data);
    else {
        storage.missing.add(icon.name);
        return true;
    }
}
/**
* Add icon set
*/ function $4216fe18cda7ab89$export$933f273b2a11730f(data, provider) {
    if (typeof data !== "object") return false;
    if (typeof provider !== "string") provider = data.provider || "";
    if ($4216fe18cda7ab89$var$simpleNames && !provider && !data.prefix) {
        let added = false;
        if ($4216fe18cda7ab89$var$quicklyValidateIconSet(data)) {
            data.prefix = "";
            $4216fe18cda7ab89$var$parseIconSet(data, (name, icon)=>{
                if ($4216fe18cda7ab89$export$3488242433cbedb(name, icon)) added = true;
            });
        }
        return added;
    }
    const prefix = data.prefix;
    if (!$4216fe18cda7ab89$var$validateIconName({
        prefix: prefix,
        name: "a"
    })) return false;
    const storage = $4216fe18cda7ab89$var$getStorage(provider, prefix);
    return !!$4216fe18cda7ab89$var$addIconSet(storage, data);
}
/**
* Check if icon data is available
*/ function $4216fe18cda7ab89$export$6728fff2d370396a(name) {
    return !!$4216fe18cda7ab89$var$getIconData(name);
}
/**
* Get full icon
*/ function $4216fe18cda7ab89$export$16b26cd5e98d9100(name) {
    const result = $4216fe18cda7ab89$var$getIconData(name);
    return result ? {
        ...$4216fe18cda7ab89$var$defaultIconProps,
        ...result
    } : result;
}
/**
* Default icon customisations values
*/ const $4216fe18cda7ab89$var$defaultIconSizeCustomisations = Object.freeze({
    width: null,
    height: null
});
const $4216fe18cda7ab89$var$defaultIconCustomisations = Object.freeze({
    ...$4216fe18cda7ab89$var$defaultIconSizeCustomisations,
    ...$4216fe18cda7ab89$var$defaultIconTransformations
});
/**
* Regular expressions for calculating dimensions
*/ const $4216fe18cda7ab89$var$unitsSplit = /(-?[0-9.]*[0-9]+[0-9.]*)/g;
const $4216fe18cda7ab89$var$unitsTest = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function $4216fe18cda7ab89$export$907c7b8171f13ef1(size, ratio, precision) {
    if (ratio === 1) return size;
    precision = precision || 100;
    if (typeof size === "number") return Math.ceil(size * ratio * precision) / precision;
    if (typeof size !== "string") return size;
    const oldParts = size.split($4216fe18cda7ab89$var$unitsSplit);
    if (oldParts === null || !oldParts.length) return size;
    const newParts = [];
    let code = oldParts.shift();
    let isNumber = $4216fe18cda7ab89$var$unitsTest.test(code);
    while(true){
        if (isNumber) {
            const num = parseFloat(code);
            if (isNaN(num)) newParts.push(code);
            else newParts.push(Math.ceil(num * ratio * precision) / precision);
        } else newParts.push(code);
        code = oldParts.shift();
        if (code === void 0) return newParts.join("");
        isNumber = !isNumber;
    }
}
function $4216fe18cda7ab89$var$splitSVGDefs(content, tag = "defs") {
    let defs = "";
    const index = content.indexOf("<" + tag);
    while(index >= 0){
        const start = content.indexOf(">", index);
        const end = content.indexOf("</" + tag);
        if (start === -1 || end === -1) break;
        const endEnd = content.indexOf(">", end);
        if (endEnd === -1) break;
        defs += content.slice(start + 1, end).trim();
        content = content.slice(0, index).trim() + content.slice(endEnd + 1);
    }
    return {
        defs: defs,
        content: content
    };
}
/**
* Merge defs and content
*/ function $4216fe18cda7ab89$var$mergeDefsAndContent(defs, content) {
    return defs ? "<defs>" + defs + "</defs>" + content : content;
}
/**
* Wrap SVG content, without wrapping definitions
*/ function $4216fe18cda7ab89$var$wrapSVGContent(body, start, end) {
    const split = $4216fe18cda7ab89$var$splitSVGDefs(body);
    return $4216fe18cda7ab89$var$mergeDefsAndContent(split.defs, start + split.content + end);
}
/**
* Check if value should be unset. Allows multiple keywords
*/ const $4216fe18cda7ab89$var$isUnsetKeyword = (value)=>value === "unset" || value === "undefined" || value === "none";
/**
* Get SVG attributes and content from icon + customisations
*
* Does not generate style to make it compatible with frameworks that use objects for style, such as React.
* Instead, it generates 'inline' value. If true, rendering engine should add verticalAlign: -0.125em to icon.
*
* Customisations should be normalised by platform specific parser.
* Result should be converted to <svg> by platform specific parser.
* Use replaceIDs to generate unique IDs for body.
*/ function $4216fe18cda7ab89$export$78c1051fc6863a0b(icon, customisations) {
    const fullIcon = {
        ...$4216fe18cda7ab89$var$defaultIconProps,
        ...icon
    };
    const fullCustomisations = {
        ...$4216fe18cda7ab89$var$defaultIconCustomisations,
        ...customisations
    };
    const box = {
        left: fullIcon.left,
        top: fullIcon.top,
        width: fullIcon.width,
        height: fullIcon.height
    };
    let body = fullIcon.body;
    [
        fullIcon,
        fullCustomisations
    ].forEach((props)=>{
        const transformations = [];
        const hFlip = props.hFlip;
        const vFlip = props.vFlip;
        let rotation = props.rotate;
        if (hFlip) {
            if (vFlip) rotation += 2;
            else {
                transformations.push("translate(" + (box.width + box.left).toString() + " " + (0 - box.top).toString() + ")");
                transformations.push("scale(-1 1)");
                box.top = box.left = 0;
            }
        } else if (vFlip) {
            transformations.push("translate(" + (0 - box.left).toString() + " " + (box.height + box.top).toString() + ")");
            transformations.push("scale(1 -1)");
            box.top = box.left = 0;
        }
        let tempValue;
        if (rotation < 0) rotation -= Math.floor(rotation / 4) * 4;
        rotation = rotation % 4;
        switch(rotation){
            case 1:
                tempValue = box.height / 2 + box.top;
                transformations.unshift("rotate(90 " + tempValue.toString() + " " + tempValue.toString() + ")");
                break;
            case 2:
                transformations.unshift("rotate(180 " + (box.width / 2 + box.left).toString() + " " + (box.height / 2 + box.top).toString() + ")");
                break;
            case 3:
                tempValue = box.width / 2 + box.left;
                transformations.unshift("rotate(-90 " + tempValue.toString() + " " + tempValue.toString() + ")");
                break;
        }
        if (rotation % 2 === 1) {
            if (box.left !== box.top) {
                tempValue = box.left;
                box.left = box.top;
                box.top = tempValue;
            }
            if (box.width !== box.height) {
                tempValue = box.width;
                box.width = box.height;
                box.height = tempValue;
            }
        }
        if (transformations.length) body = $4216fe18cda7ab89$var$wrapSVGContent(body, "<g transform=\"" + transformations.join(" ") + "\">", "</g>");
    });
    const customisationsWidth = fullCustomisations.width;
    const customisationsHeight = fullCustomisations.height;
    const boxWidth = box.width;
    const boxHeight = box.height;
    let width;
    let height;
    if (customisationsWidth === null) {
        height = customisationsHeight === null ? "1em" : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
        width = $4216fe18cda7ab89$export$907c7b8171f13ef1(height, boxWidth / boxHeight);
    } else {
        width = customisationsWidth === "auto" ? boxWidth : customisationsWidth;
        height = customisationsHeight === null ? $4216fe18cda7ab89$export$907c7b8171f13ef1(width, boxHeight / boxWidth) : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
    }
    const attributes = {};
    const setAttr = (prop, value)=>{
        if (!$4216fe18cda7ab89$var$isUnsetKeyword(value)) attributes[prop] = value.toString();
    };
    setAttr("width", width);
    setAttr("height", height);
    const viewBox = [
        box.left,
        box.top,
        boxWidth,
        boxHeight
    ];
    attributes.viewBox = viewBox.join(" ");
    return {
        attributes: attributes,
        viewBox: viewBox,
        body: body
    };
}
/**
* IDs usage:
*
* id="{id}"
* xlink:href="#{id}"
* url(#{id})
*
* From SVG animations:
*
* begin="0;{id}.end"
* begin="{id}.end"
* begin="{id}.click"
*/ /**
* Regular expression for finding ids
*/ const $4216fe18cda7ab89$var$regex = /\sid="(\S+)"/g;
/**
* New random-ish prefix for ids
*
* Do not use dash, it cannot be used in SVG 2 animations
*/ const $4216fe18cda7ab89$var$randomPrefix = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
/**
* Counter for ids, increasing with every replacement
*/ let $4216fe18cda7ab89$var$counter = 0;
/**
* Replace IDs in SVG output with unique IDs
*/ function $4216fe18cda7ab89$export$cae0fa3719aa5dc4(body, prefix = $4216fe18cda7ab89$var$randomPrefix) {
    const ids = [];
    let match;
    while(match = $4216fe18cda7ab89$var$regex.exec(body))ids.push(match[1]);
    if (!ids.length) return body;
    const suffix = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
    ids.forEach((id)=>{
        const newID = typeof prefix === "function" ? prefix(id) : prefix + ($4216fe18cda7ab89$var$counter++).toString();
        const escapedID = id.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        body = body.replace(new RegExp("([#;\"])(" + escapedID + ")([\")]|\\.[a-z])", "g"), "$1" + newID + suffix + "$3");
    });
    body = body.replace(new RegExp(suffix, "g"), "");
    return body;
}
/**
* Local storate types and entries
*/ const $4216fe18cda7ab89$var$storage = Object.create(null);
/**
* Set API module
*/ function $4216fe18cda7ab89$var$setAPIModule(provider, item) {
    $4216fe18cda7ab89$var$storage[provider] = item;
}
/**
* Get API module
*/ function $4216fe18cda7ab89$var$getAPIModule(provider) {
    return $4216fe18cda7ab89$var$storage[provider] || $4216fe18cda7ab89$var$storage[""];
}
/**
* Create full API configuration from partial data
*/ function $4216fe18cda7ab89$var$createAPIConfig(source) {
    let resources;
    if (typeof source.resources === "string") resources = [
        source.resources
    ];
    else {
        resources = source.resources;
        if (!(resources instanceof Array) || !resources.length) return null;
    }
    const result = {
        resources: resources,
        path: source.path || "/",
        maxURL: source.maxURL || 500,
        rotate: source.rotate || 750,
        timeout: source.timeout || 5e3,
        random: source.random === true,
        index: source.index || 0,
        dataAfterTimeout: source.dataAfterTimeout !== false
    };
    return result;
}
/**
* Local storage
*/ const $4216fe18cda7ab89$var$configStorage = Object.create(null);
/**
* Redundancy for API servers.
*
* API should have very high uptime because of implemented redundancy at server level, but
* sometimes bad things happen. On internet 100% uptime is not possible.
*
* There could be routing problems. Server might go down for whatever reason, but it takes
* few minutes to detect that downtime, so during those few minutes API might not be accessible.
*
* This script has some redundancy to mitigate possible network issues.
*
* If one host cannot be reached in 'rotate' (750 by default) ms, script will try to retrieve
* data from different host. Hosts have different configurations, pointing to different
* API servers hosted at different providers.
*/ const $4216fe18cda7ab89$var$fallBackAPISources = [
    "https://api.simplesvg.com",
    "https://api.unisvg.com"
];
const $4216fe18cda7ab89$var$fallBackAPI = [];
while($4216fe18cda7ab89$var$fallBackAPISources.length > 0)if ($4216fe18cda7ab89$var$fallBackAPISources.length === 1) $4216fe18cda7ab89$var$fallBackAPI.push($4216fe18cda7ab89$var$fallBackAPISources.shift());
else if (Math.random() > .5) $4216fe18cda7ab89$var$fallBackAPI.push($4216fe18cda7ab89$var$fallBackAPISources.shift());
else $4216fe18cda7ab89$var$fallBackAPI.push($4216fe18cda7ab89$var$fallBackAPISources.pop());
$4216fe18cda7ab89$var$configStorage[""] = $4216fe18cda7ab89$var$createAPIConfig({
    resources: [
        "https://api.iconify.design"
    ].concat($4216fe18cda7ab89$var$fallBackAPI)
});
/**
* Add custom config for provider
*/ function $4216fe18cda7ab89$export$ddfda4eca64d59f6(provider, customConfig) {
    const config = $4216fe18cda7ab89$var$createAPIConfig(customConfig);
    if (config === null) return false;
    $4216fe18cda7ab89$var$configStorage[provider] = config;
    return true;
}
/**
* Get API configuration
*/ function $4216fe18cda7ab89$var$getAPIConfig(provider) {
    return $4216fe18cda7ab89$var$configStorage[provider];
}
/**
* List API providers
*/ function $4216fe18cda7ab89$var$listAPIProviders() {
    return Object.keys($4216fe18cda7ab89$var$configStorage);
}
const $4216fe18cda7ab89$var$detectFetch = ()=>{
    let callback;
    try {
        callback = fetch;
        if (typeof callback === "function") return callback;
    } catch (err) {}
};
/**
* Fetch function
*/ let $4216fe18cda7ab89$var$fetchModule = $4216fe18cda7ab89$var$detectFetch();
/**
* Set custom fetch() function
*/ function $4216fe18cda7ab89$var$setFetch(fetch$1) {
    $4216fe18cda7ab89$var$fetchModule = fetch$1;
}
/**
* Get fetch() function. Used by Icon Finder Core
*/ function $4216fe18cda7ab89$var$getFetch() {
    return $4216fe18cda7ab89$var$fetchModule;
}
/**
* Calculate maximum icons list length for prefix
*/ function $4216fe18cda7ab89$var$calculateMaxLength(provider, prefix) {
    const config = $4216fe18cda7ab89$var$getAPIConfig(provider);
    if (!config) return 0;
    let result;
    if (!config.maxURL) result = 0;
    else {
        let maxHostLength = 0;
        config.resources.forEach((item)=>{
            const host = item;
            maxHostLength = Math.max(maxHostLength, host.length);
        });
        const url = prefix + ".json?icons=";
        result = config.maxURL - maxHostLength - config.path.length - url.length;
    }
    return result;
}
/**
* Should query be aborted, based on last HTTP status
*/ function $4216fe18cda7ab89$var$shouldAbort(status) {
    return status === 404;
}
/**
* Prepare params
*/ const $4216fe18cda7ab89$var$prepare = (provider, prefix, icons)=>{
    const results = [];
    const maxLength = $4216fe18cda7ab89$var$calculateMaxLength(provider, prefix);
    const type = "icons";
    let item = {
        type: type,
        provider: provider,
        prefix: prefix,
        icons: []
    };
    let length = 0;
    icons.forEach((name, index)=>{
        length += name.length + 1;
        if (length >= maxLength && index > 0) {
            results.push(item);
            item = {
                type: type,
                provider: provider,
                prefix: prefix,
                icons: []
            };
            length = name.length;
        }
        item.icons.push(name);
    });
    results.push(item);
    return results;
};
/**
* Get path
*/ function $4216fe18cda7ab89$var$getPath(provider) {
    if (typeof provider === "string") {
        const config = $4216fe18cda7ab89$var$getAPIConfig(provider);
        if (config) return config.path;
    }
    return "/";
}
/**
* Load icons
*/ const $4216fe18cda7ab89$var$send = (host, params, callback)=>{
    if (!$4216fe18cda7ab89$var$fetchModule) {
        callback("abort", 424);
        return;
    }
    let path = $4216fe18cda7ab89$var$getPath(params.provider);
    switch(params.type){
        case "icons":
            {
                const prefix = params.prefix;
                const icons = params.icons;
                const iconsList = icons.join(",");
                const urlParams = new URLSearchParams({
                    icons: iconsList
                });
                path += prefix + ".json?" + urlParams.toString();
                break;
            }
        case "custom":
            {
                const uri = params.uri;
                path += uri.slice(0, 1) === "/" ? uri.slice(1) : uri;
                break;
            }
        default:
            callback("abort", 400);
            return;
    }
    let defaultError = 503;
    $4216fe18cda7ab89$var$fetchModule(host + path).then((response)=>{
        const status = response.status;
        if (status !== 200) {
            setTimeout(()=>{
                callback($4216fe18cda7ab89$var$shouldAbort(status) ? "abort" : "next", status);
            });
            return;
        }
        defaultError = 501;
        return response.json();
    }).then((data)=>{
        if (typeof data !== "object" || data === null) {
            setTimeout(()=>{
                if (data === 404) callback("abort", data);
                else callback("next", defaultError);
            });
            return;
        }
        setTimeout(()=>{
            callback("success", data);
        });
    }).catch(()=>{
        callback("next", defaultError);
    });
};
/**
* Export module
*/ const $4216fe18cda7ab89$var$fetchAPIModule = {
    prepare: $4216fe18cda7ab89$var$prepare,
    send: $4216fe18cda7ab89$var$send
};
/**
* Remove callback
*/ function $4216fe18cda7ab89$var$removeCallback(storages, id) {
    storages.forEach((storage)=>{
        const items = storage.loaderCallbacks;
        if (items) storage.loaderCallbacks = items.filter((row)=>row.id !== id);
    });
}
/**
* Update all callbacks for provider and prefix
*/ function $4216fe18cda7ab89$var$updateCallbacks(storage) {
    if (!storage.pendingCallbacksFlag) {
        storage.pendingCallbacksFlag = true;
        setTimeout(()=>{
            storage.pendingCallbacksFlag = false;
            const items = storage.loaderCallbacks ? storage.loaderCallbacks.slice(0) : [];
            if (!items.length) return;
            let hasPending = false;
            const provider = storage.provider;
            const prefix = storage.prefix;
            items.forEach((item)=>{
                const icons = item.icons;
                const oldLength = icons.pending.length;
                icons.pending = icons.pending.filter((icon)=>{
                    if (icon.prefix !== prefix) return true;
                    const name = icon.name;
                    if (storage.icons[name]) icons.loaded.push({
                        provider: provider,
                        prefix: prefix,
                        name: name
                    });
                    else if (storage.missing.has(name)) icons.missing.push({
                        provider: provider,
                        prefix: prefix,
                        name: name
                    });
                    else {
                        hasPending = true;
                        return true;
                    }
                    return false;
                });
                if (icons.pending.length !== oldLength) {
                    if (!hasPending) $4216fe18cda7ab89$var$removeCallback([
                        storage
                    ], item.id);
                    item.callback(icons.loaded.slice(0), icons.missing.slice(0), icons.pending.slice(0), item.abort);
                }
            });
        });
    }
}
/**
* Unique id counter for callbacks
*/ let $4216fe18cda7ab89$var$idCounter = 0;
/**
* Add callback
*/ function $4216fe18cda7ab89$var$storeCallback(callback, icons, pendingSources) {
    const id = $4216fe18cda7ab89$var$idCounter++;
    const abort = $4216fe18cda7ab89$var$removeCallback.bind(null, pendingSources, id);
    if (!icons.pending.length) return abort;
    const item = {
        id: id,
        icons: icons,
        callback: callback,
        abort: abort
    };
    pendingSources.forEach((storage)=>{
        (storage.loaderCallbacks || (storage.loaderCallbacks = [])).push(item);
    });
    return abort;
}
/**
* Check if icons have been loaded
*/ function $4216fe18cda7ab89$var$sortIcons(icons) {
    const result = {
        loaded: [],
        missing: [],
        pending: []
    };
    const storage = Object.create(null);
    icons.sort((a, b)=>{
        if (a.provider !== b.provider) return a.provider.localeCompare(b.provider);
        if (a.prefix !== b.prefix) return a.prefix.localeCompare(b.prefix);
        return a.name.localeCompare(b.name);
    });
    let lastIcon = {
        provider: "",
        prefix: "",
        name: ""
    };
    icons.forEach((icon)=>{
        if (lastIcon.name === icon.name && lastIcon.prefix === icon.prefix && lastIcon.provider === icon.provider) return;
        lastIcon = icon;
        const provider = icon.provider;
        const prefix = icon.prefix;
        const name = icon.name;
        const providerStorage = storage[provider] || (storage[provider] = Object.create(null));
        const localStorage = providerStorage[prefix] || (providerStorage[prefix] = $4216fe18cda7ab89$var$getStorage(provider, prefix));
        let list;
        if (name in localStorage.icons) list = result.loaded;
        else if (prefix === "" || localStorage.missing.has(name)) list = result.missing;
        else list = result.pending;
        const item = {
            provider: provider,
            prefix: prefix,
            name: name
        };
        list.push(item);
    });
    return result;
}
/**
* Convert icons list from string/icon mix to icons and validate them
*/ function $4216fe18cda7ab89$var$listToIcons(list, validate = true, simpleNames = false) {
    const result = [];
    list.forEach((item)=>{
        const icon = typeof item === "string" ? $4216fe18cda7ab89$var$stringToIcon(item, validate, simpleNames) : item;
        if (icon) result.push(icon);
    });
    return result;
}
/**
* Default RedundancyConfig for API calls
*/ const $4216fe18cda7ab89$var$defaultConfig = {
    resources: [],
    index: 0,
    timeout: 2e3,
    rotate: 750,
    random: false,
    dataAfterTimeout: false
};
/**
* Send query
*/ function $4216fe18cda7ab89$var$sendQuery(config, payload, query, done) {
    const resourcesCount = config.resources.length;
    const startIndex = config.random ? Math.floor(Math.random() * resourcesCount) : config.index;
    let resources;
    if (config.random) {
        let list = config.resources.slice(0);
        resources = [];
        while(list.length > 1){
            const nextIndex = Math.floor(Math.random() * list.length);
            resources.push(list[nextIndex]);
            list = list.slice(0, nextIndex).concat(list.slice(nextIndex + 1));
        }
        resources = resources.concat(list);
    } else resources = config.resources.slice(startIndex).concat(config.resources.slice(0, startIndex));
    const startTime = Date.now();
    let status = "pending";
    let queriesSent = 0;
    let lastError;
    let timer = null;
    let queue = [];
    let doneCallbacks = [];
    if (typeof done === "function") doneCallbacks.push(done);
    /**
	* Reset timer
	*/ function resetTimer() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }
    /**
	* Abort everything
	*/ function abort() {
        if (status === "pending") status = "aborted";
        resetTimer();
        queue.forEach((item)=>{
            if (item.status === "pending") item.status = "aborted";
        });
        queue = [];
    }
    /**
	* Add / replace callback to call when execution is complete.
	* This can be used to abort pending query implementations when query is complete or aborted.
	*/ function subscribe(callback, overwrite) {
        if (overwrite) doneCallbacks = [];
        if (typeof callback === "function") doneCallbacks.push(callback);
    }
    /**
	* Get query status
	*/ function getQueryStatus() {
        return {
            startTime: startTime,
            payload: payload,
            status: status,
            queriesSent: queriesSent,
            queriesPending: queue.length,
            subscribe: subscribe,
            abort: abort
        };
    }
    /**
	* Fail query
	*/ function failQuery() {
        status = "failed";
        doneCallbacks.forEach((callback)=>{
            callback(void 0, lastError);
        });
    }
    /**
	* Clear queue
	*/ function clearQueue() {
        queue.forEach((item)=>{
            if (item.status === "pending") item.status = "aborted";
        });
        queue = [];
    }
    /**
	* Got response from module
	*/ function moduleResponse(item, response, data) {
        const isError = response !== "success";
        queue = queue.filter((queued)=>queued !== item);
        switch(status){
            case "pending":
                break;
            case "failed":
                if (isError || !config.dataAfterTimeout) return;
                break;
            default:
                return;
        }
        if (response === "abort") {
            lastError = data;
            failQuery();
            return;
        }
        if (isError) {
            lastError = data;
            if (!queue.length) {
                if (!resources.length) failQuery();
                else execNext();
            }
            return;
        }
        resetTimer();
        clearQueue();
        if (!config.random) {
            const index = config.resources.indexOf(item.resource);
            if (index !== -1 && index !== config.index) config.index = index;
        }
        status = "completed";
        doneCallbacks.forEach((callback)=>{
            callback(data);
        });
    }
    /**
	* Execute next query
	*/ function execNext() {
        if (status !== "pending") return;
        resetTimer();
        const resource = resources.shift();
        if (resource === void 0) {
            if (queue.length) {
                timer = setTimeout(()=>{
                    resetTimer();
                    if (status === "pending") {
                        clearQueue();
                        failQuery();
                    }
                }, config.timeout);
                return;
            }
            failQuery();
            return;
        }
        const item = {
            status: "pending",
            resource: resource,
            callback: (status$1, data)=>{
                moduleResponse(item, status$1, data);
            }
        };
        queue.push(item);
        queriesSent++;
        timer = setTimeout(execNext, config.rotate);
        query(resource, payload, item.callback);
    }
    setTimeout(execNext);
    return getQueryStatus;
}
/**
* Redundancy instance
*/ function $4216fe18cda7ab89$var$initRedundancy(cfg) {
    const config = {
        ...$4216fe18cda7ab89$var$defaultConfig,
        ...cfg
    };
    let queries = [];
    /**
	* Remove aborted and completed queries
	*/ function cleanup() {
        queries = queries.filter((item)=>item().status === "pending");
    }
    /**
	* Send query
	*/ function query(payload, queryCallback, doneCallback) {
        const query$1 = $4216fe18cda7ab89$var$sendQuery(config, payload, queryCallback, (data, error)=>{
            cleanup();
            if (doneCallback) doneCallback(data, error);
        });
        queries.push(query$1);
        return query$1;
    }
    /**
	* Find instance
	*/ function find(callback) {
        return queries.find((value)=>{
            return callback(value);
        }) || null;
    }
    const instance = {
        query: query,
        find: find,
        setIndex: (index)=>{
            config.index = index;
        },
        getIndex: ()=>config.index,
        cleanup: cleanup
    };
    return instance;
}
function $4216fe18cda7ab89$var$emptyCallback$1() {}
const $4216fe18cda7ab89$var$redundancyCache = Object.create(null);
/**
* Get Redundancy instance for provider
*/ function $4216fe18cda7ab89$var$getRedundancyCache(provider) {
    if (!$4216fe18cda7ab89$var$redundancyCache[provider]) {
        const config = $4216fe18cda7ab89$var$getAPIConfig(provider);
        if (!config) return;
        const redundancy = $4216fe18cda7ab89$var$initRedundancy(config);
        const cachedReundancy = {
            config: config,
            redundancy: redundancy
        };
        $4216fe18cda7ab89$var$redundancyCache[provider] = cachedReundancy;
    }
    return $4216fe18cda7ab89$var$redundancyCache[provider];
}
/**
* Send API query
*/ function $4216fe18cda7ab89$var$sendAPIQuery(target, query, callback) {
    let redundancy;
    let send;
    if (typeof target === "string") {
        const api = $4216fe18cda7ab89$var$getAPIModule(target);
        if (!api) {
            callback(void 0, 424);
            return $4216fe18cda7ab89$var$emptyCallback$1;
        }
        send = api.send;
        const cached = $4216fe18cda7ab89$var$getRedundancyCache(target);
        if (cached) redundancy = cached.redundancy;
    } else {
        const config = $4216fe18cda7ab89$var$createAPIConfig(target);
        if (config) {
            redundancy = $4216fe18cda7ab89$var$initRedundancy(config);
            const moduleKey = target.resources ? target.resources[0] : "";
            const api = $4216fe18cda7ab89$var$getAPIModule(moduleKey);
            if (api) send = api.send;
        }
    }
    if (!redundancy || !send) {
        callback(void 0, 424);
        return $4216fe18cda7ab89$var$emptyCallback$1;
    }
    return redundancy.query(query, send, callback)().abort;
}
function $4216fe18cda7ab89$var$emptyCallback() {}
/**
* Function called when new icons have been loaded
*/ function $4216fe18cda7ab89$var$loadedNewIcons(storage) {
    if (!storage.iconsLoaderFlag) {
        storage.iconsLoaderFlag = true;
        setTimeout(()=>{
            storage.iconsLoaderFlag = false;
            $4216fe18cda7ab89$var$updateCallbacks(storage);
        });
    }
}
/**
* Check icon names for API
*/ function $4216fe18cda7ab89$var$checkIconNamesForAPI(icons) {
    const valid = [];
    const invalid = [];
    icons.forEach((name)=>{
        (name.match($4216fe18cda7ab89$var$matchIconName) ? valid : invalid).push(name);
    });
    return {
        valid: valid,
        invalid: invalid
    };
}
/**
* Parse loader response
*/ function $4216fe18cda7ab89$var$parseLoaderResponse(storage, icons, data) {
    function checkMissing() {
        const pending = storage.pendingIcons;
        icons.forEach((name)=>{
            if (pending) pending.delete(name);
            if (!storage.icons[name]) storage.missing.add(name);
        });
    }
    if (data && typeof data === "object") try {
        const parsed = $4216fe18cda7ab89$var$addIconSet(storage, data);
        if (!parsed.length) {
            checkMissing();
            return;
        }
    } catch (err) {
        console.error(err);
    }
    checkMissing();
    $4216fe18cda7ab89$var$loadedNewIcons(storage);
}
/**
* Handle response that can be async
*/ function $4216fe18cda7ab89$var$parsePossiblyAsyncResponse(response, callback) {
    if (response instanceof Promise) response.then((data)=>{
        callback(data);
    }).catch(()=>{
        callback(null);
    });
    else callback(response);
}
/**
* Load icons
*/ function $4216fe18cda7ab89$var$loadNewIcons(storage, icons) {
    if (!storage.iconsToLoad) storage.iconsToLoad = icons;
    else storage.iconsToLoad = storage.iconsToLoad.concat(icons).sort();
    if (!storage.iconsQueueFlag) {
        storage.iconsQueueFlag = true;
        setTimeout(()=>{
            storage.iconsQueueFlag = false;
            const { provider: provider, prefix: prefix } = storage;
            const icons$1 = storage.iconsToLoad;
            delete storage.iconsToLoad;
            if (!icons$1 || !icons$1.length) return;
            const customIconLoader = storage.loadIcon;
            if (storage.loadIcons && (icons$1.length > 1 || !customIconLoader)) {
                $4216fe18cda7ab89$var$parsePossiblyAsyncResponse(storage.loadIcons(icons$1, prefix, provider), (data)=>{
                    $4216fe18cda7ab89$var$parseLoaderResponse(storage, icons$1, data);
                });
                return;
            }
            if (customIconLoader) {
                icons$1.forEach((name)=>{
                    const response = customIconLoader(name, prefix, provider);
                    $4216fe18cda7ab89$var$parsePossiblyAsyncResponse(response, (data)=>{
                        const iconSet = data ? {
                            prefix: prefix,
                            icons: {
                                [name]: data
                            }
                        } : null;
                        $4216fe18cda7ab89$var$parseLoaderResponse(storage, [
                            name
                        ], iconSet);
                    });
                });
                return;
            }
            const { valid: valid, invalid: invalid } = $4216fe18cda7ab89$var$checkIconNamesForAPI(icons$1);
            if (invalid.length) $4216fe18cda7ab89$var$parseLoaderResponse(storage, invalid, null);
            if (!valid.length) return;
            const api = prefix.match($4216fe18cda7ab89$var$matchIconName) ? $4216fe18cda7ab89$var$getAPIModule(provider) : null;
            if (!api) {
                $4216fe18cda7ab89$var$parseLoaderResponse(storage, valid, null);
                return;
            }
            const params = api.prepare(provider, prefix, valid);
            params.forEach((item)=>{
                $4216fe18cda7ab89$var$sendAPIQuery(provider, item, (data)=>{
                    $4216fe18cda7ab89$var$parseLoaderResponse(storage, item.icons, data);
                });
            });
        });
    }
}
/**
* Load icons
*/ const $4216fe18cda7ab89$export$2527eb85cb3fa9f = (icons, callback)=>{
    const cleanedIcons = $4216fe18cda7ab89$var$listToIcons(icons, true, $4216fe18cda7ab89$var$allowSimpleNames());
    const sortedIcons = $4216fe18cda7ab89$var$sortIcons(cleanedIcons);
    if (!sortedIcons.pending.length) {
        let callCallback = true;
        if (callback) setTimeout(()=>{
            if (callCallback) callback(sortedIcons.loaded, sortedIcons.missing, sortedIcons.pending, $4216fe18cda7ab89$var$emptyCallback);
        });
        return ()=>{
            callCallback = false;
        };
    }
    const newIcons = Object.create(null);
    const sources = [];
    let lastProvider, lastPrefix;
    sortedIcons.pending.forEach((icon)=>{
        const { provider: provider, prefix: prefix } = icon;
        if (prefix === lastPrefix && provider === lastProvider) return;
        lastProvider = provider;
        lastPrefix = prefix;
        sources.push($4216fe18cda7ab89$var$getStorage(provider, prefix));
        const providerNewIcons = newIcons[provider] || (newIcons[provider] = Object.create(null));
        if (!providerNewIcons[prefix]) providerNewIcons[prefix] = [];
    });
    sortedIcons.pending.forEach((icon)=>{
        const { provider: provider, prefix: prefix, name: name } = icon;
        const storage = $4216fe18cda7ab89$var$getStorage(provider, prefix);
        const pendingQueue = storage.pendingIcons || (storage.pendingIcons = /* @__PURE__ */ new Set());
        if (!pendingQueue.has(name)) {
            pendingQueue.add(name);
            newIcons[provider][prefix].push(name);
        }
    });
    sources.forEach((storage)=>{
        const list = newIcons[storage.provider][storage.prefix];
        if (list.length) $4216fe18cda7ab89$var$loadNewIcons(storage, list);
    });
    return callback ? $4216fe18cda7ab89$var$storeCallback(callback, sortedIcons, sources) : $4216fe18cda7ab89$var$emptyCallback;
};
/**
* Load one icon using Promise
*/ const $4216fe18cda7ab89$export$8e757e0542ac47f6 = (icon)=>{
    return new Promise((fulfill, reject)=>{
        const iconObj = typeof icon === "string" ? $4216fe18cda7ab89$var$stringToIcon(icon, true) : icon;
        if (!iconObj) {
            reject(icon);
            return;
        }
        $4216fe18cda7ab89$export$2527eb85cb3fa9f([
            iconObj || icon
        ], (loaded)=>{
            if (loaded.length && iconObj) {
                const data = $4216fe18cda7ab89$var$getIconData(iconObj);
                if (data) {
                    fulfill({
                        ...$4216fe18cda7ab89$var$defaultIconProps,
                        ...data
                    });
                    return;
                }
            }
            reject(icon);
        });
    });
};
/**
* Set custom loader for multiple icons
*/ function $4216fe18cda7ab89$export$e4c6e88f1f5eeacc(loader, prefix, provider) {
    $4216fe18cda7ab89$var$getStorage(provider || "", prefix).loadIcons = loader;
}
/**
* Set custom loader for one icon
*/ function $4216fe18cda7ab89$export$605d11454a711a89(loader, prefix, provider) {
    $4216fe18cda7ab89$var$getStorage(provider || "", prefix).loadIcon = loader;
}
/**
* Convert IconifyIconCustomisations to FullIconCustomisations, checking value types
*/ function $4216fe18cda7ab89$var$mergeCustomisations(defaults, item) {
    const result = {
        ...defaults
    };
    for(const key in item){
        const value = item[key];
        const valueType = typeof value;
        if (key in $4216fe18cda7ab89$var$defaultIconSizeCustomisations) {
            if (value === null || value && (valueType === "string" || valueType === "number")) result[key] = value;
        } else if (valueType === typeof result[key]) result[key] = key === "rotate" ? value % 4 : value;
    }
    return result;
}
const $4216fe18cda7ab89$var$separator = /[\s,]+/;
/**
* Apply "flip" string to icon customisations
*/ function $4216fe18cda7ab89$var$flipFromString(custom, flip) {
    flip.split($4216fe18cda7ab89$var$separator).forEach((str)=>{
        const value = str.trim();
        switch(value){
            case "horizontal":
                custom.hFlip = true;
                break;
            case "vertical":
                custom.vFlip = true;
                break;
        }
    });
}
/**
* Get rotation value
*/ function $4216fe18cda7ab89$var$rotateFromString(value, defaultValue = 0) {
    const units = value.replace(/^-?[0-9.]*/, "");
    function cleanup(value$1) {
        while(value$1 < 0)value$1 += 4;
        return value$1 % 4;
    }
    if (units === "") {
        const num = parseInt(value);
        return isNaN(num) ? 0 : cleanup(num);
    } else if (units !== value) {
        let split = 0;
        switch(units){
            case "%":
                split = 25;
                break;
            case "deg":
                split = 90;
        }
        if (split) {
            let num = parseFloat(value.slice(0, value.length - units.length));
            if (isNaN(num)) return 0;
            num = num / split;
            return num % 1 === 0 ? cleanup(num) : 0;
        }
    }
    return defaultValue;
}
/**
* Generate <svg>
*/ function $4216fe18cda7ab89$var$iconToHTML(body, attributes) {
    let renderAttribsHTML = body.indexOf("xlink:") === -1 ? "" : " xmlns:xlink=\"http://www.w3.org/1999/xlink\"";
    for(const attr in attributes)renderAttribsHTML += " " + attr + "=\"" + attributes[attr] + "\"";
    return "<svg xmlns=\"http://www.w3.org/2000/svg\"" + renderAttribsHTML + ">" + body + "</svg>";
}
/**
* Encode SVG for use in url()
*
* Short alternative to encodeURIComponent() that encodes only stuff used in SVG, generating
* smaller code.
*/ function $4216fe18cda7ab89$var$encodeSVGforURL(svg) {
    return svg.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
/**
* Generate data: URL from SVG
*/ function $4216fe18cda7ab89$var$svgToData(svg) {
    return "data:image/svg+xml," + $4216fe18cda7ab89$var$encodeSVGforURL(svg);
}
/**
* Generate url() from SVG
*/ function $4216fe18cda7ab89$var$svgToURL(svg) {
    return "url(\"" + $4216fe18cda7ab89$var$svgToData(svg) + "\")";
}
let $4216fe18cda7ab89$var$policy;
/**
* Attempt to create policy
*/ function $4216fe18cda7ab89$var$createPolicy() {
    try {
        $4216fe18cda7ab89$var$policy = window.trustedTypes.createPolicy("iconify", {
            createHTML: (s)=>s
        });
    } catch (err) {
        $4216fe18cda7ab89$var$policy = null;
    }
}
/**
* Clean up value for innerHTML assignment
*
* This code doesn't actually clean up anything.
* It is intended be used with Iconify icon data, which has already been validated
*/ function $4216fe18cda7ab89$var$cleanUpInnerHTML(html) {
    if ($4216fe18cda7ab89$var$policy === void 0) $4216fe18cda7ab89$var$createPolicy();
    return $4216fe18cda7ab89$var$policy ? $4216fe18cda7ab89$var$policy.createHTML(html) : html;
}
const $4216fe18cda7ab89$var$defaultExtendedIconCustomisations = {
    ...$4216fe18cda7ab89$var$defaultIconCustomisations,
    inline: false
};
/**
 * Default SVG attributes
 */ const $4216fe18cda7ab89$var$svgDefaults = {
    'xmlns': 'http://www.w3.org/2000/svg',
    'xmlnsXlink': 'http://www.w3.org/1999/xlink',
    'aria-hidden': true,
    'role': 'img'
};
/**
 * Style modes
 */ const $4216fe18cda7ab89$var$commonProps = {
    display: 'inline-block'
};
const $4216fe18cda7ab89$var$monotoneProps = {
    backgroundColor: 'currentColor'
};
const $4216fe18cda7ab89$var$coloredProps = {
    backgroundColor: 'transparent'
};
// Dynamically add common props to variables above
const $4216fe18cda7ab89$var$propsToAdd = {
    Image: 'var(--svg)',
    Repeat: 'no-repeat',
    Size: '100% 100%'
};
const $4216fe18cda7ab89$var$propsToAddTo = {
    WebkitMask: $4216fe18cda7ab89$var$monotoneProps,
    mask: $4216fe18cda7ab89$var$monotoneProps,
    background: $4216fe18cda7ab89$var$coloredProps
};
for(const prefix in $4216fe18cda7ab89$var$propsToAddTo){
    const list = $4216fe18cda7ab89$var$propsToAddTo[prefix];
    for(const prop in $4216fe18cda7ab89$var$propsToAdd)list[prefix + prop] = $4216fe18cda7ab89$var$propsToAdd[prop];
}
/**
 * Default values for customisations for inline icon
 */ const $4216fe18cda7ab89$var$inlineDefaults = {
    ...$4216fe18cda7ab89$var$defaultExtendedIconCustomisations,
    inline: true
};
/**
 * Fix size: add 'px' to numbers
 */ function $4216fe18cda7ab89$var$fixSize(value) {
    return value + (value.match(/^[-0-9.]+$/) ? 'px' : '');
}
/**
 * Render icon
 */ const $4216fe18cda7ab89$var$render = (// Icon must be validated before calling this function
icon, // Partial properties
props, // Icon name
name)=>{
    // Get default properties
    const defaultProps = props.inline ? $4216fe18cda7ab89$var$inlineDefaults : $4216fe18cda7ab89$var$defaultExtendedIconCustomisations;
    // Get all customisations
    const customisations = $4216fe18cda7ab89$var$mergeCustomisations(defaultProps, props);
    // Check mode
    const mode = props.mode || 'svg';
    // Create style
    const style = {};
    const customStyle = props.style || {};
    // Create SVG component properties
    const componentProps = {
        ...mode === 'svg' ? $4216fe18cda7ab89$var$svgDefaults : {}
    };
    if (name) {
        const iconName = $4216fe18cda7ab89$var$stringToIcon(name, false, true);
        if (iconName) {
            const classNames = [
                'iconify'
            ];
            const props = [
                'provider',
                'prefix'
            ];
            for (const prop of props)if (iconName[prop]) classNames.push('iconify--' + iconName[prop]);
            componentProps.className = classNames.join(' ');
        }
    }
    // Get element properties
    for(let key in props){
        const value = props[key];
        if (value === void 0) continue;
        switch(key){
            // Properties to ignore
            case 'icon':
            case 'style':
            case 'children':
            case 'onLoad':
            case 'mode':
            case 'ssr':
            case 'fallback':
                break;
            // Forward ref
            case '_ref':
                componentProps.ref = value;
                break;
            // Merge class names
            case 'className':
                componentProps[key] = (componentProps[key] ? componentProps[key] + ' ' : '') + value;
                break;
            // Boolean attributes
            case 'inline':
            case 'hFlip':
            case 'vFlip':
                customisations[key] = value === true || value === 'true' || value === 1;
                break;
            // Flip as string: 'horizontal,vertical'
            case 'flip':
                if (typeof value === 'string') $4216fe18cda7ab89$var$flipFromString(customisations, value);
                break;
            // Color: copy to style
            case 'color':
                style.color = value;
                break;
            // Rotation as string
            case 'rotate':
                if (typeof value === 'string') customisations[key] = $4216fe18cda7ab89$var$rotateFromString(value);
                else if (typeof value === 'number') customisations[key] = value;
                break;
            // Remove aria-hidden
            case 'ariaHidden':
            case 'aria-hidden':
                if (value !== true && value !== 'true') delete componentProps['aria-hidden'];
                break;
            // Copy missing property if it does not exist in customisations
            default:
                if (defaultProps[key] === void 0) componentProps[key] = value;
        }
    }
    // Generate icon
    const item = $4216fe18cda7ab89$export$78c1051fc6863a0b(icon, customisations);
    const renderAttribs = item.attributes;
    // Inline display
    if (customisations.inline) style.verticalAlign = '-0.125em';
    if (mode === 'svg') {
        // Add style
        componentProps.style = {
            ...style,
            ...customStyle
        };
        // Add icon stuff
        Object.assign(componentProps, renderAttribs);
        // Counter for ids based on "id" property to render icons consistently on server and client
        let localCounter = 0;
        let id = props.id;
        if (typeof id === 'string') // Convert '-' to '_' to avoid errors in animations
        id = id.replace(/-/g, '_');
        // Add icon stuff
        componentProps.dangerouslySetInnerHTML = {
            __html: $4216fe18cda7ab89$var$cleanUpInnerHTML($4216fe18cda7ab89$export$cae0fa3719aa5dc4(item.body, id ? ()=>id + 'ID' + localCounter++ : 'iconifyReact'))
        };
        return (0, $4RFnf.createElement)('svg', componentProps);
    }
    // Render <span> with style
    const { body: body, width: width, height: height } = icon;
    const useMask = mode === 'mask' || (mode === 'bg' ? false : body.indexOf('currentColor') !== -1);
    // Generate SVG
    const html = $4216fe18cda7ab89$var$iconToHTML(body, {
        ...renderAttribs,
        width: width + '',
        height: height + ''
    });
    // Generate style
    componentProps.style = {
        ...style,
        '--svg': $4216fe18cda7ab89$var$svgToURL(html),
        'width': $4216fe18cda7ab89$var$fixSize(renderAttribs.width),
        'height': $4216fe18cda7ab89$var$fixSize(renderAttribs.height),
        ...$4216fe18cda7ab89$var$commonProps,
        ...useMask ? $4216fe18cda7ab89$var$monotoneProps : $4216fe18cda7ab89$var$coloredProps,
        ...customStyle
    };
    return (0, $4RFnf.createElement)('span', componentProps);
};
/**
 * Initialise stuff
 */ // Enable short names
$4216fe18cda7ab89$var$allowSimpleNames(true);
// Set API module
$4216fe18cda7ab89$var$setAPIModule('', $4216fe18cda7ab89$var$fetchAPIModule);
/**
 * Browser stuff
 */ if (typeof document !== 'undefined' && typeof window !== 'undefined') {
    const _window = window;
    // Load icons from global "IconifyPreload"
    if (_window.IconifyPreload !== void 0) {
        const preload = _window.IconifyPreload;
        const err = 'Invalid IconifyPreload syntax.';
        if (typeof preload === 'object' && preload !== null) (preload instanceof Array ? preload : [
            preload
        ]).forEach((item)=>{
            try {
                if (// Check if item is an object and not null/array
                typeof item !== 'object' || item === null || item instanceof Array || // Check for 'icons' and 'prefix'
                typeof item.icons !== 'object' || typeof item.prefix !== 'string' || // Add icon set
                !$4216fe18cda7ab89$export$933f273b2a11730f(item)) console.error(err);
            } catch (e) {
                console.error(err);
            }
        });
    }
    // Set API from global "IconifyProviders"
    if (_window.IconifyProviders !== void 0) {
        const providers = _window.IconifyProviders;
        if (typeof providers === 'object' && providers !== null) for(let key in providers){
            const err = 'IconifyProviders[' + key + '] is invalid.';
            try {
                const value = providers[key];
                if (typeof value !== 'object' || !value || value.resources === void 0) continue;
                if (!$4216fe18cda7ab89$export$ddfda4eca64d59f6(key, value)) console.error(err);
            } catch (e) {
                console.error(err);
            }
        }
    }
}
function $4216fe18cda7ab89$var$IconComponent(props) {
    const [mounted, setMounted] = (0, $4RFnf.useState)(!!props.ssr);
    const [abort, setAbort] = (0, $4RFnf.useState)({});
    // Get initial state
    function getInitialState(mounted) {
        if (mounted) {
            const name = props.icon;
            if (typeof name === 'object') // Icon as object
            return {
                name: '',
                data: name
            };
            const data = $4216fe18cda7ab89$var$getIconData(name);
            if (data) return {
                name: name,
                data: data
            };
        }
        return {
            name: ''
        };
    }
    const [state, setState] = (0, $4RFnf.useState)(getInitialState(!!props.ssr));
    // Cancel loading
    function cleanup() {
        const callback = abort.callback;
        if (callback) {
            callback();
            setAbort({});
        }
    }
    // Change state if it is different
    function changeState(newState) {
        if (JSON.stringify(state) !== JSON.stringify(newState)) {
            cleanup();
            setState(newState);
            return true;
        }
    }
    // Update state
    function updateState() {
        var _a;
        const name = props.icon;
        if (typeof name === 'object') {
            // Icon as object
            changeState({
                name: '',
                data: name
            });
            return;
        }
        // New icon or got icon data
        const data = $4216fe18cda7ab89$var$getIconData(name);
        if (changeState({
            name: name,
            data: data
        })) {
            if (data === undefined) {
                // Load icon, update state when done
                const callback = $4216fe18cda7ab89$export$2527eb85cb3fa9f([
                    name
                ], updateState);
                setAbort({
                    callback: callback
                });
            } else if (data) // Icon data is available: trigger onLoad callback if present
            (_a = props.onLoad) === null || _a === void 0 || _a.call(props, name);
        }
    }
    // Mounted state, cleanup for loader
    (0, $4RFnf.useEffect)(()=>{
        setMounted(true);
        return cleanup;
    }, []);
    // Icon changed or component mounted
    (0, $4RFnf.useEffect)(()=>{
        if (mounted) updateState();
    }, [
        props.icon,
        mounted
    ]);
    // Render icon
    const { name: name, data: data } = state;
    if (!data) return props.children ? props.children : props.fallback ? props.fallback : (0, $4RFnf.createElement)('span', {});
    return $4216fe18cda7ab89$var$render({
        ...$4216fe18cda7ab89$var$defaultIconProps,
        ...data
    }, props, name);
}
/**
 * Block icon
 *
 * @param props - Component properties
 */ const $4216fe18cda7ab89$export$f04a61298a47a40f = (0, $4RFnf.forwardRef)((props, ref)=>$4216fe18cda7ab89$var$IconComponent({
        ...props,
        _ref: ref
    }));
/**
 * Inline icon (has negative verticalAlign that makes it behave like icon font)
 *
 * @param props - Component properties
 */ const $4216fe18cda7ab89$export$d1314c9fc3bb2a13 = (0, $4RFnf.forwardRef)((props, ref)=>$4216fe18cda7ab89$var$IconComponent({
        inline: true,
        ...props,
        _ref: ref
    }));
/**
 * Internal API
 */ const $4216fe18cda7ab89$export$14dadc205e26d636 = {
    getAPIConfig: $4216fe18cda7ab89$var$getAPIConfig,
    setAPIModule: $4216fe18cda7ab89$var$setAPIModule,
    sendAPIQuery: $4216fe18cda7ab89$var$sendAPIQuery,
    setFetch: $4216fe18cda7ab89$var$setFetch,
    getFetch: $4216fe18cda7ab89$var$getFetch,
    listAPIProviders: $4216fe18cda7ab89$var$listAPIProviders
};


const $af746f1bd62bcd82$export$d26e8f33c4622b5b = [
    {
        id: '100',
        title: 'Company',
        data: [
            'About',
            'Careers',
            'Team',
            'BiteSwift One',
            'BiteSwift Instamart',
            'BiteSwift Express'
        ]
    },
    {
        id: '101',
        title: 'Contact Us',
        data: [
            'Help & Support',
            'Partner with us',
            'Deliver with us'
        ]
    },
    {
        id: '102',
        title: 'Legal',
        data: [
            'Terms & Conditions',
            'Cookie Policy',
            'Privacy Policy',
            'Investor Relations'
        ]
    }
];
const $af746f1bd62bcd82$export$7f3e64c91644437c = [
    {
        type: 'general',
        title: 'General Issues',
        description: 'Covers general issues faced by customers, restaurant partners, and delivery partners on the BiteSwift platform.',
        data: [
            {
                id: 11500,
                title: 'What is BiteSwift Customer Care?',
                description: "We value your time, so we use a comprehensive chat-based support system instead of a single phone number. Just search for your issue in the Help section and start a chat \u2014 a support executive will be assigned to you promptly.",
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 206,
                title: 'I have a query related to placing an order',
                description: null,
                isLeaf: false,
                isResolutionNode: false,
                options: [
                    {
                        type: 'chat',
                        phoneNumber: null,
                        provider: 'chatengine',
                        waitTime: 'Wait time under 2 min(s)',
                        emailId: null
                    }
                ],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 212,
                title: 'I am unable to log in to BiteSwift',
                description: null,
                isLeaf: false,
                isResolutionNode: false,
                options: [
                    {
                        type: 'chat',
                        phoneNumber: null,
                        provider: 'chatengine',
                        waitTime: 'Wait time under 2 min(s)',
                        emailId: null
                    }
                ],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 215,
                title: 'I have a payment or refund related query',
                description: null,
                isLeaf: false,
                isResolutionNode: false,
                options: [
                    {
                        type: 'chat',
                        phoneNumber: null,
                        provider: 'chatengine',
                        waitTime: 'Wait time under 2 min(s)',
                        emailId: null
                    }
                ],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 223,
                title: 'I have a coupon or offer related query',
                description: null,
                isLeaf: false,
                isResolutionNode: false,
                options: [
                    {
                        type: 'chat',
                        phoneNumber: null,
                        provider: 'chatengine',
                        waitTime: 'Wait time under 2 min(s)',
                        emailId: null
                    }
                ],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 228,
                title: 'I want to unsubscribe from BiteSwift communications',
                description: "Email us mentioning which channels you would like to opt out from. We will process your request and confirm within 24\u201348 hours.",
                isLeaf: true,
                isResolutionNode: false,
                options: [
                    {
                        type: 'email',
                        phoneNumber: null,
                        provider: null,
                        waitTime: "We will revert within 24\u201348 hrs",
                        emailId: 'support@biteswift.in'
                    }
                ],
                hyperLinkText: null,
                hyperLink: null
            }
        ]
    },
    {
        type: 'partner-onboarding',
        title: 'Partner Onboarding',
        description: 'Everything you need to know about listing your restaurant or becoming a delivery partner on BiteSwift.',
        data: [
            {
                id: 492,
                title: 'I want to partner my restaurant with BiteSwift',
                description: null,
                isLeaf: false,
                isResolutionNode: true,
                options: [
                    {
                        type: 'email',
                        phoneNumber: null,
                        provider: null,
                        waitTime: "We will revert within 24\u201348 hrs",
                        emailId: 'partnersupport@biteswift.in'
                    }
                ],
                hyperLinkText: 'Partner with us',
                hyperLink: null
            },
            {
                id: 100175,
                title: 'What documents are needed to list my restaurant on BiteSwift?',
                description: 'The following documents are mandatory:\n- FSSAI Licence or FSSAI Acknowledgement\n- PAN Card\n- GSTIN Certificate\n- Cancelled Cheque or Bank Passbook\n- Menu',
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100176,
                title: 'How long does it take for my restaurant to go live after submission?',
                description: "After all mandatory documents have been received and verified, it takes up to 7\u201310 working days for onboarding to be completed and your restaurant to go live.",
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100177,
                title: 'What is the one-time onboarding fee?',
                description: 'This is a one-time fee covering system and admin costs during onboarding. It is deducted from your weekly payouts after you begin receiving orders on BiteSwift.',
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100178,
                title: 'Who can I contact for help with onboarding?',
                description: "You can reach Partner Support by writing to onboarding@biteswift.in. Our team will respond within 24\u201348 hours.",
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100179,
                title: 'How much commission does BiteSwift charge?',
                description: 'Commission rates vary by city and restaurant category. You will see the applicable rate once your preliminary onboarding details have been submitted.',
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100180,
                title: "I don't have an FSSAI licence yet. Can I still onboard?",
                description: "FSSAI registration is mandatory per government policy. However, if your licence is pending, you may proceed with the FSSAI Acknowledgement number you received upon registration.",
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            }
        ]
    },
    {
        type: 'legal',
        title: 'Legal, Terms & Conditions',
        description: 'Legal policies, terms of use, and data practices for all BiteSwift stakeholders.',
        data: [
            {
                id: 100043,
                title: 'Terms of Use',
                description: 'These Terms of Use govern your use of the BiteSwift website and mobile application (collectively, the "Services"). By installing, downloading, or using the Services you agree to be bound by these Terms. If you do not agree, please do not use the Services.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: 'Read More',
                hyperLink: null
            },
            {
                id: 100044,
                title: 'Privacy Policy',
                description: 'BiteSwift is committed to protecting your privacy. This policy describes what personal information we collect, how we use it, and with whom we share it. By using BiteSwift you consent to the practices described here.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: 'Read More',
                hyperLink: null
            },
            {
                id: 100045,
                title: 'Cancellations and Refunds',
                description: "You may cancel an order within 1 minute of placing it. After that, a cancellation fee of up to 100% of the order value may apply to compensate restaurant and delivery partners. BiteSwift reserves the right to deny refunds based on prior cancellation history.",
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: 'Read More',
                hyperLink: null
            },
            {
                id: 100046,
                title: 'Cookie Policy',
                description: 'BiteSwift uses cookies and similar technologies to improve your experience, remember preferences, and analyse platform usage. You can manage cookie preferences in your browser settings at any time.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: 'Read More',
                hyperLink: null
            }
        ]
    },
    {
        type: 'faq',
        title: 'FAQs',
        description: 'Frequently asked questions about ordering, payments, delivery, and your BiteSwift account.',
        data: [
            {
                id: 100047,
                title: 'Can I edit my order?',
                description: 'Orders can be edited only before the restaurant confirms them. Click Help \u2192 "I want to modify items in my order" and a support agent will assist you.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100048,
                title: 'How do I cancel my order?',
                description: "Go to Help \u2192 'I want to cancel my order'. Cancellation fees may apply to compensate restaurant and delivery partners.",
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100050,
                title: 'Is there a minimum order value?',
                description: 'BiteSwift has no platform-wide minimum order value. Individual restaurants may set their own minimums, which are shown at checkout.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100051,
                title: 'Do you charge a delivery fee?',
                description: 'Delivery fees vary by city and restaurant. If a delivery fee applies it will be clearly shown on the Review Order page before you pay.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100052,
                title: 'How long does delivery take?',
                description: "Estimated delivery time is shown for each restaurant based on your location and current conditions. Most orders arrive within 30\u201345 minutes.",
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100053,
                title: 'What are your delivery hours?',
                description: 'Delivery hours depend on restaurant availability in your area. Most restaurants on BiteSwift operate from 8 AM to midnight.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100054,
                title: 'Can I order from any location?',
                description: 'BiteSwift delivers from any restaurant listed in your search results. Enable GPS so the app can detect your location and show nearby options.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100055,
                title: 'Can I order from multiple restaurants in one order?',
                description: 'Currently each order is fulfilled by one restaurant. You can place separate orders from different restaurants.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100057,
                title: 'Can I schedule an order in advance?',
                description: "Yes \u2014 tap the delivery time selector to choose a future slot. Scheduled ordering is available in select cities.",
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100058,
                title: 'Can I change the delivery address after placing an order?',
                description: 'Minor changes (flat number, landmark) are allowed. Major address changes are not possible after the order is placed. Contact support or call your delivery partner directly.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100060,
                title: "I didn't receive my referral reward",
                description: 'Referral rewards are credited after the referred person completes their first successful transaction. If you still have not received it, email support@biteswift.in within 48 hours.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100061,
                title: 'How do I deactivate my account?',
                description: 'Write to us at support@biteswift.in to request account deactivation. We will process it within 7 working days.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100074,
                title: 'Will BiteSwift be accountable for food quality or quantity?',
                description: "Quality and quantity are the restaurant's responsibility. If you experience an issue, submit feedback through the app and we will relay it to the restaurant.",
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            }
        ]
    },
    {
        type: 'biteswift-one-faq',
        title: 'BiteSwift One FAQs',
        description: "Everything about BiteSwift One \u2014 our membership plan with free deliveries, exclusive discounts, and more.",
        data: [
            {
                id: 100229,
                title: 'Are BiteSwift One benefits available at all restaurants?',
                description: 'Free delivery applies to all food delivery restaurants within 10 km of your location. Member-only discounts of up to 30% are available at select partner restaurants, on top of regular offers.',
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100228,
                title: 'Is there a limit on free deliveries?',
                description: "No. BiteSwift One members get unlimited free deliveries on all restaurants within 10 km for all orders above \u20B9149, throughout the membership period.",
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100223,
                title: 'Can I club BiteSwift One discounts with other offers?',
                description: 'Yes. BiteSwift One extra discounts are applied on top of regular restaurant offers. There is no upper cap on savings.',
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100227,
                title: 'How do I renew my membership?',
                description: 'You can purchase a new plan after your current one expires. Early renewal is not available yet.',
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100225,
                title: 'Can I cancel, pause, or transfer my membership?',
                description: 'Currently, cancellation, pausing, or transfer of BiteSwift One memberships is not supported. We are working to offer this in the future.',
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100233,
                title: 'On which platforms can I use BiteSwift One benefits?',
                description: 'BiteSwift One benefits are available on Android, iOS, and mobile web. Desktop is not currently supported.',
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100265,
                title: 'Is BiteSwift One available in all cities?',
                description: 'BiteSwift One is currently available in select cities. We are expanding to more cities soon.',
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            }
        ]
    }
];



const $ac0c9409820c83f0$var$SOCIAL_LINKS = [
    {
        label: 'Portfolio',
        icon: 'lucide:globe',
        href: 'https://singhshiv.netlify.app/'
    },
    {
        label: 'GitHub',
        icon: 'lucide:github',
        href: 'https://github.com/sh1v-max'
    },
    {
        label: 'LinkedIn',
        icon: 'lucide:linkedin',
        href: 'https://www.linkedin.com/in/shiv-shankar-singh-/'
    },
    {
        label: 'X',
        icon: 'simple-icons:x',
        href: 'https://x.com/1amWaziR'
    },
    {
        label: 'Email',
        icon: 'lucide:mail',
        href: 'mailto:singhshiv0427@gmail.com'
    }
];
// Which footer column labels should link to a real route
const $ac0c9409820c83f0$var$ROUTE_MAP = {
    About: '/about',
    'Help & Support': '/contact'
};
const $ac0c9409820c83f0$var$Footer = ()=>/*#__PURE__*/ (0, $jk232.jsxs)("footer", {
        className: "footer",
        children: [
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "footer-inner",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "footer-brand",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsxs)((0, $eGOwh.Link), {
                                to: "/",
                                className: "footer-logo",
                                children: [
                                    "\uD83C\uDF7D\uFE0F ",
                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        children: "BiteSwift"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                className: "footer-tagline",
                                children: "Delivering happiness, one meal at a time. Fast, fresh, and always on time."
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("div", {
                                className: "footer-social",
                                children: $ac0c9409820c83f0$var$SOCIAL_LINKS.map(({ label: label, icon: icon, href: href })=>/*#__PURE__*/ (0, $jk232.jsx)("a", {
                                        href: href,
                                        className: "footer-social-icon",
                                        "aria-label": label,
                                        title: label,
                                        ...!href.startsWith('mailto:') && {
                                            target: '_blank',
                                            rel: 'noopener noreferrer'
                                        },
                                        children: /*#__PURE__*/ (0, $jk232.jsx)((0, $4216fe18cda7ab89$export$f04a61298a47a40f), {
                                            icon: icon,
                                            width: 18,
                                            height: 18
                                        })
                                    }, label))
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "footer-app-badges",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsxs)("button", {
                                        className: "app-badge",
                                        children: [
                                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                className: "badge-icon",
                                                children: "\uD83D\uDCF1"
                                            }),
                                            /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0, $jk232.jsx)("small", {
                                                        children: "Get it on"
                                                    }),
                                                    "Google Play"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsxs)("button", {
                                        className: "app-badge",
                                        children: [
                                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                className: "badge-icon",
                                                children: "\uD83C\uDF4E"
                                            }),
                                            /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0, $jk232.jsx)("small", {
                                                        children: "Download on the"
                                                    }),
                                                    "App Store"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $af746f1bd62bcd82$export$d26e8f33c4622b5b).map((section)=>/*#__PURE__*/ (0, $jk232.jsxs)("div", {
                            className: "footer-col",
                            children: [
                                /*#__PURE__*/ (0, $jk232.jsx)("h4", {
                                    className: "footer-col-title",
                                    children: section.title
                                }),
                                /*#__PURE__*/ (0, $jk232.jsx)("ul", {
                                    className: "footer-col-list",
                                    children: section.data.map((item)=>$ac0c9409820c83f0$var$ROUTE_MAP[item] ? /*#__PURE__*/ (0, $jk232.jsx)("li", {
                                            children: /*#__PURE__*/ (0, $jk232.jsx)((0, $eGOwh.Link), {
                                                to: $ac0c9409820c83f0$var$ROUTE_MAP[item],
                                                className: "footer-link",
                                                children: item
                                            })
                                        }, item) : /*#__PURE__*/ (0, $jk232.jsx)("li", {
                                            children: /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                className: "footer-link",
                                                children: item
                                            })
                                        }, item))
                                })
                            ]
                        }, section.id))
                ]
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "footer-bottom",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsxs)("p", {
                        children: [
                            "\xa9 ",
                            new Date().getFullYear(),
                            " BiteSwift Technologies Pvt. Ltd. All rights reserved."
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("p", {
                        className: "footer-bottom-right",
                        children: "Made with \u2764\uFE0F in India"
                    })
                ]
            })
        ]
    });
var $ac0c9409820c83f0$export$2e2bcd8739ae039 = $ac0c9409820c83f0$var$Footer;



var $jk232 = parcelRequire("jk232");


var $eGOwh = parcelRequire("eGOwh");

const $fe10913106d53c8e$var$FEATURES = [
    {
        icon: "\uD83D\uDE80",
        title: 'Fast & Reliable',
        desc: 'Average delivery in 30 minutes, tracked live from kitchen to your door.'
    },
    {
        icon: "\uD83C\uDF7D\uFE0F",
        title: 'Wide Selection',
        desc: '200+ restaurants across every cuisine, from biryani to bubble tea.'
    },
    {
        icon: "\uD83D\uDCB0",
        title: 'Fair Pricing',
        desc: "Transparent fees and regular offers \u2014 no hidden surprises at checkout."
    },
    {
        icon: "\uD83D\uDD12",
        title: 'Secure Payments',
        desc: "UPI, cards, or cash on delivery \u2014 your choice, always protected."
    }
];
const $fe10913106d53c8e$var$About = ()=>{
    return /*#__PURE__*/ (0, $jk232.jsxs)("div", {
        className: "about-page",
        children: [
            /*#__PURE__*/ (0, $jk232.jsxs)("section", {
                className: "about-hero",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "about-detail",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                className: "about-eyebrow",
                                children: "About BiteSwift"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)("h1", {
                                children: [
                                    "Food delivery,",
                                    /*#__PURE__*/ (0, $jk232.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        children: "done right."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                className: "about-lede",
                                children: "We connect you with the best restaurants in your city \u2014 fast delivery, fresh food, and a seamless ordering experience from browse to bite."
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "about-stats",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $jk232.jsx)("strong", {
                                                children: "200+"
                                            }),
                                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                children: "Restaurants"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $jk232.jsx)("strong", {
                                                children: "30 min"
                                            }),
                                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                children: "Avg delivery"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $jk232.jsx)("strong", {
                                                children: "4.8\u2605"
                                            }),
                                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                children: "Avg rating"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)((0, $eGOwh.Link), {
                                to: "/contact",
                                className: "about-cta",
                                children: "Get in touch \u2192"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("div", {
                        className: "about-img",
                        children: /*#__PURE__*/ (0, $jk232.jsx)("img", {
                            className: "image",
                            src: (0, $d39effcf12df3fc5$export$a91f4fe650c27642),
                            alt: "Fresh food from BiteSwift"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("section", {
                className: "about-features",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                        children: "Why choose BiteSwift?"
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("div", {
                        className: "about-features-grid",
                        children: $fe10913106d53c8e$var$FEATURES.map((f)=>/*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "about-feature-card",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        className: "about-feature-icon",
                                        children: f.icon
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsx)("h3", {
                                        children: f.title
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                        children: f.desc
                                    })
                                ]
                            }, f.title))
                    })
                ]
            })
        ]
    });
};
var $fe10913106d53c8e$export$2e2bcd8739ae039 = $fe10913106d53c8e$var$About;



var $jk232 = parcelRequire("jk232");

var $4RFnf = parcelRequire("4RFnf");


const $7db919d997b4a71e$var$DEV_LINKS = [
    {
        label: 'Email',
        icon: 'lucide:mail',
        href: 'mailto:singhshiv0427@gmail.com'
    },
    {
        label: 'GitHub',
        icon: 'lucide:github',
        href: 'https://github.com/sh1v-max'
    },
    {
        label: 'LinkedIn',
        icon: 'lucide:linkedin',
        href: 'https://www.linkedin.com/in/shiv-shankar-singh-/'
    },
    {
        label: 'X',
        icon: 'simple-icons:x',
        href: 'https://x.com/1amWaziR'
    },
    {
        label: 'Portfolio',
        icon: 'lucide:globe',
        href: 'https://singhshiv.netlify.app/'
    }
];
const $7db919d997b4a71e$var$Contact = ()=>{
    const [form, setForm] = (0, $4RFnf.useState)({
        name: '',
        email: '',
        message: ''
    });
    const [status, setStatus] = (0, $4RFnf.useState)('idle') // idle | sending | sent
    ;
    const handleChange = (e)=>setForm((f)=>({
                ...f,
                [e.target.name]: e.target.value
            }));
    const handleSubmit = (e)=>{
        e.preventDefault();
        setStatus('sending');
        setTimeout(()=>{
            setStatus('sent');
            setForm({
                name: '',
                email: '',
                message: ''
            });
        }, 1200);
    };
    return /*#__PURE__*/ (0, $jk232.jsxs)("div", {
        className: "contact-container",
        children: [
            /*#__PURE__*/ (0, $jk232.jsx)("h1", {
                className: "contact-us",
                children: "Contact Us"
            }),
            /*#__PURE__*/ (0, $jk232.jsx)("p", {
                className: "description",
                children: "We'd love to hear from you \u2014 questions, feedback, or just a hello. Reach out any time."
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "dev-contact",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsx)("p", {
                        className: "dev-contact-label",
                        children: "This project was built by Shiv Shankar Singh \u2014 connect directly:"
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("div", {
                        className: "dev-contact-links",
                        children: $7db919d997b4a71e$var$DEV_LINKS.map(({ label: label, icon: icon, href: href })=>/*#__PURE__*/ (0, $jk232.jsx)("a", {
                                href: href,
                                className: "dev-contact-link",
                                "aria-label": label,
                                title: label,
                                ...!href.startsWith('mailto:') && {
                                    target: '_blank',
                                    rel: 'noopener noreferrer'
                                },
                                children: /*#__PURE__*/ (0, $jk232.jsx)((0, $4216fe18cda7ab89$export$f04a61298a47a40f), {
                                    icon: icon,
                                    width: 18,
                                    height: 18
                                })
                            }, label))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "contact-info",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "contact-card",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                className: "contact-icon",
                                children: "\uD83D\uDCCD"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                                children: "Address"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                children: "BiteSwift HQ, 12th Floor, Tower B, Embassy TechVillage, Bangalore \u2013 560103"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "contact-card",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                className: "contact-icon",
                                children: "\uD83D\uDCDE"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                                children: "Phone"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)("p", {
                                children: [
                                    "+91 70689 00427",
                                    /*#__PURE__*/ (0, $jk232.jsx)("br", {}),
                                    "Mon \u2013 Sat, 9 AM \u2013 9 PM"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "contact-card",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                className: "contact-icon",
                                children: "\uD83D\uDCE7"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                children: "support@biteswift.in"
                            })
                        ]
                    })
                ]
            }),
            status === 'sent' ? /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "contact-success",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                        children: "\u2705"
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                        children: "Message sent!"
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("p", {
                        children: "Thanks for reaching out \u2014 we'll get back to you within 24 hours."
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("button", {
                        onClick: ()=>setStatus('idle'),
                        children: "Send another message"
                    })
                ]
            }) : /*#__PURE__*/ (0, $jk232.jsxs)("form", {
                className: "contact-form",
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                        children: "Send Us a Message"
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("input", {
                        type: "text",
                        name: "name",
                        placeholder: "Your Name",
                        value: form.name,
                        onChange: handleChange,
                        required: true
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("input", {
                        type: "email",
                        name: "email",
                        placeholder: "Your Email",
                        value: form.email,
                        onChange: handleChange,
                        required: true
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("textarea", {
                        name: "message",
                        placeholder: "Your Message",
                        rows: "4",
                        value: form.message,
                        onChange: handleChange,
                        required: true
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("button", {
                        type: "submit",
                        disabled: status === 'sending',
                        children: status === 'sending' ? /*#__PURE__*/ (0, $jk232.jsx)("span", {
                            className: "contact-spinner"
                        }) : 'Send Message'
                    })
                ]
            })
        ]
    });
};
var $7db919d997b4a71e$export$2e2bcd8739ae039 = $7db919d997b4a71e$var$Contact;



var $jk232 = parcelRequire("jk232");

var $3W4eU = parcelRequire("3W4eU");
const $0ff0ca03dc317819$var$Error = ()=>{
    const err = (0, $3W4eU.useRouteError)();
    console.log(err);
    return /*#__PURE__*/ (0, $jk232.jsx)("div", {
        className: "error-container",
        children: /*#__PURE__*/ (0, $jk232.jsxs)("main", {
            className: "error-content",
            children: [
                /*#__PURE__*/ (0, $jk232.jsx)("h1", {
                    children: "Oops!"
                }),
                /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                    children: "Something went wrong"
                }),
                /*#__PURE__*/ (0, $jk232.jsxs)("p", {
                    children: [
                        err.status,
                        ": ",
                        err.statusText
                    ]
                })
            ]
        })
    });
};
var $0ff0ca03dc317819$export$2e2bcd8739ae039 = $0ff0ca03dc317819$var$Error;



var $eGOwh = parcelRequire("eGOwh");
var $3W4eU = parcelRequire("3W4eU");

var $jk232 = parcelRequire("jk232");



var $eGOwh = parcelRequire("eGOwh");
var $3W4eU = parcelRequire("3W4eU");
var $3W4eU = parcelRequire("3W4eU");

var $4RFnf = parcelRequire("4RFnf");

// Fallback menu data used when the Swiggy menu API is unreachable.
// Structure mirrors the real Swiggy API response shape so no component changes needed.
// imageId values starting with "https://" are handled as full URLs in ItemList.js.
// veg/non-veg is inferred from the name+description text, bestseller from rating —
// keeps every makeItem() call site untouched while still populating the real
// Swiggy fields (itemAttribute.vegClassifier, ribbon.text) that ItemList.js reads.
const $d3e5976ef93d2b63$var$NON_VEG_HINTS = [
    'chicken',
    'lamb',
    'mutton',
    'fish',
    'prawn',
    'shrimp',
    'pepperoni',
    'bacon',
    'pork',
    'guanciale',
    'seekh',
    'kebab'
];
const $d3e5976ef93d2b63$var$makeItem = (id, name, price, description, imageId, rating = '4.1', ratingCount = '120+')=>{
    const haystack = `${name} ${description}`.toLowerCase();
    const isVeg = !$d3e5976ef93d2b63$var$NON_VEG_HINTS.some((hint)=>haystack.includes(hint));
    const isBestseller = parseFloat(rating) >= 4.4;
    return {
        card: {
            info: {
                id: id,
                name: name,
                price: price * 100,
                defaultPrice: price * 100,
                description: description,
                imageId: imageId,
                itemAttribute: {
                    vegClassifier: isVeg ? 'VEG' : 'NONVEG'
                },
                ...isBestseller && {
                    ribbon: {
                        text: 'Bestseller'
                    }
                },
                ratings: {
                    aggregatedRating: {
                        rating: rating,
                        ratingCountV2: ratingCount
                    }
                }
            }
        }
    };
};
const $d3e5976ef93d2b63$var$makeCategory = (title, items)=>({
        card: {
            card: {
                '@type': 'type.googleapis.com/swiggy.presentation.food.v2.ItemCategory',
                title: title,
                itemCards: items
            }
        }
    });
const $d3e5976ef93d2b63$var$makeMenu = (resId, info, categories)=>({
        cards: [
            {},
            {},
            {
                card: {
                    card: {
                        info: info
                    }
                }
            },
            {},
            {
                groupedCard: {
                    cardGroupMap: {
                        REGULAR: {
                            cards: categories
                        }
                    }
                }
            }
        ]
    });
// ─── North Indian — The Spice Route (mock-101) ───────────────────────────────
const $d3e5976ef93d2b63$var$SPICE_ROUTE_MENU = $d3e5976ef93d2b63$var$makeMenu('mock-101', {
    cloudinaryImageId: 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=660&q=80',
    name: 'The Spice Route',
    areaName: 'Koramangala',
    avgRating: 4.4,
    avgRatingString: '4.4',
    totalRatingsString: '5K+ ratings',
    costForTwoMessage: "\u20B9350 for two",
    cuisines: [
        'North Indian',
        'Mughlai',
        'Biryani'
    ],
    sla: {
        slaString: '28-33 mins'
    }
}, [
    $d3e5976ef93d2b63$var$makeCategory("Bestsellers \uD83D\uDD25", [
        $d3e5976ef93d2b63$var$makeItem('i101a', 'Butter Chicken', 299, 'Tender chicken in a rich, creamy tomato-butter gravy. Best paired with naan.', 'https://images.unsplash.com/photo-1588166524941-3bf61a9c41db?w=300&q=80', '4.5', '2.1K+'),
        $d3e5976ef93d2b63$var$makeItem('i101b', 'Dal Makhani', 229, 'Slow-cooked black lentils simmered overnight in butter and cream. A classic.', 'https://images.unsplash.com/photo-1546833999-b9f581a1996d?w=300&q=80', '4.3', '1.4K+'),
        $d3e5976ef93d2b63$var$makeItem('i101c', 'Chicken Biryani', 349, 'Fragrant basmati rice layered with spiced chicken, saffron, and caramelised onions.', 'https://images.unsplash.com/photo-1603133872878-684f208fb84b?w=300&q=80', '4.6', '3.2K+')
    ]),
    $d3e5976ef93d2b63$var$makeCategory('Breads & Rice', [
        $d3e5976ef93d2b63$var$makeItem('i101d', 'Garlic Naan', 69, 'Soft leavened bread brushed with garlic butter, baked in a tandoor.', 'https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=300&q=80', '4.2', '800+'),
        $d3e5976ef93d2b63$var$makeItem('i101e', 'Steamed Basmati Rice', 79, 'Long-grain aromatic basmati rice, steamed to perfection.', 'https://images.unsplash.com/photo-1536304993881-ff86e0c9b5d0?w=300&q=80', '4.0', '600+'),
        $d3e5976ef93d2b63$var$makeItem('i101f', 'Laccha Paratha', 89, 'Flaky, layered whole wheat flatbread cooked on a griddle with butter.', 'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=300&q=80', '4.1', '450+')
    ]),
    $d3e5976ef93d2b63$var$makeCategory('Starters', [
        $d3e5976ef93d2b63$var$makeItem('i101g', 'Chicken Tikka', 279, 'Juicy chicken marinated in yoghurt and spices, char-grilled in the tandoor.', 'https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?w=300&q=80', '4.4', '1.8K+'),
        $d3e5976ef93d2b63$var$makeItem('i101h', 'Paneer Tikka', 249, 'Cottage cheese cubes marinated in spiced yoghurt and grilled with peppers & onions.', 'https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?w=300&q=80', '4.3', '1.2K+'),
        $d3e5976ef93d2b63$var$makeItem('i101i', 'Seekh Kebab', 299, 'Minced lamb mixed with herbs and spices, skewered and grilled over charcoal.', 'https://images.unsplash.com/photo-1529692236671-f1f6cf9683ba?w=300&q=80', '4.2', '950+')
    ]),
    $d3e5976ef93d2b63$var$makeCategory('Desserts', [
        $d3e5976ef93d2b63$var$makeItem('i101j', 'Gulab Jamun', 99, 'Soft milk-solid dumplings soaked in rose-flavoured sugar syrup. Served warm.', 'https://images.unsplash.com/photo-1551024709-8f23081b5cc2?w=300&q=80', '4.5', '700+'),
        $d3e5976ef93d2b63$var$makeItem('i101k', 'Kheer', 119, 'Creamy rice pudding simmered with cardamom, saffron, and topped with pistachios.', 'https://images.unsplash.com/photo-1505253716362-afaea1d3d1af?w=300&q=80', '4.2', '480+')
    ])
]);
// ─── Italian — Pizzeria Roma (mock-102) ──────────────────────────────────────
const $d3e5976ef93d2b63$var$PIZZERIA_ROMA_MENU = $d3e5976ef93d2b63$var$makeMenu('mock-102', {
    cloudinaryImageId: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=660&q=80',
    name: 'Pizzeria Roma',
    areaName: 'Indiranagar',
    avgRating: 4.5,
    avgRatingString: '4.5',
    totalRatingsString: '8K+ ratings',
    costForTwoMessage: "\u20B9450 for two",
    cuisines: [
        'Pizza',
        'Italian',
        'Pasta'
    ],
    sla: {
        slaString: '25-30 mins'
    }
}, [
    $d3e5976ef93d2b63$var$makeCategory("Pizzas \uD83C\uDF55", [
        $d3e5976ef93d2b63$var$makeItem('i102a', 'Margherita', 299, 'San Marzano tomato, fresh mozzarella, basil, extra-virgin olive oil. A timeless classic.', 'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=300&q=80', '4.6', '3.5K+'),
        $d3e5976ef93d2b63$var$makeItem('i102b', 'Pepperoni Feast', 399, 'Loaded with premium pepperoni slices on a mozzarella base with rich tomato sauce.', 'https://images.unsplash.com/photo-1628840042765-356cda07504e?w=300&q=80', '4.7', '4.1K+'),
        $d3e5976ef93d2b63$var$makeItem('i102c', 'BBQ Chicken', 429, 'Smoky BBQ base, grilled chicken, red onions, and mozzarella finished with fresh coriander.', 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=300&q=80', '4.4', '2.2K+'),
        $d3e5976ef93d2b63$var$makeItem('i102d', 'Farm Veggie', 349, 'Bell peppers, mushrooms, olives, sun-dried tomatoes, and spinach on a garlic white sauce.', 'https://images.unsplash.com/photo-1571407970349-bc81e7e96d47?w=300&q=80', '4.2', '1.1K+')
    ]),
    $d3e5976ef93d2b63$var$makeCategory('Pasta', [
        $d3e5976ef93d2b63$var$makeItem('i102e', 'Penne Arrabbiata', 279, 'Penne in a spicy San Marzano tomato and garlic sauce with fresh basil.', 'https://images.unsplash.com/photo-1608219992759-8d74ed8d76eb?w=300&q=80', '4.3', '980+'),
        $d3e5976ef93d2b63$var$makeItem('i102f', 'Spaghetti Carbonara', 329, 'Spaghetti tossed with egg, pecorino romano, guanciale, and black pepper.', 'https://images.unsplash.com/photo-1612874742237-6526221588e3?w=300&q=80', '4.5', '1.6K+'),
        $d3e5976ef93d2b63$var$makeItem('i102g', 'Pesto Fusilli', 299, 'Fusilli with house-made basil pesto, cherry tomatoes, and parmesan shavings.', 'https://images.unsplash.com/photo-1473093295043-cdd812d0e601?w=300&q=80', '4.2', '760+')
    ]),
    $d3e5976ef93d2b63$var$makeCategory('Sides & Drinks', [
        $d3e5976ef93d2b63$var$makeItem('i102h', 'Garlic Bread', 149, "Toasted ciabatta with roasted garlic butter and parsley. Add cheese for \u20B930 extra.", 'https://images.unsplash.com/photo-1619535860434-cf9b902db9b6?w=300&q=80', '4.4', '2.4K+'),
        $d3e5976ef93d2b63$var$makeItem('i102i', 'Tiramisu', 199, 'Classic Italian dessert with espresso-soaked ladyfingers and mascarpone cream.', 'https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?w=300&q=80', '4.6', '1.3K+'),
        $d3e5976ef93d2b63$var$makeItem('i102j', 'San Pellegrino Sparkling', 99, 'Chilled Italian sparkling mineral water, 500ml.', 'https://images.unsplash.com/photo-1523362628745-0c100150b504?w=300&q=80', '4.0', '300+')
    ])
]);
// ─── Chinese — Dragon Bowl (mock-103) ────────────────────────────────────────
const $d3e5976ef93d2b63$var$DRAGON_BOWL_MENU = $d3e5976ef93d2b63$var$makeMenu('mock-103', {
    cloudinaryImageId: 'https://images.unsplash.com/photo-1563245372-f21724e3856d?w=660&q=80',
    name: 'Dragon Bowl',
    areaName: 'HSR Layout',
    avgRating: 4.2,
    avgRatingString: '4.2',
    totalRatingsString: '3K+ ratings',
    costForTwoMessage: "\u20B9300 for two",
    cuisines: [
        'Chinese',
        'Asian',
        'Noodles'
    ],
    sla: {
        slaString: '30-35 mins'
    }
}, [
    $d3e5976ef93d2b63$var$makeCategory("Dim Sum & Starters \uD83E\uDD5F", [
        $d3e5976ef93d2b63$var$makeItem('i103a', 'Steamed Chicken Dumplings', 199, 'Juicy chicken and ginger dumplings, steamed and served with soy-chilli dipping sauce.', 'https://images.unsplash.com/photo-1563245372-f21724e3856d?w=300&q=80', '4.5', '1.8K+'),
        $d3e5976ef93d2b63$var$makeItem('i103b', 'Crispy Spring Rolls', 169, 'Golden fried rolls stuffed with glass noodles, cabbage, and mushrooms.', 'https://images.unsplash.com/photo-1515669097368-22e68427d265?w=300&q=80', '4.2', '1.1K+'),
        $d3e5976ef93d2b63$var$makeItem('i103c', 'Chilli Chicken (Dry)', 229, 'Wok-tossed crispy chicken with chillies, soy, and sesame. A restaurant classic.', 'https://images.unsplash.com/photo-1603360946369-dc9bb6258143?w=300&q=80', '4.4', '2.3K+')
    ]),
    $d3e5976ef93d2b63$var$makeCategory('Noodles & Rice', [
        $d3e5976ef93d2b63$var$makeItem('i103d', 'Hakka Noodles', 199, 'Wok-tossed egg noodles with vegetables in a dark soy and sesame sauce.', 'https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=300&q=80', '4.3', '1.9K+'),
        $d3e5976ef93d2b63$var$makeItem('i103e', 'Schezwan Fried Rice', 219, 'Spicy Schezwan sauce tossed with rice, eggs, spring onions, and your choice of protein.', 'https://images.unsplash.com/photo-1536304993881-ff86e0c9b5d0?w=300&q=80', '4.2', '1.4K+'),
        $d3e5976ef93d2b63$var$makeItem('i103f', 'Singapore Noodles', 239, 'Thin rice vermicelli stir-fried with curry powder, shrimp, and colourful vegetables.', 'https://images.unsplash.com/photo-1569050467447-ce54b3bbc37d?w=300&q=80', '4.1', '820+')
    ]),
    $d3e5976ef93d2b63$var$makeCategory('Soups', [
        $d3e5976ef93d2b63$var$makeItem('i103g', 'Hot & Sour Soup', 149, 'Bold, tangy broth with tofu, mushrooms, bamboo shoots, and chilli oil.', 'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=300&q=80', '4.0', '640+'),
        $d3e5976ef93d2b63$var$makeItem('i103h', 'Sweet Corn Chicken Soup', 139, 'Comforting cream-style corn soup with shredded chicken and egg ribbons.', 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=300&q=80', '4.1', '570+')
    ])
]);
// ─── Generic fallback (shown for mock-104 through mock-120) ──────────────────
const $d3e5976ef93d2b63$var$GENERIC_MENU = (resId, resName, cuisine)=>$d3e5976ef93d2b63$var$makeMenu(resId, {
        cloudinaryImageId: 'https://images.unsplash.com/photo-1504754524776-8f4f37790ca0?w=660&q=80',
        name: resName,
        areaName: 'Bangalore',
        avgRating: 4.2,
        avgRatingString: '4.2',
        totalRatingsString: '1K+ ratings',
        costForTwoMessage: "\u20B9300 for two",
        cuisines: [
            cuisine
        ],
        sla: {
            slaString: '30-35 mins'
        }
    }, [
        $d3e5976ef93d2b63$var$makeCategory('Popular', [
            $d3e5976ef93d2b63$var$makeItem(`${resId}-a`, 'Chef\'s Special', 299, 'Our most-loved dish, prepared fresh with premium ingredients and the chef\'s secret spice blend.', 'https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=300&q=80', '4.4', '900+'),
            $d3e5976ef93d2b63$var$makeItem(`${resId}-b`, 'Classic Combo', 349, "A satisfying combination of our bestsellers served together \u2014 great value for one.", 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=300&q=80', '4.2', '650+'),
            $d3e5976ef93d2b63$var$makeItem(`${resId}-c`, 'House Starter', 179, 'A crispy, flavourful starter that\'s been a crowd favourite since day one.', 'https://images.unsplash.com/photo-1529692236671-f1f6cf9683ba?w=300&q=80', '4.1', '480+')
        ]),
        $d3e5976ef93d2b63$var$makeCategory('Mains', [
            $d3e5976ef93d2b63$var$makeItem(`${resId}-d`, 'Signature Main Course', 329, "Our flagship main course \u2014 bold flavours, generous portions, made to order.", 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=300&q=80', '4.3', '1.1K+'),
            $d3e5976ef93d2b63$var$makeItem(`${resId}-e`, 'Vegetarian Delight', 249, 'A hearty, flavour-packed vegetarian option that satisfies every time.', 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=300&q=80', '4.0', '420+')
        ]),
        $d3e5976ef93d2b63$var$makeCategory('Desserts & Drinks', [
            $d3e5976ef93d2b63$var$makeItem(`${resId}-f`, 'House Dessert', 149, "A sweet finish to your meal \u2014 ask your delivery partner for today's special.", 'https://images.unsplash.com/photo-1551024709-8f23081b5cc2?w=300&q=80', '4.3', '390+'),
            $d3e5976ef93d2b63$var$makeItem(`${resId}-g`, 'Fresh Lime Soda', 79, "Chilled fresh lime with soda \u2014 sweet, salted, or mixed.", 'https://images.unsplash.com/photo-1523362628745-0c100150b504?w=300&q=80', '4.0', '290+')
        ])
    ]);
// Map of resId → menu data
const $d3e5976ef93d2b63$var$MOCK_MENU_MAP = {
    'mock-101': $d3e5976ef93d2b63$var$SPICE_ROUTE_MENU,
    'mock-102': $d3e5976ef93d2b63$var$PIZZERIA_ROMA_MENU,
    'mock-103': $d3e5976ef93d2b63$var$DRAGON_BOWL_MENU
};
const $d3e5976ef93d2b63$export$c9a7a65a56a52b97 = (resId, resName = 'Restaurant', cuisine = 'Indian')=>$d3e5976ef93d2b63$var$MOCK_MENU_MAP[resId] ?? $d3e5976ef93d2b63$var$GENERIC_MENU(resId, resName, cuisine);
var $d3e5976ef93d2b63$export$2e2bcd8739ae039 = $d3e5976ef93d2b63$var$MOCK_MENU_MAP;


const $cd789a687638562c$var$useRestaurantMenu = (resId)=>{
    const [resInfo, setResInfo] = (0, $4RFnf.useState)(null);
    (0, $4RFnf.useEffect)(()=>{
        fetchData();
    }, []);
    const fetchData = async ()=>{
        try {
            const data = await fetch((0, $d39effcf12df3fc5$export$b77c1aa4fb57bd1c) + resId);
            const json = await data.json();
            const parsed = json?.data;
            // Swiggy's menu API is reliably blocked by bot-detection outside a real
            // browser session — fall back to a mock menu so the page still works.
            if (parsed && parsed.cards?.length) setResInfo(parsed);
            else setResInfo((0, $d3e5976ef93d2b63$export$c9a7a65a56a52b97)(resId));
        } catch  {
            setResInfo((0, $d3e5976ef93d2b63$export$c9a7a65a56a52b97)(resId));
        }
    };
    return resInfo;
};
var $cd789a687638562c$export$2e2bcd8739ae039 = $cd789a687638562c$var$useRestaurantMenu;


/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $490d40a9708f8873$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m12 19-7-7 7-7",
            key: "1l729n"
        }
    ],
    [
        "path",
        {
            d: "M19 12H5",
            key: "x3x0zl"
        }
    ]
];
const $490d40a9708f8873$export$2e2bcd8739ae039 = (0, $e81754e696bcea24$export$2e2bcd8739ae039)("arrow-left", $490d40a9708f8873$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3f6b251a61adee8c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21 21-4.34-4.34",
            key: "14j7rj"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ]
];
const $3f6b251a61adee8c$export$2e2bcd8739ae039 = (0, $e81754e696bcea24$export$2e2bcd8739ae039)("search", $3f6b251a61adee8c$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3c2a7fc58561546e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
            key: "r04s7s"
        }
    ]
];
const $3c2a7fc58561546e$export$2e2bcd8739ae039 = (0, $e81754e696bcea24$export$2e2bcd8739ae039)("star", $3c2a7fc58561546e$export$3efd853dbb351e94);



var $jk232 = parcelRequire("jk232");

var $jk232 = parcelRequire("jk232");



// src/utils/formatProdErrorMessage.ts
function $876d8277641f3cc3$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $876d8277641f3cc3$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $876d8277641f3cc3$var$symbol_observable_default = $876d8277641f3cc3$var$$$observable;
// src/utils/actionTypes.ts
var $876d8277641f3cc3$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $876d8277641f3cc3$var$ActionTypes = {
    INIT: `@@redux/INIT${$876d8277641f3cc3$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$876d8277641f3cc3$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$876d8277641f3cc3$var$randomString()}`
};
var $876d8277641f3cc3$export$4219e499db7ca678 = $876d8277641f3cc3$var$ActionTypes;
// src/utils/isPlainObject.ts
function $876d8277641f3cc3$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $876d8277641f3cc3$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($876d8277641f3cc3$var$isDate(val)) return "date";
    if ($876d8277641f3cc3$var$isError(val)) return "error";
    const constructorName = $876d8277641f3cc3$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $876d8277641f3cc3$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $876d8277641f3cc3$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $876d8277641f3cc3$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $876d8277641f3cc3$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $876d8277641f3cc3$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(1));
        return enhancer($876d8277641f3cc3$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$876d8277641f3cc3$export$53b83ca8eaab0383(action)) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $876d8277641f3cc3$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$876d8277641f3cc3$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $876d8277641f3cc3$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$876d8277641f3cc3$var$symbol_observable_default]: observable
    };
    return store;
}
function $876d8277641f3cc3$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $876d8277641f3cc3$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $876d8277641f3cc3$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $876d8277641f3cc3$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $876d8277641f3cc3$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$876d8277641f3cc3$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$876d8277641f3cc3$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $876d8277641f3cc3$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $876d8277641f3cc3$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $876d8277641f3cc3$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $876d8277641f3cc3$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(13));
    });
}
function $876d8277641f3cc3$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $876d8277641f3cc3$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $876d8277641f3cc3$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $876d8277641f3cc3$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $876d8277641f3cc3$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $876d8277641f3cc3$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $876d8277641f3cc3$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $876d8277641f3cc3$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $876d8277641f3cc3$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $876d8277641f3cc3$export$b956e38827fca970(action) {
    return $876d8277641f3cc3$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $3fcdd01f4bd90a60$var$__defProp = Object.defineProperty;
var $3fcdd01f4bd90a60$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3fcdd01f4bd90a60$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3fcdd01f4bd90a60$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3fcdd01f4bd90a60$var$__defNormalProp = (obj, key, value)=>key in obj ? $3fcdd01f4bd90a60$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3fcdd01f4bd90a60$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($3fcdd01f4bd90a60$var$__hasOwnProp.call(b, prop)) $3fcdd01f4bd90a60$var$__defNormalProp(a, prop, b[prop]);
    if ($3fcdd01f4bd90a60$var$__getOwnPropSymbols) {
        for (var prop of $3fcdd01f4bd90a60$var$__getOwnPropSymbols(b))if ($3fcdd01f4bd90a60$var$__propIsEnum.call(b, prop)) $3fcdd01f4bd90a60$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $3fcdd01f4bd90a60$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $3fcdd01f4bd90a60$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $3fcdd01f4bd90a60$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $3fcdd01f4bd90a60$var$errors = [];
function $3fcdd01f4bd90a60$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $3fcdd01f4bd90a60$var$getPrototypeOf = Object.getPrototypeOf;
function $3fcdd01f4bd90a60$export$541ac630993a4c84(value) {
    return !!value && !!value[$3fcdd01f4bd90a60$var$DRAFT_STATE];
}
function $3fcdd01f4bd90a60$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $3fcdd01f4bd90a60$var$isPlainObject(value) || Array.isArray(value) || !!value[$3fcdd01f4bd90a60$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$3fcdd01f4bd90a60$export$6ee2082928bcb0ee]) || $3fcdd01f4bd90a60$var$isMap(value) || $3fcdd01f4bd90a60$var$isSet(value);
}
var $3fcdd01f4bd90a60$var$objectCtorString = Object.prototype.constructor.toString();
function $3fcdd01f4bd90a60$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $3fcdd01f4bd90a60$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $3fcdd01f4bd90a60$var$objectCtorString;
}
function $3fcdd01f4bd90a60$export$22e8af3f75a010e3(value) {
    if (!$3fcdd01f4bd90a60$export$541ac630993a4c84(value)) $3fcdd01f4bd90a60$var$die(15, value);
    return value[$3fcdd01f4bd90a60$var$DRAFT_STATE].base_;
}
function $3fcdd01f4bd90a60$var$each(obj, iter) {
    if ($3fcdd01f4bd90a60$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $3fcdd01f4bd90a60$var$getArchtype(thing) {
    const state = thing[$3fcdd01f4bd90a60$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $3fcdd01f4bd90a60$var$isMap(thing) ? 2 /* Map */  : $3fcdd01f4bd90a60$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $3fcdd01f4bd90a60$var$has(thing, prop) {
    return $3fcdd01f4bd90a60$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $3fcdd01f4bd90a60$var$get(thing, prop) {
    return $3fcdd01f4bd90a60$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $3fcdd01f4bd90a60$var$set(thing, propOrOldValue, value) {
    const t = $3fcdd01f4bd90a60$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $3fcdd01f4bd90a60$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $3fcdd01f4bd90a60$var$isMap(target) {
    return target instanceof Map;
}
function $3fcdd01f4bd90a60$var$isSet(target) {
    return target instanceof Set;
}
function $3fcdd01f4bd90a60$var$latest(state) {
    return state.copy_ || state.base_;
}
function $3fcdd01f4bd90a60$var$shallowCopy(base, strict) {
    if ($3fcdd01f4bd90a60$var$isMap(base)) return new Map(base);
    if ($3fcdd01f4bd90a60$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $3fcdd01f4bd90a60$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$3fcdd01f4bd90a60$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($3fcdd01f4bd90a60$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $3fcdd01f4bd90a60$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $3fcdd01f4bd90a60$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $3fcdd01f4bd90a60$export$792f3d81ea979f55(obj, deep = false) {
    if ($3fcdd01f4bd90a60$var$isFrozen(obj) || $3fcdd01f4bd90a60$export$541ac630993a4c84(obj) || !$3fcdd01f4bd90a60$export$16e3aed3edb85946(obj)) return obj;
    if ($3fcdd01f4bd90a60$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $3fcdd01f4bd90a60$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$3fcdd01f4bd90a60$export$792f3d81ea979f55(value, true));
    return obj;
}
function $3fcdd01f4bd90a60$var$dontMutateFrozenCollections() {
    $3fcdd01f4bd90a60$var$die(2);
}
function $3fcdd01f4bd90a60$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $3fcdd01f4bd90a60$var$plugins = {};
function $3fcdd01f4bd90a60$var$getPlugin(pluginKey) {
    const plugin = $3fcdd01f4bd90a60$var$plugins[pluginKey];
    if (!plugin) $3fcdd01f4bd90a60$var$die(0, pluginKey);
    return plugin;
}
function $3fcdd01f4bd90a60$var$loadPlugin(pluginKey, implementation) {
    if (!$3fcdd01f4bd90a60$var$plugins[pluginKey]) $3fcdd01f4bd90a60$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $3fcdd01f4bd90a60$var$currentScope;
function $3fcdd01f4bd90a60$var$getCurrentScope() {
    return $3fcdd01f4bd90a60$var$currentScope;
}
function $3fcdd01f4bd90a60$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $3fcdd01f4bd90a60$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $3fcdd01f4bd90a60$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $3fcdd01f4bd90a60$var$revokeScope(scope) {
    $3fcdd01f4bd90a60$var$leaveScope(scope);
    scope.drafts_.forEach($3fcdd01f4bd90a60$var$revokeDraft);
    scope.drafts_ = null;
}
function $3fcdd01f4bd90a60$var$leaveScope(scope) {
    if (scope === $3fcdd01f4bd90a60$var$currentScope) $3fcdd01f4bd90a60$var$currentScope = scope.parent_;
}
function $3fcdd01f4bd90a60$var$enterScope(immer2) {
    return $3fcdd01f4bd90a60$var$currentScope = $3fcdd01f4bd90a60$var$createScope($3fcdd01f4bd90a60$var$currentScope, immer2);
}
function $3fcdd01f4bd90a60$var$revokeDraft(draft) {
    const state = draft[$3fcdd01f4bd90a60$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $3fcdd01f4bd90a60$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$3fcdd01f4bd90a60$var$DRAFT_STATE].modified_) {
            $3fcdd01f4bd90a60$var$revokeScope(scope);
            $3fcdd01f4bd90a60$var$die(4);
        }
        if ($3fcdd01f4bd90a60$export$16e3aed3edb85946(result)) {
            result = $3fcdd01f4bd90a60$var$finalize(scope, result);
            if (!scope.parent_) $3fcdd01f4bd90a60$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $3fcdd01f4bd90a60$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$3fcdd01f4bd90a60$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $3fcdd01f4bd90a60$var$finalize(scope, baseDraft, []);
    $3fcdd01f4bd90a60$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $3fcdd01f4bd90a60$export$45b790e32b2810ee ? result : void 0;
}
function $3fcdd01f4bd90a60$var$finalize(rootScope, value, path) {
    if ($3fcdd01f4bd90a60$var$isFrozen(value)) return value;
    const state = value[$3fcdd01f4bd90a60$var$DRAFT_STATE];
    if (!state) {
        $3fcdd01f4bd90a60$var$each(value, (key, childValue)=>$3fcdd01f4bd90a60$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $3fcdd01f4bd90a60$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $3fcdd01f4bd90a60$var$each(resultEach, (key, childValue)=>$3fcdd01f4bd90a60$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $3fcdd01f4bd90a60$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $3fcdd01f4bd90a60$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $3fcdd01f4bd90a60$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($3fcdd01f4bd90a60$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$3fcdd01f4bd90a60$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $3fcdd01f4bd90a60$var$finalize(rootScope, childValue, path);
        $3fcdd01f4bd90a60$var$set(targetObject, prop, res);
        if ($3fcdd01f4bd90a60$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($3fcdd01f4bd90a60$export$16e3aed3edb85946(childValue) && !$3fcdd01f4bd90a60$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $3fcdd01f4bd90a60$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $3fcdd01f4bd90a60$var$maybeFreeze(rootScope, childValue);
    }
}
function $3fcdd01f4bd90a60$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $3fcdd01f4bd90a60$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $3fcdd01f4bd90a60$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $3fcdd01f4bd90a60$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $3fcdd01f4bd90a60$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $3fcdd01f4bd90a60$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $3fcdd01f4bd90a60$var$objectTraps = {
    get (state, prop) {
        if (prop === $3fcdd01f4bd90a60$var$DRAFT_STATE) return state;
        const source = $3fcdd01f4bd90a60$var$latest(state);
        if (!$3fcdd01f4bd90a60$var$has(source, prop)) return $3fcdd01f4bd90a60$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$3fcdd01f4bd90a60$export$16e3aed3edb85946(value)) return value;
        if (value === $3fcdd01f4bd90a60$var$peek(state.base_, prop)) {
            $3fcdd01f4bd90a60$var$prepareCopy(state);
            return state.copy_[prop] = $3fcdd01f4bd90a60$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $3fcdd01f4bd90a60$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($3fcdd01f4bd90a60$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $3fcdd01f4bd90a60$var$getDescriptorFromProto($3fcdd01f4bd90a60$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $3fcdd01f4bd90a60$var$peek($3fcdd01f4bd90a60$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($3fcdd01f4bd90a60$var$is(value, current2) && (value !== void 0 || $3fcdd01f4bd90a60$var$has(state.base_, prop))) return true;
            $3fcdd01f4bd90a60$var$prepareCopy(state);
            $3fcdd01f4bd90a60$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($3fcdd01f4bd90a60$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $3fcdd01f4bd90a60$var$prepareCopy(state);
            $3fcdd01f4bd90a60$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $3fcdd01f4bd90a60$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $3fcdd01f4bd90a60$var$die(11);
    },
    getPrototypeOf (state) {
        return $3fcdd01f4bd90a60$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $3fcdd01f4bd90a60$var$die(12);
    }
};
var $3fcdd01f4bd90a60$var$arrayTraps = {};
$3fcdd01f4bd90a60$var$each($3fcdd01f4bd90a60$var$objectTraps, (key, fn)=>{
    $3fcdd01f4bd90a60$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$3fcdd01f4bd90a60$var$arrayTraps.deleteProperty = function(state, prop) {
    return $3fcdd01f4bd90a60$var$arrayTraps.set.call(this, state, prop, void 0);
};
$3fcdd01f4bd90a60$var$arrayTraps.set = function(state, prop, value) {
    return $3fcdd01f4bd90a60$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $3fcdd01f4bd90a60$var$peek(draft, prop) {
    const state = draft[$3fcdd01f4bd90a60$var$DRAFT_STATE];
    const source = state ? $3fcdd01f4bd90a60$var$latest(state) : draft;
    return source[prop];
}
function $3fcdd01f4bd90a60$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $3fcdd01f4bd90a60$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $3fcdd01f4bd90a60$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $3fcdd01f4bd90a60$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $3fcdd01f4bd90a60$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $3fcdd01f4bd90a60$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $3fcdd01f4bd90a60$var$markChanged(state.parent_);
    }
}
function $3fcdd01f4bd90a60$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $3fcdd01f4bd90a60$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $3fcdd01f4bd90a60$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $3fcdd01f4bd90a60$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $3fcdd01f4bd90a60$var$die(7);
            let result;
            if ($3fcdd01f4bd90a60$export$16e3aed3edb85946(base)) {
                const scope = $3fcdd01f4bd90a60$var$enterScope(this);
                const proxy = $3fcdd01f4bd90a60$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $3fcdd01f4bd90a60$var$revokeScope(scope);
                    else $3fcdd01f4bd90a60$var$leaveScope(scope);
                }
                $3fcdd01f4bd90a60$var$usePatchesInScope(scope, patchListener);
                return $3fcdd01f4bd90a60$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $3fcdd01f4bd90a60$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $3fcdd01f4bd90a60$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $3fcdd01f4bd90a60$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $3fcdd01f4bd90a60$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$3fcdd01f4bd90a60$export$16e3aed3edb85946(base)) $3fcdd01f4bd90a60$var$die(8);
        if ($3fcdd01f4bd90a60$export$541ac630993a4c84(base)) base = $3fcdd01f4bd90a60$export$97aac956da55dae9(base);
        const scope = $3fcdd01f4bd90a60$var$enterScope(this);
        const proxy = $3fcdd01f4bd90a60$var$createProxy(base, void 0);
        proxy[$3fcdd01f4bd90a60$var$DRAFT_STATE].isManual_ = true;
        $3fcdd01f4bd90a60$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$3fcdd01f4bd90a60$var$DRAFT_STATE];
        if (!state || !state.isManual_) $3fcdd01f4bd90a60$var$die(9);
        const { scope_: scope } = state;
        $3fcdd01f4bd90a60$var$usePatchesInScope(scope, patchListener);
        return $3fcdd01f4bd90a60$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $3fcdd01f4bd90a60$var$getPlugin("Patches").applyPatches_;
        if ($3fcdd01f4bd90a60$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $3fcdd01f4bd90a60$var$createProxy(value, parent) {
    const draft = $3fcdd01f4bd90a60$var$isMap(value) ? $3fcdd01f4bd90a60$var$getPlugin("MapSet").proxyMap_(value, parent) : $3fcdd01f4bd90a60$var$isSet(value) ? $3fcdd01f4bd90a60$var$getPlugin("MapSet").proxySet_(value, parent) : $3fcdd01f4bd90a60$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $3fcdd01f4bd90a60$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $3fcdd01f4bd90a60$export$97aac956da55dae9(value) {
    if (!$3fcdd01f4bd90a60$export$541ac630993a4c84(value)) $3fcdd01f4bd90a60$var$die(10, value);
    return $3fcdd01f4bd90a60$var$currentImpl(value);
}
function $3fcdd01f4bd90a60$var$currentImpl(value) {
    if (!$3fcdd01f4bd90a60$export$16e3aed3edb85946(value) || $3fcdd01f4bd90a60$var$isFrozen(value)) return value;
    const state = value[$3fcdd01f4bd90a60$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $3fcdd01f4bd90a60$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $3fcdd01f4bd90a60$var$shallowCopy(value, true);
    $3fcdd01f4bd90a60$var$each(copy, (key, childValue)=>{
        $3fcdd01f4bd90a60$var$set(copy, key, $3fcdd01f4bd90a60$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $3fcdd01f4bd90a60$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $3fcdd01f4bd90a60$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $3fcdd01f4bd90a60$var$get(base_, key);
            const value = $3fcdd01f4bd90a60$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $3fcdd01f4bd90a60$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $3fcdd01f4bd90a60$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $3fcdd01f4bd90a60$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $3fcdd01f4bd90a60$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $3fcdd01f4bd90a60$var$die(errorOffset + 3);
                base = $3fcdd01f4bd90a60$var$get(base, p);
                if (typeof base !== "object") $3fcdd01f4bd90a60$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $3fcdd01f4bd90a60$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $3fcdd01f4bd90a60$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $3fcdd01f4bd90a60$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$3fcdd01f4bd90a60$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($3fcdd01f4bd90a60$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($3fcdd01f4bd90a60$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($3fcdd01f4bd90a60$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($3fcdd01f4bd90a60$var$has(obj, $3fcdd01f4bd90a60$export$6ee2082928bcb0ee)) cloned[$3fcdd01f4bd90a60$export$6ee2082928bcb0ee] = obj[$3fcdd01f4bd90a60$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($3fcdd01f4bd90a60$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $3fcdd01f4bd90a60$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $3fcdd01f4bd90a60$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$3fcdd01f4bd90a60$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $3fcdd01f4bd90a60$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $3fcdd01f4bd90a60$var$latest(this[$3fcdd01f4bd90a60$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $3fcdd01f4bd90a60$var$latest(this[$3fcdd01f4bd90a60$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$3fcdd01f4bd90a60$var$latest(state).has(key) || $3fcdd01f4bd90a60$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $3fcdd01f4bd90a60$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $3fcdd01f4bd90a60$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($3fcdd01f4bd90a60$var$latest(state).size) {
                prepareMapCopy(state);
                $3fcdd01f4bd90a60$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $3fcdd01f4bd90a60$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            $3fcdd01f4bd90a60$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $3fcdd01f4bd90a60$var$latest(state).get(key);
            if (state.finalized_ || !$3fcdd01f4bd90a60$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $3fcdd01f4bd90a60$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $3fcdd01f4bd90a60$var$latest(this[$3fcdd01f4bd90a60$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($3fcdd01f4bd90a60$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$3fcdd01f4bd90a60$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $3fcdd01f4bd90a60$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $3fcdd01f4bd90a60$var$latest(this[$3fcdd01f4bd90a60$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $3fcdd01f4bd90a60$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $3fcdd01f4bd90a60$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($3fcdd01f4bd90a60$var$latest(state).size) {
                prepareSetCopy(state);
                $3fcdd01f4bd90a60$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($3fcdd01f4bd90a60$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($3fcdd01f4bd90a60$export$16e3aed3edb85946(value)) {
                    const draft = $3fcdd01f4bd90a60$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $3fcdd01f4bd90a60$var$die(3, JSON.stringify($3fcdd01f4bd90a60$var$latest(state)));
    }
    $3fcdd01f4bd90a60$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $3fcdd01f4bd90a60$var$immer = new $3fcdd01f4bd90a60$export$aaadc6ff0f822719();
var $3fcdd01f4bd90a60$export$b46cabe22e78bc00 = $3fcdd01f4bd90a60$var$immer.produce;
var $3fcdd01f4bd90a60$export$4da66d41c9492c78 = $3fcdd01f4bd90a60$var$immer.produceWithPatches.bind($3fcdd01f4bd90a60$var$immer);
var $3fcdd01f4bd90a60$export$573f26f60825c493 = $3fcdd01f4bd90a60$var$immer.setAutoFreeze.bind($3fcdd01f4bd90a60$var$immer);
var $3fcdd01f4bd90a60$export$333ce65961cbe047 = $3fcdd01f4bd90a60$var$immer.setUseStrictShallowCopy.bind($3fcdd01f4bd90a60$var$immer);
var $3fcdd01f4bd90a60$export$a8b8e03e6bbe5473 = $3fcdd01f4bd90a60$var$immer.applyPatches.bind($3fcdd01f4bd90a60$var$immer);
var $3fcdd01f4bd90a60$export$3c3214997190395f = $3fcdd01f4bd90a60$var$immer.createDraft.bind($3fcdd01f4bd90a60$var$immer);
var $3fcdd01f4bd90a60$export$c60f5e69c521b528 = $3fcdd01f4bd90a60$var$immer.finishDraft.bind($3fcdd01f4bd90a60$var$immer);
function $3fcdd01f4bd90a60$export$c05b21e3257751e5(value) {
    return value;
}
function $3fcdd01f4bd90a60$export$20f911b3f8cf0b74(value) {
    return value;
}


var $9ed9907f1a4dda7a$var$__defProp = Object.defineProperty;
var $9ed9907f1a4dda7a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $9ed9907f1a4dda7a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $9ed9907f1a4dda7a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $9ed9907f1a4dda7a$var$__defNormalProp = (obj, key, value)=>key in obj ? $9ed9907f1a4dda7a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $9ed9907f1a4dda7a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($9ed9907f1a4dda7a$var$__hasOwnProp.call(b, prop)) $9ed9907f1a4dda7a$var$__defNormalProp(a, prop, b[prop]);
    if ($9ed9907f1a4dda7a$var$__getOwnPropSymbols) {
        for (var prop of $9ed9907f1a4dda7a$var$__getOwnPropSymbols(b))if ($9ed9907f1a4dda7a$var$__propIsEnum.call(b, prop)) $9ed9907f1a4dda7a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $9ed9907f1a4dda7a$var$__publicField = (obj, key, value)=>{
    $9ed9907f1a4dda7a$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $9ed9907f1a4dda7a$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $9ed9907f1a4dda7a$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $9ed9907f1a4dda7a$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $9ed9907f1a4dda7a$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($9ed9907f1a4dda7a$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $9ed9907f1a4dda7a$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $9ed9907f1a4dda7a$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $9ed9907f1a4dda7a$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $9ed9907f1a4dda7a$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $9ed9907f1a4dda7a$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $9ed9907f1a4dda7a$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $9ed9907f1a4dda7a$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $9ed9907f1a4dda7a$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $9ed9907f1a4dda7a$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $9ed9907f1a4dda7a$var$__spreadValues($9ed9907f1a4dda7a$var$__spreadValues({}, $9ed9907f1a4dda7a$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $9ed9907f1a4dda7a$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $9ed9907f1a4dda7a$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $9ed9907f1a4dda7a$var$$REVISION = 0;
var $9ed9907f1a4dda7a$var$CURRENT_TRACKER = null;
var $9ed9907f1a4dda7a$var$Cell = class {
    constructor(initialValue, isEqual = $9ed9907f1a4dda7a$var$tripleEq){
        $9ed9907f1a4dda7a$var$__publicField(this, "revision", $9ed9907f1a4dda7a$var$$REVISION);
        $9ed9907f1a4dda7a$var$__publicField(this, "_value");
        $9ed9907f1a4dda7a$var$__publicField(this, "_lastValue");
        $9ed9907f1a4dda7a$var$__publicField(this, "_isEqual", $9ed9907f1a4dda7a$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $9ed9907f1a4dda7a$var$CURRENT_TRACKER == null || $9ed9907f1a4dda7a$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$9ed9907f1a4dda7a$var$$REVISION;
    }
};
function $9ed9907f1a4dda7a$var$tripleEq(a, b) {
    return a === b;
}
var $9ed9907f1a4dda7a$var$TrackingCache = class {
    constructor(fn){
        $9ed9907f1a4dda7a$var$__publicField(this, "_cachedValue");
        $9ed9907f1a4dda7a$var$__publicField(this, "_cachedRevision", -1);
        $9ed9907f1a4dda7a$var$__publicField(this, "_deps", []);
        $9ed9907f1a4dda7a$var$__publicField(this, "hits", 0);
        $9ed9907f1a4dda7a$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $9ed9907f1a4dda7a$var$CURRENT_TRACKER;
            $9ed9907f1a4dda7a$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $9ed9907f1a4dda7a$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $9ed9907f1a4dda7a$var$CURRENT_TRACKER == null || $9ed9907f1a4dda7a$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $9ed9907f1a4dda7a$var$getValue(cell) {
    if (!(cell instanceof $9ed9907f1a4dda7a$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $9ed9907f1a4dda7a$var$setValue(storage, value) {
    if (!(storage instanceof $9ed9907f1a4dda7a$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $9ed9907f1a4dda7a$var$createCell(initialValue, isEqual = $9ed9907f1a4dda7a$var$tripleEq) {
    return new $9ed9907f1a4dda7a$var$Cell(initialValue, isEqual);
}
function $9ed9907f1a4dda7a$var$createCache(fn) {
    $9ed9907f1a4dda7a$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $9ed9907f1a4dda7a$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $9ed9907f1a4dda7a$var$neverEq = (a, b)=>false;
function $9ed9907f1a4dda7a$var$createTag() {
    return $9ed9907f1a4dda7a$var$createCell(null, $9ed9907f1a4dda7a$var$neverEq);
}
function $9ed9907f1a4dda7a$var$dirtyTag(tag, value) {
    $9ed9907f1a4dda7a$var$setValue(tag, value);
}
var $9ed9907f1a4dda7a$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $9ed9907f1a4dda7a$var$createTag();
    $9ed9907f1a4dda7a$var$getValue(tag);
};
var $9ed9907f1a4dda7a$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $9ed9907f1a4dda7a$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $9ed9907f1a4dda7a$var$REDUX_PROXY_LABEL = Symbol();
var $9ed9907f1a4dda7a$var$nextId = 0;
var $9ed9907f1a4dda7a$var$proto = Object.getPrototypeOf({});
var $9ed9907f1a4dda7a$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $9ed9907f1a4dda7a$var$__publicField(this, "proxy", new Proxy(this, $9ed9907f1a4dda7a$var$objectProxyHandler));
        $9ed9907f1a4dda7a$var$__publicField(this, "tag", $9ed9907f1a4dda7a$var$createTag());
        $9ed9907f1a4dda7a$var$__publicField(this, "tags", {});
        $9ed9907f1a4dda7a$var$__publicField(this, "children", {});
        $9ed9907f1a4dda7a$var$__publicField(this, "collectionTag", null);
        $9ed9907f1a4dda7a$var$__publicField(this, "id", $9ed9907f1a4dda7a$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $9ed9907f1a4dda7a$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $9ed9907f1a4dda7a$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $9ed9907f1a4dda7a$var$createNode(childValue);
                if (childNode.tag) $9ed9907f1a4dda7a$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $9ed9907f1a4dda7a$var$createTag();
                    tag.value = childValue;
                }
                $9ed9907f1a4dda7a$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $9ed9907f1a4dda7a$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $9ed9907f1a4dda7a$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $9ed9907f1a4dda7a$var$__publicField(this, "proxy", new Proxy([
            this
        ], $9ed9907f1a4dda7a$var$arrayProxyHandler));
        $9ed9907f1a4dda7a$var$__publicField(this, "tag", $9ed9907f1a4dda7a$var$createTag());
        $9ed9907f1a4dda7a$var$__publicField(this, "tags", {});
        $9ed9907f1a4dda7a$var$__publicField(this, "children", {});
        $9ed9907f1a4dda7a$var$__publicField(this, "collectionTag", null);
        $9ed9907f1a4dda7a$var$__publicField(this, "id", $9ed9907f1a4dda7a$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $9ed9907f1a4dda7a$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $9ed9907f1a4dda7a$var$consumeCollection(node);
        return $9ed9907f1a4dda7a$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $9ed9907f1a4dda7a$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $9ed9907f1a4dda7a$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $9ed9907f1a4dda7a$var$objectProxyHandler.has(node, prop);
    }
};
function $9ed9907f1a4dda7a$var$createNode(value) {
    if (Array.isArray(value)) return new $9ed9907f1a4dda7a$var$ArrayTreeNode(value);
    return new $9ed9907f1a4dda7a$var$ObjectTreeNode(value);
}
function $9ed9907f1a4dda7a$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $9ed9907f1a4dda7a$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $9ed9907f1a4dda7a$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $9ed9907f1a4dda7a$var$dirtyCollection(node);
            $9ed9907f1a4dda7a$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $9ed9907f1a4dda7a$var$updateNode(childNode, newChildValue);
        else {
            $9ed9907f1a4dda7a$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $9ed9907f1a4dda7a$var$deleteNode(node) {
    if (node.tag) $9ed9907f1a4dda7a$var$dirtyTag(node.tag, null);
    $9ed9907f1a4dda7a$var$dirtyCollection(node);
    for(const key in node.tags)$9ed9907f1a4dda7a$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$9ed9907f1a4dda7a$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $9ed9907f1a4dda7a$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $9ed9907f1a4dda7a$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $9ed9907f1a4dda7a$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $9ed9907f1a4dda7a$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $9ed9907f1a4dda7a$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $9ed9907f1a4dda7a$export$3f025202a230c6dd = (a, b)=>a === b;
function $9ed9907f1a4dda7a$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $9ed9907f1a4dda7a$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $9ed9907f1a4dda7a$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $9ed9907f1a4dda7a$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $9ed9907f1a4dda7a$var$createSingletonCache(comparator) : $9ed9907f1a4dda7a$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $9ed9907f1a4dda7a$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $9ed9907f1a4dda7a$export$c8f9cf88d9fdee55(func) {
    const node = $9ed9907f1a4dda7a$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $9ed9907f1a4dda7a$var$createCacheKeyComparator($9ed9907f1a4dda7a$export$3f025202a230c6dd);
    const cache = $9ed9907f1a4dda7a$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $9ed9907f1a4dda7a$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $9ed9907f1a4dda7a$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $9ed9907f1a4dda7a$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $9ed9907f1a4dda7a$var$StrongRef;
var $9ed9907f1a4dda7a$var$UNTERMINATED = 0;
var $9ed9907f1a4dda7a$var$TERMINATED = 1;
function $9ed9907f1a4dda7a$var$createCacheNode() {
    return {
        s: $9ed9907f1a4dda7a$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $9ed9907f1a4dda7a$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $9ed9907f1a4dda7a$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $9ed9907f1a4dda7a$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $9ed9907f1a4dda7a$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $9ed9907f1a4dda7a$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $9ed9907f1a4dda7a$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $9ed9907f1a4dda7a$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $9ed9907f1a4dda7a$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $9ed9907f1a4dda7a$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $9ed9907f1a4dda7a$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $9ed9907f1a4dda7a$var$__spreadValues($9ed9907f1a4dda7a$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $9ed9907f1a4dda7a$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $9ed9907f1a4dda7a$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $9ed9907f1a4dda7a$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $9ed9907f1a4dda7a$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $9ed9907f1a4dda7a$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $9ed9907f1a4dda7a$export$595d22ed68ca2841 = /* @__PURE__ */ $9ed9907f1a4dda7a$export$5943f4447f6ef248($9ed9907f1a4dda7a$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $9ed9907f1a4dda7a$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $9ed9907f1a4dda7a$export$595d22ed68ca2841)=>{
    $9ed9907f1a4dda7a$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$9ed9907f1a4dda7a$export$75979cfcd91bf38f
});


// src/index.ts
function $7c2f93b225350c5e$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $7c2f93b225350c5e$export$dd164f5517779f15 = $7c2f93b225350c5e$var$createThunkMiddleware();
var $7c2f93b225350c5e$export$16d06542a1949d9e = $7c2f93b225350c5e$var$createThunkMiddleware;


var $6d3bbb1da5d24806$var$__defProp = Object.defineProperty;
var $6d3bbb1da5d24806$var$__defProps = Object.defineProperties;
var $6d3bbb1da5d24806$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $6d3bbb1da5d24806$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $6d3bbb1da5d24806$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $6d3bbb1da5d24806$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $6d3bbb1da5d24806$var$__defNormalProp = (obj, key, value)=>key in obj ? $6d3bbb1da5d24806$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $6d3bbb1da5d24806$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($6d3bbb1da5d24806$var$__hasOwnProp.call(b, prop)) $6d3bbb1da5d24806$var$__defNormalProp(a, prop, b[prop]);
    if ($6d3bbb1da5d24806$var$__getOwnPropSymbols) {
        for (var prop of $6d3bbb1da5d24806$var$__getOwnPropSymbols(b))if ($6d3bbb1da5d24806$var$__propIsEnum.call(b, prop)) $6d3bbb1da5d24806$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $6d3bbb1da5d24806$var$__spreadProps = (a, b)=>$6d3bbb1da5d24806$var$__defProps(a, $6d3bbb1da5d24806$var$__getOwnPropDescs(b));
var $6d3bbb1da5d24806$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($6d3bbb1da5d24806$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $6d3bbb1da5d24806$var$__getOwnPropSymbols) {
        for (var prop of $6d3bbb1da5d24806$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $6d3bbb1da5d24806$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $6d3bbb1da5d24806$var$__publicField = (obj, key, value)=>$6d3bbb1da5d24806$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $6d3bbb1da5d24806$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $9ed9907f1a4dda7a$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $3fcdd01f4bd90a60$export$541ac630993a4c84)(value) ? (0, $3fcdd01f4bd90a60$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $6d3bbb1da5d24806$export$a5d3c27355e35910 = /* @__PURE__ */ $6d3bbb1da5d24806$export$aab6de9e3dbb1473((0, $9ed9907f1a4dda7a$export$8402dc26d96f6902));
var $6d3bbb1da5d24806$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $876d8277641f3cc3$export$f672e0b6f7222cd7;
    return (0, $876d8277641f3cc3$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $6d3bbb1da5d24806$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $6d3bbb1da5d24806$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $6d3bbb1da5d24806$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(0));
            return $6d3bbb1da5d24806$var$__spreadValues($6d3bbb1da5d24806$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $876d8277641f3cc3$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $6d3bbb1da5d24806$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $6d3bbb1da5d24806$var$hasMatchFunction(action);
}
function $6d3bbb1da5d24806$export$ebd532f9034651f3(action) {
    return (0, $876d8277641f3cc3$export$b956e38827fca970)(action) && Object.keys(action).every($6d3bbb1da5d24806$var$isValidKey);
}
function $6d3bbb1da5d24806$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $6d3bbb1da5d24806$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $6d3bbb1da5d24806$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $6d3bbb1da5d24806$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $6d3bbb1da5d24806$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $6d3bbb1da5d24806$var$freezeDraftable(val) {
    return (0, $3fcdd01f4bd90a60$export$16e3aed3edb85946)(val) ? (0, $3fcdd01f4bd90a60$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $6d3bbb1da5d24806$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $6d3bbb1da5d24806$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $6d3bbb1da5d24806$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $6d3bbb1da5d24806$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $6d3bbb1da5d24806$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $6d3bbb1da5d24806$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $6d3bbb1da5d24806$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $6d3bbb1da5d24806$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $6d3bbb1da5d24806$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $6d3bbb1da5d24806$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $6d3bbb1da5d24806$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $876d8277641f3cc3$export$53b83ca8eaab0383)(val);
}
function $6d3bbb1da5d24806$export$ada5dca0b571bc7(value, path = "", isSerializable = $6d3bbb1da5d24806$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $6d3bbb1da5d24806$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $6d3bbb1da5d24806$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $6d3bbb1da5d24806$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$6d3bbb1da5d24806$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $6d3bbb1da5d24806$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $6d3bbb1da5d24806$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $6d3bbb1da5d24806$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $6d3bbb1da5d24806$export$1908877435b1d5e9();
        if (thunk) {
            if ($6d3bbb1da5d24806$var$isBoolean(thunk)) middlewareArray.push((0, $7c2f93b225350c5e$export$dd164f5517779f15));
            else middlewareArray.push((0, $7c2f93b225350c5e$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $6d3bbb1da5d24806$export$8fb31c0f05df007b = "RTK_autoBatch";
var $6d3bbb1da5d24806$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$6d3bbb1da5d24806$export$8fb31c0f05df007b]: true
            }
        });
var $6d3bbb1da5d24806$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $6d3bbb1da5d24806$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $6d3bbb1da5d24806$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $6d3bbb1da5d24806$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$6d3bbb1da5d24806$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $6d3bbb1da5d24806$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $6d3bbb1da5d24806$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($6d3bbb1da5d24806$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $6d3bbb1da5d24806$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $6d3bbb1da5d24806$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $876d8277641f3cc3$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $876d8277641f3cc3$export$66e4520cdb265d18)(reducer);
    else throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    let finalCompose = (0, $876d8277641f3cc3$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $6d3bbb1da5d24806$var$composeWithDevTools($6d3bbb1da5d24806$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $876d8277641f3cc3$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $6d3bbb1da5d24806$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $876d8277641f3cc3$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $6d3bbb1da5d24806$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $6d3bbb1da5d24806$var$isStateFunction(x) {
    return typeof x === "function";
}
function $6d3bbb1da5d24806$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $6d3bbb1da5d24806$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($6d3bbb1da5d24806$var$isStateFunction(initialState)) getInitialState = ()=>$6d3bbb1da5d24806$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $6d3bbb1da5d24806$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $3fcdd01f4bd90a60$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $3fcdd01f4bd90a60$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $3fcdd01f4bd90a60$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $6d3bbb1da5d24806$var$matches = (matcher, action)=>{
    if ($6d3bbb1da5d24806$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $6d3bbb1da5d24806$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$6d3bbb1da5d24806$var$matches(matcher, action));
    };
}
function $6d3bbb1da5d24806$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$6d3bbb1da5d24806$var$matches(matcher, action));
    };
}
function $6d3bbb1da5d24806$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $6d3bbb1da5d24806$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $6d3bbb1da5d24806$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$6d3bbb1da5d24806$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$6d3bbb1da5d24806$var$isAsyncThunkArray(asyncThunks)) return $6d3bbb1da5d24806$export$872dec21e9a69476()(asyncThunks[0]);
    return $6d3bbb1da5d24806$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $6d3bbb1da5d24806$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$6d3bbb1da5d24806$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$6d3bbb1da5d24806$var$isAsyncThunkArray(asyncThunks)) return $6d3bbb1da5d24806$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $6d3bbb1da5d24806$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $6d3bbb1da5d24806$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $6d3bbb1da5d24806$export$9dd1fb32974da385($6d3bbb1da5d24806$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$6d3bbb1da5d24806$var$isAsyncThunkArray(asyncThunks)) return $6d3bbb1da5d24806$export$fcc3388fb56de601()(asyncThunks[0]);
    return $6d3bbb1da5d24806$export$9dd1fb32974da385($6d3bbb1da5d24806$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $6d3bbb1da5d24806$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$6d3bbb1da5d24806$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$6d3bbb1da5d24806$var$isAsyncThunkArray(asyncThunks)) return $6d3bbb1da5d24806$export$1da80a6ef1307441()(asyncThunks[0]);
    return $6d3bbb1da5d24806$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $6d3bbb1da5d24806$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$6d3bbb1da5d24806$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$6d3bbb1da5d24806$var$isAsyncThunkArray(asyncThunks)) return $6d3bbb1da5d24806$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $6d3bbb1da5d24806$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $6d3bbb1da5d24806$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $6d3bbb1da5d24806$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $6d3bbb1da5d24806$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $6d3bbb1da5d24806$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $6d3bbb1da5d24806$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $6d3bbb1da5d24806$var$__publicField(this, "_type");
    }
};
var $6d3bbb1da5d24806$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $6d3bbb1da5d24806$var$__publicField(this, "_type");
    }
};
var $6d3bbb1da5d24806$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $6d3bbb1da5d24806$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $6d3bbb1da5d24806$var$externalAbortMessage = "External signal was aborted";
var $6d3bbb1da5d24806$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $6d3bbb1da5d24806$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $6d3bbb1da5d24806$var$__spreadProps($6d3bbb1da5d24806$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $6d3bbb1da5d24806$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $6d3bbb1da5d24806$var$__spreadProps($6d3bbb1da5d24806$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $6d3bbb1da5d24806$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $6d3bbb1da5d24806$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $6d3bbb1da5d24806$var$__spreadProps($6d3bbb1da5d24806$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $6d3bbb1da5d24806$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($6d3bbb1da5d24806$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($6d3bbb1da5d24806$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($6d3bbb1da5d24806$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $6d3bbb1da5d24806$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $6d3bbb1da5d24806$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $6d3bbb1da5d24806$var$RejectWithValue) throw result;
                                if (result instanceof $6d3bbb1da5d24806$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $6d3bbb1da5d24806$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($6d3bbb1da5d24806$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $6d3bbb1da5d24806$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $6d3bbb1da5d24806$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $6d3bbb1da5d24806$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $6d3bbb1da5d24806$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $6d3bbb1da5d24806$export$343355ed40c51c46 = {
    [$6d3bbb1da5d24806$var$asyncThunkSymbol]: $6d3bbb1da5d24806$export$6abd22dc03e5063f
};
var $6d3bbb1da5d24806$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($6d3bbb1da5d24806$export$23a094319a4b586 || {});
function $6d3bbb1da5d24806$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $6d3bbb1da5d24806$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$6d3bbb1da5d24806$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($6d3bbb1da5d24806$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $6d3bbb1da5d24806$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($6d3bbb1da5d24806$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $6d3bbb1da5d24806$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $6d3bbb1da5d24806$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $6d3bbb1da5d24806$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $6d3bbb1da5d24806$var$__spreadValues($6d3bbb1da5d24806$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $6d3bbb1da5d24806$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $6d3bbb1da5d24806$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $6d3bbb1da5d24806$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $6d3bbb1da5d24806$var$wrapSelector(selector, selectState, getInitialState, injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $6d3bbb1da5d24806$var$__spreadProps($6d3bbb1da5d24806$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $6d3bbb1da5d24806$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $6d3bbb1da5d24806$var$__spreadValues($6d3bbb1da5d24806$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $6d3bbb1da5d24806$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $6d3bbb1da5d24806$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $6d3bbb1da5d24806$export$affdea4146de9cf5();
function $6d3bbb1da5d24806$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $6d3bbb1da5d24806$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $6d3bbb1da5d24806$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$6d3bbb1da5d24806$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $6d3bbb1da5d24806$export$309c7a02b0b0bc62(type, prepareCallback) : $6d3bbb1da5d24806$export$309c7a02b0b0bc62(type));
}
function $6d3bbb1da5d24806$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $6d3bbb1da5d24806$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $6d3bbb1da5d24806$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $6d3bbb1da5d24806$var$noop,
        pending: pending || $6d3bbb1da5d24806$var$noop,
        rejected: rejected || $6d3bbb1da5d24806$var$noop,
        settled: settled || $6d3bbb1da5d24806$var$noop
    });
}
function $6d3bbb1da5d24806$var$noop() {}
// src/entities/entity_state.ts
function $6d3bbb1da5d24806$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $6d3bbb1da5d24806$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($6d3bbb1da5d24806$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $6d3bbb1da5d24806$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $6d3bbb1da5d24806$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $6d3bbb1da5d24806$var$isDraftTyped = (0, $3fcdd01f4bd90a60$export$541ac630993a4c84);
function $6d3bbb1da5d24806$var$createSingleArgumentStateOperator(mutator) {
    const operator = $6d3bbb1da5d24806$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $6d3bbb1da5d24806$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $6d3bbb1da5d24806$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($6d3bbb1da5d24806$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $3fcdd01f4bd90a60$export$b46cabe22e78bc00)(state, runMutator);
    };
}
function $6d3bbb1da5d24806$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $6d3bbb1da5d24806$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $6d3bbb1da5d24806$var$getCurrent(value) {
    return (0, $3fcdd01f4bd90a60$export$541ac630993a4c84)(value) ? (0, $3fcdd01f4bd90a60$export$97aac956da55dae9)(value) : value;
}
function $6d3bbb1da5d24806$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $6d3bbb1da5d24806$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $6d3bbb1da5d24806$var$selectIdValue(entity, selectId);
        if (existingIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $6d3bbb1da5d24806$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $6d3bbb1da5d24806$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $6d3bbb1da5d24806$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $6d3bbb1da5d24806$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $6d3bbb1da5d24806$var$__spreadValues($6d3bbb1da5d24806$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$6d3bbb1da5d24806$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $6d3bbb1da5d24806$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $6d3bbb1da5d24806$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $6d3bbb1da5d24806$var$createStateOperator(addOneMutably),
        addMany: $6d3bbb1da5d24806$var$createStateOperator(addManyMutably),
        setOne: $6d3bbb1da5d24806$var$createStateOperator(setOneMutably),
        setMany: $6d3bbb1da5d24806$var$createStateOperator(setManyMutably),
        setAll: $6d3bbb1da5d24806$var$createStateOperator(setAllMutably),
        updateOne: $6d3bbb1da5d24806$var$createStateOperator(updateOneMutably),
        updateMany: $6d3bbb1da5d24806$var$createStateOperator(updateManyMutably),
        upsertOne: $6d3bbb1da5d24806$var$createStateOperator(upsertOneMutably),
        upsertMany: $6d3bbb1da5d24806$var$createStateOperator(upsertManyMutably),
        removeOne: $6d3bbb1da5d24806$var$createStateOperator(removeOneMutably),
        removeMany: $6d3bbb1da5d24806$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $6d3bbb1da5d24806$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $6d3bbb1da5d24806$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $6d3bbb1da5d24806$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $6d3bbb1da5d24806$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $6d3bbb1da5d24806$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $6d3bbb1da5d24806$var$getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has($6d3bbb1da5d24806$var$selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $6d3bbb1da5d24806$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $6d3bbb1da5d24806$var$getCurrent(state.entities);
        const currentIds = $6d3bbb1da5d24806$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $6d3bbb1da5d24806$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $6d3bbb1da5d24806$var$createStateOperator(addOneMutably),
        updateOne: $6d3bbb1da5d24806$var$createStateOperator(updateOneMutably),
        upsertOne: $6d3bbb1da5d24806$var$createStateOperator(upsertOneMutably),
        setOne: $6d3bbb1da5d24806$var$createStateOperator(setOneMutably),
        setMany: $6d3bbb1da5d24806$var$createStateOperator(setManyMutably),
        setAll: $6d3bbb1da5d24806$var$createStateOperator(setAllMutably),
        addMany: $6d3bbb1da5d24806$var$createStateOperator(addManyMutably),
        updateMany: $6d3bbb1da5d24806$var$createStateOperator(updateManyMutably),
        upsertMany: $6d3bbb1da5d24806$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $6d3bbb1da5d24806$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $6d3bbb1da5d24806$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $6d3bbb1da5d24806$var$createSortedStateAdapter(selectId, sortComparer) : $6d3bbb1da5d24806$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $6d3bbb1da5d24806$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $6d3bbb1da5d24806$var$createSelectorsFactory();
    return $6d3bbb1da5d24806$var$__spreadValues($6d3bbb1da5d24806$var$__spreadValues($6d3bbb1da5d24806$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $6d3bbb1da5d24806$var$task = "task";
var $6d3bbb1da5d24806$var$listener = "listener";
var $6d3bbb1da5d24806$var$completed = "completed";
var $6d3bbb1da5d24806$var$cancelled = "cancelled";
var $6d3bbb1da5d24806$var$taskCancelled = `task-${$6d3bbb1da5d24806$var$cancelled}`;
var $6d3bbb1da5d24806$var$taskCompleted = `task-${$6d3bbb1da5d24806$var$completed}`;
var $6d3bbb1da5d24806$var$listenerCancelled = `${$6d3bbb1da5d24806$var$listener}-${$6d3bbb1da5d24806$var$cancelled}`;
var $6d3bbb1da5d24806$var$listenerCompleted = `${$6d3bbb1da5d24806$var$listener}-${$6d3bbb1da5d24806$var$completed}`;
var $6d3bbb1da5d24806$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $6d3bbb1da5d24806$var$__publicField(this, "name", "TaskAbortError");
        $6d3bbb1da5d24806$var$__publicField(this, "message");
        this.message = `${$6d3bbb1da5d24806$var$task} ${$6d3bbb1da5d24806$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $6d3bbb1da5d24806$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($6d3bbb1da5d24806$export$378fa86b259c0280(32));
};
var $6d3bbb1da5d24806$var$noop2 = ()=>{};
var $6d3bbb1da5d24806$var$catchRejection = (promise, onError = $6d3bbb1da5d24806$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $6d3bbb1da5d24806$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $6d3bbb1da5d24806$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $6d3bbb1da5d24806$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $6d3bbb1da5d24806$export$cb1bdac908fed7f(reason);
    }
};
function $6d3bbb1da5d24806$var$raceWithSignal(signal, promise) {
    let cleanup = $6d3bbb1da5d24806$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $6d3bbb1da5d24806$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $6d3bbb1da5d24806$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $6d3bbb1da5d24806$var$noop2;
    });
}
var $6d3bbb1da5d24806$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $6d3bbb1da5d24806$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $6d3bbb1da5d24806$var$createPause = (signal)=>{
    return (promise)=>{
        return $6d3bbb1da5d24806$var$catchRejection($6d3bbb1da5d24806$var$raceWithSignal(signal, promise).then((output)=>{
            $6d3bbb1da5d24806$var$validateActive(signal);
            return output;
        }));
    };
};
var $6d3bbb1da5d24806$var$createDelay = (signal)=>{
    const pause = $6d3bbb1da5d24806$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $6d3bbb1da5d24806$var$assign } = Object;
var $6d3bbb1da5d24806$var$INTERNAL_NIL_TOKEN = {};
var $6d3bbb1da5d24806$var$alm = "listenerMiddleware";
var $6d3bbb1da5d24806$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$6d3bbb1da5d24806$var$addAbortSignalListener(parentAbortSignal, ()=>$6d3bbb1da5d24806$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $6d3bbb1da5d24806$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $6d3bbb1da5d24806$var$runTask(async ()=>{
            $6d3bbb1da5d24806$var$validateActive(parentAbortSignal);
            $6d3bbb1da5d24806$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $6d3bbb1da5d24806$var$createPause(childAbortController.signal),
                delay: $6d3bbb1da5d24806$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $6d3bbb1da5d24806$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$6d3bbb1da5d24806$var$abortControllerWithReason(childAbortController, $6d3bbb1da5d24806$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($6d3bbb1da5d24806$var$noop2));
        return {
            result: $6d3bbb1da5d24806$var$createPause(parentAbortSignal)(result),
            cancel () {
                $6d3bbb1da5d24806$var$abortControllerWithReason(childAbortController, $6d3bbb1da5d24806$var$taskCancelled);
            }
        };
    };
};
var $6d3bbb1da5d24806$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $6d3bbb1da5d24806$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $6d3bbb1da5d24806$var$raceWithSignal(signal, Promise.race(promises));
            $6d3bbb1da5d24806$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$6d3bbb1da5d24806$var$catchRejection(take(predicate, timeout));
};
var $6d3bbb1da5d24806$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $6d3bbb1da5d24806$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(21));
    $6d3bbb1da5d24806$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $6d3bbb1da5d24806$var$createListenerEntry = /* @__PURE__ */ $6d3bbb1da5d24806$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $6d3bbb1da5d24806$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $6d3bbb1da5d24806$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$6d3bbb1da5d24806$var$createListenerEntry
});
var $6d3bbb1da5d24806$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $6d3bbb1da5d24806$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $6d3bbb1da5d24806$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $6d3bbb1da5d24806$var$abortControllerWithReason(controller, $6d3bbb1da5d24806$var$listenerCancelled);
    });
};
var $6d3bbb1da5d24806$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($6d3bbb1da5d24806$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $6d3bbb1da5d24806$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $6d3bbb1da5d24806$export$f03a6b845d3fb58b = /* @__PURE__ */ $6d3bbb1da5d24806$var$assign(/* @__PURE__ */ $6d3bbb1da5d24806$export$309c7a02b0b0bc62(`${$6d3bbb1da5d24806$var$alm}/add`), {
    withTypes: ()=>$6d3bbb1da5d24806$export$f03a6b845d3fb58b
});
var $6d3bbb1da5d24806$export$b1b8022855fb2b71 = /* @__PURE__ */ $6d3bbb1da5d24806$export$309c7a02b0b0bc62(`${$6d3bbb1da5d24806$var$alm}/removeAll`);
var $6d3bbb1da5d24806$export$b03e9483f936dccb = /* @__PURE__ */ $6d3bbb1da5d24806$var$assign(/* @__PURE__ */ $6d3bbb1da5d24806$export$309c7a02b0b0bc62(`${$6d3bbb1da5d24806$var$alm}/remove`), {
    withTypes: ()=>$6d3bbb1da5d24806$export$b03e9483f936dccb
});
var $6d3bbb1da5d24806$var$defaultErrorHandler = (...args)=>{
    console.error(`${$6d3bbb1da5d24806$var$alm}/error`, ...args);
};
var $6d3bbb1da5d24806$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $6d3bbb1da5d24806$var$defaultErrorHandler } = middlewareOptions;
    $6d3bbb1da5d24806$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $6d3bbb1da5d24806$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $6d3bbb1da5d24806$var$findListenerEntry(listenerMap, options)) != null ? _a : $6d3bbb1da5d24806$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $6d3bbb1da5d24806$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $6d3bbb1da5d24806$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $6d3bbb1da5d24806$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $6d3bbb1da5d24806$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $6d3bbb1da5d24806$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $6d3bbb1da5d24806$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $6d3bbb1da5d24806$var$createDelay(internalTaskController.signal),
                pause: $6d3bbb1da5d24806$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $6d3bbb1da5d24806$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $6d3bbb1da5d24806$var$abortControllerWithReason(controller, $6d3bbb1da5d24806$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $6d3bbb1da5d24806$var$abortControllerWithReason(internalTaskController, $6d3bbb1da5d24806$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $6d3bbb1da5d24806$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $6d3bbb1da5d24806$export$cb1bdac908fed7f)) $6d3bbb1da5d24806$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $6d3bbb1da5d24806$var$abortControllerWithReason(internalTaskController, $6d3bbb1da5d24806$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $6d3bbb1da5d24806$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $876d8277641f3cc3$export$b956e38827fca970)(action)) return next(action);
                if ($6d3bbb1da5d24806$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($6d3bbb1da5d24806$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($6d3bbb1da5d24806$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $6d3bbb1da5d24806$var$INTERNAL_NIL_TOKEN) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $6d3bbb1da5d24806$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $6d3bbb1da5d24806$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $6d3bbb1da5d24806$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $6d3bbb1da5d24806$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $6d3bbb1da5d24806$export$4bb1606a79445586 = ()=>{
    const instanceId = $6d3bbb1da5d24806$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($6d3bbb1da5d24806$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $6d3bbb1da5d24806$var$getOrInsertComputed(middlewareMap, middleware2, $6d3bbb1da5d24806$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$6d3bbb1da5d24806$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $876d8277641f3cc3$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $6d3bbb1da5d24806$export$9dd1fb32974da385(withMiddleware, $6d3bbb1da5d24806$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $6d3bbb1da5d24806$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $6d3bbb1da5d24806$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$6d3bbb1da5d24806$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $6d3bbb1da5d24806$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $6d3bbb1da5d24806$var$isStateProxy = (value)=>!!value && !!value[$6d3bbb1da5d24806$var$ORIGINAL_STATE];
var $6d3bbb1da5d24806$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $6d3bbb1da5d24806$var$createStateProxy = (state, reducerMap)=>$6d3bbb1da5d24806$var$getOrInsertComputed($6d3bbb1da5d24806$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $6d3bbb1da5d24806$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const reducer = reducerMap[prop.toString()];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $6d3bbb1da5d24806$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(24));
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $6d3bbb1da5d24806$var$original = (state)=>{
    if (!$6d3bbb1da5d24806$var$isStateProxy(state)) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(25));
    return state[$6d3bbb1da5d24806$var$ORIGINAL_STATE];
};
var $6d3bbb1da5d24806$var$noopReducer = (state = {})=>state;
function $6d3bbb1da5d24806$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($6d3bbb1da5d24806$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $876d8277641f3cc3$export$66e4520cdb265d18)(reducerMap) : $6d3bbb1da5d24806$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($6d3bbb1da5d24806$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $6d3bbb1da5d24806$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $6d3bbb1da5d24806$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


const $aa17040ca94f7895$var$findItem = (items, id)=>items.find((item)=>item.card.info.id === id);
const $aa17040ca94f7895$var$cartSlice = (0, $6d3bbb1da5d24806$export$4d8d9bd83c24ae8b)({
    name: "cart",
    initialState: {
        items: []
    },
    reducers: {
        addItem: (state, action)=>{
            const id = action.payload?.card?.info?.id;
            const existing = $aa17040ca94f7895$var$findItem(state.items, id);
            if (existing) existing.quantity += 1;
            else state.items.push({
                ...action.payload,
                quantity: 1
            });
        },
        removeItem: (state, action)=>{
            state.items = state.items.filter((item)=>item.card.info.id !== action.payload);
        },
        incrementQuantity: (state, action)=>{
            const item = $aa17040ca94f7895$var$findItem(state.items, action.payload);
            if (item) item.quantity += 1;
        },
        decrementQuantity: (state, action)=>{
            const item = $aa17040ca94f7895$var$findItem(state.items, action.payload);
            if (!item) return;
            if (item.quantity <= 1) state.items = state.items.filter((i)=>i.card.info.id !== action.payload);
            else item.quantity -= 1;
        },
        clearCart: (state)=>{
            state.items.length = 0;
        }
    }
});
const { addItem: $aa17040ca94f7895$export$fb9705de59d96855, removeItem: $aa17040ca94f7895$export$fe2d9b4e03920b4c, incrementQuantity: $aa17040ca94f7895$export$992d1dcfb85ffd46, decrementQuantity: $aa17040ca94f7895$export$f7f4b3ebb8c96d1d, clearCart: $aa17040ca94f7895$export$810121176e3e3671 } = $aa17040ca94f7895$var$cartSlice.actions;
var $aa17040ca94f7895$export$2e2bcd8739ae039 = $aa17040ca94f7895$var$cartSlice.reducer;


const $3566844ce298d87b$var$ratingColor = (rating)=>{
    if (rating >= 4.3) return 'var(--bs-success)';
    if (rating >= 3.8) return 'var(--bs-warn)';
    return 'var(--bs-danger)';
};
const $3566844ce298d87b$var$ItemList = ({ items: items })=>{
    const dispatch = (0, $99aed3ab2dc6c7d9$export$8ad76b76a4c905f8)();
    const cartItems = (0, $99aed3ab2dc6c7d9$export$2105062e25df4afe)((store)=>store.cart.items);
    const getQuantity = (id)=>cartItems.find((c)=>c.card.info.id === id)?.quantity || 0;
    return /*#__PURE__*/ (0, $jk232.jsx)("div", {
        className: "menu-item-list",
        children: items.map((item)=>{
            const { id: id, name: name, price: price, defaultPrice: defaultPrice, ratings: ratings, imageId: imageId, description: description, itemAttribute: itemAttribute, ribbon: ribbon } = item.card.info;
            const rating = ratings?.aggregatedRating?.rating;
            const ratingCount = ratings?.aggregatedRating?.ratingCountV2;
            const isVeg = itemAttribute?.vegClassifier === 'VEG';
            const quantity = getQuantity(id);
            return /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "menu-items",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "left",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "menu-item-name-row",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        className: `veg-indicator ${isVeg ? 'veg-indicator--veg' : 'veg-indicator--nonveg'}`,
                                        title: isVeg ? 'Veg' : 'Non-veg'
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                                        children: name
                                    }),
                                    ribbon?.text && /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        className: "menu-item-badge",
                                        children: ribbon.text
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)("h4", {
                                children: [
                                    "\u20B9",
                                    (price ?? defaultPrice ?? 0) / 100
                                ]
                            }),
                            description && /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                children: description.slice(0, 140)
                            }),
                            rating && /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "rating",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsx)((0, $3c2a7fc58561546e$export$2e2bcd8739ae039), {
                                        size: 13,
                                        fill: "currentColor",
                                        style: {
                                            color: $3566844ce298d87b$var$ratingColor(rating)
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                        children: [
                                            rating,
                                            ratingCount ? ` (${ratingCount})` : ''
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "right",
                        children: [
                            imageId && /*#__PURE__*/ (0, $jk232.jsx)("img", {
                                src: imageId.startsWith('http') ? imageId : (0, $d39effcf12df3fc5$export$3c67ec6258c4a827) + imageId,
                                alt: name
                            }),
                            quantity > 0 ? /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "qty-stepper",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsx)("button", {
                                        onClick: ()=>dispatch((0, $aa17040ca94f7895$export$f7f4b3ebb8c96d1d)(id)),
                                        "aria-label": "Decrease quantity",
                                        children: "\u2212"
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        children: quantity
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsx)("button", {
                                        onClick: ()=>dispatch((0, $aa17040ca94f7895$export$992d1dcfb85ffd46)(id)),
                                        "aria-label": "Increase quantity",
                                        children: "+"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $jk232.jsx)("button", {
                                className: "add-btn",
                                onClick: ()=>dispatch((0, $aa17040ca94f7895$export$fb9705de59d96855)(item)),
                                children: "ADD"
                            })
                        ]
                    })
                ]
            }, id);
        })
    });
};
var $3566844ce298d87b$export$2e2bcd8739ae039 = $3566844ce298d87b$var$ItemList;


/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $bfd72f55fc35ed94$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
const $bfd72f55fc35ed94$export$2e2bcd8739ae039 = (0, $e81754e696bcea24$export$2e2bcd8739ae039)("chevron-down", $bfd72f55fc35ed94$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $593c26003cb7737c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m18 15-6-6-6 6",
            key: "153udz"
        }
    ]
];
const $593c26003cb7737c$export$2e2bcd8739ae039 = (0, $e81754e696bcea24$export$2e2bcd8739ae039)("chevron-up", $593c26003cb7737c$export$3efd853dbb351e94);


const $fc5f1f7c7a60f123$var$RestaurantCategory = ({ data: data, showItems: showItems, setShowIndex: setShowIndex, forceOpen: forceOpen = false })=>{
    const isOpen = forceOpen || showItems;
    return /*#__PURE__*/ (0, $jk232.jsxs)("div", {
        className: "menu-category",
        children: [
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: `menu-category-header ${forceOpen ? 'menu-category-header--static' : ''}`,
                onClick: forceOpen ? undefined : setShowIndex,
                children: [
                    /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                        className: "menu-category-title",
                        children: [
                            data?.title?.slice(0, 40),
                            /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                className: "menu-category-count",
                                children: [
                                    "(",
                                    data?.itemCards?.length,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    !forceOpen && /*#__PURE__*/ (0, $jk232.jsx)("span", {
                        className: "menu-category-arrow",
                        children: isOpen ? /*#__PURE__*/ (0, $jk232.jsx)((0, $593c26003cb7737c$export$2e2bcd8739ae039), {
                            size: 20
                        }) : /*#__PURE__*/ (0, $jk232.jsx)((0, $bfd72f55fc35ed94$export$2e2bcd8739ae039), {
                            size: 20
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $jk232.jsx)((0, $3566844ce298d87b$export$2e2bcd8739ae039), {
                items: data?.itemCards
            })
        ]
    });
};
var $fc5f1f7c7a60f123$export$2e2bcd8739ae039 = $fc5f1f7c7a60f123$var$RestaurantCategory;



var $4RFnf = parcelRequire("4RFnf");

const $9fce8677a912ffae$var$FALLBACK_IMAGE = 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200&q=80';
const $9fce8677a912ffae$var$ratingColor = (rating)=>{
    if (rating >= 4.3) return 'var(--bs-success)';
    if (rating >= 3.8) return 'var(--bs-warn)';
    return 'var(--bs-danger)';
};
const $9fce8677a912ffae$var$RestaurantMenu = ()=>{
    const { resId: resId } = (0, $3W4eU.useParams)();
    const navigate = (0, $3W4eU.useNavigate)();
    const resInfo = (0, $cd789a687638562c$export$2e2bcd8739ae039)(resId);
    const [showIndex, setShowIndex] = (0, $4RFnf.useState)(0);
    const [searchText, setSearchText] = (0, $4RFnf.useState)('');
    const [vegOnly, setVegOnly] = (0, $4RFnf.useState)(false);
    const [bestsellerOnly, setBestsellerOnly] = (0, $4RFnf.useState)(false);
    if (resInfo === null) return /*#__PURE__*/ (0, $jk232.jsx)((0, $7967c36430cc139a$export$2e2bcd8739ae039), {});
    const { cloudinaryImageId: cloudinaryImageId, name: name, areaName: areaName, avgRating: avgRating, totalRatingsString: totalRatingsString, costForTwoMessage: costForTwoMessage, cuisines: cuisines, sla: sla } = resInfo?.cards[2]?.card?.card?.info || {};
    const cards = resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards || [];
    const categories = cards.filter((c)=>c?.card?.['card']?.['@type'] === 'type.googleapis.com/swiggy.presentation.food.v2.ItemCategory');
    const rating = avgRating ?? 3.8;
    const heroImage = cloudinaryImageId?.startsWith('http') ? cloudinaryImageId : (0, $d39effcf12df3fc5$export$3c67ec6258c4a827) + cloudinaryImageId;
    // ── Search / veg / bestseller filtering ─────────────────────────────
    const hasActiveFilters = searchText.trim() || vegOnly || bestsellerOnly;
    const itemMatchesFilters = (item)=>{
        const info = item?.card?.info;
        if (!info) return false;
        if (vegOnly && info.itemAttribute?.vegClassifier !== 'VEG') return false;
        if (bestsellerOnly && !info.ribbon?.text) return false;
        if (searchText.trim() && !info.name?.toLowerCase().includes(searchText.trim().toLowerCase())) return false;
        return true;
    };
    const filteredCategories = categories.map((category)=>({
            category: category,
            items: (category?.card?.card?.itemCards || []).filter(itemMatchesFilters)
        })).filter(({ items: items })=>items.length > 0);
    return /*#__PURE__*/ (0, $jk232.jsxs)("div", {
        className: "restaurant-page",
        children: [
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "menu-breadcrumb",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsx)((0, $eGOwh.Link), {
                        to: "/",
                        children: "Home"
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                        className: "breadcrumb-sep",
                        children: "/"
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("section", {
                className: "menu-hero",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "menu-hero-media",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)("img", {
                                src: heroImage,
                                alt: name,
                                onError: (e)=>{
                                    e.target.onerror = null;
                                    e.target.src = $9fce8677a912ffae$var$FALLBACK_IMAGE;
                                }
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("div", {
                                className: "menu-hero-scrim"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("button", {
                        className: "menu-hero-back",
                        onClick: ()=>navigate(-1),
                        "aria-label": "Go back",
                        children: /*#__PURE__*/ (0, $jk232.jsx)((0, $490d40a9708f8873$export$2e2bcd8739ae039), {
                            size: 18
                        })
                    }),
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "menu-hero-content",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)("h1", {
                                children: name
                            }),
                            areaName && /*#__PURE__*/ (0, $jk232.jsxs)("p", {
                                className: "menu-hero-area",
                                children: [
                                    "\uD83D\uDCCD ",
                                    areaName
                                ]
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "menu-hero-info",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                        className: "rating",
                                        children: [
                                            /*#__PURE__*/ (0, $jk232.jsx)((0, $3c2a7fc58561546e$export$2e2bcd8739ae039), {
                                                size: 14,
                                                fill: "currentColor",
                                                style: {
                                                    color: $9fce8677a912ffae$var$ratingColor(rating)
                                                }
                                            }),
                                            rating,
                                            " (",
                                            totalRatingsString || '1K+ ratings',
                                            ")"
                                        ]
                                    }),
                                    costForTwoMessage && /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                        children: [
                                            "\xb7 ",
                                            costForTwoMessage
                                        ]
                                    }),
                                    sla?.slaString && /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                        children: [
                                            "\xb7 \u23F3 ",
                                            sla.slaString
                                        ]
                                    })
                                ]
                            }),
                            cuisines?.length > 0 && /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                className: "menu-hero-cuisines",
                                children: cuisines.join(', ')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "restaurant-container",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "menu-toolbar",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "menu-search",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsx)((0, $3f6b251a61adee8c$export$2e2bcd8739ae039), {
                                        size: 16
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsx)("input", {
                                        type: "text",
                                        placeholder: "Search for dishes",
                                        value: searchText,
                                        onChange: (e)=>setSearchText(e.target.value)
                                    }),
                                    searchText && /*#__PURE__*/ (0, $jk232.jsx)("button", {
                                        className: "menu-search-clear",
                                        onClick: ()=>setSearchText(''),
                                        "aria-label": "Clear search",
                                        children: /*#__PURE__*/ (0, $jk232.jsx)((0, $ee865572a14312f4$export$2e2bcd8739ae039), {
                                            size: 15
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "menu-filter-chips",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsxs)("button", {
                                        className: `menu-filter-chip ${vegOnly ? 'active' : ''}`,
                                        onClick: ()=>setVegOnly((v)=>!v),
                                        children: [
                                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                className: "veg-indicator veg-indicator--veg"
                                            }),
                                            "Veg only"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsx)("button", {
                                        className: `menu-filter-chip ${bestsellerOnly ? 'active' : ''}`,
                                        onClick: ()=>setBestsellerOnly((v)=>!v),
                                        children: "\uD83D\uDD25 Bestseller"
                                    })
                                ]
                            })
                        ]
                    }),
                    hasActiveFilters ? filteredCategories.length === 0 ? /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "menu-no-results",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                children: "\uD83C\uDF7D\uFE0F"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                children: "No dishes match your filters."
                            })
                        ]
                    }) : filteredCategories.map(({ category: category, items: items })=>/*#__PURE__*/ (0, $jk232.jsx)((0, $fc5f1f7c7a60f123$export$2e2bcd8739ae039), {
                            data: {
                                ...category.card.card,
                                itemCards: items
                            },
                            forceOpen: true
                        }, category?.card?.card?.title)) : categories.map((category, index)=>/*#__PURE__*/ (0, $jk232.jsx)((0, $fc5f1f7c7a60f123$export$2e2bcd8739ae039), {
                            data: category?.card?.card,
                            showItems: index === showIndex,
                            setShowIndex: ()=>setShowIndex(index === showIndex ? null : index)
                        }, category?.card?.card?.title))
                ]
            })
        ]
    });
};
var $9fce8677a912ffae$export$2e2bcd8739ae039 = $9fce8677a912ffae$var$RestaurantMenu;



var $4RFnf = parcelRequire("4RFnf");
const $b82f5bc1455b2c3b$var$UserContext = /*#__PURE__*/ (0, $4RFnf.createContext)({
    loggedInUser: "Default User"
});
var $b82f5bc1455b2c3b$export$2e2bcd8739ae039 = $b82f5bc1455b2c3b$var$UserContext;





const $fe6c2c553256b578$var$appStore = (0, $6d3bbb1da5d24806$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $aa17040ca94f7895$export$2e2bcd8739ae039)
    }
});
var $fe6c2c553256b578$export$2e2bcd8739ae039 = $fe6c2c553256b578$var$appStore;



var $jk232 = parcelRequire("jk232");

var $4RFnf = parcelRequire("4RFnf");


var $eGOwh = parcelRequire("eGOwh");



const $97a68d5db2fe50bd$var$DELIVERY_FEE = 40;
const $97a68d5db2fe50bd$var$PLATFORM_FEE = 6;
const $97a68d5db2fe50bd$var$GST_RATE = 0.05;
const $97a68d5db2fe50bd$var$COUPONS = {
    BITESWIFT20: {
        discount: (subtotal)=>subtotal >= 200 ? 20 : 0,
        minOrder: 200
    },
    FREEDEL: {
        discount: ()=>0,
        freeDelivery: true
    }
};
const $97a68d5db2fe50bd$var$PAYMENT_METHODS = [
    {
        id: 'upi',
        label: 'UPI',
        icon: "\uD83D\uDCF1"
    },
    {
        id: 'card',
        label: 'Card',
        icon: "\uD83D\uDCB3"
    },
    {
        id: 'cod',
        label: 'Cash on Delivery',
        icon: "\uD83D\uDCB5"
    }
];
const $97a68d5db2fe50bd$var$generateOrderId = ()=>`#BS${Math.floor(100000 + Math.random() * 900000)}`;
const $97a68d5db2fe50bd$var$randomEta = ()=>`${25 + Math.floor(Math.random() * 15)}-${40 + Math.floor(Math.random() * 10)} mins`;
const $97a68d5db2fe50bd$var$Cart = ()=>{
    const cartItems = (0, $99aed3ab2dc6c7d9$export$2105062e25df4afe)((store)=>store.cart.items);
    const dispatch = (0, $99aed3ab2dc6c7d9$export$8ad76b76a4c905f8)();
    const [couponInput, setCouponInput] = (0, $4RFnf.useState)('');
    const [appliedCoupon, setAppliedCoupon] = (0, $4RFnf.useState)(null);
    const [couponError, setCouponError] = (0, $4RFnf.useState)('');
    const [paymentMethod, setPaymentMethod] = (0, $4RFnf.useState)('upi');
    const [isPlacingOrder, setIsPlacingOrder] = (0, $4RFnf.useState)(false);
    const [order, setOrder] = (0, $4RFnf.useState)(null);
    const subtotal = cartItems.reduce((sum, item)=>{
        const price = (item.card.info.price ?? item.card.info.defaultPrice ?? 0) / 100;
        return sum + price * item.quantity;
    }, 0);
    const gst = subtotal * $97a68d5db2fe50bd$var$GST_RATE;
    const coupon = appliedCoupon ? $97a68d5db2fe50bd$var$COUPONS[appliedCoupon] : null;
    const discount = coupon ? coupon.discount(subtotal) : 0;
    const deliveryFee = coupon?.freeDelivery ? 0 : $97a68d5db2fe50bd$var$DELIVERY_FEE;
    const total = subtotal + gst + deliveryFee + $97a68d5db2fe50bd$var$PLATFORM_FEE - discount;
    const handleApplyCoupon = ()=>{
        const code = couponInput.trim().toUpperCase();
        if (!code) return;
        const found = $97a68d5db2fe50bd$var$COUPONS[code];
        if (!found) {
            setCouponError('Invalid coupon code');
            return;
        }
        if (found.minOrder && subtotal < found.minOrder) {
            setCouponError(`Add \u{20B9}${(found.minOrder - subtotal).toFixed(0)} more to use this code`);
            return;
        }
        setAppliedCoupon(code);
        setCouponError('');
    };
    const handleRemoveCoupon = ()=>{
        setAppliedCoupon(null);
        setCouponInput('');
        setCouponError('');
    };
    const handlePlaceOrder = ()=>{
        setIsPlacingOrder(true);
        setTimeout(()=>{
            setOrder({
                id: $97a68d5db2fe50bd$var$generateOrderId(),
                items: cartItems,
                total: total,
                paymentMethod: paymentMethod,
                eta: $97a68d5db2fe50bd$var$randomEta()
            });
            dispatch((0, $aa17040ca94f7895$export$810121176e3e3671)());
            setIsPlacingOrder(false);
        }, 1400);
    };
    if (order) return /*#__PURE__*/ (0, $jk232.jsxs)("div", {
        className: "cart-status",
        children: [
            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                className: "cart-status-icon",
                children: "\uD83C\uDF89"
            }),
            /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                children: "Order placed!"
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("p", {
                className: "cart-order-id",
                children: [
                    "Order ",
                    order.id
                ]
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("p", {
                children: [
                    "Arriving in ",
                    /*#__PURE__*/ (0, $jk232.jsx)("strong", {
                        children: order.eta
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "order-receipt",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsx)("h3", {
                        children: "Order summary"
                    }),
                    order.items.map((item)=>/*#__PURE__*/ (0, $jk232.jsxs)("div", {
                            className: "order-receipt-row",
                            children: [
                                /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                    children: [
                                        item.quantity,
                                        " \xd7 ",
                                        item.card.info.name
                                    ]
                                }),
                                /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                    children: [
                                        "\u20B9",
                                        ((item.card.info.price ?? item.card.info.defaultPrice ?? 0) / 100 * item.quantity).toFixed(0)
                                    ]
                                })
                            ]
                        }, item.card.info.id)),
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "order-receipt-row order-receipt-total",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                children: "Total paid"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                children: [
                                    "\u20B9",
                                    order.total.toFixed(0)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsxs)("p", {
                        className: "order-payment-method",
                        children: [
                            "Paid via ",
                            $97a68d5db2fe50bd$var$PAYMENT_METHODS.find((p)=>p.id === order.paymentMethod)?.label
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jk232.jsx)((0, $eGOwh.Link), {
                to: "/",
                className: "cart-cta",
                children: "Back to home"
            })
        ]
    });
    if (cartItems.length === 0) return /*#__PURE__*/ (0, $jk232.jsxs)("div", {
        className: "cart-status",
        children: [
            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                className: "cart-status-icon",
                children: "\uD83D\uDED2"
            }),
            /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                children: "Your cart is empty"
            }),
            /*#__PURE__*/ (0, $jk232.jsx)("p", {
                children: "Looks like you haven't added anything yet."
            }),
            /*#__PURE__*/ (0, $jk232.jsx)((0, $eGOwh.Link), {
                to: "/",
                className: "cart-cta",
                children: "Browse restaurants"
            })
        ]
    });
    return /*#__PURE__*/ (0, $jk232.jsxs)("div", {
        className: "cart-page",
        children: [
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "cart-header",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsx)("h1", {
                        children: "Your Cart"
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("button", {
                        className: "cart-clear-btn",
                        onClick: ()=>dispatch((0, $aa17040ca94f7895$export$810121176e3e3671)()),
                        children: "Clear cart"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "cart-body",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "cart-main",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)("div", {
                                className: "cart-items",
                                children: cartItems.map((item)=>{
                                    const { id: id, name: name, price: price, defaultPrice: defaultPrice, imageId: imageId, description: description } = item.card.info;
                                    const unitPrice = (price ?? defaultPrice ?? 0) / 100;
                                    return /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                        className: "cart-item",
                                        children: [
                                            imageId && /*#__PURE__*/ (0, $jk232.jsx)("img", {
                                                className: "cart-item-img",
                                                src: imageId.startsWith('http') ? imageId : (0, $d39effcf12df3fc5$export$3c67ec6258c4a827) + imageId,
                                                alt: name
                                            }),
                                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                                className: "cart-item-info",
                                                children: [
                                                    /*#__PURE__*/ (0, $jk232.jsx)("h3", {
                                                        children: name
                                                    }),
                                                    description && /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                                        children: description.slice(0, 90)
                                                    }),
                                                    /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                                        className: "cart-item-price",
                                                        children: [
                                                            "\u20B9",
                                                            unitPrice
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                                className: "cart-item-actions",
                                                children: [
                                                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                                        className: "qty-stepper",
                                                        children: [
                                                            /*#__PURE__*/ (0, $jk232.jsx)("button", {
                                                                onClick: ()=>dispatch((0, $aa17040ca94f7895$export$f7f4b3ebb8c96d1d)(id)),
                                                                "aria-label": "Decrease quantity",
                                                                children: "\u2212"
                                                            }),
                                                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                                children: item.quantity
                                                            }),
                                                            /*#__PURE__*/ (0, $jk232.jsx)("button", {
                                                                onClick: ()=>dispatch((0, $aa17040ca94f7895$export$992d1dcfb85ffd46)(id)),
                                                                "aria-label": "Increase quantity",
                                                                children: "+"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $jk232.jsx)("button", {
                                                        className: "cart-remove-btn",
                                                        onClick: ()=>dispatch((0, $aa17040ca94f7895$export$fe2d9b4e03920b4c)(id)),
                                                        children: "Remove"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                                className: "cart-item-subtotal",
                                                children: [
                                                    "\u20B9",
                                                    (unitPrice * item.quantity).toFixed(0)
                                                ]
                                            })
                                        ]
                                    }, id);
                                })
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "cart-section",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                                        children: "Delivery address"
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                        className: "cart-address",
                                        children: [
                                            /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                className: "cart-address-icon",
                                                children: "\uD83D\uDCCD"
                                            }),
                                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $jk232.jsx)("strong", {
                                                        children: "Home"
                                                    }),
                                                    /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                                        children: "221B, Koramangala 4th Block, Bangalore, Karnataka 560034"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "cart-section",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                                        children: "Payment method"
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsx)("div", {
                                        className: "payment-methods",
                                        children: $97a68d5db2fe50bd$var$PAYMENT_METHODS.map((method)=>/*#__PURE__*/ (0, $jk232.jsxs)("button", {
                                                className: `payment-method ${paymentMethod === method.id ? 'active' : ''}`,
                                                onClick: ()=>setPaymentMethod(method.id),
                                                children: [
                                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                                        children: method.icon
                                                    }),
                                                    method.label
                                                ]
                                            }, method.id))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "cart-summary",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                                children: "Bill summary"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("div", {
                                className: "cart-coupon",
                                children: appliedCoupon ? /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                    className: "cart-coupon-applied",
                                    children: [
                                        /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                            children: [
                                                "\uD83C\uDFF7\uFE0F ",
                                                appliedCoupon,
                                                " applied"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $jk232.jsx)("button", {
                                            onClick: handleRemoveCoupon,
                                            children: "Remove"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $jk232.jsxs)((0, $jk232.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                            className: "cart-coupon-input",
                                            children: [
                                                /*#__PURE__*/ (0, $jk232.jsx)("input", {
                                                    type: "text",
                                                    placeholder: "Enter coupon code",
                                                    value: couponInput,
                                                    onChange: (e)=>{
                                                        setCouponInput(e.target.value);
                                                        setCouponError('');
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $jk232.jsx)("button", {
                                                    onClick: handleApplyCoupon,
                                                    children: "Apply"
                                                })
                                            ]
                                        }),
                                        couponError && /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                            className: "cart-coupon-error",
                                            children: couponError
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "cart-summary-row",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        children: "Item total"
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                        children: [
                                            "\u20B9",
                                            subtotal.toFixed(0)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "cart-summary-row",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        children: "GST & restaurant charges"
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                        children: [
                                            "\u20B9",
                                            gst.toFixed(0)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "cart-summary-row",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        children: "Delivery fee"
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        children: deliveryFee === 0 ? /*#__PURE__*/ (0, $jk232.jsxs)((0, $jk232.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $jk232.jsxs)("s", {
                                                    children: [
                                                        "\u20B9",
                                                        $97a68d5db2fe50bd$var$DELIVERY_FEE
                                                    ]
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $jk232.jsx)("em", {
                                                    children: "FREE"
                                                })
                                            ]
                                        }) : `\u{20B9}${deliveryFee}`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "cart-summary-row",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        children: "Platform fee"
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                        children: [
                                            "\u20B9",
                                            $97a68d5db2fe50bd$var$PLATFORM_FEE
                                        ]
                                    })
                                ]
                            }),
                            discount > 0 && /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "cart-summary-row cart-summary-discount",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        children: "Coupon discount"
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                        children: [
                                            "\u2212\u20B9",
                                            discount.toFixed(0)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                className: "cart-summary-row cart-summary-total",
                                children: [
                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        children: "To pay"
                                    }),
                                    /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                        children: [
                                            "\u20B9",
                                            total.toFixed(0)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("button", {
                                className: "cart-checkout-btn",
                                onClick: handlePlaceOrder,
                                disabled: isPlacingOrder,
                                children: isPlacingOrder ? /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                    className: "cart-btn-spinner"
                                }) : 'Place Order'
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $97a68d5db2fe50bd$export$2e2bcd8739ae039 = $97a68d5db2fe50bd$var$Cart;



var $jk232 = parcelRequire("jk232");

var $4RFnf = parcelRequire("4RFnf");

var $eGOwh = parcelRequire("eGOwh");
var $3W4eU = parcelRequire("3W4eU");
var $3W4eU = parcelRequire("3W4eU");





const $2d8ecaad9e3d2ce8$var$COLLECTION_URL = '/.netlify/functions/swiggy-collection';
const $2d8ecaad9e3d2ce8$var$extractRestaurants = (cards = [])=>{
    for (const card of cards){
        const grid = card?.card?.card?.gridElements?.infoWithStyle?.restaurants;
        if (grid?.length) return grid;
    }
    return cards.map((c)=>c?.card?.card).filter((c)=>c?.info?.id).map((c)=>({
            info: c.info
        }));
};
const $2d8ecaad9e3d2ce8$var$RestaurantCardWithDiscount = (0, $c2f90b08ce5e36f9$export$69fb0609e92726e3)((0, $c2f90b08ce5e36f9$export$2e2bcd8739ae039));
const $2d8ecaad9e3d2ce8$var$CollectionPage = ()=>{
    const { slug: slug } = (0, $3W4eU.useParams)();
    const navigate = (0, $3W4eU.useNavigate)();
    const category = (0, $7094f95aa1680fa7$export$a513ea61a7bee91c).find((c)=>c.slug === slug);
    const [restaurants, setRestaurants] = (0, $4RFnf.useState)([]);
    const [isLoading, setIsLoading] = (0, $4RFnf.useState)(true);
    (0, $4RFnf.useEffect)(()=>{
        if (!category) {
            navigate('/');
            return;
        }
        setRestaurants([]);
        setIsLoading(true);
        fetchRestaurants();
    }, [
        slug
    ]);
    const fetchRestaurants = async ()=>{
        try {
            const res = await fetch(`${$2d8ecaad9e3d2ce8$var$COLLECTION_URL}?collection=${category.collection}&tags=${category.tags}&offset=0`);
            const json = await res.json();
            const list = $2d8ecaad9e3d2ce8$var$extractRestaurants(json?.data?.cards ?? []);
            setRestaurants(list);
        } catch (e) {
            console.error('[CollectionPage] fetch error:', e.message);
        } finally{
            setIsLoading(false);
        }
    };
    if (!category) return null;
    return /*#__PURE__*/ (0, $jk232.jsxs)("div", {
        className: "collection-page",
        children: [
            /*#__PURE__*/ (0, $jk232.jsx)("div", {
                className: "collection-back-bar",
                children: /*#__PURE__*/ (0, $jk232.jsx)("button", {
                    className: "collection-back-btn",
                    onClick: ()=>navigate('/'),
                    children: "\u2190 Back"
                })
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "collection-header",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                        className: "collection-header-emoji",
                        children: category.emoji
                    }),
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "collection-header-text",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsxs)("h1", {
                                children: [
                                    category.label,
                                    " Restaurants"
                                ]
                            }),
                            !isLoading && /*#__PURE__*/ (0, $jk232.jsxs)("p", {
                                children: [
                                    restaurants.length,
                                    " restaurant",
                                    restaurants.length !== 1 ? 's' : '',
                                    " near you"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jk232.jsx)("section", {
                className: "collection-restaurants",
                children: isLoading ? /*#__PURE__*/ (0, $jk232.jsx)((0, $7967c36430cc139a$export$2e2bcd8739ae039), {}) : restaurants.length === 0 ? /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                    className: "empty-state",
                    children: [
                        /*#__PURE__*/ (0, $jk232.jsx)("span", {
                            children: category.emoji
                        }),
                        /*#__PURE__*/ (0, $jk232.jsxs)("h3", {
                            children: [
                                "No ",
                                category.label,
                                " restaurants found"
                            ]
                        }),
                        /*#__PURE__*/ (0, $jk232.jsx)("p", {
                            children: "Try a different category or check back later."
                        }),
                        /*#__PURE__*/ (0, $jk232.jsx)("button", {
                            onClick: ()=>navigate('/'),
                            children: "Back to home"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $jk232.jsx)("div", {
                    className: "restaurant-grid",
                    children: restaurants.map((restaurant)=>/*#__PURE__*/ (0, $jk232.jsx)((0, $eGOwh.Link), {
                            to: '/restaurant/' + restaurant.info.id,
                            className: "card-link",
                            children: restaurant.info.aggregatedDiscountInfoV3 ? /*#__PURE__*/ (0, $jk232.jsx)($2d8ecaad9e3d2ce8$var$RestaurantCardWithDiscount, {
                                resData: restaurant
                            }) : /*#__PURE__*/ (0, $jk232.jsx)((0, $c2f90b08ce5e36f9$export$2e2bcd8739ae039), {
                                resData: restaurant
                            })
                        }, restaurant.info.id))
                })
            })
        ]
    });
};
var $2d8ecaad9e3d2ce8$export$2e2bcd8739ae039 = $2d8ecaad9e3d2ce8$var$CollectionPage;



const $3c1483f93957eaf7$var$Grocery = /*#__PURE__*/ (0, $4RFnf.lazy)(()=>(parcelRequire("cLzjP")));
// it's not same import as above, it's dynamic import... a function
const $3c1483f93957eaf7$var$AppLayout = ()=>{
    const [userName, setUserName] = (0, $4RFnf.useState)([]);
    // authentication
    (0, $4RFnf.useEffect)(()=>{
        // make api call and send username and password
        const data = {
            name: 'User'
        };
        setUserName(data.name);
    }, []);
    return /*#__PURE__*/ (0, $jk232.jsx)((0, $99aed3ab2dc6c7d9$export$2881499e37b75b9a), {
        store: (0, $fe6c2c553256b578$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $jk232.jsx)((0, $b82f5bc1455b2c3b$export$2e2bcd8739ae039).Provider, {
            value: {
                loggedInUser: userName,
                setUserName: setUserName
            },
            children: /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "app",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsx)((0, $2082b37973b7af43$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $jk232.jsx)((0, $3W4eU.Outlet), {}),
                    /*#__PURE__*/ (0, $jk232.jsx)((0, $ac0c9409820c83f0$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
};
const $3c1483f93957eaf7$var$appRouter = (0, $eGOwh.createBrowserRouter)([
    {
        path: '/',
        element: /*#__PURE__*/ (0, $jk232.jsx)($3c1483f93957eaf7$var$AppLayout, {}),
        children: [
            {
                path: '/',
                element: /*#__PURE__*/ (0, $jk232.jsx)((0, $22ed7a426ac2c232$export$2e2bcd8739ae039), {})
            },
            {
                path: '/about',
                element: /*#__PURE__*/ (0, $jk232.jsx)((0, $fe10913106d53c8e$export$2e2bcd8739ae039), {})
            },
            {
                path: '/contact',
                element: /*#__PURE__*/ (0, $jk232.jsx)((0, $7db919d997b4a71e$export$2e2bcd8739ae039), {})
            },
            {
                path: '/restaurant/:resId',
                element: /*#__PURE__*/ (0, $jk232.jsx)((0, $9fce8677a912ffae$export$2e2bcd8739ae039), {})
            },
            {
                path: '/cart',
                element: /*#__PURE__*/ (0, $jk232.jsx)((0, $97a68d5db2fe50bd$export$2e2bcd8739ae039), {})
            },
            {
                path: '/collection/:slug',
                element: /*#__PURE__*/ (0, $jk232.jsx)((0, $2d8ecaad9e3d2ce8$export$2e2bcd8739ae039), {})
            },
            {
                path: '/grocery',
                element: /*#__PURE__*/ (0, $jk232.jsx)((0, $4RFnf.Suspense), {
                    fallback: /*#__PURE__*/ (0, $jk232.jsx)("div", {
                        className: "page-loading",
                        children: /*#__PURE__*/ (0, $jk232.jsx)("span", {
                            className: "page-loading-spinner"
                        })
                    }),
                    children: /*#__PURE__*/ (0, $jk232.jsx)($3c1483f93957eaf7$var$Grocery, {})
                })
            }
        ],
        errorElement: /*#__PURE__*/ (0, $jk232.jsx)((0, $0ff0ca03dc317819$export$2e2bcd8739ae039), {})
    }
]);
const $3c1483f93957eaf7$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($e6901a497e5ba7f6$exports))).createRoot(document.getElementById('root'));
$3c1483f93957eaf7$var$root.render(/*#__PURE__*/ (0, $jk232.jsx)((0, $eGOwh.RouterProvider), {
    router: $3c1483f93957eaf7$var$appRouter
})) // lazy loading is a technique in which we load only the required part of the application and not the entire application at once
 // we can use lazy loading with react-router-dom by using dynamic import
;


//# sourceMappingURL=repo.16b269a9.js.map
